var _slicedToArray = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/defineProperty");

var _taggedTemplateLiteral = require("/var/lib/jenkins/workspace/Genomica_site_latest/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n                    animation: ", " ", "s infinite;\n                "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    .react-datepicker {\n        &-popper {\n            z-index: ", ";\n        }\n\n        &__portal {\n            width: 100vw;\n            height: 100vh;\n            position: fixed;\n            left: 0;\n            top: 0;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background: ", ";\n            z-index: ", ";\n        }\n\n        &__month-container {\n            margin-right: 48px;\n\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n\n        &__day-names {\n            display: block;\n            white-space: nowrap;\n            border-bottom: 1px solid ", ";\n        }\n\n        &__week {\n            display: block;\n            white-space: nowrap;\n        }\n\n        &__day--in-selecting-range {\n            background-color: ", ";\n        }\n\n        &__day-name,\n        &__day {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            width: 44px;\n\n            &:not(:empty) {\n                height: 44px;\n            }\n\n            & p {\n                color: ", ";\n                border-bottom: 1px solid transparent;\n            }\n        }\n\n        &__day {\n            cursor: pointer;\n        }\n\n        &__day:focus:not(.react-datepicker__day--excluded),\n        &__day--selected,\n        &__day--selecting-range-start,\n        &__day--selecting-range-end,\n        &__day--selecting-range-start.react-datepicker__day--selecting-range-end,\n        &__day--selected.react-datepicker__day--outside-month {\n            background-color: ", ";\n            border-radius: ", ";\n\n            & p {\n                color: ", ";\n            }\n\n            &.react-datepicker__day--today {\n                & p {\n                    box-sizing: border-box;\n                    border-bottom: 1px solid ", ";\n                }\n            }\n        }\n\n        &__day--outside-month,\n        &__day--excluded {\n            & p {\n                color: ", ";\n            }\n        }\n\n        &__day--selecting-range-start {\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0;\n\n            & p {\n                color: ", ";\n            }\n        }\n\n        &__day--selecting-range-end {\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n\n            & p {\n                color: ", ";\n            }\n        }\n\n        &__day--today {\n            & p {\n                box-sizing: border-box;\n                border-bottom: 1px solid ", ";\n            }\n        }\n    }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    p {\n        ", "\n    }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    max-width: 120px;\n\n    p {\n        ", "\n    }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n            border-radius: ", ";\n            bottom: ", "px;\n            ", " {\n                &::-webkit-scrollbar-track {\n                    border-radius: 0 ", " ", " 0;\n                }\n            }\n        "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    position: absolute;\n    width: 100%;\n\n    ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n\n    input {\n        ", "\n    }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    overflow: hidden;\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n    z-index: 10;\n    position: absolute;\n\n    &:focus-within {\n        > ", " {\n            &:focus {\n                outline: none;\n            }\n        }\n    }\n\n    &:focus-visible {\n        outline: none !important;\n    }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    position: relative;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    max-height: ", ";\n    &::-webkit-scrollbar-track {\n        border-radius: 0 0 ", " 0;\n    }\n    &:focus {\n        outline: none;\n    }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n            background-color: ", " !important;\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    p {\n        ", "\n    }\n\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    * {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        vertical-align: baseline;\n        font-family: 'Dasa Sans', 'Montserrat', sans-serif;\n    }\n    *:focus {\n        outline: none;\n    }\n    /* HTML5 display-role reset for older browsers */\n    article, aside, details, figcaption, figure,\n    footer, header, hgroup, menu, nav, section {\n        display: block;\n    }\n    body {\n        line-height: 1;\n    }\n    ol, ul {\n        list-style: none;\n    }\n    blockquote, q {\n        quotes: none;\n    }\n    blockquote:before, blockquote:after,\n    q:before, q:after {\n        content: '';\n        content: none;\n    }\n    table {\n        border-collapse: collapse;\n        border-spacing: 0;\n    }\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Bold.eot');\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Bold.eot?#iefix') format('embedded-opentype'),\n            url('https://alma-assets.dasa.com.br/fonts/woff/DasaSans-Bold.woff') format('woff'),\n            url('https://alma-assets.dasa.com.br/fonts/woff2/DasaSans-Bold.woff2') format('woff2');\n        font-weight: 700;\n    }\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Semibold.eot');\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Semibold.eot?#iefix') format('embedded-opentype'),\n            url('https://alma-assets.dasa.com.br/fonts/woff/DasaSans-Semibold.woff') format('woff'),\n            url('https://alma-assets.dasa.com.br/fonts/woff2/DasaSans-Semibold.woff2') format('woff2');\n        font-weight: 600;\n    }\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Medium.eot');\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Medium.eot?#iefix') format('embedded-opentype'),\n            url('https://alma-assets.dasa.com.br/fonts/woff/DasaSans-Medium.woff') format('woff'),\n            url('https://alma-assets.dasa.com.br/fonts/woff2/DasaSans-Medium.woff2') format('woff2');\n        font-weight: 500;\n    }\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Regular.eot');\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Regular.eot?#iefix') format('embedded-opentype'),\n            url('https://alma-assets.dasa.com.br/fonts/woff/DasaSans-Regular.woff') format('woff'),\n            url('https://alma-assets.dasa.com.br/fonts/woff2/DasaSans-Regular.woff2') format('woff2');\n        font-weight: 400;\n    }\n    @font-face {\n        font-family: 'Dasa Sans';\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Light.eot');\n        src: url('https://alma-assets.dasa.com.br/fonts/eot/DasaSans-Light.eot?#iefix') format('embedded-opentype'),\n            url('https://alma-assets.dasa.com.br/fonts/woff/DasaSans-Light.woff') format('woff'),\n            url('https://alma-assets.dasa.com.br/fonts/woff2/DasaSans-Light.woff2') format('woff2');\n        font-weight: 300;\n    }\n\n    ", "\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('styled-components'), require('@dasa-health/alma-tokens'), require('react'), require('@emotion/react'), require('@emotion/react/package.json'), require('@emotion/styled'), require('styled-system'), require('theme-ui'), require('@dasa-health/alma-icons'), require('react-dom'), require('imask'), require('react-datepicker')) : typeof define === 'function' && define.amd ? define(['exports', 'styled-components', '@dasa-health/alma-tokens', 'react', '@emotion/react', '@emotion/react/package.json', '@emotion/styled', 'styled-system', 'theme-ui', '@dasa-health/alma-icons', 'react-dom', 'imask', 'react-datepicker'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["alma-react"] = {}, global.StyledComponents, global["UndefineddasaHealth/almaTokens"], global.React, global["Undefinedemotion/react"], global.packageInfo, global["Undefinedemotion/styled"], global.StyledSystem, global.ThemeUi, global["UndefineddasaHealth/almaIcons"], global.ReactDom, global.Imask, global.ReactDatepicker));
})(this, function (exports, styled, almaTokens, React, react, packageInfo, styled$1, styledSystem, themeUi, almaIcons, reactDom, IMask, ReactDatePicker) {
  'use strict';

  function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
      'default': e
    };
  }

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);

    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function get() {
              return e[k];
            }
          });
        }
      });
    }

    n["default"] = e;
    return Object.freeze(n);
  }

  var styled__default$1 = /*#__PURE__*/_interopDefaultLegacy(styled);

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  var packageInfo__default = /*#__PURE__*/_interopDefaultLegacy(packageInfo);

  var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled$1);

  var styledSystem__namespace = /*#__PURE__*/_interopNamespace(styledSystem);

  var IMask__default = /*#__PURE__*/_interopDefaultLegacy(IMask);

  var ReactDatePicker__default = /*#__PURE__*/_interopDefaultLegacy(ReactDatePicker);

  var tail$2 = function tail$2(arr) {
    return arr && arr.length ? arr[arr.length - 1] : void 0;
  };

  var head = function head(arr) {
    return arr && arr.length ? arr[0] : void 0;
  };

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  } // based on https://github.com/developit/dlv


  var get$2 = function get(obj, key, def, p, undef) {
    key = key && key.split ? key.split('.') : [key];

    for (p = 0; p < key.length; p++) {
      obj = obj ? obj[key[p]] : undef;
    }

    return obj === undef ? def : obj;
  };

  var defaultBreakpoints$1 = [40, 52, 64].map(function (n) {
    return n + 'em';
  });
  var defaultTheme$2 = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  };
  var aliases$1 = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
  };
  var multiples$1 = {
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    size: ['width', 'height']
  };
  var scales$1 = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    outlineColor: 'colors',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
  };

  var positiveOrNegative$1 = function positiveOrNegative(scale, value) {
    if (typeof value !== 'number' || value >= 0) {
      return get$2(scale, value, value);
    }

    var absolute = Math.abs(value);
    var n = get$2(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return n * -1;
  };

  var transforms$1 = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
    var _extends2;

    return _extends$1({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative$1, _extends2));
  }, {});

  var responsive$1 = function responsive(styles) {
    return function (theme) {
      var next = {};
      var breakpoints = get$2(theme, 'breakpoints', defaultBreakpoints$1);
      var mediaQueries = [null].concat(breakpoints.map(function (n) {
        return "@media screen and (min-width: " + n + ")";
      }));

      for (var key in styles) {
        var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
        if (value == null) continue;

        if (!Array.isArray(value)) {
          next[key] = value;
          continue;
        }

        for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
          var media = mediaQueries[i];

          if (!media) {
            next[key] = value[i];
            continue;
          }

          next[media] = next[media] || {};
          if (value[i] == null) continue;
          next[media][key] = value[i];
        }
      }

      return next;
    };
  };

  var css$1 = function css(args) {
    return function (props) {
      if (props === void 0) {
        props = {};
      }

      var theme = _extends$1({}, defaultTheme$2, {}, props.theme || props);

      var result = {};
      var obj = typeof args === 'function' ? args(theme) : args;
      var styles = responsive$1(obj)(theme);

      for (var key in styles) {
        var x = styles[key];
        var val = typeof x === 'function' ? x(theme) : x;

        if (key === 'variant') {
          var variant = css(get$2(theme, val))(theme);
          result = _extends$1({}, result, {}, variant);
          continue;
        }

        if (val && typeof val === 'object') {
          result[key] = css(val)(theme);
          continue;
        }

        var prop = get$2(aliases$1, key, key);
        var scaleName = get$2(scales$1, prop);
        var scale = get$2(theme, scaleName, get$2(theme, prop, {}));
        var transform = get$2(transforms$1, prop, get$2);
        var value = transform(scale, val, val);

        if (multiples$1[prop]) {
          var dirs = multiples$1[prop];

          for (var i = 0; i < dirs.length; i++) {
            result[dirs[i]] = value;
          }
        } else {
          result[prop] = value;
        }
      }

      return result;
    };
  };

  var css$2 = css$1;

  var stringNormalize = function stringNormalize(text) {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  var cssTextEllipsisOneLine = styled.css(_templateObject());

  var mapResponsive = function mapResponsive(prop, mapperFn) {
    if (Array.isArray(prop)) {
      return prop.map(function (item) {
        if (item === null) {
          return null;
        }

        return mapperFn(item);
      });
    } else if (prop) {
      return mapperFn(prop);
    }

    return null;
  };

  var sx$1 = function sx$1(props) {
    return css$2(props.sx);
  };

  var __defProp$1h = Object.defineProperty;
  var __defProps$Q = Object.defineProperties;
  var __getOwnPropDescs$Q = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$1h = Object.getOwnPropertySymbols;
  var __hasOwnProp$1h = Object.prototype.hasOwnProperty;
  var __propIsEnum$1h = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1h = function __defNormalProp$1h(obj, key, value) {
    return key in obj ? __defProp$1h(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1h = function __spreadValues$1h(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1h.call(b, prop)) __defNormalProp$1h(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1h) {
      var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols$1h(b)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var prop = _step.value;
          if (__propIsEnum$1h.call(b, prop)) __defNormalProp$1h(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return a;
  };

  var __spreadProps$Q = function __spreadProps$Q(a, b) {
    return __defProps$Q(a, __getOwnPropDescs$Q(b));
  };

  var getThemedColorTokens = function getThemedColorTokens(newTokens) {
    var tokens = newTokens ? newTokens : almaTokens.dasTokens;
    var palette = {
      black: tokens.ColorPaletteBlack,
      gray: {
        10: tokens.ColorPaletteGray10,
        20: tokens.ColorPaletteGray20,
        30: tokens.ColorPaletteGray30,
        40: tokens.ColorPaletteGray40,
        50: tokens.ColorPaletteGray50,
        60: tokens.ColorPaletteGray60,
        70: tokens.ColorPaletteGray70,
        80: tokens.ColorPaletteGray80
      },
      green: {
        10: tokens.ColorPaletteGreen10,
        20: tokens.ColorPaletteGreen20,
        30: tokens.ColorPaletteGreen30,
        40: tokens.ColorPaletteGreen40,
        50: tokens.ColorPaletteGreen50,
        60: tokens.ColorPaletteGreen60,
        70: tokens.ColorPaletteGreen70,
        80: tokens.ColorPaletteGreen80
      },
      purple: {
        10: tokens.ColorPalettePurple10,
        20: tokens.ColorPalettePurple20,
        30: tokens.ColorPalettePurple30,
        40: tokens.ColorPalettePurple40,
        50: tokens.ColorPalettePurple50,
        60: tokens.ColorPalettePurple60,
        70: tokens.ColorPalettePurple70,
        80: tokens.ColorPalettePurple80
      },
      red: {
        10: tokens.ColorPaletteRed10,
        20: tokens.ColorPaletteRed20,
        30: tokens.ColorPaletteRed30,
        40: tokens.ColorPaletteRed40,
        50: tokens.ColorPaletteRed50,
        60: tokens.ColorPaletteRed60,
        70: tokens.ColorPaletteRed70,
        80: tokens.ColorPaletteRed80
      },
      white: tokens.ColorPaletteWhite,
      yellow: {
        10: tokens.ColorPaletteYellow10,
        20: tokens.ColorPaletteYellow20,
        30: tokens.ColorPaletteYellow30,
        40: tokens.ColorPaletteYellow40,
        50: tokens.ColorPaletteYellow50,
        60: tokens.ColorPaletteYellow60,
        70: tokens.ColorPaletteYellow70,
        80: tokens.ColorPaletteYellow80
      }
    };
    var colorTokens = {
      brand: {
        primary: {
          10: tokens.ColorBrandPrimary10,
          20: tokens.ColorBrandPrimary20,
          30: tokens.ColorBrandPrimary30,
          40: tokens.ColorBrandPrimary40,
          50: tokens.ColorBrandPrimary50,
          60: tokens.ColorBrandPrimary60,
          70: tokens.ColorBrandPrimary70,
          80: tokens.ColorBrandPrimary80
        }
      },
      dataviz: {
        inverse: {
          negative: {
            shape: {
              "01": tokens.ColorDatavizInverseNegativeShape01,
              "02": tokens.ColorDatavizInverseNegativeShape02,
              "03": tokens.ColorDatavizInverseNegativeShape03
            },
            text: tokens.ColorDatavizInverseNegativeText
          },
          positive: {
            shape: {
              "01": tokens.ColorDatavizInversePositiveShape01,
              "02": tokens.ColorDatavizInversePositiveShape02,
              "03": tokens.ColorDatavizInversePositiveShape03
            },
            text: tokens.ColorDatavizInversePositiveText
          }
        },
        negative: {
          "01": tokens.ColorDatavizNegativeShape01,
          "02": tokens.ColorDatavizNegativeShape02,
          "03": tokens.ColorDatavizNegativeShape03,
          text: tokens.ColorDatavizNegativeText
        },
        positive: {
          "01": tokens.ColorDatavizPositiveShape01,
          "02": tokens.ColorDatavizPositiveShape02,
          "03": tokens.ColorDatavizPositiveShape03,
          text: tokens.ColorDatavizPositiveText
        }
      },
      feedback: {
        error: {
          shape: tokens.ColorFeedbackErrorShape,
          text: tokens.ColorFeedbackErrorText
        },
        inverse: {
          error: {
            shape: tokens.ColorFeedbackInverseErrorShape,
            text: tokens.ColorFeedbackInverseErrorText
          },
          on: {
            brand: {
              error: {
                shape: tokens.ColorFeedbackInverseOnBrandErrorShape,
                text: tokens.ColorFeedbackInverseOnBrandErrorText
              },
              success: {
                shape: tokens.ColorFeedbackInverseOnBrandSuccessShape,
                text: tokens.ColorFeedbackInverseOnBrandSuccessText
              }
            }
          },
          success: {
            shape: tokens.ColorFeedbackInverseSuccessShape,
            text: tokens.ColorFeedbackInverseSuccessText
          }
        },
        on: {
          brand: {
            error: {
              shape: tokens.ColorFeedbackOnBrandErrorShape,
              text: tokens.ColorFeedbackOnBrandErrorText
            },
            success: {
              shape: tokens.ColorFeedbackOnBrandSuccessShape,
              text: tokens.ColorFeedbackOnBrandSuccessText
            }
          }
        },
        success: {
          shape: tokens.ColorFeedbackSuccessShape,
          text: tokens.ColorFeedbackSuccessText
        }
      },
      interaction: {
        accent: {
          "01": tokens.ColorInteractionAccent01,
          "02": tokens.ColorInteractionAccent02,
          "03": tokens.ColorInteractionAccent03
        },
        blend: {
          "01": tokens.ColorInteractionBlend01,
          "02": tokens.ColorInteractionBlend02,
          "03": tokens.ColorInteractionBlend03,
          "04": tokens.ColorInteractionBlend04,
          "05": tokens.ColorInteractionBlend05,
          "06": tokens.ColorInteractionBlend06,
          "07": tokens.ColorInteractionBlend07,
          "08": tokens.ColorInteractionBlend08
        },
        danger: {
          "01": tokens.ColorInteractionDanger01,
          "02": tokens.ColorInteractionDanger02,
          "03": tokens.ColorInteractionDanger03
        },
        inverse: {
          accent: {
            "01": tokens.ColorInteractionInverseAccent01,
            "02": tokens.ColorInteractionInverseAccent02,
            "03": tokens.ColorInteractionInverseAccent03
          },
          blend: {
            "01": tokens.ColorInteractionInverseBlend01,
            "02": tokens.ColorInteractionInverseBlend02,
            "03": tokens.ColorInteractionInverseBlend03,
            "04": tokens.ColorInteractionInverseBlend04,
            "05": tokens.ColorInteractionInverseBlend05,
            "06": tokens.ColorInteractionInverseBlend06,
            "07": tokens.ColorInteractionInverseBlend07,
            "08": tokens.ColorInteractionInverseBlend08
          },
          danger: {
            "01": tokens.ColorInteractionInverseDanger01,
            "02": tokens.ColorInteractionInverseDanger02,
            "03": tokens.ColorInteractionInverseDanger03
          },
          on: {
            brand: {
              accent: {
                "01": tokens.ColorInteractionInverseOnBrandAccent01,
                "02": tokens.ColorInteractionInverseOnBrandAccent02,
                "03": tokens.ColorInteractionInverseOnBrandAccent03
              },
              blend: {
                "01": tokens.ColorInteractionInverseOnBrandBlend01,
                "02": tokens.ColorInteractionInverseOnBrandBlend02,
                "03": tokens.ColorInteractionInverseOnBrandBlend03,
                "04": tokens.ColorInteractionInverseOnBrandBlend04,
                "05": tokens.ColorInteractionInverseOnBrandBlend05,
                "06": tokens.ColorInteractionInverseOnBrandBlend06,
                "07": tokens.ColorInteractionInverseOnBrandBlend07,
                "08": tokens.ColorInteractionInverseOnBrandBlend08
              },
              danger: {
                "01": tokens.ColorInteractionInverseOnBrandDanger01,
                "02": tokens.ColorInteractionInverseOnBrandDanger02,
                "03": tokens.ColorInteractionInverseOnBrandDanger03
              },
              select: {
                active: tokens.ColorInteractionInverseOnBrandSelectActive,
                default: tokens.ColorInteractionInverseOnBrandSelectDefault,
                focus: tokens.ColorInteractionInverseOnBrandSelectFocus
              },
              subtle: {
                "01": tokens.ColorInteractionInverseOnBrandSubtle01,
                "02": tokens.ColorInteractionInverseOnBrandSubtle02,
                "03": tokens.ColorInteractionInverseOnBrandSubtle03
              }
            }
          },
          select: {
            active: tokens.ColorInteractionInverseSelectActive,
            default: tokens.ColorInteractionInverseSelectDefault,
            focus: tokens.ColorInteractionInverseSelectFocus
          },
          subtle: {
            "01": tokens.ColorInteractionInverseSubtle01,
            "02": tokens.ColorInteractionInverseSubtle02,
            "03": tokens.ColorInteractionInverseSubtle03
          }
        },
        on: {
          brand: {
            accent: {
              "01": tokens.ColorInteractionOnBrandAccent01,
              "02": tokens.ColorInteractionOnBrandAccent02,
              "03": tokens.ColorInteractionOnBrandAccent03
            },
            blend: {
              "01": tokens.ColorInteractionOnBrandBlend01,
              "02": tokens.ColorInteractionOnBrandBlend02,
              "03": tokens.ColorInteractionOnBrandBlend03,
              "04": tokens.ColorInteractionOnBrandBlend04,
              "05": tokens.ColorInteractionOnBrandBlend05,
              "06": tokens.ColorInteractionOnBrandBlend06,
              "07": tokens.ColorInteractionOnBrandBlend07,
              "08": tokens.ColorInteractionOnBrandBlend08
            },
            danger: {
              "01": tokens.ColorInteractionOnBrandDanger01,
              "02": tokens.ColorInteractionOnBrandDanger02,
              "03": tokens.ColorInteractionOnBrandDanger03
            },
            select: {
              active: tokens.ColorInteractionOnBrandSelectActive,
              default: tokens.ColorInteractionOnBrandSelectDefault,
              focus: tokens.ColorInteractionOnBrandSelectFocus
            },
            subtle: {
              "01": tokens.ColorInteractionOnBrandSubtle01,
              "02": tokens.ColorInteractionOnBrandSubtle02,
              "03": tokens.ColorInteractionOnBrandSubtle03
            }
          }
        },
        select: {
          active: tokens.ColorInteractionSelectActive,
          default: tokens.ColorInteractionSelectDefault,
          focus: tokens.ColorInteractionSelectFocus
        },
        subtle: {
          "01": tokens.ColorInteractionSubtle01,
          "02": tokens.ColorInteractionSubtle02,
          "03": tokens.ColorInteractionSubtle03
        }
      },
      neutral: {
        "00": tokens.ColorNeutral00,
        10: tokens.ColorNeutral10,
        20: tokens.ColorNeutral20,
        30: tokens.ColorNeutral30,
        inverse: {
          "00": tokens.ColorNeutralInverse00,
          10: tokens.ColorNeutralInverse10,
          20: tokens.ColorNeutralInverse20,
          30: tokens.ColorNeutralInverse30,
          on: {
            brand: {
              "00": tokens.ColorNeutralInverseOnBrand00,
              10: tokens.ColorNeutralInverseOnBrand10,
              20: tokens.ColorNeutralInverseOnBrand20,
              30: tokens.ColorNeutralInverseOnBrand30
            }
          }
        },
        on: {
          brand: {
            "00": tokens.ColorNeutralOnBrand00,
            10: tokens.ColorNeutralOnBrand10,
            20: tokens.ColorNeutralOnBrand20,
            30: tokens.ColorNeutralOnBrand30
          }
        }
      },
      support: {
        "01": tokens.ColorSupport01,
        "02": tokens.ColorSupport02,
        inverse: {
          "01": tokens.ColorSupportInverse01,
          "02": tokens.ColorSupportInverse02,
          on: {
            brand: {
              "01": tokens.ColorSupportInverseOnBrand01,
              "02": tokens.ColorSupportInverseOnBrand02
            }
          }
        },
        on: {
          brand: {
            "01": tokens.ColorSupportOnBrand01,
            "02": tokens.ColorSupportOnBrand02
          }
        }
      },
      typeface: {
        inverse: {
          meld: tokens.ColorTypefaceInverseMeld,
          on: {
            brand: {
              meld: tokens.ColorTypefaceInverseOnBrandMeld,
              pure: tokens.ColorTypefaceInverseOnBrandPure,
              smooth: tokens.ColorTypefaceInverseOnBrandSmooth,
              strong: tokens.ColorTypefaceInverseOnBrandStrong
            }
          },
          pure: tokens.ColorTypefaceInversePure,
          smooth: tokens.ColorTypefaceInverseSmooth,
          strong: tokens.ColorTypefaceInverseStrong
        },
        meld: tokens.ColorTypefaceMeld,
        on: {
          brand: {
            meld: tokens.ColorTypefaceOnBrandMeld,
            pure: tokens.ColorTypefaceOnBrandPure,
            smooth: tokens.ColorTypefaceOnBrandSmooth,
            strong: tokens.ColorTypefaceOnBrandStrong
          }
        },
        pure: tokens.ColorTypefacePure,
        smooth: tokens.ColorTypefaceSmooth,
        strong: tokens.ColorTypefaceStrong
      }
    };
    return __spreadProps$Q(__spreadValues$1h({}, colorTokens), {
      accent: tokens.ColorSupport01,
      background: "inherit",
      muted: tokens.ColorPaletteGray50,
      palette: palette,
      primary: tokens.ColorBrandPrimary40,
      secondary: tokens.ColorInteractionAccent01,
      text: "inherit"
    });
  };

  var radii = {
    circle: almaTokens.almTokens.BorderRadiusCircle,
    lg: almaTokens.almTokens.BorderRadiusLg,
    md: almaTokens.almTokens.BorderRadiusMd,
    none: almaTokens.almTokens.BorderRadiusNone,
    pill: almaTokens.almTokens.BorderRadiusPill,
    sm: almaTokens.almTokens.BorderRadiusSm,
    xs: almaTokens.almTokens.BorderRadiusXs
  };
  var shadows = {
    "01": almaTokens.almTokens.Shadow01,
    "02": almaTokens.almTokens.Shadow02,
    "03": almaTokens.almTokens.Shadow03,
    "04": almaTokens.almTokens.Shadow04
  };
  var space$1 = {
    inline: {
      giant: almaTokens.almTokens.SpacingInlineGiant,
      huge: almaTokens.almTokens.SpacingInlineHuge,
      lg: almaTokens.almTokens.SpacingInlineLg,
      md: almaTokens.almTokens.SpacingInlineMd,
      nano: almaTokens.almTokens.SpacingInlineNano,
      quark: almaTokens.almTokens.SpacingInlineQuark,
      sm: almaTokens.almTokens.SpacingInlineSm,
      xl: almaTokens.almTokens.SpacingInlineXl,
      xs: almaTokens.almTokens.SpacingInlineXs,
      xxl: almaTokens.almTokens.SpacingInlineXxl,
      xxs: almaTokens.almTokens.SpacingInlineXxs,
      xxxl: almaTokens.almTokens.SpacingInlineXxxl,
      xxxs: almaTokens.almTokens.SpacingInlineXxxs
    },
    inset: {
      lg: almaTokens.almTokens.SpacingInsetLg,
      md: almaTokens.almTokens.SpacingInsetMd,
      nano: almaTokens.almTokens.SpacingInsetNano,
      quark: almaTokens.almTokens.SpacingInsetQuark,
      sm: almaTokens.almTokens.SpacingInsetSm,
      xs: almaTokens.almTokens.SpacingInsetXs
    },
    squish: {
      nano: almaTokens.almTokens.SpacingSquishNano,
      quark: almaTokens.almTokens.SpacingSquishQuark,
      sm: almaTokens.almTokens.SpacingSquishSm,
      xs: almaTokens.almTokens.SpacingSquishXs
    },
    stack: {
      giant: almaTokens.almTokens.SpacingStackGiant,
      huge: almaTokens.almTokens.SpacingStackHuge,
      lg: almaTokens.almTokens.SpacingStackLg,
      md: almaTokens.almTokens.SpacingStackMd,
      nano: almaTokens.almTokens.SpacingStackNano,
      quark: almaTokens.almTokens.SpacingStackQuark,
      sm: almaTokens.almTokens.SpacingStackSm,
      xl: almaTokens.almTokens.SpacingStackXl,
      xs: almaTokens.almTokens.SpacingStackXs,
      xxl: almaTokens.almTokens.SpacingStackXxl,
      xxs: almaTokens.almTokens.SpacingStackXxs,
      xxxl: almaTokens.almTokens.SpacingStackXxxl,
      xxxs: almaTokens.almTokens.SpacingStackXxxs
    }
  };
  var borderWidths = {
    hairline: almaTokens.almTokens.BorderWidthHairline,
    heavy: almaTokens.almTokens.BorderWidthHeavy,
    none: almaTokens.almTokens.BorderWidthNone,
    thick: almaTokens.almTokens.BorderWidthThick,
    thin: almaTokens.almTokens.BorderWidthThin
  };
  var typography = {
    fontSizes: {
      display: almaTokens.almTokens.FontSizeDisplay,
      giant: almaTokens.almTokens.FontSizeGiant,
      lg: almaTokens.almTokens.FontSizeLg,
      md: almaTokens.almTokens.FontSizeMd,
      sm: almaTokens.almTokens.FontSizeSm,
      xl: almaTokens.almTokens.FontSizeXl,
      xs: almaTokens.almTokens.FontSizeXs,
      xxl: almaTokens.almTokens.FontSizeXxl,
      xxs: almaTokens.almTokens.FontSizeXxs,
      xxxl: almaTokens.almTokens.FontSizeXxxl,
      xxxs: almaTokens.almTokens.FontSizeXxxs
    },
    letterSpacings: {
      medium: almaTokens.almTokens.LetterSpacingMedium,
      small: almaTokens.almTokens.LetterSpacingSmall,
      standard: almaTokens.almTokens.LetterSpacingStandard
    },
    lineHeights: {
      distant: almaTokens.almTokens.LineHeightDistant,
      huge: almaTokens.almTokens.LineHeightHuge,
      large: almaTokens.almTokens.LineHeightLarge,
      medium: almaTokens.almTokens.LineHeightMedium,
      standard: almaTokens.almTokens.LineHeightStandard,
      superdistant: almaTokens.almTokens.LineHeightSuperdistant,
      tiny: almaTokens.almTokens.LineHeightTiny
    }
  };
  var fonts = {
    base: almaTokens.almTokens.FontFamilyBase
  };
  var fontWeights = {
    bold: almaTokens.almTokens.FontWeightBold,
    light: almaTokens.almTokens.FontWeightLight,
    medium: almaTokens.almTokens.FontWeightMedium,
    regular: almaTokens.almTokens.FontWeightRegular,
    semibold: almaTokens.almTokens.FontWeightSemibold
  };
  var breakpoints = ["37.5rem", "52.5rem", "64rem", "90rem"];
  var forms = {
    input: {
      "&:focus": {
        borderColor: "primary",
        borderWidth: 1,
        outline: "none"
      },
      borderColor: "grays.60",
      borderWidth: 1,
      fontFamily: "base",
      outline: "none"
    },
    label: {
      color: "grays.60",
      fontSize: 1,
      fontWeight: "normal",
      margin: 0,
      width: "auto"
    },
    select: {
      "&:focus": {
        borderColor: "primary",
        borderWidth: 1,
        outline: "none"
      },
      borderColor: "grays.60",
      fontFamily: "base"
    },
    slider: {
      bg: "muted"
    },
    textarea: {
      "&:focus": {
        borderColor: "primary",
        borderWidth: 1,
        outline: "none"
      },
      borderColor: "grays.60",
      fontFamily: "base"
    }
  };
  var text = {
    default: {
      color: "inherit"
    },
    h0: {
      fontSize: 7,
      fontWeight: "bold"
    },
    h1: {
      fontSize: 6,
      fontWeight: "bold"
    },
    h2: {
      fontSize: 5,
      fontWeight: "bold"
    },
    h3: {
      fontSize: 4,
      fontWeight: "bold"
    },
    h4: {
      fontSize: 3,
      fontWeight: "bold"
    },
    h5: {
      fontSize: 2,
      fontWeight: "bold"
    },
    h6: {
      fontSize: 1,
      fontWeight: "bold"
    }
  };
  var opacities = {
    "01": almaTokens.almTokens.Opacity01,
    "02": almaTokens.almTokens.Opacity02,
    "03": almaTokens.almTokens.Opacity03,
    "04": almaTokens.almTokens.Opacity04,
    "05": almaTokens.almTokens.Opacity05,
    "06": almaTokens.almTokens.Opacity06,
    "07": almaTokens.almTokens.Opacity07,
    "08": almaTokens.almTokens.Opacity08
  };
  var __defProp$1g = Object.defineProperty;
  var __defProps$P = Object.defineProperties;
  var __getOwnPropDescs$P = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$1g = Object.getOwnPropertySymbols;
  var __hasOwnProp$1g = Object.prototype.hasOwnProperty;
  var __propIsEnum$1g = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1g = function __defNormalProp$1g(obj, key, value) {
    return key in obj ? __defProp$1g(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1g = function __spreadValues$1g(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1g.call(b, prop)) __defNormalProp$1g(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1g) {
      var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols$1g(b)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var prop = _step2.value;
          if (__propIsEnum$1g.call(b, prop)) __defNormalProp$1g(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    return a;
  };

  var __spreadProps$P = function __spreadProps$P(a, b) {
    return __defProps$P(a, __getOwnPropDescs$P(b));
  };

  var lineHeights = typography.lineHeights,
      fontSizes = typography.fontSizes,
      letterSpacings = typography.letterSpacings;

  var getCustomTheme = function getCustomTheme(defaultTokens, modes) {
    var getCustomModes = function getCustomModes() {
      if (modes && modes.length > 0) {
        var modesObject = {};
        modes.forEach(function (mode) {
          var name = mode.name,
              tokens = mode.tokens;
          return modesObject[name] = getThemedColorTokens(tokens);
        });
        return modesObject;
      }

      return {};
    };

    return {
      borderWidths: borderWidths,
      breakpoints: breakpoints,
      colors: __spreadProps$P(__spreadValues$1g({}, getThemedColorTokens(defaultTokens)), {
        modes: getCustomModes()
      }),
      config: {
        initialColorModeName: "default",
        printColorModeName: "default",
        useColorSchemeMediaQuery: false,
        useLocalStorage: false
      },
      fontSizes: fontSizes,
      fontWeights: fontWeights,
      fonts: fonts,
      forms: forms,
      letterSpacings: letterSpacings,
      lineHeights: lineHeights,
      opacities: opacities,
      radii: radii,
      shadows: shadows,
      space: space$1,
      text: text
    };
  };

  var defaultColors = getThemedColorTokens();
  var defaultTheme$1 = getCustomTheme();

  var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
  };

  function isNonNullObject(value) {
    return !!value && typeof value === 'object';
  }

  function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
  } // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


  var canUseSymbol$1 = typeof Symbol === 'function' && Symbol.for;
  var REACT_ELEMENT_TYPE = canUseSymbol$1 ? Symbol.for('react.element') : 0xeac7;

  function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
  }

  function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
  }

  function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
  }

  function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function (element) {
      return cloneUnlessOtherwiseSpecified(element, options);
    });
  }

  function getMergeFunction(key, options) {
    if (!options.customMerge) {
      return deepmerge;
    }

    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : deepmerge;
  }

  function getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
      return target.propertyIsEnumerable(symbol);
    }) : [];
  }

  function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
  }

  function propertyIsOnObject(object, property) {
    try {
      return property in object;
    } catch (_) {
      return false;
    }
  } // Protects from prototype poisoning and unexpected merging up the prototype chain.


  function propertyIsUnsafe(target, key) {
    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
    && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
    && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
  }

  function mergeObject(target, source, options) {
    var destination = {};

    if (options.isMergeableObject(target)) {
      getKeys(target).forEach(function (key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
      });
    }

    getKeys(source).forEach(function (key) {
      if (propertyIsUnsafe(target, key)) {
        return;
      }

      if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
        destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
      } else {
        destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
      }
    });
    return destination;
  }

  function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject; // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.

    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
      return cloneUnlessOtherwiseSpecified(source, options);
    } else if (sourceIsArray) {
      return options.arrayMerge(target, source, options);
    } else {
      return mergeObject(target, source, options);
    }
  }

  deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) {
      throw new Error('first argument should be an array');
    }

    return array.reduce(function (prev, next) {
      return deepmerge(prev, next, options);
    }, {});
  };

  var deepmerge_1 = deepmerge;
  var cjs = deepmerge_1;
  /**
   * Allows for nested scales with shorthand values
   * @example
   * {
   *   colors: {
   *     primary: { __default: '#00f', light: '#33f' }
   *   }
   * }
   * css({ color: 'primary' }); // { color: '#00f' }
   * css({ color: 'primary.light' }) // { color: '#33f' }
   */

  var THEME_UI_DEFAULT_KEY = '__default';

  var hasDefault = function hasDefault(x) {
    return typeof x === 'object' && x !== null && THEME_UI_DEFAULT_KEY in x;
  };
  /**
   * Extracts value under path from a deeply nested object.
   * Used for Themes, variants and Theme UI style objects.
   * Given a path to object with `__default` key, returns the value under that key.
   *
   * @param obj a theme, variant or style object
   * @param path path separated with dots (`.`)
   * @param fallback default value returned if get(obj, path) is not found
   */


  function get$1(obj, path, fallback, p, undef) {
    var pathArray = path && typeof path === 'string' ? path.split('.') : [path];

    for (p = 0; p < pathArray.length; p++) {
      obj = obj ? obj[pathArray[p]] : undef;
    }

    if (obj === undef) return fallback;
    return hasDefault(obj) ? obj[THEME_UI_DEFAULT_KEY] : obj;
  }

  var getObjectWithVariants = function getObjectWithVariants(obj, theme) {
    if (obj && obj['variant']) {
      var result = {};

      for (var key in obj) {
        var x = obj[key];

        if (key === 'variant') {
          var val = typeof x === 'function' ? x(theme) : x;

          var _variant = getObjectWithVariants(get$1(theme, val), theme);

          result = _objectSpread(_objectSpread({}, result), _variant);
        } else {
          result[key] = x;
        }
      }

      return result;
    }

    return obj;
  };

  var defaultBreakpoints = [40, 52, 64].map(function (n) {
    return n + 'em';
  });
  var defaultTheme = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  };
  var aliases = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
  };
  var multiples = {
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    scrollMarginX: ['scrollMarginLeft', 'scrollMarginRight'],
    scrollMarginY: ['scrollMarginTop', 'scrollMarginBottom'],
    scrollPaddingX: ['scrollPaddingLeft', 'scrollPaddingRight'],
    scrollPaddingY: ['scrollPaddingTop', 'scrollPaddingBottom'],
    size: ['width', 'height']
  };
  var scales = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    caretColor: 'colors',
    columnRuleColor: 'colors',
    textDecorationColor: 'colors',
    opacity: 'opacities',
    transition: 'transitions',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    marginBlock: 'space',
    marginBlockEnd: 'space',
    marginBlockStart: 'space',
    marginInline: 'space',
    marginInlineEnd: 'space',
    marginInlineStart: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    paddingBlock: 'space',
    paddingBlockEnd: 'space',
    paddingBlockStart: 'space',
    paddingInline: 'space',
    paddingInlineEnd: 'space',
    paddingInlineStart: 'space',
    scrollMargin: 'space',
    scrollMarginTop: 'space',
    scrollMarginRight: 'space',
    scrollMarginBottom: 'space',
    scrollMarginLeft: 'space',
    scrollMarginX: 'space',
    scrollMarginY: 'space',
    scrollPadding: 'space',
    scrollPaddingTop: 'space',
    scrollPaddingRight: 'space',
    scrollPaddingBottom: 'space',
    scrollPaddingLeft: 'space',
    scrollPaddingX: 'space',
    scrollPaddingY: 'space',
    inset: 'space',
    insetBlock: 'space',
    insetBlockEnd: 'space',
    insetBlockStart: 'space',
    insetInline: 'space',
    insetInlineEnd: 'space',
    insetInlineStart: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    borderBlock: 'borders',
    borderBlockColor: 'colors',
    borderBlockEnd: 'borders',
    borderBlockEndColor: 'colors',
    borderBlockEndStyle: 'borderStyles',
    borderBlockEndWidth: 'borderWidths',
    borderBlockStart: 'borders',
    borderBlockStartColor: 'colors',
    borderBlockStartStyle: 'borderStyles',
    borderBlockStartWidth: 'borderWidths',
    borderBlockStyle: 'borderStyles',
    borderBlockWidth: 'borderWidths',
    borderEndEndRadius: 'radii',
    borderEndStartRadius: 'radii',
    borderInline: 'borders',
    borderInlineColor: 'colors',
    borderInlineEnd: 'borders',
    borderInlineEndColor: 'colors',
    borderInlineEndStyle: 'borderStyles',
    borderInlineEndWidth: 'borderWidths',
    borderInlineStart: 'borders',
    borderInlineStartColor: 'colors',
    borderInlineStartStyle: 'borderStyles',
    borderInlineStartWidth: 'borderWidths',
    borderInlineStyle: 'borderStyles',
    borderInlineWidth: 'borderWidths',
    borderStartEndRadius: 'radii',
    borderStartStartRadius: 'radii',
    columnRuleWidth: 'borderWidths',
    outlineColor: 'colors',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    blockSize: 'sizes',
    inlineSize: 'sizes',
    maxBlockSize: 'sizes',
    maxInlineSize: 'sizes',
    minBlockSize: 'sizes',
    minInlineSize: 'sizes',
    columnWidth: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
  };

  var positiveOrNegative = function positiveOrNegative(scale, value) {
    if (typeof value !== 'number' || value >= 0) {
      if (typeof value === 'string' && value.startsWith('-')) {
        var valueWithoutMinus = value.substring(1);

        var _n = get$1(scale, valueWithoutMinus, valueWithoutMinus);

        if (typeof _n === 'number') {
          return _n * -1;
        }

        return "-".concat(_n);
      }

      return get$1(scale, value, value);
    }

    var absolute = Math.abs(value);
    var n = get$1(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return Number(n) * -1;
  };

  var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginBlock', 'marginBlockEnd', 'marginBlockStart', 'marginInline', 'marginInlineEnd', 'marginInlineStart', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, curr, positiveOrNegative));
  }, {});

  var responsive = function responsive(styles) {
    return function (theme) {
      var next = {};
      var breakpoints = theme && theme.breakpoints || defaultBreakpoints;
      var mediaQueries = [null].concat(_toConsumableArray(breakpoints.map(function (n) {
        return n.includes('@media') ? n : "@media screen and (min-width: ".concat(n, ")");
      })));

      for (var k in styles) {
        var key = k;
        var value = styles[key];

        if (typeof value === 'function') {
          value = value(theme || {});
        }

        if (value === false || value == null) {
          continue;
        }

        if (!Array.isArray(value)) {
          next[key] = value;
          continue;
        }

        for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
          var media = mediaQueries[i];

          if (!media) {
            next[key] = value[i];
            continue;
          }

          next[media] = next[media] || {};
          if (value[i] == null) continue;
          next[media][key] = value[i];
        }
      }

      return next;
    };
  };

  var css = function css() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var theme = _objectSpread(_objectSpread({}, defaultTheme), 'theme' in props ? props.theme : props); // insert variant props before responsive styles, so they can be merged
      // we need to maintain order of the style props, so if a variant is place in the middle
      // of other props, it will extends its props at that same location order.


      var obj = getObjectWithVariants(typeof args === 'function' ? args(theme) : args, theme);
      var styles = responsive(obj)(theme);
      var result = {};

      for (var key in styles) {
        var x = styles[key];
        var val = typeof x === 'function' ? x(theme) : x;

        if (val && typeof val === 'object') {
          if (hasDefault(val)) {
            result[key] = val[THEME_UI_DEFAULT_KEY];
            continue;
          } // On type level, val can also be an array here,
          // but we transform all arrays in `responsive` function.


          result[key] = css(val)(theme);
          continue;
        }

        var prop = key in aliases ? aliases[key] : key;
        var scaleName = prop in scales ? scales[prop] : undefined;
        var scale = scaleName ? theme == null ? void 0 : theme[scaleName] : get$1(theme, prop, {});
        var transform = get$1(transforms, prop, get$1);
        var value = transform(scale, val, val);

        if (prop in multiples) {
          var dirs = multiples[prop];

          for (var i = 0; i < dirs.length; i++) {
            result[dirs[i]] = value;
          }
        } else {
          result[prop] = value;
        }
      }

      return result;
    };
  };

  var getCSS = function getCSS(props) {
    return function (theme) {
      var styles = css(props.sx)(theme);
      var raw = typeof props.css === 'function' ? props.css(theme) : props.css;
      return [styles, raw];
    };
  };

  var parseProps = function parseProps(props) {
    if (!props || !props.sx && !props.css) return props;
    var next = {};

    for (var key in props) {
      if (key === 'sx') continue;
      next[key] = props[key];
    }

    next.css = getCSS(props);
    return next;
  };

  var parseProps$1 = parseProps;
  var __EMOTION_VERSION__ = packageInfo__default["default"].version;

  var jsx = function jsx(type, props) {
    for (var _len2 = arguments.length, children = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      children[_key2 - 2] = arguments[_key2];
    }

    return react.jsx.apply(react, [type, parseProps$1(props)].concat(children));
  };
  /**
   * @internal
   */


  var __themeUiDefaultContextValue = {
    __EMOTION_VERSION__: __EMOTION_VERSION__,
    theme: {}
  };
  /**
   * @internal
   */

  var __ThemeUIContext = /*#__PURE__*/React.createContext(__themeUiDefaultContextValue);

  var useThemeUI = function useThemeUI() {
    return React.useContext(__ThemeUIContext);
  };

  var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
  var REACT_ELEMENT = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
  var FORWARD_REF = canUseSymbol ? Symbol.for('react.forward_ref') : 0xeac7;
  var deepmergeOptions = {
    isMergeableObject: function isMergeableObject(n) {
      return !!n && typeof n === 'object' && n.$$typeof !== REACT_ELEMENT && n.$$typeof !== FORWARD_REF;
    },
    arrayMerge: function arrayMerge(_leftArray, rightArray) {
      return rightArray;
    }
  };
  /**
   * Deeply merge themes
   */

  var merge$1 = function merge$1(a, b) {
    return cjs(a, b, deepmergeOptions);
  };

  function mergeAll() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return cjs.all(args, deepmergeOptions);
  }

  merge$1.all = mergeAll;
  /**
   * @internal
   */

  var __ThemeUIInternalBaseThemeProvider = function __ThemeUIInternalBaseThemeProvider(_ref6) {
    var context = _ref6.context,
        children = _ref6.children;
    return jsx(react.ThemeContext.Provider, {
      value: context.theme
    }, jsx(__ThemeUIContext.Provider, {
      value: context,
      children: children
    }));
  };

  function ThemeProvider$1(_ref7) {
    var theme = _ref7.theme,
        children = _ref7.children;
    var outer = useThemeUI();

    if (process.env.NODE_ENV !== 'production') {
      if (outer.__EMOTION_VERSION__ !== __EMOTION_VERSION__) {
        console.warn('Multiple versions of Emotion detected,', 'and theming might not work as expected.', 'Please ensure there is only one copy of @emotion/react installed in your application.');
      }
    }

    var context = typeof theme === 'function' ? _objectSpread(_objectSpread({}, outer), {}, {
      theme: theme(outer.theme)
    }) : merge$1.all({}, outer, {
      theme: theme
    });
    return jsx(__ThemeUIInternalBaseThemeProvider, {
      context: context,
      children: children
    });
  }

  var css_248z$1 = ".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;white-space:normal;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}";
  var css_248z = ".tippy-box[data-placement^=top]>.tippy-svg-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-svg-arrow:after,.tippy-box[data-placement^=top]>.tippy-svg-arrow>svg{top:16px;transform:rotate(180deg)}.tippy-box[data-placement^=bottom]>.tippy-svg-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-placement^=left]>.tippy-svg-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-svg-arrow:after,.tippy-box[data-placement^=left]>.tippy-svg-arrow>svg{transform:rotate(90deg);top:calc(50% - 3px);left:11px}.tippy-box[data-placement^=right]>.tippy-svg-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-svg-arrow:after,.tippy-box[data-placement^=right]>.tippy-svg-arrow>svg{transform:rotate(-90deg);top:calc(50% - 3px);right:11px}.tippy-svg-arrow{width:16px;height:16px;fill:#333;text-align:initial}.tippy-svg-arrow,.tippy-svg-arrow>svg{position:absolute}";
  var GlobalStylesCoreCss = styled.css(_templateObject2(), css_248z$1, css_248z);
  var GlobalStylesCore = styled.createGlobalStyle(_templateObject3(), GlobalStylesCoreCss);
  var GlobalStyles = styled.createGlobalStyle(_templateObject4(), GlobalStylesCoreCss);

  var toVarName = function toVarName(key) {
    return "--theme-ui-".concat(key.replace('-__default', ''));
  };

  var toVarValue = function toVarValue(key) {
    return "var(".concat(toVarName(key), ")");
  };

  var join = function join() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return args.filter(Boolean).join('-');
  };

  var reservedKeys = new Set(['useCustomProperties', 'initialColorModeName', 'printColorModeName', 'initialColorMode', 'useLocalStorage', 'config']); // convert theme values to custom properties

  var toCustomProperties = function toCustomProperties(obj, parent) {
    var next = Array.isArray(obj) ? [] : {};

    for (var key in obj) {
      var value = obj[key];
      var name = join(parent, key);

      if (value && typeof value === 'object') {
        next[key] = toCustomProperties(value, name);
        continue;
      }

      if (reservedKeys.has(key)) {
        next[key] = value;
        continue;
      }

      next[key] = toVarValue(name);
    }

    return next;
  };
  /**
   * @internal
   * Recursively transforms an object into CSS variables excluding "modes" key.
   */


  var __objectToVars = function __objectToVars(parent, obj) {
    var vars = {};

    for (var key in obj) {
      if (key === 'modes') continue;
      var name = join(parent, key);
      var value = obj[key];

      if (value && typeof value === 'object') {
        vars = _objectSpread(_objectSpread({}, vars), __objectToVars(name, value));
      } else {
        vars[toVarName(name)] = value;
      }
    }

    return vars;
  };
  /**
   * @internal
   * Creates root styles for color modes.
   * - Transforms color scale into CSS variables.
   * - Sets background and text color.
   */


  var __createColorStyles = function __createColorStyles() {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref8 = theme.config || theme || {},
        useCustomProperties = _ref8.useCustomProperties,
        initialColorModeName = _ref8.initialColorModeName,
        printColorModeName = _ref8.printColorModeName,
        useRootStyles = _ref8.useRootStyles;

    var colors = theme.rawColors || theme.colors;
    if (!colors || useRootStyles === false) return {};

    if (useCustomProperties === false) {
      return css({
        color: 'text',
        bg: 'background'
      })(theme);
    }

    var modes = colors.modes || {};

    var styles = __createColorProperties(colors, modes);

    if (printColorModeName) {
      var mode = printColorModeName === 'initial' || printColorModeName === initialColorModeName ? colors : modes[printColorModeName];
      styles['@media print'] = __objectToVars('colors', mode);
    }

    var colorToVarValue = function colorToVarValue(color) {
      return toVarValue("colors-".concat(color));
    };

    return css(_objectSpread(_objectSpread({}, styles), {}, {
      color: colorToVarValue('text'),
      bg: colorToVarValue('background')
    }))(theme);
  };
  /**
   * @internal
   * Returns an object with colors turned into Custom CSS Properties and
   * .theme-ui-<colormode> classes used for no-flash serverside rendering.
   */


  function __createColorProperties(colors, modes) {
    var styles = __objectToVars('colors', colors);

    Object.keys(modes).forEach(function (mode) {
      var className = ".theme-ui-".concat(mode);
      var key = "&".concat(className, ", ").concat(className, " &");
      styles[key] = __objectToVars('colors', modes[mode]);
    });
    return styles;
  }

  var STORAGE_KEY = 'theme-ui-color-mode';
  var DARK_QUERY = '(prefers-color-scheme: dark)';
  var LIGHT_QUERY = '(prefers-color-scheme: light)';
  var storage = {
    get: function get() {
      try {
        return window.localStorage.getItem(STORAGE_KEY);
      } catch (err) {
        console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
      }
    },
    set: function set(value) {
      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch (err) {
        console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
      }
    }
  };

  var getPreferredColorScheme = function getPreferredColorScheme() {
    if (typeof window !== 'undefined' && window.matchMedia) {
      if (window.matchMedia(DARK_QUERY).matches) {
        return 'dark';
      }

      if (window.matchMedia(LIGHT_QUERY).matches) {
        return 'light';
      }
    }

    return null;
  };

  var useClientsideEffect = typeof window === 'undefined' ? function () {} : React.useLayoutEffect;

  var TopLevelColorModeProvider = function TopLevelColorModeProvider(_ref9) {
    var outerCtx = _ref9.outerCtx,
        children = _ref9.children;
    var outerTheme = outerCtx.theme || {};

    var _ref10 = outerTheme.config || outerTheme,
        initialColorModeName = _ref10.initialColorModeName,
        useColorSchemeMediaQuery = _ref10.useColorSchemeMediaQuery,
        useLocalStorage = _ref10.useLocalStorage;

    var _React$useState = React.useState(function () {
      var preferredMode = useColorSchemeMediaQuery !== false && getPreferredColorScheme();
      return preferredMode || initialColorModeName;
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        colorMode = _React$useState2[0],
        setColorMode = _React$useState2[1]; // on first render, we read the color mode from localStorage and
    // clear the class on document element body


    useClientsideEffect(function () {
      var stored = useLocalStorage !== false && storage.get();

      if (typeof document !== 'undefined') {
        document.documentElement.classList.remove('theme-ui-' + stored);
      }

      if (useColorSchemeMediaQuery !== 'system' && stored && stored !== colorMode) {
        colorMode = stored;
        setColorMode(stored);
      }
    }, []); // when mode changes, we save it to localStorage

    React.useEffect(function () {
      if (colorMode && useLocalStorage !== false) {
        storage.set(colorMode);
      }
    }, [colorMode, useLocalStorage]);
    var setPreferredColorScheme = React.useCallback(function () {
      var preferredColorScheme = getPreferredColorScheme();
      setColorMode(preferredColorScheme || initialColorModeName);
    }, [initialColorModeName]);
    React.useEffect(function () {
      if (useColorSchemeMediaQuery === 'system' && window.matchMedia) {
        // It doesn't matter if we add the listener only to the dark media query
        // Because in our callback function we'll check for both media queries (light and dark).
        var darkMQL = window.matchMedia(DARK_QUERY);

        if (typeof darkMQL.addEventListener === 'function') {
          darkMQL.addEventListener('change', setPreferredColorScheme);
        } else if (typeof darkMQL.addListener === 'function') {
          darkMQL.addListener(setPreferredColorScheme);
        }
      }

      return function () {
        if (useColorSchemeMediaQuery === 'system' && window.matchMedia) {
          var _darkMQL = window.matchMedia(DARK_QUERY);

          if (typeof _darkMQL.removeEventListener === 'function') {
            _darkMQL.removeEventListener('change', setPreferredColorScheme);
          } else if (typeof _darkMQL.removeListener === 'function') {
            _darkMQL.removeListener(setPreferredColorScheme);
          }
        }
      };
    }, [useColorSchemeMediaQuery, setPreferredColorScheme]);

    if (process.env.NODE_ENV !== 'production') {
      var _outerTheme$colors;

      if ((_outerTheme$colors = outerTheme.colors) != null && _outerTheme$colors.modes && initialColorModeName && Object.keys(outerTheme.colors.modes).indexOf(initialColorModeName) > -1) {
        console.warn('[theme-ui] The `initialColorModeName` value should be a unique name' + ' and cannot reference a key in `theme.colors.modes`.');
      }
    }

    var newTheme = useThemeWithAppliedColorMode({
      colorMode: colorMode,
      outerTheme: outerTheme
    });

    var newCtx = _objectSpread(_objectSpread({}, outerCtx), {}, {
      theme: newTheme,
      colorMode: colorMode,
      setColorMode: setColorMode
    });

    return /*#__PURE__*/React__default["default"].createElement(__ThemeUIInternalBaseThemeProvider, {
      context: newCtx
    }, /*#__PURE__*/React__default["default"].createElement(GlobalColorStyles, {
      theme: newTheme
    }), children);
  };

  function useColorMode() {
    var _useThemeUI = useThemeUI(),
        colorMode = _useThemeUI.colorMode,
        setColorMode = _useThemeUI.setColorMode;

    if (typeof setColorMode !== 'function') {
      throw new Error("[useColorMode] requires the ColorModeProvider component");
    } // We're allowing the user to specify a narrower type for its color mode name.


    return [colorMode, setColorMode];
  }

  var omitModes = function omitModes(colors) {
    var res = _objectSpread({}, colors);

    delete res.modes;
    return res;
  };

  function copyRawColors(colors, outerThemeRawColors) {
    for (var _i2 = 0, _Object$entries = Object.entries(colors); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (typeof value === 'string' && !value.startsWith('var(')) {
        outerThemeRawColors[key] = value;
      } else if (typeof value === 'object') {
        var newValue = _objectSpread({}, outerThemeRawColors[key]);

        copyRawColors(value, newValue);
        outerThemeRawColors[key] = newValue;
      }
    }
  }

  function useThemeWithAppliedColorMode(_ref11) {
    var outerTheme = _ref11.outerTheme,
        colorMode = _ref11.colorMode;
    var theme = React.useMemo(function () {
      var res = _objectSpread({}, outerTheme);

      var modes = get$1(res, 'colors.modes', {});
      var currentColorMode = get$1(modes, colorMode, {});

      if (colorMode) {
        res.colors = _objectSpread(_objectSpread({}, res.colors), currentColorMode);
      }

      var _ref12 = outerTheme.config || outerTheme,
          useCustomProperties = _ref12.useCustomProperties,
          _ref12$initialColorMo = _ref12.initialColorModeName,
          initialColorModeName = _ref12$initialColorMo === void 0 ? '__default' : _ref12$initialColorMo;

      var outerThemeRawColors = outerTheme.rawColors || outerTheme.colors || {};

      if (useCustomProperties !== false) {
        var alreadyHasRawColors = res.rawColors != null;
        var colors = res.colors || {};

        if (alreadyHasRawColors) {
          outerThemeRawColors = _objectSpread({}, outerThemeRawColors);
          copyRawColors(colors, outerThemeRawColors);

          if (outerThemeRawColors.modes) {
            outerThemeRawColors.modes[initialColorModeName] = omitModes(outerThemeRawColors);
          }

          res.rawColors = outerThemeRawColors;
        } else {
          if (!('modes' in outerThemeRawColors)) {
            res.rawColors = colors;
          } else {
            var _modes = _objectSpread(_defineProperty({}, initialColorModeName, omitModes(outerThemeRawColors)), outerThemeRawColors.modes);

            res.rawColors = _objectSpread(_objectSpread({}, colors), {}, {
              modes: _modes
            });
            /* modes doesn't match index signature by design */
          }
        }

        res.colors = toCustomProperties(omitModes(outerThemeRawColors), 'colors');
      }

      return res;
    }, [colorMode, outerTheme]);
    return theme;
  }

  function GlobalColorStyles(_ref13) {
    var theme = _ref13.theme;
    return jsx(react.Global, {
      styles: function styles() {
        return {
          html: __createColorStyles(theme)
        };
      }
    });
  }

  function NestedColorModeProvider(_ref14) {
    var outerCtx = _ref14.outerCtx,
        children = _ref14.children;

    var _newTheme$config2;

    var newTheme = useThemeWithAppliedColorMode({
      outerTheme: outerCtx.theme,
      colorMode: outerCtx.colorMode
    }); // Nested theme providers need to be rerendered after hydration for the correct
    // color mode to apply.

    var _React$useState3 = React.useState( // Note: we could also check some "ssr-enabled" flag as an optimization for
    // SPAs, as deeply nested theme providers will also pay a performance penalty
    // for this SSR bug fix
    function () {
      var _newTheme$config;

      return ((_newTheme$config = newTheme.config) == null ? void 0 : _newTheme$config.useLocalStorage) !== false;
    }),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        needsRerender = _React$useState4[0],
        setNeedsRerender = _React$useState4[1];

    useClientsideEffect(function () {
      return void setNeedsRerender(false);
    }, []);
    var themeColors = newTheme.rawColors || newTheme.colors;
    var useCustomProperties = (_newTheme$config2 = newTheme.config) == null ? void 0 : _newTheme$config2.useCustomProperties;
    var colorVars = React.useMemo(function () {
      if (useCustomProperties === false) {
        return {};
      }

      var colors = themeColors || {};
      return css(__createColorProperties(colors, colors.modes || {}))(newTheme);
    }, [newTheme, themeColors, useCustomProperties]);
    return /*#__PURE__*/React__default["default"].createElement(__ThemeUIInternalBaseThemeProvider, {
      context: _objectSpread(_objectSpread({}, outerCtx), {}, {
        theme: newTheme
      })
    }, jsx('div', {
      'data-themeui-nested-provider': true,
      // the key here ensures that children will be rerendered after color
      // mode is read from localStorage
      key: Number(needsRerender),
      suppressHydrationWarning: true,
      css: colorVars,
      children: children
    }));
  }

  var ColorModeProvider = function ColorModeProvider(_ref15) {
    var children = _ref15.children;
    var outerCtx = useThemeUI();
    var isTopLevelColorModeProvider = typeof outerCtx.setColorMode !== 'function';
    return isTopLevelColorModeProvider ? /*#__PURE__*/React__default["default"].createElement(TopLevelColorModeProvider, {
      outerCtx: outerCtx
    }, children) : /*#__PURE__*/React__default["default"].createElement(NestedColorModeProvider, {
      outerCtx: outerCtx
    }, children);
  };

  var __defProp$1f = Object.defineProperty;
  var __getOwnPropSymbols$1f = Object.getOwnPropertySymbols;
  var __hasOwnProp$1f = Object.prototype.hasOwnProperty;
  var __propIsEnum$1f = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1f = function __defNormalProp$1f(obj, key, value) {
    return key in obj ? __defProp$1f(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1f = function __spreadValues$1f(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1f.call(b, prop)) __defNormalProp$1f(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1f) {
      var _iterator3 = _createForOfIteratorHelper(__getOwnPropSymbols$1f(b)),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var prop = _step3.value;
          if (__propIsEnum$1f.call(b, prop)) __defNormalProp$1f(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    return a;
  };

  var __objRest$V = function __objRest$V(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$1f.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$1f) {
      var _iterator4 = _createForOfIteratorHelper(__getOwnPropSymbols$1f(source)),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var prop = _step4.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$1f.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }

    return target;
  };

  var useThemeContext = useThemeUI;

  var ThemeProvider = function ThemeProvider(_a) {
    var _b = _a,
        children = _b.children,
        themeProps = _b.theme,
        _b$cleanGlobalStyle = _b.cleanGlobalStyle,
        cleanGlobalStyle = _b$cleanGlobalStyle === void 0 ? false : _b$cleanGlobalStyle,
        props = __objRest$V(_b, ["children", "theme", "cleanGlobalStyle"]);

    var customTheme = Object.assign(defaultTheme$1, themeProps || {});
    return /* @__PURE__ */React__default["default"].createElement(ThemeProvider$1, {
      theme: function theme(_theme) {
        return merge$1(_theme, customTheme);
      }
    }, cleanGlobalStyle ? /* @__PURE__ */React__default["default"].createElement(GlobalStylesCore, null) : /* @__PURE__ */React__default["default"].createElement(GlobalStyles, null), /* @__PURE__ */React__default["default"].createElement(styled.ThemeProvider, __spreadValues$1f({
      theme: customTheme
    }, props), /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, children)));
  };

  function memoize$1(fn) {
    var cache = Object.create(null);
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  function memoize(fn) {
    var cache = {};
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

  var index$1 = memoize(function (prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
    /* o */
    && prop.charCodeAt(1) === 110
    /* n */
    && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
  );
  var all = styledSystem.compose(styledSystem.space, styledSystem.typography, styledSystem.color, styledSystem.layout, styledSystem.flexbox, styledSystem.border, styledSystem.background, styledSystem.position, styledSystem.grid, styledSystem.shadow, styledSystem.buttonStyle, styledSystem.textStyle, styledSystem.colorStyle);
  var props = all.propNames;

  var createShouldForwardProp = function createShouldForwardProp(props) {
    var regex = new RegExp("^(" + props.join('|') + ")$");
    return memoize$1(function (prop) {
      return index$1(prop) && !regex.test(prop);
    });
  };

  createShouldForwardProp(props);
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty$1.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };

  var merge = function merge(a, b) {
    var result = objectAssign({}, a, b);

    for (var key in a) {
      var _assign;

      if (!a[key] || typeof b[key] !== 'object') continue;
      objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
    }

    return result;
  }; // sort object-value responsive styles


  var sort = function sort(obj) {
    var next = {};
    Object.keys(obj).sort(function (a, b) {
      return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    }).forEach(function (key) {
      next[key] = obj[key];
    });
    return next;
  };

  var defaults$1 = {
    breakpoints: [40, 52, 64].map(function (n) {
      return n + 'em';
    })
  };

  var createMediaQuery = function createMediaQuery(n) {
    return "@media screen and (min-width: " + n + ")";
  };

  var getValue = function getValue(n, scale) {
    return get(scale, n, n);
  };

  var get = function get(obj, key, def, p, undef) {
    key = key && key.split ? key.split('.') : [key];

    for (p = 0; p < key.length; p++) {
      obj = obj ? obj[key[p]] : undef;
    }

    return obj === undef ? def : obj;
  };

  var createParser = function createParser(config) {
    var cache = {};

    var parse = function parse(props) {
      var styles = {};
      var shouldSort = false;
      var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

      for (var key in props) {
        if (!config[key]) continue;
        var sx = config[key];
        var raw = props[key];
        var scale = get(props.theme, sx.scale, sx.defaults);

        if (typeof raw === 'object') {
          cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults$1.breakpoints);

          if (Array.isArray(raw)) {
            cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
            styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
            continue;
          }

          if (raw !== null) {
            styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
            shouldSort = true;
          }

          continue;
        }

        objectAssign(styles, sx(raw, scale, props));
      } // sort object-based responsive styles


      if (shouldSort) {
        styles = sort(styles);
      }

      return styles;
    };

    parse.config = config;
    parse.propNames = Object.keys(config);
    parse.cache = cache;
    var keys = Object.keys(config).filter(function (k) {
      return k !== 'config';
    });

    if (keys.length > 1) {
      keys.forEach(function (key) {
        var _createParser;

        parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
      });
    }

    return parse;
  };

  var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
    var styles = {};
    raw.slice(0, mediaQueries.length).forEach(function (value, i) {
      var media = mediaQueries[i];
      var style = sx(value, scale, _props);

      if (!media) {
        objectAssign(styles, style);
      } else {
        var _assign2;

        objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
      }
    });
    return styles;
  };

  var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
    var styles = {};

    for (var key in raw) {
      var breakpoint = breakpoints[key];
      var value = raw[key];
      var style = sx(value, scale, _props);

      if (!breakpoint) {
        objectAssign(styles, style);
      } else {
        var _assign3;

        var media = createMediaQuery(breakpoint);
        objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
      }
    }

    return styles;
  };

  var createStyleFunction = function createStyleFunction(_ref) {
    var properties = _ref.properties,
        property = _ref.property,
        scale = _ref.scale,
        _ref$transform = _ref.transform,
        transform = _ref$transform === void 0 ? getValue : _ref$transform,
        defaultScale = _ref.defaultScale;
    properties = properties || [property];

    var sx = function sx(value, scale, _props) {
      var result = {};
      var n = transform(value, scale, _props);
      if (n === null) return;
      properties.forEach(function (prop) {
        result[prop] = n;
      });
      return result;
    };

    sx.scale = scale;
    sx.defaults = defaultScale;
    return sx;
  }; // new v5 API


  var system$1 = function system(args) {
    if (args === void 0) {
      args = {};
    }

    var config = {};
    Object.keys(args).forEach(function (key) {
      var conf = args[key];

      if (conf === true) {
        // shortcut definition
        config[key] = createStyleFunction({
          property: key,
          scale: key
        });
        return;
      }

      if (typeof conf === 'function') {
        config[key] = conf;
        return;
      }

      config[key] = createStyleFunction(conf);
    });
    var parser = createParser(config);
    return parser;
  };

  var compose$1 = function compose() {
    var config = {};

    for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
      parsers[_key] = arguments[_key];
    }

    parsers.forEach(function (parser) {
      if (!parser || !parser.config) return;
      objectAssign(config, parser.config);
    });
    var parser = createParser(config);
    return parser;
  };

  var defaults = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
  };

  var isNumber = function isNumber(n) {
    return typeof n === 'number' && !isNaN(n);
  };

  var getMargin = function getMargin(n, scale) {
    if (!isNumber(n)) {
      return get(scale, n, n);
    }

    var isNegative = n < 0;
    var absolute = Math.abs(n);
    var value = get(scale, absolute, absolute);

    if (!isNumber(value)) {
      return isNegative ? '-' + value : value;
    }

    return value * (isNegative ? -1 : 1);
  };

  var configs = {};
  configs.margin = {
    margin: {
      property: 'margin',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginTop: {
      property: 'marginTop',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginRight: {
      property: 'marginRight',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginBottom: {
      property: 'marginBottom',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginLeft: {
      property: 'marginLeft',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginX: {
      properties: ['marginLeft', 'marginRight'],
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginY: {
      properties: ['marginTop', 'marginBottom'],
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    }
  };
  configs.margin.m = configs.margin.margin;
  configs.margin.mt = configs.margin.marginTop;
  configs.margin.mr = configs.margin.marginRight;
  configs.margin.mb = configs.margin.marginBottom;
  configs.margin.ml = configs.margin.marginLeft;
  configs.margin.mx = configs.margin.marginX;
  configs.margin.my = configs.margin.marginY;
  configs.padding = {
    padding: {
      property: 'padding',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingTop: {
      property: 'paddingTop',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingRight: {
      property: 'paddingRight',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingBottom: {
      property: 'paddingBottom',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingLeft: {
      property: 'paddingLeft',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingX: {
      properties: ['paddingLeft', 'paddingRight'],
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingY: {
      properties: ['paddingTop', 'paddingBottom'],
      scale: 'space',
      defaultScale: defaults.space
    }
  };
  configs.padding.p = configs.padding.padding;
  configs.padding.pt = configs.padding.paddingTop;
  configs.padding.pr = configs.padding.paddingRight;
  configs.padding.pb = configs.padding.paddingBottom;
  configs.padding.pl = configs.padding.paddingLeft;
  configs.padding.px = configs.padding.paddingX;
  configs.padding.py = configs.padding.paddingY;
  var margin = system$1(configs.margin);
  var padding = system$1(configs.padding);
  var space = compose$1(margin, padding);
  var config = {
    color: {
      property: 'color',
      scale: 'colors'
    },
    backgroundColor: {
      property: 'backgroundColor',
      scale: 'colors'
    },
    opacity: true
  };
  config.bg = config.backgroundColor;
  var color = system$1(config);
  var boxSystemProps = [].concat(_toConsumableArray(space.propNames), _toConsumableArray(color.propNames));
  var shouldForwardProp = createShouldForwardProp(boxSystemProps);

  var sx = function sx(props) {
    return css(props.sx)(props.theme);
  };

  var base = function base(props) {
    return css(props.__css)(props.theme);
  };

  var variant = function variant(_ref16) {
    var theme = _ref16.theme,
        variant = _ref16.variant,
        _ref16$__themeKey = _ref16.__themeKey,
        __themeKey = _ref16$__themeKey === void 0 ? 'variants' : _ref16$__themeKey;

    return css(get$1(theme, __themeKey + '.' + variant, get$1(theme, variant)));
  };

  var Box$1 = styled__default["default"]('div', {
    shouldForwardProp: shouldForwardProp
  })({
    boxSizing: 'border-box',
    margin: 0,
    minWidth: 0
  }, base, variant, space, color, sx, function (props) {
    return props.css;
  });
  Box$1.displayName = 'Box';
  var Flex$1 = styled__default["default"](Box$1)({
    display: 'flex'
  });
  Flex$1.displayName = 'Flex';

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var Image = /*#__PURE__*/React__default["default"].forwardRef(function Image(props, ref) {
    return /*#__PURE__*/React__default["default"].createElement(Box$1, _extends({
      ref: ref,
      as: "img"
    }, props, {
      __themeKey: "images",
      __css: _objectSpread({
        maxWidth: '100%',
        height: 'auto'
      }, props.__css)
    }));
  });
  react.keyframes({
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  });
  var __defProp$1e = Object.defineProperty;
  var __getOwnPropSymbols$1e = Object.getOwnPropertySymbols;
  var __hasOwnProp$1e = Object.prototype.hasOwnProperty;
  var __propIsEnum$1e = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1e = function __defNormalProp$1e(obj, key, value) {
    return key in obj ? __defProp$1e(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1e = function __spreadValues$1e(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1e.call(b, prop)) __defNormalProp$1e(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1e) {
      var _iterator5 = _createForOfIteratorHelper(__getOwnPropSymbols$1e(b)),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var prop = _step5.value;
          if (__propIsEnum$1e.call(b, prop)) __defNormalProp$1e(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }

    return a;
  };

  var getSizeStyle = function getSizeStyle(variant) {
    switch (variant) {
      case "md":
        return {
          height: 48,
          width: 48
        };

      case "sm":
        return {
          height: 32,
          width: 32
        };

      default:
        return {
          height: 56,
          width: 56
        };
    }
  };

  var getContainerStyle$4 = function getContainerStyle$4(variant, brand) {
    return __spreadValues$1e({
      borderRadius: "circle",
      borderStyle: "solid",
      borderWidth: "hairline",
      boxSizing: "border-box",
      color: brand ? "typeface.on.brand.pure" : "neutral.30",
      display: "inline-flex",
      justifyContent: "center",
      overflow: "hidden",
      placeItems: "center",
      position: "relative"
    }, getSizeStyle(variant));
  };

  var imageStyle = {
    height: "100%",
    objectFit: "cover",
    position: "relative",
    width: "100%",
    zIndex: "1"
  };
  var initialsStyle = {
    m: "auto",
    position: "absolute"
  };
  var portugueseNameArticles = ["da", "de", "do"];

  var getInitials = function getInitials() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var filteredNames = text.split(/\W+/gi).filter(function (name) {
      return !portugueseNameArticles.includes(name.toLowerCase());
    });
    var leadingName = head(filteredNames);
    var trallingName = head(filteredNames.slice(1, 2));

    if (!filteredNames.length) {
      return "";
    }

    if (filteredNames.length === 1) {
      return "".concat(leadingName && leadingName.slice(0, 2).toUpperCase(), " ");
    }

    return "".concat(leadingName && leadingName.slice(0, 1)).concat(trallingName && trallingName.slice(0, 1)).toUpperCase();
  };

  var getKey = styledSystem__namespace.get,
      compose = styledSystem__namespace.compose,
      system = styledSystem__namespace.system;
  var COMMON = compose(styledSystem__namespace.space, styledSystem__namespace.color, styledSystem__namespace.display);
  var whiteSpace = system({
    whiteSpace: {
      property: "whiteSpace"
    }
  });
  var TYPOGRAPHY = compose(styledSystem__namespace.typography, whiteSpace);
  var BORDER = compose(styledSystem__namespace.border, styledSystem__namespace.shadow);
  var LAYOUT = styledSystem__namespace.layout;
  var FLEX = styledSystem__namespace.flexbox;
  var GRID = styledSystem__namespace.grid;
  var weekParser = {
    Friday: "Sexta",
    Monday: "Segunda",
    Saturday: "S\xE1bado",
    Sunday: "Domingo",
    Thursday: "Quinta",
    Tuesday: "Ter\xE7a",
    Wednesday: "Quarta"
  };
  var months = ["Janeiro", "Fevereiro", "Mar\xE7o", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  var monthParse = {
    Abril: 3,
    Agosto: 7,
    Dezembro: 11,
    Fevereiro: 1,
    Janeiro: 0,
    Julho: 6,
    Junho: 5,
    Maio: 4,
    Março: 2,
    Novembro: 10,
    Outubro: 9,
    Setembro: 8
  };

  var getBoxStyle = function getBoxStyle(_ref17) {
    var fullWidth = _ref17.fullWidth,
        width = _ref17.width;
    return {
      width: fullWidth ? "100%" : width
    };
  };

  var __defProp$1d = Object.defineProperty;
  var __defProps$O = Object.defineProperties;
  var __getOwnPropDescs$O = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$1d = Object.getOwnPropertySymbols;
  var __hasOwnProp$1d = Object.prototype.hasOwnProperty;
  var __propIsEnum$1d = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1d = function __defNormalProp$1d(obj, key, value) {
    return key in obj ? __defProp$1d(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1d = function __spreadValues$1d(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1d.call(b, prop)) __defNormalProp$1d(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1d) {
      var _iterator6 = _createForOfIteratorHelper(__getOwnPropSymbols$1d(b)),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var prop = _step6.value;
          if (__propIsEnum$1d.call(b, prop)) __defNormalProp$1d(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }

    return a;
  };

  var __spreadProps$O = function __spreadProps$O(a, b) {
    return __defProps$O(a, __getOwnPropDescs$O(b));
  };

  var Wrapper$1 = styled__default$1["default"](themeUi.Box)(LAYOUT, FLEX, TYPOGRAPHY, COMMON, BORDER, sx$1);
  var Box = React__default["default"].forwardRef(function (props, ref) {
    return /* @__PURE__ */React__default["default"].createElement(Wrapper$1, __spreadProps$O(__spreadValues$1d({
      sx: __spreadValues$1d(__spreadValues$1d({}, getBoxStyle(props)), props.sx)
    }, props), {
      ref: ref
    }));
  });
  var __defProp$1c = Object.defineProperty;
  var __getOwnPropSymbols$1c = Object.getOwnPropertySymbols;
  var __hasOwnProp$1c = Object.prototype.hasOwnProperty;
  var __propIsEnum$1c = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1c = function __defNormalProp$1c(obj, key, value) {
    return key in obj ? __defProp$1c(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1c = function __spreadValues$1c(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1c.call(b, prop)) __defNormalProp$1c(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1c) {
      var _iterator7 = _createForOfIteratorHelper(__getOwnPropSymbols$1c(b)),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var prop = _step7.value;
          if (__propIsEnum$1c.call(b, prop)) __defNormalProp$1c(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }

    return a;
  };

  var Wrapper = styled__default$1["default"](Box)(COMMON, TYPOGRAPHY, sx$1, LAYOUT);

  var noWrapStyle = function noWrapStyle(_ref18) {
    var noWrap = _ref18.noWrap,
        noOfLines = _ref18.noOfLines;
    var defaultStyle = {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
    var linesStyle = {
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: noOfLines || 1,
      display: "-webkit-box !important",
      whiteSpace: "normal"
    };

    if (noOfLines || noWrap) {
      return __spreadValues$1c(__spreadValues$1c({}, defaultStyle), linesStyle);
    }

    return {};
  };

  var __defProp$1b = Object.defineProperty;
  var __defProps$N = Object.defineProperties;
  var __getOwnPropDescs$N = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$1b = Object.getOwnPropertySymbols;
  var __hasOwnProp$1b = Object.prototype.hasOwnProperty;
  var __propIsEnum$1b = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1b = function __defNormalProp$1b(obj, key, value) {
    return key in obj ? __defProp$1b(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1b = function __spreadValues$1b(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1b.call(b, prop)) __defNormalProp$1b(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1b) {
      var _iterator8 = _createForOfIteratorHelper(__getOwnPropSymbols$1b(b)),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var prop = _step8.value;
          if (__propIsEnum$1b.call(b, prop)) __defNormalProp$1b(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }

    return a;
  };

  var __spreadProps$N = function __spreadProps$N(a, b) {
    return __defProps$N(a, __getOwnPropDescs$N(b));
  };

  var __objRest$U = function __objRest$U(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$1b.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$1b) {
      var _iterator9 = _createForOfIteratorHelper(__getOwnPropSymbols$1b(source)),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var prop = _step9.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$1b.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }

    return target;
  };

  var Typography = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        sx = _b.sx,
        props = __objRest$U(_b, ["sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Wrapper, __spreadProps$N(__spreadValues$1b({
      as: "p",
      m: 0,
      p: 0,
      sx: __spreadValues$1b(__spreadValues$1b({}, noWrapStyle(props)), sx)
    }, props), {
      ref: ref
    }));
  });

  var isSmallProp$2 = function isSmallProp$2(variant) {
    return variant === "sm";
  };

  var getColorTypfaceTokenByProp = function getColorTypfaceTokenByProp(_ref19, suffix) {
    var brand = _ref19.brand,
        inverse = _ref19.inverse;
    return "typeface.".concat(inverse ? "inverse." : "").concat(brand ? "on.brand." : "").concat(suffix);
  };

  var __defProp$1a = Object.defineProperty;
  var __getOwnPropSymbols$1a = Object.getOwnPropertySymbols;
  var __hasOwnProp$1a = Object.prototype.hasOwnProperty;
  var __propIsEnum$1a = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1a = function __defNormalProp$1a(obj, key, value) {
    return key in obj ? __defProp$1a(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1a = function __spreadValues$1a(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1a.call(b, prop)) __defNormalProp$1a(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1a) {
      var _iterator10 = _createForOfIteratorHelper(__getOwnPropSymbols$1a(b)),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var prop = _step10.value;
          if (__propIsEnum$1a.call(b, prop)) __defNormalProp$1a(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }

    return a;
  };

  var __objRest$T = function __objRest$T(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$1a.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$1a) {
      var _iterator11 = _createForOfIteratorHelper(__getOwnPropSymbols$1a(source)),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var prop = _step11.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$1a.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }

    return target;
  };

  var Body = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        variant = _b.variant,
        props = __objRest$T(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$1a({
      color: getColorTypfaceTokenByProp(props, "pure"),
      fontFamily: "base",
      fontSize: isSmallProp$2(variant) ? "xxs" : "xs",
      letterSpacing: "standard",
      lineHeight: isSmallProp$2(variant) ? "huge" : "superdistant",
      ref: ref
    }, props));
  });
  Body.defaultProps = {
    brand: false,
    variant: "lg"
  };
  var __defProp$19 = Object.defineProperty;
  var __defProps$M = Object.defineProperties;
  var __getOwnPropDescs$M = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$19 = Object.getOwnPropertySymbols;
  var __hasOwnProp$19 = Object.prototype.hasOwnProperty;
  var __propIsEnum$19 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$19 = function __defNormalProp$19(obj, key, value) {
    return key in obj ? __defProp$19(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$19 = function __spreadValues$19(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$19.call(b, prop)) __defNormalProp$19(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$19) {
      var _iterator12 = _createForOfIteratorHelper(__getOwnPropSymbols$19(b)),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var prop = _step12.value;
          if (__propIsEnum$19.call(b, prop)) __defNormalProp$19(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }

    return a;
  };

  var __spreadProps$M = function __spreadProps$M(a, b) {
    return __defProps$M(a, __getOwnPropDescs$M(b));
  };

  var __objRest$S = function __objRest$S(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$19.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$19) {
      var _iterator13 = _createForOfIteratorHelper(__getOwnPropSymbols$19(source)),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var prop = _step13.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$19.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }

    return target;
  };

  var AvatarBase = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        name = _b.name,
        imageSrc = _b.imageSrc,
        variant = _b.variant,
        brand = _b.brand,
        sx = _b.sx,
        props = __objRest$S(_b, ["name", "imageSrc", "variant", "brand", "sx"]);

    var initials = getInitials(name);
    var hasSrcImg = !!imageSrc || false;
    var typoSize = variant === "sm" ? "sm" : "lg";

    var _React$useState5 = React.useState(hasSrcImg),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        showImage = _React$useState6[0],
        handleShowImage = _React$useState6[1];

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$M(__spreadValues$19({
      sx: __spreadValues$19(__spreadValues$19({}, getContainerStyle$4(variant, brand)), sx)
    }, props), {
      ref: ref
    }), showImage ? /* @__PURE__ */React__default["default"].createElement(Image, {
      alt: name,
      as: "img",
      "data-testid": "avatar-image",
      onError: function onError() {
        return handleShowImage(false);
      },
      src: imageSrc,
      sx: imageStyle
    }) : /* @__PURE__ */React__default["default"].createElement(Box, {
      as: "span",
      sx: initialsStyle
    }, /* @__PURE__ */React__default["default"].createElement(Body, {
      color: brand ? "neutral.on.brand.30" : "typeface.pure",
      variant: typoSize
    }, initials)));
  });
  var PersonAvatar = React__default["default"].forwardRef(function (_c, ref) {
    var props = __objRest$S(_c, []);

    return /* @__PURE__ */React__default["default"].createElement(AvatarBase, __spreadProps$M(__spreadValues$19({
      sx: {
        borderRadius: "circle"
      }
    }, props), {
      ref: ref
    }));
  });
  var BrandAvatar = React__default["default"].forwardRef(function (_d, ref) {
    var props = __objRest$S(_d, []);

    return /* @__PURE__ */React__default["default"].createElement(AvatarBase, __spreadProps$M(__spreadValues$19({
      sx: {
        borderRadius: "xs"
      }
    }, props), {
      ref: ref
    }));
  });
  styled__default$1["default"](PersonAvatar);
  styled__default$1["default"](BrandAvatar);

  var getIconSize$1 = function getIconSize$1(size) {
    switch (size) {
      case "md":
        return "1.5rem";

      case "lg":
        return "2rem";

      default:
        return "1rem";
    }
  };

  var getIconStyle$1 = function getIconStyle$1(_ref20) {
    var size = _ref20.size,
        variant = _ref20.variant,
        color = _ref20.color;
    return {
      "& > svg": {
        cursor: "inherit",
        fill: "currentcolor",
        fontSize: mapResponsive(size, function (propSize) {
          return getIconSize$1(propSize);
        })
      },
      border: "none",
      borderRadius: "pill",
      color: variant || color || "inherit",
      cursor: "inherit",
      height: mapResponsive(size, function (propSize) {
        return getIconSize$1(propSize);
      }),
      minWidth: "auto",
      width: mapResponsive(size, function (propSize) {
        return getIconSize$1(propSize);
      })
    };
  };

  var __defProp$18 = Object.defineProperty;
  var __getOwnPropSymbols$18 = Object.getOwnPropertySymbols;
  var __hasOwnProp$18 = Object.prototype.hasOwnProperty;
  var __propIsEnum$18 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$18 = function __defNormalProp$18(obj, key, value) {
    return key in obj ? __defProp$18(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$18 = function __spreadValues$18(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$18.call(b, prop)) __defNormalProp$18(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$18) {
      var _iterator14 = _createForOfIteratorHelper(__getOwnPropSymbols$18(b)),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var prop = _step14.value;
          if (__propIsEnum$18.call(b, prop)) __defNormalProp$18(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }

    return a;
  };

  var __objRest$R = function __objRest$R(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$18.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$18) {
      var _iterator15 = _createForOfIteratorHelper(__getOwnPropSymbols$18(source)),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var prop = _step15.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$18.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }

    return target;
  };

  var Icon = React.forwardRef(function (_a, ref) {
    var _b = _a,
        _b$sx = _b.sx,
        sx = _b$sx === void 0 ? {} : _b$sx,
        _b$size = _b.size,
        size = _b$size === void 0 ? "md" : _b$size,
        props = __objRest$R(_b, ["sx", "size"]);

    return /* @__PURE__ */React__default["default"].createElement(themeUi.IconButton, __spreadValues$18({
      as: "span",
      ref: ref,
      sx: __spreadValues$18(__spreadValues$18({}, getIconStyle$1(__spreadValues$18({
        size: size
      }, props))), sx)
    }, props));
  });

  var getSpinnerStyle = function getSpinnerStyle(size, strokeWidth) {
    var loadingSize;

    if (size === "lg") {
      loadingSize = 32;
    } else if (size === "md") {
      loadingSize = 24;
    } else {
      loadingSize = 16;
    }

    return {
      "& div": {
        animation: "spin 1s linear infinite",
        borderBottomColor: "inherit",
        borderLeftColor: "transparent",
        borderRadius: "circle",
        borderRightColor: "inherit",
        borderStyle: "solid",
        borderTopColor: "inherit",
        borderWidth: strokeWidth,
        display: "block",
        height: "100%",
        position: "relative",
        width: "100%"
      },
      "@keyframes spin": {
        "0%": {
          transform: "rotate(0deg)"
        },
        "100%": {
          transform: "rotate(360deg)"
        }
      },
      alignItems: "center",
      display: "flex",
      height: loadingSize,
      justifyContent: "center",
      position: "relative",
      width: loadingSize
    };
  };

  var __defProp$17 = Object.defineProperty;
  var __getOwnPropSymbols$17 = Object.getOwnPropertySymbols;
  var __hasOwnProp$17 = Object.prototype.hasOwnProperty;
  var __propIsEnum$17 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$17 = function __defNormalProp$17(obj, key, value) {
    return key in obj ? __defProp$17(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$17 = function __spreadValues$17(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$17.call(b, prop)) __defNormalProp$17(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$17) {
      var _iterator16 = _createForOfIteratorHelper(__getOwnPropSymbols$17(b)),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var prop = _step16.value;
          if (__propIsEnum$17.call(b, prop)) __defNormalProp$17(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
    }

    return a;
  };

  var __objRest$Q = function __objRest$Q(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$17.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$17) {
      var _iterator17 = _createForOfIteratorHelper(__getOwnPropSymbols$17(source)),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var prop = _step17.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$17.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }

    return target;
  };

  var Spinner = React.forwardRef(function (_a, ref) {
    var _b = _a,
        progress = _b.progress,
        _b$size2 = _b.size,
        size = _b$size2 === void 0 ? "lg" : _b$size2,
        _b$strokeWidth = _b.strokeWidth,
        strokeWidth = _b$strokeWidth === void 0 ? 2 : _b$strokeWidth,
        _b$text = _b.text,
        text = _b$text === void 0 ? "" : _b$text,
        sx = _b.sx,
        props = __objRest$Q(_b, ["progress", "size", "strokeWidth", "text", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$17({
      "aria-describedby": "id",
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuetext": progress ? progress.toString() : text,
      ref: ref,
      role: "progressbar",
      sx: __spreadValues$17(__spreadValues$17({}, getSpinnerStyle(size, strokeWidth)), sx),
      tabIndex: 0
    }, props), /* @__PURE__ */React__default["default"].createElement(Box, null));
  });
  var __defProp$16 = Object.defineProperty;
  var __getOwnPropSymbols$16 = Object.getOwnPropertySymbols;
  var __hasOwnProp$16 = Object.prototype.hasOwnProperty;
  var __propIsEnum$16 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$16 = function __defNormalProp$16(obj, key, value) {
    return key in obj ? __defProp$16(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$16 = function __spreadValues$16(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$16.call(b, prop)) __defNormalProp$16(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$16) {
      var _iterator18 = _createForOfIteratorHelper(__getOwnPropSymbols$16(b)),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var prop = _step18.value;
          if (__propIsEnum$16.call(b, prop)) __defNormalProp$16(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
    }

    return a;
  };

  var __objRest$P = function __objRest$P(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$16.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$16) {
      var _iterator19 = _createForOfIteratorHelper(__getOwnPropSymbols$16(source)),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var prop = _step19.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$16.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }

    return target;
  };

  var Action = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant = _b.variant,
        variant = _b$variant === void 0 ? "lg" : _b$variant,
        props = __objRest$P(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$16({
      color: getColorTypfaceTokenByProp(props, "strong"),
      fontFamily: "base",
      fontSize: isSmallProp$2(variant) ? "xxs" : "xs",
      fontWeight: "bold",
      letterSpacing: "standard",
      lineHeight: isSmallProp$2(variant) ? "tiny" : "superdistant",
      ref: ref
    }, props));
  });
  var __defProp$15 = Object.defineProperty;
  var __defProps$L = Object.defineProperties;
  var __getOwnPropDescs$L = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$15 = Object.getOwnPropertySymbols;
  var __hasOwnProp$15 = Object.prototype.hasOwnProperty;
  var __propIsEnum$15 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$15 = function __defNormalProp$15(obj, key, value) {
    return key in obj ? __defProp$15(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$15 = function __spreadValues$15(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$15.call(b, prop)) __defNormalProp$15(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$15) {
      var _iterator20 = _createForOfIteratorHelper(__getOwnPropSymbols$15(b)),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var prop = _step20.value;
          if (__propIsEnum$15.call(b, prop)) __defNormalProp$15(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
    }

    return a;
  };

  var __spreadProps$L = function __spreadProps$L(a, b) {
    return __defProps$L(a, __getOwnPropDescs$L(b));
  };

  var __objRest$O = function __objRest$O(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$15.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$15) {
      var _iterator21 = _createForOfIteratorHelper(__getOwnPropSymbols$15(source)),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var prop = _step21.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$15.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }

    return target;
  };

  var getCursorStyle = function getCursorStyle(_ref21) {
    var isLoading = _ref21.isLoading,
        disabled = _ref21.disabled;

    if (isLoading) {
      return "progress";
    } else if (disabled) {
      return "not-allowed";
    }

    return "pointer";
  };

  var getButtonBaseStyle = function getButtonBaseStyle(_ref22) {
    var _ref22$borderRadius = _ref22.borderRadius,
        borderRadius = _ref22$borderRadius === void 0 ? "xs" : _ref22$borderRadius,
        fullWidth = _ref22.fullWidth,
        width = _ref22.width,
        isLoading = _ref22.isLoading,
        disabled = _ref22.disabled;
    return {
      alignItems: "center",
      bg: "transparent",
      border: "2px solid",
      borderColor: "transparent",
      borderRadius: borderRadius,
      boxSizing: "border-box",
      cursor: getCursorStyle({
        disabled: disabled,
        isLoading: isLoading
      }),
      display: "flex",
      justifyContent: "center",
      minWidth: 99,
      transition: "all 0.1s",
      width: fullWidth && "100%" || width || "auto"
    };
  };

  var activeInteractionBaseStyle = {
    borderWidth: "hairline",
    boxShadow: "none"
  };
  var disabledBaseStyle = {
    bg: "transparent",
    borderStyle: "none",
    boxShadow: "none",
    cursor: "auto"
  };
  var buttonShapeStyleSize = {
    lg: {
      height: "48px",
      px: "inline.xxxs"
    },
    sm: {
      height: "32px",
      px: "inline.nano"
    }
  };

  var getButtonsVariantsStyle = function getButtonsVariantsStyle(_ref23) {
    var brand = _ref23.brand,
        variant = _ref23.variant;

    if (brand) {
      return {};
    }

    if (variant === "primary") {
      return {
        "&:active:enabled": __spreadValues$15({
          bg: "interaction.accent.03"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$L(__spreadValues$15({}, disabledBaseStyle), {
          bg: "interaction.blend.02",
          color: "typeface.meld"
        }),
        "&:focus:enabled:not(:active)": {
          bg: "interaction.accent.02",
          borderColor: "interaction.accent.02",
          borderStyle: "solid",
          borderWidth: "thin",
          boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$1.colors.neutral["00"]),
          outline: "none"
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.accent.02"
        },
        bg: "interaction.accent.01",
        borderWidth: "hairline",
        color: "typeface.inverse.strong"
      };
    } else if (variant === "secondary") {
      return {
        "&:active:enabled": __spreadValues$15({
          bg: "interaction.subtle.02",
          borderColor: "interaction.accent.03",
          color: "interaction.accent.03"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$L(__spreadValues$15({}, disabledBaseStyle), {
          borderColor: "interaction.blend.04",
          borderStyle: "solid",
          color: "typeface.meld"
        }),
        "&:focus:enabled:not(:active)": {
          bg: "interaction.subtle.01",
          borderColor: "interaction.accent.02",
          borderWidth: "thin",
          boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$1.colors.neutral["00"]),
          color: "interaction.accent.02"
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.subtle.01",
          borderColor: "interaction.accent.02",
          color: "interaction.accent.02"
        },
        borderColor: "interaction.accent.01",
        borderStyle: "solid",
        borderWidth: "hairline",
        color: "interaction.accent.01"
      };
    } else if (variant === "tertiary") {
      return {
        "&:active:enabled": __spreadValues$15({
          bg: "interaction.subtle.02",
          color: "interaction.accent.03"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$L(__spreadValues$15({}, disabledBaseStyle), {
          color: "typeface.meld"
        }),
        "&:focus:enabled:not(:active)": {
          bg: "interaction.subtle.01",
          borderColor: "interaction.accent.02",
          borderWidth: "thin",
          boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$1.colors.neutral["00"])
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.subtle.01",
          color: "interaction.accent.02"
        },
        borderWidth: "hairline",
        color: "interaction.accent.01"
      };
    }

    return {};
  };

  var getBrandButtonTheme = function getBrandButtonTheme(_ref24) {
    var brand = _ref24.brand,
        variant = _ref24.variant;

    if (!brand) {
      return {};
    }

    if (variant === "primary") {
      return {
        "&:active": __spreadValues$15({
          bg: "interaction.on.brand.accent.03",
          borderColor: "transparent",
          color: "interaction.accent.03"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$L(__spreadValues$15({}, disabledBaseStyle), {
          bg: "interaction.on.brand.blend.02",
          color: "typeface.on.brand.meld"
        }),
        "&:focus:not(:active)": {
          bg: "interaction.on.brand.accent.02",
          borderColor: "interaction.on.brand.accent.02",
          borderWidth: "thin",
          boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$1.colors.interaction.accent["02"]),
          color: "interaction.accent.02",
          outline: "none"
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.on.brand.accent.02",
          color: "interaction.accent.02"
        },
        bg: "interaction.on.brand.accent.01",
        borderWidth: "hairline",
        color: "interaction.accent.01"
      };
    } else if (variant === "tertiary" || variant === "secondary") {
      return {
        "&:active": __spreadValues$15({
          bg: "interaction.on.brand.subtle.02"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$L(__spreadValues$15({}, disabledBaseStyle), {
          borderColor: "interaction.on.brand.blend.04",
          borderStyle: "solid",
          color: "typeface.on.brand.meld"
        }),
        "&:focus:not(:active)": {
          bg: "interaction.on.brand.subtle.01",
          borderWidth: "thin",
          boxShadow: "inset 0 0 0 2px ".concat(defaultTheme$1.colors.interaction.inverse.on.brand.blend["04"]),
          outline: "none"
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.on.brand.subtle.01"
        },
        borderColor: "interaction.on.brand.accent.01",
        borderWidth: "hairline",
        color: "interaction.on.brand.accent.01"
      };
    }

    return {};
  };

  var getButtonStyle = function getButtonStyle(_a) {
    var _b = _a,
        _b$size3 = _b.size,
        size = _b$size3 === void 0 ? "lg" : _b$size3,
        width = _b.width,
        props = __objRest$O(_b, ["size", "width"]);

    return __spreadProps$L(__spreadValues$15(__spreadValues$15(__spreadValues$15(__spreadValues$15({}, buttonShapeStyleSize[size]), getButtonBaseStyle(__spreadValues$15({
      width: width
    }, props))), getButtonsVariantsStyle(props)), getBrandButtonTheme(props)), {
      "& > *": {
        pointerEvents: "none"
      }
    });
  };

  var getIsSmallSize = function getIsSmallSize(_ref25) {
    var size = _ref25.size;
    return size === "sm";
  };

  var getIconSize = function getIconSize(_ref26) {
    var size = _ref26.size;
    return getIsSmallSize({
      size: size
    }) ? 16 : 20;
  };

  var getIconSpacing = function getIconSpacing(_ref27) {
    var size = _ref27.size;
    return size && getIsSmallSize({
      size: size
    }) ? "inline.quark" : "inline.nano";
  };

  var getSpinnerStrokeSize = function getSpinnerStrokeSize(_ref28) {
    var size = _ref28.size;
    return size && getIsSmallSize({
      size: size
    }) ? 2 : 3;
  };

  var __defProp$14 = Object.defineProperty;
  var __defProps$K = Object.defineProperties;
  var __getOwnPropDescs$K = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$14 = Object.getOwnPropertySymbols;
  var __hasOwnProp$14 = Object.prototype.hasOwnProperty;
  var __propIsEnum$14 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$14 = function __defNormalProp$14(obj, key, value) {
    return key in obj ? __defProp$14(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$14 = function __spreadValues$14(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$14.call(b, prop)) __defNormalProp$14(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$14) {
      var _iterator22 = _createForOfIteratorHelper(__getOwnPropSymbols$14(b)),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var prop = _step22.value;
          if (__propIsEnum$14.call(b, prop)) __defNormalProp$14(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
    }

    return a;
  };

  var __spreadProps$K = function __spreadProps$K(a, b) {
    return __defProps$K(a, __getOwnPropDescs$K(b));
  };

  var __objRest$N = function __objRest$N(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$14.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$14) {
      var _iterator23 = _createForOfIteratorHelper(__getOwnPropSymbols$14(source)),
          _step23;

      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var prop = _step23.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$14.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }

    return target;
  };

  var Button = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant2 = _b.variant,
        variant = _b$variant2 === void 0 ? "primary" : _b$variant2,
        _b$brand = _b.brand,
        brand = _b$brand === void 0 ? false : _b$brand,
        _onMouseUp = _b.onMouseUp,
        _b$disabled = _b.disabled,
        disabled = _b$disabled === void 0 ? false : _b$disabled,
        _b$size4 = _b.size,
        size = _b$size4 === void 0 ? "lg" : _b$size4,
        sx = _b.sx,
        iconOnly = _b.iconOnly,
        children = _b.children,
        isLoading = _b.isLoading,
        props = __objRest$N(_b, ["variant", "brand", "onMouseUp", "disabled", "size", "sx", "iconOnly", "children", "isLoading"]);

    var buttonSimilarProps = __spreadProps$K(__spreadValues$14({}, props), {
      brand: brand,
      disabled: disabled,
      isLoading: isLoading,
      size: size,
      variant: variant
    });

    var leadingIcon = props.leadingIcon,
        leadingIconSize = props.leadingIconSize,
        trailingIcon = props.trailingIcon,
        trailingIconSize = props.trailingIconSize;

    var renderLeadingIcon = function renderLeadingIcon() {
      return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, leadingIcon && /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement(Icon, {
        size: leadingIconSize
      }, leadingIcon), /* @__PURE__ */React__default["default"].createElement(Box, {
        mr: iconOnly ? 0 : getIconSpacing({
          size: size
        })
      })));
    };

    var renderLoading = function renderLoading() {
      return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, isLoading && /* @__PURE__ */React__default["default"].createElement(Spinner, {
        ml: iconOnly ? 0 : getIconSpacing({
          size: size
        }),
        size: getIconSize({
          size: size
        }),
        strokeWidth: getSpinnerStrokeSize({
          size: size
        })
      }));
    };

    var renderButtonContent = function renderButtonContent() {
      if (iconOnly) {
        return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, !isLoading && renderLeadingIcon(), renderLoading(), children && children);
      }

      return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, renderLeadingIcon(), !iconOnly && /* @__PURE__ */React__default["default"].createElement(Action, {
        color: "inherit",
        sx: {
          pointerEvents: "none"
        },
        variant: size
      }, children), !isLoading && trailingIcon && /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement(Box, {
        ml: getIconSpacing({
          size: size
        })
      }), /* @__PURE__ */React__default["default"].createElement(Icon, {
        size: trailingIconSize
      }, trailingIcon)), renderLoading());
    };

    return /* @__PURE__ */React__default["default"].createElement(themeUi.Button, __spreadProps$K(__spreadValues$14({
      "aria-disabled": disabled,
      "data-loading": isLoading,
      sx: __spreadValues$14(__spreadValues$14({}, getButtonStyle(buttonSimilarProps)), sx),
      tabIndex: 0
    }, buttonSimilarProps), {
      disabled: disabled,
      onMouseUp: function onMouseUp(evt) {
        var target = evt.target;
        target.blur();

        if (_onMouseUp) {
          _onMouseUp(evt);
        }
      },
      ref: ref
    }), renderButtonContent());
  });

  var getIconOnlyStyle = function getIconOnlyStyle(floating, size, brand, disabled, color, isLoading) {
    var iconSize;

    switch (size) {
      case "lg":
        iconSize = 48;
        break;

      case "sm":
        iconSize = floating ? 48 : 32;
        break;

      default:
        iconSize = 48;
        break;
    }

    var iconColor = function iconColor() {
      if (color) {
        return color;
      } else if (floating) {
        if (disabled || isLoading) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }

        return brand ? "interaction.accent.01" : "interaction.on.brand.08";
      }

      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };

    var fillColor = function fillColor() {
      if (color) {
        return color;
      } else if (floating) {
        if (disabled || isLoading) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }

        return brand ? "interaction.accent.01" : "interaction.on.brand.08";
      }

      return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
    };

    var backgroundColor = function backgroundColor() {
      if (floating) {
        if (disabled || isLoading) {
          return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
        }

        return brand ? "interaction.on.brand.blend.08" : "interaction.accent.01";
      }

      return "transparent";
    };

    var hoverBackgroundColor = function hoverBackgroundColor() {
      if (floating) {
        return brand ? "interaction.inverse.accent.03" : "interaction.accent.02";
      }

      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };

    var focusBackgroundColor = function focusBackgroundColor() {
      if (floating) {
        return brand ? "interaction.inverse.accent.03" : "interaction.accent.02";
      }

      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };

    var focusBorderColor = function focusBorderColor() {
      if (floating) {
        return brand ? "interaction.inverse.accent.03" : "interaction.accent.02";
      }

      return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
    };

    var focusBoxshadowColor = function focusBoxshadowColor() {
      if (floating) {
        return brand ? defaultTheme$1.colors.interaction.accent["02"] : defaultTheme$1.colors.neutral["00"];
      }

      return brand ? defaultTheme$1.colors.interaction.inverse.on.brand.blend["04"] : defaultTheme$1.colors.neutral["00"];
    };

    var activeBackgroundColor = function activeBackgroundColor() {
      if (floating) {
        return brand ? "interaction.inverse.accent.01" : "interaction.accent.03";
      }

      return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
    };

    return {
      "& span > svg > path": {
        fill: iconColor()
      },
      "&:active:enabled": {
        "& span > svg > path": {
          fill: fillColor()
        },
        backgroundColor: activeBackgroundColor()
      },
      "&:disabled": {
        "& span > svg": {
          cursor: "not-allowed",
          fill: color ? color : brand ? "interaction.on.brand.blend.05" : "interaction.blend.05"
        },
        "& span > svg > path": {
          cursor: "not-allowed",
          fill: color ? color : brand ? "interaction.on.brand.blend.05" : "interaction.blend.05"
        },
        cursor: "not-allowed"
      },
      "&:disabled:enabled": {
        "& span > svg > path": {
          fill: color ? color : brand ? "interaction.on.brand.blend.05" : "interaction.blend.05"
        },
        cursor: "not-allowed"
      },
      "&:focus:enabled:not(:active)": {
        "& span > svg > path": {
          fill: fillColor()
        },
        backgroundColor: focusBackgroundColor(),
        borderColor: focusBorderColor(),
        borderStyle: "solid",
        borderWidth: "thin",
        boxShadow: "inset 0 0 0 2px ".concat(focusBoxshadowColor())
      },
      "&:hover:enabled:not(:active)": {
        "& span > svg > path": {
          fill: fillColor()
        },
        backgroundColor: hoverBackgroundColor()
      },
      alignItems: "center",
      backgroundColor: backgroundColor(),
      borderColor: "transparent",
      borderRadius: floating ? "circle" : "xs",
      borderStyle: "solid",
      borderWidth: "thin",
      boxShadow: floating ? defaultTheme$1.shadows["03"] : void 0,
      color: iconColor(),
      cursor: disabled ? "not-allowed" : "pointer",
      display: "flex",
      height: iconSize,
      justifyContent: "center",
      minWidth: "min-content",
      px: 0,
      transition: "all 0.1s",
      width: iconSize
    };
  };

  var __defProp$13 = Object.defineProperty;
  var __getOwnPropSymbols$13 = Object.getOwnPropertySymbols;
  var __hasOwnProp$13 = Object.prototype.hasOwnProperty;
  var __propIsEnum$13 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$13 = function __defNormalProp$13(obj, key, value) {
    return key in obj ? __defProp$13(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$13 = function __spreadValues$13(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$13.call(b, prop)) __defNormalProp$13(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$13) {
      var _iterator24 = _createForOfIteratorHelper(__getOwnPropSymbols$13(b)),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var prop = _step24.value;
          if (__propIsEnum$13.call(b, prop)) __defNormalProp$13(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
    }

    return a;
  };

  var __objRest$M = function __objRest$M(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$13.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$13) {
      var _iterator25 = _createForOfIteratorHelper(__getOwnPropSymbols$13(source)),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var prop = _step25.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$13.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
    }

    return target;
  };

  var ButtonIcon = function ButtonIcon(_a) {
    var _b = _a,
        brand = _b.brand,
        floating = _b.floating,
        isLoading = _b.isLoading,
        _b$size5 = _b.size,
        size = _b$size5 === void 0 ? "lg" : _b$size5,
        sx = _b.sx,
        disabled = _b.disabled,
        props = __objRest$M(_b, ["brand", "floating", "isLoading", "size", "sx", "disabled"]);

    return /* @__PURE__ */React__default["default"].createElement(Button, __spreadValues$13({
      disabled: disabled,
      iconOnly: true,
      isLoading: isLoading,
      sx: __spreadValues$13(__spreadValues$13({}, getIconOnlyStyle(floating, size, brand, disabled, props.color, isLoading)), sx),
      tabIndex: 0
    }, props));
  };

  var __defProp$12 = Object.defineProperty;
  var __getOwnPropSymbols$12 = Object.getOwnPropertySymbols;
  var __hasOwnProp$12 = Object.prototype.hasOwnProperty;
  var __propIsEnum$12 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$12 = function __defNormalProp$12(obj, key, value) {
    return key in obj ? __defProp$12(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$12 = function __spreadValues$12(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$12.call(b, prop)) __defNormalProp$12(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$12) {
      var _iterator26 = _createForOfIteratorHelper(__getOwnPropSymbols$12(b)),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var prop = _step26.value;
          if (__propIsEnum$12.call(b, prop)) __defNormalProp$12(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
    }

    return a;
  };

  var ButtonFloating = function ButtonFloating(props) {
    return /* @__PURE__ */React__default["default"].createElement(ButtonIcon, __spreadValues$12({
      floating: true
    }, props));
  };

  var __defProp$11 = Object.defineProperty;
  var __defProps$J = Object.defineProperties;
  var __getOwnPropDescs$J = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$11 = Object.getOwnPropertySymbols;
  var __hasOwnProp$11 = Object.prototype.hasOwnProperty;
  var __propIsEnum$11 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$11 = function __defNormalProp$11(obj, key, value) {
    return key in obj ? __defProp$11(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$11 = function __spreadValues$11(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$11.call(b, prop)) __defNormalProp$11(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$11) {
      var _iterator27 = _createForOfIteratorHelper(__getOwnPropSymbols$11(b)),
          _step27;

      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var prop = _step27.value;
          if (__propIsEnum$11.call(b, prop)) __defNormalProp$11(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
    }

    return a;
  };

  var __spreadProps$J = function __spreadProps$J(a, b) {
    return __defProps$J(a, __getOwnPropDescs$J(b));
  };

  var baseStyle = {
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  };
  var axisStyle = {
    both: __spreadProps$J(__spreadValues$11({}, baseStyle), {
      insetStart: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)"
    }),
    default: __spreadValues$11({}, baseStyle),
    horizontal: __spreadProps$J(__spreadValues$11({}, baseStyle), {
      insetStart: "50%",
      transform: "translateX(-50%)"
    }),
    vertical: __spreadProps$J(__spreadValues$11({}, baseStyle), {
      top: "50%",
      transform: "translateY(-50%)"
    })
  };
  var __defProp$10 = Object.defineProperty;
  var __defProps$I = Object.defineProperties;
  var __getOwnPropDescs$I = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$10 = Object.getOwnPropertySymbols;
  var __hasOwnProp$10 = Object.prototype.hasOwnProperty;
  var __propIsEnum$10 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$10 = function __defNormalProp$10(obj, key, value) {
    return key in obj ? __defProp$10(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$10 = function __spreadValues$10(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$10.call(b, prop)) __defNormalProp$10(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$10) {
      var _iterator28 = _createForOfIteratorHelper(__getOwnPropSymbols$10(b)),
          _step28;

      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var prop = _step28.value;
          if (__propIsEnum$10.call(b, prop)) __defNormalProp$10(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
    }

    return a;
  };

  var __spreadProps$I = function __spreadProps$I(a, b) {
    return __defProps$I(a, __getOwnPropDescs$I(b));
  };

  var __objRest$L = function __objRest$L(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$10.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$10) {
      var _iterator29 = _createForOfIteratorHelper(__getOwnPropSymbols$10(source)),
          _step29;

      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var prop = _step29.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$10.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    }

    return target;
  };

  var Center = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$axis = _b.axis,
        axis = _b$axis === void 0 ? "default" : _b$axis,
        sx = _b.sx,
        props = __objRest$L(_b, ["axis", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$I(__spreadValues$10({
      sx: __spreadValues$10(__spreadValues$10({}, axisStyle[axis]), sx)
    }, props), {
      ref: ref
    }));
  });

  var getCheckBoxStyle = function getCheckBoxStyle(brand, disabled, hover, focus, active) {
    var getSpanBackgroundColor = function getSpanBackgroundColor() {
      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }

      return "transparent";
    };

    var getSpanBorderColor = function getSpanBorderColor() {
      if (focus) {
        return brand ? "interaction.on.brand.blend.05" : "interaction.blend.05";
      }

      return "transparent";
    };

    var getInputColor = function getInputColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }

      return brand ? "interaction.on.brand.select.focus" : "interaction.select.focus";
    };

    var getCheckedInputColor = function getCheckedInputColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }

      return brand ? "interaction.on.brand.select.active" : "interaction.select.active";
    };

    return {
      alignItems: "center",
      input: {
        ":checked": {
          "~ svg": {
            color: getCheckedInputColor()
          }
        },
        ":not(:checked)": {
          "~ svg": {
            color: getInputColor()
          }
        },
        "~ svg": {
          backgroundColor: "transparent !important",
          color: getInputColor(),
          position: "relative"
        }
      },
      span: {
        bg: getSpanBackgroundColor(),
        borderColor: getSpanBorderColor(),
        borderRadius: "circle",
        borderStyle: "solid",
        borderWidth: "thin",
        boxSizing: "border-box",
        display: "block",
        height: "40px",
        position: "absolute",
        transform: "translateX(-8px)",
        width: "40px"
      }
    };
  };

  var __defProp$$ = Object.defineProperty;
  var __defProps$H = Object.defineProperties;
  var __getOwnPropDescs$H = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$$ = Object.getOwnPropertySymbols;
  var __hasOwnProp$$ = Object.prototype.hasOwnProperty;
  var __propIsEnum$$ = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$$ = function __defNormalProp$$(obj, key, value) {
    return key in obj ? __defProp$$(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$$ = function __spreadValues$$(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$$.call(b, prop)) __defNormalProp$$(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$$) {
      var _iterator30 = _createForOfIteratorHelper(__getOwnPropSymbols$$(b)),
          _step30;

      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var prop = _step30.value;
          if (__propIsEnum$$.call(b, prop)) __defNormalProp$$(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    }

    return a;
  };

  var __spreadProps$H = function __spreadProps$H(a, b) {
    return __defProps$H(a, __getOwnPropDescs$H(b));
  };

  var __objRest$K = function __objRest$K(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$$.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$$) {
      var _iterator31 = _createForOfIteratorHelper(__getOwnPropSymbols$$(source)),
          _step31;

      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var prop = _step31.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$$.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
    }

    return target;
  };

  var CheckBox = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        label = _b.label,
        _onChange = _b.onChange,
        indeterminate = _b.indeterminate,
        brand = _b.brand,
        sx = _b.sx,
        props = __objRest$K(_b, ["label", "onChange", "indeterminate", "brand", "sx"]);

    var _React$useState7 = React.useState(false),
        _React$useState8 = _slicedToArray(_React$useState7, 2),
        hover = _React$useState8[0],
        setHover = _React$useState8[1];

    var _React$useState9 = React.useState(false),
        _React$useState10 = _slicedToArray(_React$useState9, 2),
        focus = _React$useState10[0],
        setFocus = _React$useState10[1];

    var _React$useState11 = React.useState(false),
        _React$useState12 = _slicedToArray(_React$useState11, 2),
        active = _React$useState12[0],
        setActive = _React$useState12[1];

    var _React$useState13 = React.useState(!!indeterminate),
        _React$useState14 = _slicedToArray(_React$useState13, 2),
        controlIndeterminate = _React$useState14[0],
        setControlIndeterminate = _React$useState14[1];

    var getLabelColor = function getLabelColor() {
      if (props.disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }

      return brand ? "typeface.on.brand.pure" : "typeface.pure";
    };

    React__default["default"].useEffect(function () {
      setControlIndeterminate(!!indeterminate);
    }, [indeterminate]);
    return /* @__PURE__ */React__default["default"].createElement(themeUi.Label, {
      onBlur: function onBlur() {
        return setFocus(false);
      },
      onFocus: function onFocus() {
        return !props.disabled && setFocus(true);
      },
      onMouseDown: function onMouseDown() {
        return !props.disabled && setActive(true);
      },
      onMouseEnter: function onMouseEnter() {
        return !props.disabled && setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      },
      onMouseUp: function onMouseUp(evt) {
        evt.currentTarget.blur();
        setActive(false);
      },
      sx: __spreadValues$$(__spreadValues$$({}, getCheckBoxStyle(brand, props.disabled, hover, focus, active)), sx)
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      as: "span"
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        position: "relative"
      }
    }, /* @__PURE__ */React__default["default"].createElement(themeUi.Checkbox, __spreadProps$H(__spreadValues$$({}, props), {
      onChange: function onChange(e) {
        _onChange && _onChange(e);
        indeterminate && setControlIndeterminate(!e.target.checked);
      },
      ref: ref
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        height: "100%",
        left: 0,
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        width: "100%"
      }
    }, controlIndeterminate && /* @__PURE__ */React__default["default"].createElement(Icon, {
      as: "div",
      color: getLabelColor()
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.CheckboxIndeterminate, null))))), typeof label === "string" ? /* @__PURE__ */React__default["default"].createElement(Body, {
      brand: brand,
      color: getLabelColor(),
      ml: "inline.nano",
      tabIndex: -1,
      variant: "lg"
    }, label) : label);
  });
  var __defProp$_ = Object.defineProperty;
  var __getOwnPropSymbols$_ = Object.getOwnPropertySymbols;
  var __hasOwnProp$_ = Object.prototype.hasOwnProperty;
  var __propIsEnum$_ = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$_ = function __defNormalProp$_(obj, key, value) {
    return key in obj ? __defProp$_(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$_ = function __spreadValues$_(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$_.call(b, prop)) __defNormalProp$_(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$_) {
      var _iterator32 = _createForOfIteratorHelper(__getOwnPropSymbols$_(b)),
          _step32;

      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var prop = _step32.value;
          if (__propIsEnum$_.call(b, prop)) __defNormalProp$_(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
    }

    return a;
  };

  var getDividerStyle = function getDividerStyle(brand, variant) {
    var customStyle = {};

    if (variant === "horizontal") {
      customStyle["borderTopWidth"] = "1px";
      customStyle["width"] = "100%";
    } else {
      customStyle["borderRightWidth"] = "1px";
      customStyle["height"] = "100%";
    }

    return __spreadValues$_({
      borderColor: brand ? "neutral.on.brand.30" : "neutral.30",
      borderStyle: "solid",
      borderWidth: "none",
      margin: 0,
      position: "relative"
    }, customStyle);
  };

  var __defProp$Z = Object.defineProperty;
  var __defProps$G = Object.defineProperties;
  var __getOwnPropDescs$G = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$Z = Object.getOwnPropertySymbols;
  var __hasOwnProp$Z = Object.prototype.hasOwnProperty;
  var __propIsEnum$Z = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$Z = function __defNormalProp$Z(obj, key, value) {
    return key in obj ? __defProp$Z(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$Z = function __spreadValues$Z(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$Z.call(b, prop)) __defNormalProp$Z(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$Z) {
      var _iterator33 = _createForOfIteratorHelper(__getOwnPropSymbols$Z(b)),
          _step33;

      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var prop = _step33.value;
          if (__propIsEnum$Z.call(b, prop)) __defNormalProp$Z(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
    }

    return a;
  };

  var __spreadProps$G = function __spreadProps$G(a, b) {
    return __defProps$G(a, __getOwnPropDescs$G(b));
  };

  var __objRest$J = function __objRest$J(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$Z.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$Z) {
      var _iterator34 = _createForOfIteratorHelper(__getOwnPropSymbols$Z(source)),
          _step34;

      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var prop = _step34.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$Z.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
    }

    return target;
  };

  var Divider = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        sx = _b.sx,
        _b$variant3 = _b.variant,
        variant = _b$variant3 === void 0 ? "horizontal" : _b$variant3,
        props = __objRest$J(_b, ["brand", "sx", "variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$G(__spreadValues$Z({
      sx: __spreadValues$Z(__spreadValues$Z({}, getDividerStyle(brand, variant)), sx)
    }, props), {
      ref: ref
    }));
  });
  var __defProp$Y = Object.defineProperty;
  var __getOwnPropSymbols$Y = Object.getOwnPropertySymbols;
  var __hasOwnProp$Y = Object.prototype.hasOwnProperty;
  var __propIsEnum$Y = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$Y = function __defNormalProp$Y(obj, key, value) {
    return key in obj ? __defProp$Y(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$Y = function __spreadValues$Y(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$Y.call(b, prop)) __defNormalProp$Y(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$Y) {
      var _iterator35 = _createForOfIteratorHelper(__getOwnPropSymbols$Y(b)),
          _step35;

      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var prop = _step35.value;
          if (__propIsEnum$Y.call(b, prop)) __defNormalProp$Y(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
    }

    return a;
  };

  var Spacer = function Spacer(props) {
    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$Y({
      mx: "auto",
      p: 0
    }, props));
  };

  function _isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
  }
  /**
   * Optimized internal one-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry1(fn) {
    return function f1(a) {
      if (arguments.length === 0 || _isPlaceholder(a)) {
        return f1;
      } else {
        return fn.apply(this, arguments);
      }
    };
  }
  /**
   * Optimized internal two-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry2(fn) {
    return function f2(a, b) {
      switch (arguments.length) {
        case 0:
          return f2;

        case 1:
          return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
            return fn(a, _b);
          });

        default:
          return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
            return fn(_a, b);
          }) : _isPlaceholder(b) ? _curry1(function (_b) {
            return fn(a, _b);
          }) : fn(a, b);
      }
    };
  }

  function _arity(n, fn) {
    /* eslint-disable no-unused-vars */
    switch (n) {
      case 0:
        return function () {
          return fn.apply(this, arguments);
        };

      case 1:
        return function (a0) {
          return fn.apply(this, arguments);
        };

      case 2:
        return function (a0, a1) {
          return fn.apply(this, arguments);
        };

      case 3:
        return function (a0, a1, a2) {
          return fn.apply(this, arguments);
        };

      case 4:
        return function (a0, a1, a2, a3) {
          return fn.apply(this, arguments);
        };

      case 5:
        return function (a0, a1, a2, a3, a4) {
          return fn.apply(this, arguments);
        };

      case 6:
        return function (a0, a1, a2, a3, a4, a5) {
          return fn.apply(this, arguments);
        };

      case 7:
        return function (a0, a1, a2, a3, a4, a5, a6) {
          return fn.apply(this, arguments);
        };

      case 8:
        return function (a0, a1, a2, a3, a4, a5, a6, a7) {
          return fn.apply(this, arguments);
        };

      case 9:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
          return fn.apply(this, arguments);
        };

      case 10:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
          return fn.apply(this, arguments);
        };

      default:
        throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
  }
  /**
   * Optimized internal three-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry3(fn) {
    return function f3(a, b, c) {
      switch (arguments.length) {
        case 0:
          return f3;

        case 1:
          return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          });

        case 2:
          return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _curry1(function (_c) {
            return fn(a, b, _c);
          });

        default:
          return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
            return fn(_a, _b, c);
          }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _isPlaceholder(a) ? _curry1(function (_a) {
            return fn(_a, b, c);
          }) : _isPlaceholder(b) ? _curry1(function (_b) {
            return fn(a, _b, c);
          }) : _isPlaceholder(c) ? _curry1(function (_c) {
            return fn(a, b, _c);
          }) : fn(a, b, c);
      }
    };
  }
  /**
   * Tests whether or not an object is an array.
   *
   * @private
   * @param {*} val The object to test.
   * @return {Boolean} `true` if `val` is an array, `false` otherwise.
   * @example
   *
   *      _isArray([]); //=> true
   *      _isArray(null); //=> false
   *      _isArray({}); //=> false
   */


  var _isArray = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
  };

  function _isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
  }
  /**
   * Tests whether or not an object is similar to an array.
   *
   * @private
   * @category Type
   * @category List
   * @sig * -> Boolean
   * @param {*} x The object to test.
   * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
   * @example
   *
   *      _isArrayLike([]); //=> true
   *      _isArrayLike(true); //=> false
   *      _isArrayLike({}); //=> false
   *      _isArrayLike({length: 10}); //=> false
   *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
   *      _isArrayLike({nodeType: 1, length: 1}) // => false
   */


  var _isArrayLike = /*#__PURE__*/_curry1(function isArrayLike(x) {
    if (_isArray(x)) {
      return true;
    }

    if (!x) {
      return false;
    }

    if (typeof x !== 'object') {
      return false;
    }

    if (_isString(x)) {
      return false;
    }

    if (x.length === 0) {
      return true;
    }

    if (x.length > 0) {
      return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    }

    return false;
  });

  var XWrap = /*#__PURE__*/function () {
    function XWrap(fn) {
      this.f = fn;
    }

    XWrap.prototype['@@transducer/init'] = function () {
      throw new Error('init not implemented on XWrap');
    };

    XWrap.prototype['@@transducer/result'] = function (acc) {
      return acc;
    };

    XWrap.prototype['@@transducer/step'] = function (acc, x) {
      return this.f(acc, x);
    };

    return XWrap;
  }();

  function _xwrap(fn) {
    return new XWrap(fn);
  }
  /**
   * Creates a function that is bound to a context.
   * Note: `R.bind` does not provide the additional argument-binding capabilities of
   * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
   *
   * @func
   * @memberOf R
   * @since v0.6.0
   * @category Function
   * @category Object
   * @sig (* -> *) -> {*} -> (* -> *)
   * @param {Function} fn The function to bind to context
   * @param {Object} thisObj The context to bind `fn` to
   * @return {Function} A function that will execute in the context of `thisObj`.
   * @see R.partial
   * @example
   *
   *      const log = R.bind(console.log, console);
   *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
   *      // logs {a: 2}
   * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
   */


  var bind = /*#__PURE__*/_curry2(function bind(fn, thisObj) {
    return _arity(fn.length, function () {
      return fn.apply(thisObj, arguments);
    });
  });

  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;

    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      idx += 1;
    }

    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();

    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      step = iter.next();
    }

    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

  function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }

    if (_isArrayLike(list)) {
      return _arrayReduce(fn, acc, list);
    }

    if (typeof list['fantasy-land/reduce'] === 'function') {
      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    }

    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }

    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }

    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list, 'reduce');
    }

    throw new TypeError('reduce: list must be array or iterable');
  }
  /**
   * Returns a single item by iterating through the list, successively calling
   * the iterator function and passing it an accumulator value and the current
   * value from the array, and then passing the result to the next call.
   *
   * The iterator function receives two values: *(acc, value)*. It may use
   * [`R.reduced`](#reduced) to shortcut the iteration.
   *
   * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
   * is *(value, acc)*.
   *
   * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
   * arrays), unlike the native `Array.prototype.reduce` method. For more details
   * on this behavior, see:
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
   *
   * Dispatches to the `reduce` method of the third argument, if present. When
   * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
   * shortcuting, as this is not implemented by `reduce`.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig ((a, b) -> a) -> a -> [b] -> a
   * @param {Function} fn The iterator function. Receives two values, the accumulator and the
   *        current element from the array.
   * @param {*} acc The accumulator value.
   * @param {Array} list The list to iterate over.
   * @return {*} The final, accumulated value.
   * @see R.reduced, R.addIndex, R.reduceRight
   * @example
   *
   *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
   *      //          -               -10
   *      //         / \              / \
   *      //        -   4           -6   4
   *      //       / \              / \
   *      //      -   3   ==>     -3   3
   *      //     / \              / \
   *      //    -   2           -1   2
   *      //   / \              / \
   *      //  0   1            0   1
   *
   * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
   */


  var reduce = /*#__PURE__*/_curry3(_reduce);

  var reduce$1 = reduce;

  function _pipe(f, g) {
    return function () {
      return g.call(this, f.apply(this, arguments));
    };
  }
  /**
   * This checks whether a function has a [methodname] function. If it isn't an
   * array it will execute that function otherwise it will default to the ramda
   * implementation.
   *
   * @private
   * @param {Function} fn ramda implementation
   * @param {String} methodname property to check for a custom implementation
   * @return {Object} Whatever the return value of the method is.
   */


  function _checkForMethod(methodname, fn) {
    return function () {
      var length = arguments.length;

      if (length === 0) {
        return fn();
      }

      var obj = arguments[length - 1];
      return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
  }
  /**
   * Returns the elements of the given list or string (or object with a `slice`
   * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
   *
   * Dispatches to the `slice` method of the third argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.4
   * @category List
   * @sig Number -> Number -> [a] -> [a]
   * @sig Number -> Number -> String -> String
   * @param {Number} fromIndex The start index (inclusive).
   * @param {Number} toIndex The end index (exclusive).
   * @param {*} list
   * @return {*}
   * @example
   *
   *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
   *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
   *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
   *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
   *      R.slice(0, 3, 'ramda');                     //=> 'ram'
   */


  var slice = /*#__PURE__*/_curry3( /*#__PURE__*/_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
  }));
  /**
   * Returns all but the first element of the given list or string (or object
   * with a `tail` method).
   *
   * Dispatches to the `slice` method of the first argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig [a] -> [a]
   * @sig String -> String
   * @param {*} list
   * @return {*}
   * @see R.head, R.init, R.last
   * @example
   *
   *      R.tail([1, 2, 3]);  //=> [2, 3]
   *      R.tail([1, 2]);     //=> [2]
   *      R.tail([1]);        //=> []
   *      R.tail([]);         //=> []
   *
   *      R.tail('abc');  //=> 'bc'
   *      R.tail('ab');   //=> 'b'
   *      R.tail('a');    //=> ''
   *      R.tail('');     //=> ''
   */


  var tail = /*#__PURE__*/_curry1( /*#__PURE__*/_checkForMethod('tail', /*#__PURE__*/slice(1, Infinity)));

  var tail$1 = tail;
  /**
   * Performs left-to-right function composition. The first argument may have
   * any arity; the remaining arguments must be unary.
   *
   * In some libraries this function is named `sequence`.
   *
   * **Note:** The result of pipe is not automatically curried.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
   * @param {...Function} functions
   * @return {Function}
   * @see R.compose
   * @example
   *
   *      const f = R.pipe(Math.pow, R.negate, R.inc);
   *
   *      f(3, 4); // -(3^4) + 1
   * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
   * @symb R.pipe(f, g, h)(a)(b) = h(g(f(a)))(b)
   */

  function pipe() {
    if (arguments.length === 0) {
      throw new Error('pipe requires at least one argument');
    }

    return _arity(arguments[0].length, reduce$1(_pipe, arguments[0], tail$1(arguments)));
  }

  function _isNumber(x) {
    return Object.prototype.toString.call(x) === '[object Number]';
  }
  /**
   * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig Number -> Number -> [Number]
   * @param {Number} from The first number in the list.
   * @param {Number} to One more than the last number in the list.
   * @return {Array} The list of numbers in the set `[a, b)`.
   * @example
   *
   *      R.range(1, 5);    //=> [1, 2, 3, 4]
   *      R.range(50, 53);  //=> [50, 51, 52]
   */


  var range = /*#__PURE__*/_curry2(function range(from, to) {
    if (!(_isNumber(from) && _isNumber(to))) {
      throw new TypeError('Both arguments to range must be numbers');
    }

    var result = [];
    var n = from;

    while (n < to) {
      result.push(n);
      n += 1;
    }

    return result;
  });

  var range$1 = range;

  var getIconColor$1 = function getIconColor$1(_ref29) {
    var variant = _ref29.variant,
        brand = _ref29.brand,
        disabled = _ref29.disabled;
    var blnd07 = "interaction.inverse.blend.07";

    if (disabled) {
      return brand ? blnd07 : "interaction.blend.06";
    }

    switch (variant) {
      case "invalid":
        return brand ? blnd07 : "feedback.error.shape";

      case "valid":
        return brand ? "interaction.inverse.blend.08" : "feedback.success.shape";

      default:
        return brand ? blnd07 : "neutral.inverse.10";
    }
  };

  var getTextColor$1 = function getTextColor$1(_ref30) {
    var variant = _ref30.variant,
        brand = _ref30.brand,
        disabled = _ref30.disabled;

    if (brand) {
      return "interaction.inverse.blend.07";
    }

    if (disabled) {
      return "interaction.blend.06";
    }

    switch (variant) {
      case "invalid":
        return "feedback.error.text";

      case "valid":
        return "feedback.success.text";

      default:
        return "typeface.smooth";
    }
  };

  var __defProp$X = Object.defineProperty;
  var __getOwnPropSymbols$X = Object.getOwnPropertySymbols;
  var __hasOwnProp$X = Object.prototype.hasOwnProperty;
  var __propIsEnum$X = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$X = function __defNormalProp$X(obj, key, value) {
    return key in obj ? __defProp$X(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$X = function __spreadValues$X(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$X.call(b, prop)) __defNormalProp$X(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$X) {
      var _iterator36 = _createForOfIteratorHelper(__getOwnPropSymbols$X(b)),
          _step36;

      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var prop = _step36.value;
          if (__propIsEnum$X.call(b, prop)) __defNormalProp$X(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
    }

    return a;
  };

  var __objRest$I = function __objRest$I(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$X.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$X) {
      var _iterator37 = _createForOfIteratorHelper(__getOwnPropSymbols$X(source)),
          _step37;

      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var prop = _step37.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$X.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
    }

    return target;
  };

  var Caption = React__default["default"].forwardRef(function (_a, ref) {
    var props = __objRest$I(_a, []);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$X({
      color: getColorTypfaceTokenByProp(props, "pure"),
      fontFamily: "base",
      fontSize: "xxxs",
      letterSpacing: "standard",
      lineHeight: "distant",
      ref: ref
    }, props));
  });

  var getFlexStyle = function getFlexStyle(_ref31) {
    var fullWidth = _ref31.fullWidth,
        width = _ref31.width,
        align = _ref31.align,
        basis = _ref31.basis,
        direction = _ref31.direction,
        grow = _ref31.grow,
        justify = _ref31.justify,
        shrink = _ref31.shrink,
        wrap = _ref31.wrap;
    return {
      alignItems: align,
      display: "flex",
      flexBasis: basis,
      flexDirection: direction,
      flexGrow: grow,
      flexShrink: shrink,
      flexWrap: wrap,
      justifyContent: justify,
      width: fullWidth ? "100%" : width
    };
  };

  var __defProp$W = Object.defineProperty;
  var __defProps$F = Object.defineProperties;
  var __getOwnPropDescs$F = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$W = Object.getOwnPropertySymbols;
  var __hasOwnProp$W = Object.prototype.hasOwnProperty;
  var __propIsEnum$W = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$W = function __defNormalProp$W(obj, key, value) {
    return key in obj ? __defProp$W(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$W = function __spreadValues$W(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$W.call(b, prop)) __defNormalProp$W(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$W) {
      var _iterator38 = _createForOfIteratorHelper(__getOwnPropSymbols$W(b)),
          _step38;

      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var prop = _step38.value;
          if (__propIsEnum$W.call(b, prop)) __defNormalProp$W(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
    }

    return a;
  };

  var __spreadProps$F = function __spreadProps$F(a, b) {
    return __defProps$F(a, __getOwnPropDescs$F(b));
  };

  var __objRest$H = function __objRest$H(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$W.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$W) {
      var _iterator39 = _createForOfIteratorHelper(__getOwnPropSymbols$W(source)),
          _step39;

      try {
        for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
          var prop = _step39.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$W.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator39.e(err);
      } finally {
        _iterator39.f();
      }
    }

    return target;
  };

  var Flex = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        sx = _b.sx,
        props = __objRest$H(_b, ["sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$F(__spreadValues$W({
      display: "flex",
      flex: "none",
      sx: __spreadValues$W(__spreadValues$W({}, getFlexStyle(props)), sx)
    }, props), {
      ref: ref
    }));
  });
  var __defProp$V = Object.defineProperty;
  var __defProps$E = Object.defineProperties;
  var __getOwnPropDescs$E = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$V = Object.getOwnPropertySymbols;
  var __hasOwnProp$V = Object.prototype.hasOwnProperty;
  var __propIsEnum$V = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$V = function __defNormalProp$V(obj, key, value) {
    return key in obj ? __defProp$V(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$V = function __spreadValues$V(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$V.call(b, prop)) __defNormalProp$V(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$V) {
      var _iterator40 = _createForOfIteratorHelper(__getOwnPropSymbols$V(b)),
          _step40;

      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var prop = _step40.value;
          if (__propIsEnum$V.call(b, prop)) __defNormalProp$V(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
    }

    return a;
  };

  var __spreadProps$E = function __spreadProps$E(a, b) {
    return __defProps$E(a, __getOwnPropDescs$E(b));
  };

  var renderIcon = function renderIcon(props) {
    var disabled = props.disabled,
        variant = props.variant,
        icon = props.icon;
    var iconToRender = null;

    if (disabled) {
      iconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.Lock, null);
    } else {
      switch (variant) {
        case "valid":
          iconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.CheckRound, null);
          break;

        case "invalid":
          iconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.WarningRound, null);
          break;

        case "custom":
          if (icon) {
            iconToRender = icon;
          }

          break;
      }
    }

    if (iconToRender) {
      return /* @__PURE__ */React__default["default"].createElement(Icon, {
        color: getIconColor$1(props),
        size: "sm"
      }, iconToRender);
    }

    return null;
  };

  var SupportMessage = function SupportMessage(props) {
    var value = props.value,
        brand = props.brand,
        disabled = props.disabled;
    return /* @__PURE__ */React__default["default"].createElement(Flex, __spreadProps$E(__spreadValues$V({
      "aria-disabled": disabled,
      minHeight: "1em"
    }, props), {
      alignItems: "center"
    }), renderIcon(props), /* @__PURE__ */React__default["default"].createElement(Caption, {
      brand: brand,
      color: getTextColor$1(props),
      pl: "inline.quark"
    }, value));
  };

  var __defProp$U = Object.defineProperty;
  var __defProps$D = Object.defineProperties;
  var __getOwnPropDescs$D = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$U = Object.getOwnPropertySymbols;
  var __hasOwnProp$U = Object.prototype.hasOwnProperty;
  var __propIsEnum$U = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$U = function __defNormalProp$U(obj, key, value) {
    return key in obj ? __defProp$U(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$U = function __spreadValues$U(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$U.call(b, prop)) __defNormalProp$U(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$U) {
      var _iterator41 = _createForOfIteratorHelper(__getOwnPropSymbols$U(b)),
          _step41;

      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var prop = _step41.value;
          if (__propIsEnum$U.call(b, prop)) __defNormalProp$U(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
    }

    return a;
  };

  var __spreadProps$D = function __spreadProps$D(a, b) {
    return __defProps$D(a, __getOwnPropDescs$D(b));
  };

  var __objRest$G = function __objRest$G(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$U.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$U) {
      var _iterator42 = _createForOfIteratorHelper(__getOwnPropSymbols$U(source)),
          _step42;

      try {
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          var prop = _step42.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$U.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }
    }

    return target;
  };

  var StyledContainer = function StyledContainer(_a) {
    var _b = _a,
        _b$width = _b.width,
        width = _b$width === void 0 ? 320 : _b$width,
        _b$height = _b.height,
        height = _b$height === void 0 ? "auto" : _b$height,
        sx = _b.sx,
        props = __objRest$G(_b, ["width", "height", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$U({
      sx: __spreadValues$U({
        height: height,
        minWidth: 72,
        position: "relative",
        width: width
      }, sx)
    }, props));
  };

  var StyledInputLabelContainer = function StyledInputLabelContainer(_ref32) {
    var color = _ref32.color,
        children = _ref32.children,
        variantSize = _ref32.variantSize,
        focused = _ref32.focused,
        brand = _ref32.brand,
        height = _ref32.height,
        disabled = _ref32.disabled;

    var getBgHoverInput = function getBgHoverInput() {
      if (disabled) {
        return "";
      }

      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };

    return /* @__PURE__ */React__default["default"].createElement(Flex, {
      flex: "none",
      sx: {
        "&:disabled": {
          cursor: "not-allowed"
        },
        "&:focus-visible": {
          outline: "none"
        },
        "&:hover": {
          bg: getBgHoverInput()
        },
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        border: "none",
        borderBottomColor: "".concat(color),
        borderBottomLeftRadius: "none",
        borderBottomRightRadius: "none",
        borderBottomStyle: "solid",
        borderBottomWidth: focused ? "thin" : "hairline",
        borderTopLeftRadius: "xs",
        borderTopRightRadius: "xs",
        height: height || (variantSize === "lg" ? 56 : 32),
        minHeight: variantSize === "lg" ? 56 : 32
      }
    }, children);
  };

  var activeLabelStyle = {
    "& > p": {
      fontSize: "xxxs"
    },
    mt: "inline.xxxs",
    overflow: "hidden",
    pt: 0,
    transform: "translateY(-0.625rem)",
    width: "auto"
  };
  var StyledLabel = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        color = _d.color,
        isActive = _d.isActive,
        label = _d.label,
        variant = _d.variant,
        variantSize = _d.variantSize,
        leadingIcon = _d.leadingIcon,
        props = __objRest$G(_d, ["color", "isActive", "label", "variant", "variantSize", "leadingIcon"]);

    var activeStyle = isActive && variantSize === "lg" ? activeLabelStyle : "";
    var isSmall = variantSize === "sm";

    var labelPaddingLeft = function labelPaddingLeft() {
      if (isSmall) {
        if (leadingIcon) {
          return "inline.sm";
        }

        return "inline.nano";
      }

      return "";
    };

    return /* @__PURE__ */React__default["default"].createElement(themeUi.Label, __spreadProps$D(__spreadValues$U({
      color: color,
      pt: "inline.xxxs",
      sx: __spreadValues$U({
        alignItems: "center",
        flex: "none",
        left: leadingIcon ? "inline.lg" : "inline.xxxs",
        pl: labelPaddingLeft(),
        pointerEvents: "none",
        position: isSmall ? "static" : "absolute",
        pt: isSmall ? 0 : "",
        transition: "all 200ms",
        whiteSpace: "nowrap"
      }, activeStyle)
    }, props), {
      ref: ref
    }), /* @__PURE__ */React__default["default"].createElement(Body, {
      color: "inherit",
      variant: variantSize
    }, label));
  });
  var StyledInput = React__default["default"].forwardRef(function (_e, ref) {
    var _f = _e,
        name = _f.name,
        trailingIcon = _f.trailingIcon,
        leadingIcon = _f.leadingIcon,
        variantSize = _f.variantSize,
        brand = _f.brand,
        height = _f.height,
        props = __objRest$G(_f, ["name", "trailingIcon", "leadingIcon", "variantSize", "brand", "height"]);

    var isSmall = variantSize === "sm";

    var paddingRightInput = function paddingRightInput() {
      if (trailingIcon) {
        if (isSmall) {
          return "inline.sm";
        }

        return "inline.xxxs";
      }

      if (trailingIcon) {
        return "inline.lg";
      }

      return "inline.xxxs";
    };

    var paddingLeftInput = function paddingLeftInput() {
      if (leadingIcon) {
        if (isSmall) {
          return "inline.xxxs";
        }

        return "inline.lg";
      }

      return "inline.xxxs";
    };

    var variantSizeHeight = variantSize === "lg" ? 56 : 32;
    return /* @__PURE__ */React__default["default"].createElement(themeUi.Input, __spreadProps$D(__spreadValues$U({
      name: name,
      sx: {
        "&:disabled": {
          color: brand ? "typeface.on.brand.pure" : "typeface.meld",
          cursor: "not-allowed"
        },
        '&[type="password"]': {
          font: "small-caption",
          fontSize: "xs"
        },
        border: "none",
        color: brand ? "typeface.on.brand.pure" : "typeface.smooth",
        fontFamily: "base",
        height: height || variantSizeHeight,
        minHeight: variantSizeHeight,
        minWidth: "72px",
        pl: paddingLeftInput(),
        pr: paddingRightInput(),
        pt: variantSize === "sm" ? "" : "inline.xxs"
      }
    }, props), {
      ref: ref
    }));
  });

  var getColorInputToken = function getColorInputToken(type, variant) {
    return "feedback.".concat(variant, ".").concat(type);
  };

  var getInputColors = function getInputColors(_ref33) {
    var variant = _ref33.variant,
        disabled = _ref33.disabled,
        active = _ref33.active,
        brand = _ref33.brand;
    var isNotDefaultVariant = variant !== "default";
    var defaultToken = "interaction.select.default";
    var activeColor = !disabled && active && "interaction.select.active";
    var disabledTypoToken = disabled && "typeface.meld";
    var brandShapeColor = brand ? "interaction.on.brand.select.default" : "";
    var brandLabelColor = brand ? "typeface.on.brand.pure" : "";
    var variantColorShape = isNotDefaultVariant && getColorInputToken("shape", variant);
    var variantColorLabel = isNotDefaultVariant && getColorInputToken("text", variant);
    var colorShape = brandShapeColor || disabledTypoToken || variantColorShape || activeColor || defaultToken;
    var colorLabel = brandLabelColor || disabledTypoToken || variantColorLabel || activeColor || defaultToken;
    return {
      colorLabel: colorLabel,
      colorShape: colorShape
    };
  };

  var getWrapStyle = function getWrapStyle(_ref34) {
    var spacing = _ref34.spacing;
    return {
      "& > *:not(style)": {
        margin: spacing
      },
      flexWrap: "wrap"
    };
  };

  var wrapItemStyle = {
    alignItems: "flex-start",
    display: "flex",
    flexWrap: "wrap"
  };
  var __defProp$T = Object.defineProperty;
  var __defProps$C = Object.defineProperties;
  var __getOwnPropDescs$C = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$T = Object.getOwnPropertySymbols;
  var __hasOwnProp$T = Object.prototype.hasOwnProperty;
  var __propIsEnum$T = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$T = function __defNormalProp$T(obj, key, value) {
    return key in obj ? __defProp$T(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$T = function __spreadValues$T(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$T.call(b, prop)) __defNormalProp$T(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$T) {
      var _iterator43 = _createForOfIteratorHelper(__getOwnPropSymbols$T(b)),
          _step43;

      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var prop = _step43.value;
          if (__propIsEnum$T.call(b, prop)) __defNormalProp$T(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }
    }

    return a;
  };

  var __spreadProps$C = function __spreadProps$C(a, b) {
    return __defProps$C(a, __getOwnPropDescs$C(b));
  };

  var __objRest$F = function __objRest$F(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$T.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$T) {
      var _iterator44 = _createForOfIteratorHelper(__getOwnPropSymbols$T(source)),
          _step44;

      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var prop = _step44.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$T.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
    }

    return target;
  };

  var Wrap = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$spacing = _b.spacing,
        spacing = _b$spacing === void 0 ? 10 : _b$spacing,
        props = __objRest$F(_b, ["spacing"]);

    return /* @__PURE__ */React__default["default"].createElement(Flex, __spreadProps$C(__spreadValues$T({
      as: "ul",
      flexWrap: "wrap",
      sx: getWrapStyle(__spreadProps$C(__spreadValues$T({}, props), {
        spacing: spacing
      }))
    }, props), {
      ref: ref
    }));
  });
  var WrapItem = React__default["default"].forwardRef(function (props, ref) {
    return /* @__PURE__ */React__default["default"].createElement(Wrap, __spreadProps$C(__spreadValues$T({
      as: "li",
      sx: wrapItemStyle
    }, props), {
      ref: ref
    }));
  });

  var StyledIcon = function StyledIcon(_ref35) {
    var _sx;

    var children = _ref35.children,
        disabled = _ref35.disabled,
        variantSize = _ref35.variantSize,
        _ref35$direction = _ref35.direction,
        direction = _ref35$direction === void 0 ? "left" : _ref35$direction;
    return /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: (_sx = {
        cursor: disabled ? "not-allowed" : "pointer"
      }, _defineProperty(_sx, direction, "inline.nano"), _defineProperty(_sx, "mx", variantSize === "lg" ? "inline.nano" : "inline.quark"), _defineProperty(_sx, "pointerEvents", "none"), _defineProperty(_sx, "position", "absolute"), _defineProperty(_sx, "top", variantSize === "lg" ? "inline.xxxs" : "inline.nano"), _sx)
    }, children);
  };

  var __defProp$S = Object.defineProperty;
  var __defProps$B = Object.defineProperties;
  var __getOwnPropDescs$B = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$S = Object.getOwnPropertySymbols;
  var __hasOwnProp$S = Object.prototype.hasOwnProperty;
  var __propIsEnum$S = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$S = function __defNormalProp$S(obj, key, value) {
    return key in obj ? __defProp$S(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$S = function __spreadValues$S(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$S.call(b, prop)) __defNormalProp$S(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$S) {
      var _iterator45 = _createForOfIteratorHelper(__getOwnPropSymbols$S(b)),
          _step45;

      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var prop = _step45.value;
          if (__propIsEnum$S.call(b, prop)) __defNormalProp$S(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
    }

    return a;
  };

  var __spreadProps$B = function __spreadProps$B(a, b) {
    return __defProps$B(a, __getOwnPropDescs$B(b));
  };

  var __objRest$E = function __objRest$E(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$S.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$S) {
      var _iterator46 = _createForOfIteratorHelper(__getOwnPropSymbols$S(source)),
          _step46;

      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var prop = _step46.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$S.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }
    }

    return target;
  };

  var getSpacingValue = function getSpacingValue(type, _ref36) {
    var size = _ref36.size,
        variant = _ref36.variant;

    if (type === "bottom") {
      if (variant === "horizontal") {
        return "stack.".concat(size);
      }

      return "0";
    } else if (type === "right") {
      if (variant === "vertical") {
        return "inline.".concat(size);
      }

      return "0";
    }

    return "0";
  };

  var Spacing = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$size6 = _b.size,
        size = _b$size6 === void 0 ? "quark" : _b$size6,
        sx = _b.sx,
        _b$variant4 = _b.variant,
        variant = _b$variant4 === void 0 ? "horizontal" : _b$variant4,
        props = __objRest$E(_b, ["size", "sx", "variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$B(__spreadValues$S({}, props), {
      ref: ref,
      sx: __spreadValues$S(__spreadValues$S({}, {
        paddingBottom: mapResponsive(size, function (propSize) {
          return getSpacingValue("bottom", {
            size: propSize,
            variant: variant
          });
        }),
        paddingRight: mapResponsive(size, function (propSize) {
          return getSpacingValue("right", {
            size: propSize,
            variant: variant
          });
        }),
        position: "relative"
      }), sx)
    }));
  });
  var __defProp$R = Object.defineProperty;
  var __getOwnPropSymbols$R = Object.getOwnPropertySymbols;
  var __hasOwnProp$R = Object.prototype.hasOwnProperty;
  var __propIsEnum$R = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$R = function __defNormalProp$R(obj, key, value) {
    return key in obj ? __defProp$R(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$R = function __spreadValues$R(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$R.call(b, prop)) __defNormalProp$R(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$R) {
      var _iterator47 = _createForOfIteratorHelper(__getOwnPropSymbols$R(b)),
          _step47;

      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var prop = _step47.value;
          if (__propIsEnum$R.call(b, prop)) __defNormalProp$R(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
    }

    return a;
  };

  var __objRest$D = function __objRest$D(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$R.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$R) {
      var _iterator48 = _createForOfIteratorHelper(__getOwnPropSymbols$R(source)),
          _step48;

      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var prop = _step48.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$R.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
    }

    return target;
  };

  var InputIcon = function InputIcon(_a) {
    var _b = _a,
        iconClick = _b.iconClick,
        leadingIcon = _b.leadingIcon,
        trailingIcon = _b.trailingIcon,
        variantSize = _b.variantSize,
        color = _b.color,
        disabled = _b.disabled,
        brand = _b.brand,
        props = __objRest$D(_b, ["iconClick", "leadingIcon", "trailingIcon", "variantSize", "color", "disabled", "brand"]);

    return iconClick && trailingIcon ? /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
      brand: brand,
      color: color,
      disabled: disabled,
      leadingIcon: trailingIcon,
      onClick: iconClick,
      size: variantSize,
      sx: {
        alignSelf: "center"
      },
      type: "button"
    }), /* @__PURE__ */React__default["default"].createElement(Spacing, {
      size: "quark",
      variant: "vertical"
    })) : /* @__PURE__ */React__default["default"].createElement(StyledIcon, __spreadValues$R({
      direction: leadingIcon ? "left" : "right",
      disabled: disabled,
      variantSize: variantSize
    }, props), /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: color,
      size: variantSize === "sm" ? "xs" : "md",
      sx: {
        pointerEvents: "none"
      }
    }, trailingIcon || leadingIcon));
  };

  var __defProp$Q = Object.defineProperty;
  var __defProps$A = Object.defineProperties;
  var __getOwnPropDescs$A = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$Q = Object.getOwnPropertySymbols;
  var __hasOwnProp$Q = Object.prototype.hasOwnProperty;
  var __propIsEnum$Q = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$Q = function __defNormalProp$Q(obj, key, value) {
    return key in obj ? __defProp$Q(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$Q = function __spreadValues$Q(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$Q.call(b, prop)) __defNormalProp$Q(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$Q) {
      var _iterator49 = _createForOfIteratorHelper(__getOwnPropSymbols$Q(b)),
          _step49;

      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var prop = _step49.value;
          if (__propIsEnum$Q.call(b, prop)) __defNormalProp$Q(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
    }

    return a;
  };

  var __spreadProps$A = function __spreadProps$A(a, b) {
    return __defProps$A(a, __getOwnPropDescs$A(b));
  };

  var __objRest$C = function __objRest$C(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$Q.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$Q) {
      var _iterator50 = _createForOfIteratorHelper(__getOwnPropSymbols$Q(source)),
          _step50;

      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var prop = _step50.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$Q.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
    }

    return target;
  };

  var Input = React__default["default"].forwardRef(function (_a, _ref37) {
    var _b = _a,
        _b$variantSize = _b.variantSize,
        variantSize = _b$variantSize === void 0 ? "lg" : _b$variantSize,
        _onFocus = _b.onFocus,
        _onChange2 = _b.onChange,
        _onBlur = _b.onBlur,
        width = _b.width,
        height = _b.height,
        sx = _b.sx,
        value = _b.value,
        rest = __objRest$C(_b, ["variantSize", "onFocus", "onChange", "onBlur", "width", "height", "sx", "value"]);

    var _a2;

    var label = rest.label,
        disabled = rest.disabled,
        supportMessage = rest.supportMessage,
        _rest$variant = rest.variant,
        variant = _rest$variant === void 0 ? "default" : _rest$variant,
        leadingIcon = rest.leadingIcon,
        trailingIcon = rest.trailingIcon,
        placeholder = rest.placeholder,
        id = rest.id,
        iconColor = rest.iconColor,
        triggerActive = rest.triggerFocus,
        brand = rest.brand,
        iconClick = rest.iconClick,
        right = rest.right;
    var sharedInputRef = React__default["default"].useRef(null);

    var _React$useState15 = React.useState(false),
        _React$useState16 = _slicedToArray(_React$useState15, 2),
        active = _React$useState16[0],
        setActive = _React$useState16[1];

    var _React__default$defau = React__default["default"].useState(value),
        _React__default$defau2 = _slicedToArray(_React__default$defau, 2),
        controlValue = _React__default$defau2[0],
        setControlValue = _React__default$defau2[1];

    React__default["default"].useEffect(function () {
      if (value !== void 0 && value !== controlValue) {
        setControlValue(value);
      }
    }, [value, controlValue]);

    var handleOnChange = function handleOnChange(e) {
      if (value !== void 0) {
        setControlValue(e.target.value);
      }
    };

    React__default["default"].useEffect(function () {
      var _a3;

      if (value === void 0 && ((_a3 = sharedInputRef.current) == null ? void 0 : _a3.value)) {
        setActive(true);
      }
    }, [value]);
    var isActiveLabel = triggerActive || active || !!controlValue || !!((_a2 = sharedInputRef.current) == null ? void 0 : _a2.value) || !!placeholder;
    var supportVariants = {
      error: "invalid",
      success: "valid"
    };
    var inputColors = getInputColors({
      active: active,
      brand: brand,
      disabled: disabled,
      variant: variant
    });
    return /* @__PURE__ */React__default["default"].createElement(StyledContainer, {
      height: height,
      sx: sx,
      width: width
    }, /* @__PURE__ */React__default["default"].createElement(StyledInputLabelContainer, {
      brand: brand,
      color: inputColors.colorShape,
      disabled: disabled,
      focused: active,
      height: height,
      variantSize: variantSize
    }, /* @__PURE__ */React__default["default"].createElement(InputIcon, {
      color: iconColor || inputColors.colorShape,
      disabled: disabled,
      iconClick: iconClick,
      leadingIcon: leadingIcon,
      variant: variant,
      variantSize: variantSize
    }), /* @__PURE__ */React__default["default"].createElement(StyledLabel, {
      color: inputColors.colorLabel,
      htmlFor: id,
      isActive: isActiveLabel,
      label: label,
      leadingIcon: leadingIcon,
      variant: variant,
      variantSize: variantSize
    }), /* @__PURE__ */React__default["default"].createElement(StyledInput, __spreadProps$A(__spreadValues$Q({
      "aria-disabled": disabled,
      "aria-invalid": variant === "error",
      "aria-placeholder": placeholder,
      "aria-readonly": "true",
      autoCapitalize: "none",
      autoComplete: "off",
      color: inputColors.colorShape,
      disabled: disabled,
      height: height,
      id: id,
      role: "textbox",
      type: "text",
      value: value,
      variant: variant,
      variantSize: variantSize
    }, rest), {
      onBlur: function onBlur(e) {
        return pipe(function () {
          return setActive(false);
        }, function () {
          return _onBlur && _onBlur(e);
        })();
      },
      onChange: function onChange(e) {
        return pipe(function () {
          return handleOnChange(e);
        }, function () {
          return _onChange2 && _onChange2(e);
        })();
      },
      onFocus: function onFocus(e) {
        return pipe(function () {
          return setActive(true);
        }, function () {
          return _onFocus && _onFocus(e);
        })();
      },
      ref: function ref(e) {
        if (_ref37) {
          if (typeof _ref37 === "object") {
            _ref37.current = e;
          } else if (typeof _ref37 === "function") {
            _ref37(e);
          }
        }

        sharedInputRef.current = e;
      }
    })), right && !trailingIcon ? right : /* @__PURE__ */React__default["default"].createElement(InputIcon, {
      brand: brand,
      color: iconColor || inputColors.colorShape,
      disabled: disabled,
      iconClick: iconClick,
      trailingIcon: trailingIcon,
      variant: variant,
      variantSize: variantSize
    })), /* @__PURE__ */React__default["default"].createElement(Wrap, null, typeof supportMessage === "string" ? /* @__PURE__ */React__default["default"].createElement(SupportMessage, {
      brand: brand,
      disabled: disabled,
      value: supportMessage,
      variant: supportVariants[variant]
    }) : supportMessage == null ? void 0 : supportMessage.map(function (suptMsg, i) {
      return /* @__PURE__ */React__default["default"].createElement(WrapItem, {
        key: i,
        mb: "inline.quark",
        mr: "inline.nano"
      }, /* @__PURE__ */React__default["default"].createElement(SupportMessage, {
        brand: brand,
        disabled: disabled,
        tabIndex: i,
        value: suptMsg,
        variant: supportVariants[variant]
      }));
    })));
  });
  var __defProp$P = Object.defineProperty;
  var __defProps$z = Object.defineProperties;
  var __getOwnPropDescs$z = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$P = Object.getOwnPropertySymbols;
  var __hasOwnProp$P = Object.prototype.hasOwnProperty;
  var __propIsEnum$P = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$P = function __defNormalProp$P(obj, key, value) {
    return key in obj ? __defProp$P(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$P = function __spreadValues$P(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$P.call(b, prop)) __defNormalProp$P(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$P) {
      var _iterator51 = _createForOfIteratorHelper(__getOwnPropSymbols$P(b)),
          _step51;

      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var prop = _step51.value;
          if (__propIsEnum$P.call(b, prop)) __defNormalProp$P(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
    }

    return a;
  };

  var __spreadProps$z = function __spreadProps$z(a, b) {
    return __defProps$z(a, __getOwnPropDescs$z(b));
  };

  var __objRest$B = function __objRest$B(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$P.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$P) {
      var _iterator52 = _createForOfIteratorHelper(__getOwnPropSymbols$P(source)),
          _step52;

      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var prop = _step52.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$P.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
    }

    return target;
  };

  var InputPassword = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        variantSize = _b.variantSize,
        disabled = _b.disabled,
        brand = _b.brand,
        props = __objRest$B(_b, ["variantSize", "disabled", "brand"]);

    var _React$useState17 = React.useState(true),
        _React$useState18 = _slicedToArray(_React$useState17, 2),
        passwordShown = _React$useState18[0],
        setPasswordShown = _React$useState18[1];

    function toggleVisibility() {
      setPasswordShown(!passwordShown);
    }

    function renderIcon(showPassword) {
      if (showPassword) {
        return /* @__PURE__ */React__default["default"].createElement(almaIcons.ViewOn, null);
      }

      return /* @__PURE__ */React__default["default"].createElement(almaIcons.ViewOff, null);
    }

    function getInputType(showPassword) {
      if (showPassword) {
        return "password";
      }

      return "text";
    }

    function getInputRole(showPassword) {
      if (showPassword) {
        return void 0;
      }

      return "textbox";
    }

    return /* @__PURE__ */React__default["default"].createElement(Input, __spreadProps$z(__spreadValues$P({
      brand: brand,
      disabled: disabled,
      right: /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
        brand: brand,
        disabled: disabled,
        leadingIcon: renderIcon(passwordShown),
        onClick: toggleVisibility,
        size: variantSize,
        sx: {
          alignSelf: "center"
        },
        type: "button"
      }), /* @__PURE__ */React__default["default"].createElement(Spacing, {
        size: "quark",
        variant: "vertical"
      })),
      role: getInputRole(passwordShown),
      variantSize: variantSize
    }, props), {
      ref: ref,
      type: getInputType(passwordShown)
    }));
  });
  var __defProp$O = Object.defineProperty;
  var __defProps$y = Object.defineProperties;
  var __getOwnPropDescs$y = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$O = Object.getOwnPropertySymbols;
  var __hasOwnProp$O = Object.prototype.hasOwnProperty;
  var __propIsEnum$O = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$O = function __defNormalProp$O(obj, key, value) {
    return key in obj ? __defProp$O(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$O = function __spreadValues$O(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$O.call(b, prop)) __defNormalProp$O(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$O) {
      var _iterator53 = _createForOfIteratorHelper(__getOwnPropSymbols$O(b)),
          _step53;

      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var prop = _step53.value;
          if (__propIsEnum$O.call(b, prop)) __defNormalProp$O(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    }

    return a;
  };

  var __spreadProps$y = function __spreadProps$y(a, b) {
    return __defProps$y(a, __getOwnPropDescs$y(b));
  };

  var interactionAcessibleElementBaseStyle = {
    bg: "interaction.blend.02",
    borderRadius: "circle",
    display: "block",
    height: "40px",
    position: "absolute",
    transform: "translateX(-8px)",
    transition: "background-color 0.12s ease-in",
    width: "40px",
    zIndex: 1
  };

  var getTextColor = function getTextColor(_ref38) {
    var brand = _ref38.brand,
        disabled = _ref38.disabled;

    if (brand) {
      if (!disabled) {
        return {
          color: "typeface.on.brand.pure"
        };
      }

      return {
        color: "typeface.on.brand.meld"
      };
    } else if (disabled) {
      return {
        color: "typeface.meld"
      };
    }

    return {
      color: "typeface.pure"
    };
  };

  var radioStyle = function radioStyle(_ref39) {
    var brand = _ref39.brand,
        disabled = _ref39.disabled;

    var getHoverBackground = function getHoverBackground() {
      if (disabled) {
        return "transparent";
      }

      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };

    var getActiveBackground = function getActiveBackground() {
      if (disabled) {
        return "transparent";
      }

      return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
    };

    return {
      "&:active": {
        span: __spreadProps$y(__spreadValues$O({}, interactionAcessibleElementBaseStyle), {
          bg: getActiveBackground(),
          borderStyle: "none"
        })
      },
      "&:focus, &:focus-visible": {
        span: __spreadProps$y(__spreadValues$O({}, interactionAcessibleElementBaseStyle), {
          bg: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02",
          borderColor: brand ? "interaction.on.brand.blend.04" : "interaction.blend.05",
          borderStyle: "solid",
          borderWidth: "thin",
          transform: "translateX(-10px)"
        })
      },
      "&:hover": {
        span: __spreadProps$y(__spreadValues$O({}, interactionAcessibleElementBaseStyle), {
          bg: getHoverBackground(),
          fill: brand ? "interaction.select.focus" : "interaction.on.brand.select.focus"
        })
      },
      alignItems: "center",
      input: {
        "&:checked": {
          "~ svg": {
            color: brand ? "interaction.on.brand.select.active" : "interaction.select.active"
          }
        },
        "&:disabled": {
          "~ svg": {
            color: brand ? "interaction.on.brand.blend.04" : "interaction.blend.04"
          }
        },
        "&:focus": {
          "~ svg": {
            bg: "transparent"
          }
        },
        "~ svg": {
          color: brand ? "interaction.on.brand.select.default" : "interaction.select.default"
        }
      }
    };
  };

  var __defProp$N = Object.defineProperty;
  var __defProps$x = Object.defineProperties;
  var __getOwnPropDescs$x = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$N = Object.getOwnPropertySymbols;
  var __hasOwnProp$N = Object.prototype.hasOwnProperty;
  var __propIsEnum$N = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$N = function __defNormalProp$N(obj, key, value) {
    return key in obj ? __defProp$N(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$N = function __spreadValues$N(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$N.call(b, prop)) __defNormalProp$N(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$N) {
      var _iterator54 = _createForOfIteratorHelper(__getOwnPropSymbols$N(b)),
          _step54;

      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var prop = _step54.value;
          if (__propIsEnum$N.call(b, prop)) __defNormalProp$N(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
    }

    return a;
  };

  var __spreadProps$x = function __spreadProps$x(a, b) {
    return __defProps$x(a, __getOwnPropDescs$x(b));
  };

  var __objRest$A = function __objRest$A(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$N.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$N) {
      var _iterator55 = _createForOfIteratorHelper(__getOwnPropSymbols$N(source)),
          _step55;

      try {
        for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
          var prop = _step55.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$N.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator55.e(err);
      } finally {
        _iterator55.f();
      }
    }

    return target;
  };

  var Radio = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        sx = _b.sx,
        props = __objRest$A(_b, ["sx"]);

    var _a2 = props,
        label = _a2.label,
        value = _a2.value,
        disabled = _a2.disabled,
        rest = __objRest$A(_a2, ["label", "value", "disabled"]);

    return /* @__PURE__ */React__default["default"].createElement(themeUi.Label, {
      sx: __spreadValues$N(__spreadValues$N({}, radioStyle(props)), sx)
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      as: "span"
    }), /* @__PURE__ */React__default["default"].createElement(themeUi.Radio, __spreadProps$x(__spreadValues$N({
      disabled: disabled,
      value: value,
      width: 24
    }, rest), {
      ref: ref
    })), /* @__PURE__ */React__default["default"].createElement(Body, {
      ml: "inline.nano",
      sx: __spreadValues$N({}, getTextColor(props))
    }, label));
  });
  var __defProp$M = Object.defineProperty;
  var __defProps$w = Object.defineProperties;
  var __getOwnPropDescs$w = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$M = Object.getOwnPropertySymbols;
  var __hasOwnProp$M = Object.prototype.hasOwnProperty;
  var __propIsEnum$M = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$M = function __defNormalProp$M(obj, key, value) {
    return key in obj ? __defProp$M(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$M = function __spreadValues$M(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$M.call(b, prop)) __defNormalProp$M(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$M) {
      var _iterator56 = _createForOfIteratorHelper(__getOwnPropSymbols$M(b)),
          _step56;

      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var prop = _step56.value;
          if (__propIsEnum$M.call(b, prop)) __defNormalProp$M(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }
    }

    return a;
  };

  var __spreadProps$w = function __spreadProps$w(a, b) {
    return __defProps$w(a, __getOwnPropDescs$w(b));
  };

  var getInputBoxStyle = function getInputBoxStyle(brand) {
    return {
      "::-webkit-search-decoration, ::-webkit-search-cancel-button, ::-webkit-search-results-button, ::-webkit-search-results-decoration": {
        MozAppearance: "none",
        WebkitAppearance: "none",
        appearance: "none",
        display: "none"
      },
      ":disabled": {
        cursor: "not-allowed"
      },
      ":focus": {
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.blend.02",
        borderBottomWidth: "thin",
        borderColor: brand ? "interaction.inverse.blend.08" : "interaction.select.active",
        borderLeftWidth: "none",
        borderRightWidth: "none",
        borderTopWidth: "none"
      },
      ":hover:enabled": {
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.blend.02"
      },
      backgroundColor: brand ? "interaction.inverse.blend.02" : "interaction.blend.01",
      borderBottomLeftRadius: "none",
      borderBottomRightRadius: "none",
      borderBottomWidth: "hairline",
      borderColor: brand ? "interaction.inverse.blend.07" : "interaction.select.default",
      borderLeftWidth: "none",
      borderRightWidth: "none",
      borderStyle: "solid",
      borderTopLeftRadius: "xs",
      borderTopRightRadius: "xs",
      borderTopWidth: "none",
      width: "100%"
    };
  };

  var getMagnifierIconSize = function getMagnifierIconSize(variantSize) {
    return variantSize === "lg" ? 26 : 20;
  };

  var getCustomStyle = function getCustomStyle(variantSize) {
    var baseObject = {
      padding: getVerticalSpacing(variantSize).string,
      paddingLeft: "".concat(parseInt(getVerticalSpacing(variantSize).themeUi, 10) * 2 + getMagnifierIconSize(variantSize), "px"),
      paddingRight: "".concat(parseInt(getVerticalSpacing(variantSize).themeUi, 10) * 2 + 18, "px")
    };

    if (variantSize === "lg") {
      baseObject["height"] = "56px";
    } else {
      baseObject["height"] = "32px";
    }

    return baseObject;
  };

  var getVerticalSpacing = function getVerticalSpacing(variantSize) {
    if (variantSize === "lg") {
      return {
        string: "xxxs",
        themeUi: defaultTheme$1.space.inline.xxxs
      };
    }

    return {
      string: "nano",
      themeUi: defaultTheme$1.space.inline.nano
    };
  };

  var getFontStyle = function getFontStyle(_ref40) {
    var variantSize = _ref40.variantSize,
        brand = _ref40.brand;
    var fontStyleObject = {
      "::placeholder": {
        color: brand ? "typeface.on.brand.pure" : "typeface.smooth"
      },
      "::selection": {
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.subtle.02"
      },
      color: brand ? "typeface.on.brand.pure" : "typeface.smooth",
      fontFamily: "base",
      fontStyle: "normal",
      fontWeight: "normal"
    };

    if (variantSize === "lg") {
      return __spreadProps$w(__spreadValues$M({}, fontStyleObject), {
        fontSize: "xs"
      });
    }

    return __spreadProps$w(__spreadValues$M({}, fontStyleObject), {
      fontSize: "xxs"
    });
  };

  var getSearchStyle = function getSearchStyle(_ref41) {
    var variantSize = _ref41.variantSize,
        brand = _ref41.brand;
    return __spreadValues$M(__spreadValues$M(__spreadValues$M({}, getInputBoxStyle(brand)), getFontStyle({
      brand: brand,
      variantSize: variantSize
    })), getCustomStyle(variantSize));
  };

  var getMagnifierIconStyle = function getMagnifierIconStyle(_ref42) {
    var variantSize = _ref42.variantSize,
        focused = _ref42.focused,
        hovered = _ref42.hovered,
        brand = _ref42.brand;
    var iconColor;

    if (focused) {
      iconColor = {
        "& > svg > path": {
          fill: brand ? "interaction.inverse.blend.08" : "interaction.select.active"
        }
      };
    } else if (hovered) {
      iconColor = {
        "& > svg > path": {
          fill: brand ? "interaction.inverse.blend.07" : "interaction.select.focus"
        }
      };
    } else {
      iconColor = {
        "& > svg > path": {
          fill: brand ? "interaction.inverse.blend.07" : "interaction.select.default"
        }
      };
    }

    return __spreadValues$M({
      "& > svg": {
        height: "100%",
        width: "100%"
      },
      height: "".concat(getMagnifierIconSize(variantSize), "px"),
      left: getVerticalSpacing(variantSize).themeUi,
      pointerEvents: "none",
      position: "absolute",
      top: "calc(50% - ".concat(getMagnifierIconSize(variantSize) / 2, "px)"),
      width: "".concat(getMagnifierIconSize(variantSize), "px")
    }, iconColor);
  };

  var getClearIconStyle = function getClearIconStyle(_ref43) {
    var brand = _ref43.brand,
        variantSize = _ref43.variantSize;
    return {
      cursor: "pointer",
      position: "absolute",
      right: getVerticalSpacing(variantSize).themeUi
    };
  };

  var __defProp$L = Object.defineProperty;
  var __defProps$v = Object.defineProperties;
  var __getOwnPropDescs$v = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$L = Object.getOwnPropertySymbols;
  var __hasOwnProp$L = Object.prototype.hasOwnProperty;
  var __propIsEnum$L = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$L = function __defNormalProp$L(obj, key, value) {
    return key in obj ? __defProp$L(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$L = function __spreadValues$L(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$L.call(b, prop)) __defNormalProp$L(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$L) {
      var _iterator57 = _createForOfIteratorHelper(__getOwnPropSymbols$L(b)),
          _step57;

      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var prop = _step57.value;
          if (__propIsEnum$L.call(b, prop)) __defNormalProp$L(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }
    }

    return a;
  };

  var __spreadProps$v = function __spreadProps$v(a, b) {
    return __defProps$v(a, __getOwnPropDescs$v(b));
  };

  var __objRest$z = function __objRest$z(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$L.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$L) {
      var _iterator58 = _createForOfIteratorHelper(__getOwnPropSymbols$L(source)),
          _step58;

      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var prop = _step58.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$L.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
    }

    return target;
  };

  var Search = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        value = _b.value,
        defaultValue = _b.defaultValue,
        disabled = _b.disabled,
        placeholder = _b.placeholder,
        _b$variantSize2 = _b.variantSize,
        variantSize = _b$variantSize2 === void 0 ? "lg" : _b$variantSize2,
        _onBlur2 = _b.onBlur,
        _onFocus2 = _b.onFocus,
        _onChange3 = _b.onChange,
        _onMouseEnter = _b.onMouseEnter,
        _onMouseLeave = _b.onMouseLeave,
        onClear = _b.onClear,
        sx = _b.sx,
        otherProps = __objRest$z(_b, ["brand", "value", "defaultValue", "disabled", "placeholder", "variantSize", "onBlur", "onFocus", "onChange", "onMouseEnter", "onMouseLeave", "onClear", "sx"]);

    var _React$useState19 = React.useState(false),
        _React$useState20 = _slicedToArray(_React$useState19, 2),
        focused = _React$useState20[0],
        setFocused = _React$useState20[1];

    var _React$useState21 = React.useState(false),
        _React$useState22 = _slicedToArray(_React$useState21, 2),
        hovered = _React$useState22[0],
        setHovered = _React$useState22[1];

    var _React$useState23 = React.useState(defaultValue || value),
        _React$useState24 = _slicedToArray(_React$useState23, 2),
        controlValue = _React$useState24[0],
        setValue = _React$useState24[1];

    React.useEffect(function () {
      if (value) {
        setValue(value);
      }
    }, [value]);
    return /* @__PURE__ */React__default["default"].createElement(Center, {
      sx: __spreadValues$L(__spreadValues$L({}, {
        opacity: disabled ? defaultTheme$1.opacities["07"] : 1,
        position: "relative"
      }), sx)
    }, /* @__PURE__ */React__default["default"].createElement(Icon, {
      sx: getMagnifierIconStyle({
        brand: brand,
        focused: focused,
        hovered: hovered,
        variantSize: variantSize
      })
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.Search, null)), /* @__PURE__ */React__default["default"].createElement(themeUi.Input, __spreadProps$v(__spreadValues$L({
      autoComplete: "off",
      dir: "auto",
      disabled: disabled,
      placeholder: placeholder,
      role: "combobox",
      spellCheck: "false",
      sx: getSearchStyle({
        brand: brand,
        variantSize: variantSize
      }),
      type: "search",
      value: controlValue || ""
    }, otherProps), {
      onBlur: function onBlur(e) {
        if (!disabled) {
          setFocused(false);
        }

        if (_onBlur2) {
          _onBlur2(e);
        }
      },
      onChange: function onChange(e) {
        setValue(e.target.value);

        if (_onChange3) {
          _onChange3(e);
        }
      },
      onFocus: function onFocus(e) {
        if (!disabled) {
          setFocused(true);
        }

        if (_onFocus2) {
          _onFocus2(e);
        }
      },
      onMouseEnter: function onMouseEnter(e) {
        if (!disabled) {
          setHovered(true);
        }

        if (_onMouseEnter) {
          _onMouseEnter(e);
        }
      },
      onMouseLeave: function onMouseLeave(e) {
        if (!disabled) {
          setHovered(false);
        }

        if (_onMouseLeave) {
          _onMouseLeave(e);
        }
      },
      ref: ref
    })), !disabled && controlValue && /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
      id: "search-element-id",
      leadingIcon: /* @__PURE__ */React__default["default"].createElement(almaIcons.Close, null),
      onClick: function onClick() {
        setValue("");

        if (onClear) {
          onClear();
        }
      },
      size: "sm",
      sx: getClearIconStyle({
        brand: brand,
        focused: focused,
        hovered: hovered,
        variantSize: variantSize
      }),
      type: "button"
    }));
  });
  var titleStyle = {
    color: "typeface.strong",
    fontFamily: "base",
    fontSize: "xs",
    fontWeight: "bold",
    letterSpacing: "standard",
    lineHeight: "superdistant",
    padding: "inset.quark",
    width: "calc(100% - ".concat(parseInt(defaultTheme$1.space.inset.md, 10), "px)")
  };

  var getMessageStyle$1 = function getMessageStyle$1(linkProps) {
    var baseObject = {
      margin: 0,
      paddingLeft: "inset.quark",
      paddingRight: "inset.quark",
      whiteSpace: "pre-wrap",
      width: "calc(100% - ".concat(parseInt(defaultTheme$1.space.inset.md, 10), "px)")
    };

    if (linkProps) {
      baseObject["marginBottom"] = "stack.nano";
    }

    return baseObject;
  };

  var linkStyle = {
    alignItems: "center",
    display: "flex",
    marginTop: "stack.nano",
    paddingLeft: "inset.quark",
    paddingRight: "inset.quark",
    textDecoration: "none",
    width: "calc(100% - ".concat(parseInt(defaultTheme$1.space.inset.md, 10), "px)")
  };
  var iconTypeStyle$1 = {
    height: "inset.md",
    left: "inset.xs",
    position: "absolute",
    top: "inset.xs",
    width: "inset.md"
  };
  var closeButtonStyle = {
    position: "absolute",
    right: "inset.xs",
    top: "inset.xs"
  };

  var getContentStyle$1 = function getContentStyle$1(variant, open, bottomDistance) {
    var containerStyle = {
      alignItems: "flex-start",
      backgroundColor: "neutral.00",
      borderColor: "neutral.30",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "hairline",
      bottom: open ? bottomDistance : -100,
      boxShadow: defaultTheme$1.shadows["02"],
      flexDirection: "column",
      padding: "inset.xs",
      position: "relative",
      transition: "bottom 0.3s ease-in",
      width: "320px"
    };

    if (variant !== "simple") {
      containerStyle["paddingLeft"] = "".concat(parseInt(defaultTheme$1.space.inset.xs, 10) + parseInt(defaultTheme$1.space.inset.md, 10), "px");
    }

    return containerStyle;
  };

  var getContainerStyle$3 = function getContainerStyle$3(zIndex) {
    return {
      "&.show": {
        visibility: "visible"
      },
      alignItems: "flex-end",
      bottom: 0,
      display: "flex",
      height: "100%",
      justifyContent: "center",
      left: 0,
      overflow: "hidden",
      position: "absolute",
      visibility: "hidden",
      width: "100%",
      zIndex: zIndex
    };
  };

  var __defProp$K = Object.defineProperty;
  var __defProps$u = Object.defineProperties;
  var __getOwnPropDescs$u = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$K = Object.getOwnPropertySymbols;
  var __hasOwnProp$K = Object.prototype.hasOwnProperty;
  var __propIsEnum$K = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$K = function __defNormalProp$K(obj, key, value) {
    return key in obj ? __defProp$K(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$K = function __spreadValues$K(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$K.call(b, prop)) __defNormalProp$K(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$K) {
      var _iterator59 = _createForOfIteratorHelper(__getOwnPropSymbols$K(b)),
          _step59;

      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var prop = _step59.value;
          if (__propIsEnum$K.call(b, prop)) __defNormalProp$K(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }
    }

    return a;
  };

  var __spreadProps$u = function __spreadProps$u(a, b) {
    return __defProps$u(a, __getOwnPropDescs$u(b));
  };

  var __objRest$y = function __objRest$y(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$K.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$K) {
      var _iterator60 = _createForOfIteratorHelper(__getOwnPropSymbols$K(source)),
          _step60;

      try {
        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
          var prop = _step60.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$K.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator60.e(err);
      } finally {
        _iterator60.f();
      }
    }

    return target;
  };

  var isSmallProp$1 = function isSmallProp$1(variant) {
    return variant === "sm";
  };

  var LinkInline = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant5 = _b.variant,
        variant = _b$variant5 === void 0 ? "lg" : _b$variant5,
        props = __objRest$y(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadProps$u(__spreadValues$K({
      as: "a",
      color: getColorTypfaceTokenByProp(props, "pure"),
      css: {
        textDecoration: "underline"
      },
      fontFamily: "base",
      fontSize: isSmallProp$1(variant) ? "xxs" : "xs",
      letterSpacing: "standard",
      lineHeight: isSmallProp$1(variant) ? "huge" : "superdistant"
    }, props), {
      ref: ref
    }));
  });
  var __defProp$J = Object.defineProperty;
  var __getOwnPropSymbols$J = Object.getOwnPropertySymbols;
  var __hasOwnProp$J = Object.prototype.hasOwnProperty;
  var __propIsEnum$J = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$J = function __defNormalProp$J(obj, key, value) {
    return key in obj ? __defProp$J(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$J = function __spreadValues$J(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$J.call(b, prop)) __defNormalProp$J(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$J) {
      var _iterator61 = _createForOfIteratorHelper(__getOwnPropSymbols$J(b)),
          _step61;

      try {
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          var prop = _step61.value;
          if (__propIsEnum$J.call(b, prop)) __defNormalProp$J(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
    }

    return a;
  };

  var getCustomAttributes = function getCustomAttributes(variant) {
    var customAttributes = {};

    switch (variant) {
      case "lg":
        customAttributes["fontSize"] = "xs";
        customAttributes["height"] = "32px";
        customAttributes["lineHeight"] = "medium";
        break;

      case "sm":
        customAttributes["fontSize"] = "xxs";
        customAttributes["height"] = "24px";
        customAttributes["lineHeight"] = "standard";
        break;
    }

    return customAttributes;
  };

  var getContainerStyle$2 = function getContainerStyle$2(brand, variant) {
    var getInteractionAttributes = function getInteractionAttributes(defaultColor, brandColor) {
      return {
        "& > p": {
          borderBottomColor: brand ? brandColor : defaultColor,
          borderBottomStyle: "solid",
          borderBottomWidth: "thin",
          color: "inherit"
        }
      };
    };

    return __spreadValues$J({
      "& > p": {
        borderBottomColor: "transparent",
        borderBottomStyle: "solid",
        borderBottomWidth: "thin",
        color: "inherit",
        fontSize: "inherit",
        lineHeight: "inherit",
        paddingTop: "1px"
      },
      ":active": __spreadValues$J({
        color: brand ? "interaction.inverse.blend.08" : "interaction.select.active"
      }, getInteractionAttributes("interaction.select.active", "interaction.inverse.blend.08")),
      ":focus:not(:active)": __spreadValues$J({
        borderColor: brand ? "interaction.inverse.blend.08" : "interaction.select.focus",
        borderStyle: "solid",
        borderWidth: "thin",
        color: brand ? "interaction.inverse.blend.08" : "interaction.select.focus"
      }, getInteractionAttributes("interaction.select.focus", "interaction.inverse.blend.08")),
      ":hover:not(:active)": __spreadValues$J({
        color: brand ? "interaction.inverse.blend.08" : "interaction.select.focus"
      }, getInteractionAttributes("interaction.select.focus", "interaction.inverse.blend.08")),
      alignItems: "center",
      borderColor: "transparent",
      borderStyle: "solid",
      borderWidth: "thin",
      boxSizing: "border-box",
      color: brand ? "interaction.inverse.blend.07" : "interaction.select.default",
      display: "inline-flex",
      margin: 0,
      padding: "inline.quark",
      textDecoration: "none"
    }, getCustomAttributes(variant));
  };

  var getDisabledContainerStyle = function getDisabledContainerStyle(brand, variant) {
    return __spreadValues$J({
      "& > p": {
        borderBottomColor: "transparent",
        borderBottomStyle: "solid",
        borderBottomWidth: "thin",
        color: "inherit",
        fontSize: "inherit",
        lineHeight: "inherit",
        paddingTop: "1px"
      },
      alignItems: "center",
      color: brand ? "interaction.inverse.blend.05" : "typeface.meld",
      display: "inline-flex",
      margin: 0,
      padding: "inline.quark",
      textDecoration: "none"
    }, getCustomAttributes(variant));
  };

  var __defProp$I = Object.defineProperty;
  var __defProps$t = Object.defineProperties;
  var __getOwnPropDescs$t = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$I = Object.getOwnPropertySymbols;
  var __hasOwnProp$I = Object.prototype.hasOwnProperty;
  var __propIsEnum$I = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$I = function __defNormalProp$I(obj, key, value) {
    return key in obj ? __defProp$I(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$I = function __spreadValues$I(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$I.call(b, prop)) __defNormalProp$I(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$I) {
      var _iterator62 = _createForOfIteratorHelper(__getOwnPropSymbols$I(b)),
          _step62;

      try {
        for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
          var prop = _step62.value;
          if (__propIsEnum$I.call(b, prop)) __defNormalProp$I(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator62.e(err);
      } finally {
        _iterator62.f();
      }
    }

    return a;
  };

  var __spreadProps$t = function __spreadProps$t(a, b) {
    return __defProps$t(a, __getOwnPropDescs$t(b));
  };

  var __objRest$x = function __objRest$x(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$I.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$I) {
      var _iterator63 = _createForOfIteratorHelper(__getOwnPropSymbols$I(source)),
          _step63;

      try {
        for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
          var prop = _step63.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$I.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator63.e(err);
      } finally {
        _iterator63.f();
      }
    }

    return target;
  };

  var LinkStandalone = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        disabled = _b.disabled,
        href = _b.href,
        leadingIcon = _b.leadingIcon,
        trailingIcon = _b.trailingIcon,
        label = _b.label,
        target = _b.target,
        sx = _b.sx,
        variant = _b.variant,
        props = __objRest$x(_b, ["brand", "disabled", "href", "leadingIcon", "trailingIcon", "label", "target", "sx", "variant"]);

    var getIconSize = function getIconSize() {
      switch (variant) {
        case "lg":
          return "md";

        case "sm":
          return "xs";

        default:
          return "md";
      }
    };

    var renderContent = function renderContent() {
      return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, leadingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
        size: getIconSize(),
        sx: {
          marginRight: "10px"
        }
      }, leadingIcon), /* @__PURE__ */React__default["default"].createElement(Body, null, label), trailingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
        size: getIconSize(),
        sx: {
          marginLeft: "10px"
        }
      }, trailingIcon));
    };

    if (disabled) {
      return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$t(__spreadValues$I({}, props), {
        ref: ref,
        sx: __spreadValues$I(__spreadValues$I({}, getDisabledContainerStyle(brand, variant)), sx),
        tabIndex: 0
      }), renderContent());
    }

    return /* @__PURE__ */React__default["default"].createElement(LinkInline, __spreadProps$t(__spreadValues$I({}, props), {
      href: href,
      onMouseUp: function onMouseUp(evt) {
        evt.currentTarget.blur();

        if (props.onMouseUp) {
          props.onMouseUp(evt);
        }
      },
      ref: ref,
      sx: __spreadValues$I(__spreadValues$I({}, getContainerStyle$2(brand, variant)), sx),
      tabIndex: 0,
      target: target,
      variant: variant
    }), renderContent());
  });
  var __defProp$H = Object.defineProperty;
  var __defProps$s = Object.defineProperties;
  var __getOwnPropDescs$s = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$H = Object.getOwnPropertySymbols;
  var __hasOwnProp$H = Object.prototype.hasOwnProperty;
  var __propIsEnum$H = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$H = function __defNormalProp$H(obj, key, value) {
    return key in obj ? __defProp$H(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$H = function __spreadValues$H(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$H.call(b, prop)) __defNormalProp$H(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$H) {
      var _iterator64 = _createForOfIteratorHelper(__getOwnPropSymbols$H(b)),
          _step64;

      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var prop = _step64.value;
          if (__propIsEnum$H.call(b, prop)) __defNormalProp$H(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
    }

    return a;
  };

  var __spreadProps$s = function __spreadProps$s(a, b) {
    return __defProps$s(a, __getOwnPropDescs$s(b));
  };

  var __objRest$w = function __objRest$w(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$H.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$H) {
      var _iterator65 = _createForOfIteratorHelper(__getOwnPropSymbols$H(source)),
          _step65;

      try {
        for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
          var prop = _step65.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$H.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator65.e(err);
      } finally {
        _iterator65.f();
      }
    }

    return target;
  };

  var Toast = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$bottomDistance = _b.bottomDistance,
        bottomDistance = _b$bottomDistance === void 0 ? 100 : _b$bottomDistance,
        className = _b.className,
        _b$duration = _b.duration,
        duration = _b$duration === void 0 ? 3e3 : _b$duration,
        onClose = _b.onClose,
        _b$variant6 = _b.variant,
        variant = _b$variant6 === void 0 ? "simple" : _b$variant6,
        supportIcon = _b.supportIcon,
        linkProps = _b.linkProps,
        message = _b.message,
        open = _b.open,
        sx = _b.sx,
        title = _b.title,
        zIndex = _b.zIndex,
        otherProps = __objRest$w(_b, ["bottomDistance", "className", "duration", "onClose", "variant", "supportIcon", "linkProps", "message", "open", "sx", "title", "zIndex"]);

    var renderToastTypeIcon = function renderToastTypeIcon() {
      var iconColor = "";
      var IconToRender = null;

      switch (variant) {
        case "success":
          iconColor = "feedback.success.shape";
          IconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.CheckRound, null);
          break;

        case "error":
          iconColor = "feedback.error.shape";
          IconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.WarningRound, null);
          break;

        case "custom":
          IconToRender = supportIcon ? supportIcon : /* @__PURE__ */React__default["default"].createElement(almaIcons.App, null);
          break;
      }

      if (IconToRender) {
        return /* @__PURE__ */React__default["default"].createElement(Icon, {
          color: iconColor,
          size: "md",
          sx: iconTypeStyle$1
        }, IconToRender);
      }

      return null;
    };

    var openRef = React.useRef(false);
    React.useEffect(function () {
      if (duration) {
        var openTimeout;

        if (!openRef.current && open) {
          openTimeout = window.setTimeout(function () {
            onClose && onClose(false);
          }, duration);
        }

        if (openRef.current !== open) {
          openRef.current = open;
        }

        return function () {
          return clearTimeout(openTimeout);
        };
      }

      return;
    });
    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$s(__spreadValues$H({}, otherProps), {
      className: "".concat(className ? className : "", " ").concat(open ? "show" : ""),
      ref: ref,
      sx: __spreadValues$H(__spreadValues$H({}, getContainerStyle$3(zIndex)), sx)
    }), /* @__PURE__ */React__default["default"].createElement(Center, {
      ref: ref,
      sx: getContentStyle$1(variant, open, bottomDistance)
    }, renderToastTypeIcon(), title && /* @__PURE__ */React__default["default"].createElement(themeUi.Heading, {
      as: "h3",
      sx: titleStyle
    }, title), message && /* @__PURE__ */React__default["default"].createElement(Body, {
      sx: getMessageStyle$1(linkProps),
      variant: "sm"
    }, message), /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
      leadingIcon: /* @__PURE__ */React__default["default"].createElement(almaIcons.Close, null),
      onClick: function onClick() {
        return onClose && onClose(false);
      },
      size: "sm",
      sx: closeButtonStyle
    }), linkProps && /* @__PURE__ */React__default["default"].createElement(LinkStandalone, {
      href: linkProps.href,
      label: linkProps.label,
      sx: linkStyle,
      target: linkProps.target,
      trailingIcon: linkProps.icon,
      variant: "sm"
    })));
  });
  var __defProp$G = Object.defineProperty;
  var __getOwnPropSymbols$G = Object.getOwnPropertySymbols;
  var __hasOwnProp$G = Object.prototype.hasOwnProperty;
  var __propIsEnum$G = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$G = function __defNormalProp$G(obj, key, value) {
    return key in obj ? __defProp$G(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$G = function __spreadValues$G(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$G.call(b, prop)) __defNormalProp$G(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$G) {
      var _iterator66 = _createForOfIteratorHelper(__getOwnPropSymbols$G(b)),
          _step66;

      try {
        for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
          var prop = _step66.value;
          if (__propIsEnum$G.call(b, prop)) __defNormalProp$G(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator66.e(err);
      } finally {
        _iterator66.f();
      }
    }

    return a;
  };

  var getMessageStyle = function getMessageStyle(actionButton) {
    var baseObject = {
      margin: 0,
      maxHeight: "96px",
      overflow: "auto",
      paddingY: "stack.quark",
      position: "relative"
    };

    if (actionButton) {
      baseObject["marginRight"] = "inline.xxxs";
    }

    return baseObject;
  };

  var iconTypeStyle = {
    marginRight: "inline.xxxs"
  };

  var getAnchorOrigin = function getAnchorOrigin(anchorOrigin, bottomDistance, horizontalDistance, open) {
    if (anchorOrigin) {
      return __spreadValues$G(__spreadValues$G(__spreadValues$G(__spreadValues$G({}, (anchorOrigin == null ? void 0 : anchorOrigin.vertical) === "top" ? {
        alignSelf: "start",
        top: open ? bottomDistance : -100,
        transition: "top 0.3s ease-in"
      } : {
        alignSelf: "end",
        bottom: open ? bottomDistance : -100,
        transition: "bottom 0.3s ease-in"
      }), (anchorOrigin == null ? void 0 : anchorOrigin.horizontal) === "left" && {
        left: horizontalDistance,
        marginRight: "auto"
      }), (anchorOrigin == null ? void 0 : anchorOrigin.horizontal) === "center" && {
        marginLeft: "auto",
        marginRight: "auto"
      }), (anchorOrigin == null ? void 0 : anchorOrigin.horizontal) === "right" && {
        marginLeft: "auto",
        right: horizontalDistance
      });
    }

    return {
      bottom: open ? bottomDistance : -100,
      transition: "bottom 0.3s ease-in"
    };
  };

  var getContentStyle = function getContentStyle(anchorOrigin, bottomDistance, horizontalDistance, open) {
    return __spreadValues$G({
      alignItems: "center",
      backgroundColor: "neutral.00",
      borderColor: "neutral.30",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "hairline",
      boxShadow: defaultTheme$1.shadows["02"],
      display: "flex",
      padding: "squish.nano",
      pointerEvents: "auto",
      position: "relative"
    }, getAnchorOrigin(anchorOrigin, bottomDistance, horizontalDistance, open));
  };

  var getContainerStyle$1 = function getContainerStyle$1(zIndex) {
    return {
      "&.show": {
        visibility: "visible"
      },
      alignItems: "flex-end",
      bottom: 0,
      display: "flex",
      height: "100%",
      justifyContent: "center",
      left: 0,
      overflow: "hidden",
      pointerEvents: "none",
      position: "absolute",
      visibility: "hidden",
      width: "100%",
      zIndex: zIndex
    };
  };

  var __defProp$F = Object.defineProperty;
  var __defProps$r = Object.defineProperties;
  var __getOwnPropDescs$r = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$F = Object.getOwnPropertySymbols;
  var __hasOwnProp$F = Object.prototype.hasOwnProperty;
  var __propIsEnum$F = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$F = function __defNormalProp$F(obj, key, value) {
    return key in obj ? __defProp$F(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$F = function __spreadValues$F(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$F.call(b, prop)) __defNormalProp$F(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$F) {
      var _iterator67 = _createForOfIteratorHelper(__getOwnPropSymbols$F(b)),
          _step67;

      try {
        for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
          var prop = _step67.value;
          if (__propIsEnum$F.call(b, prop)) __defNormalProp$F(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator67.e(err);
      } finally {
        _iterator67.f();
      }
    }

    return a;
  };

  var __spreadProps$r = function __spreadProps$r(a, b) {
    return __defProps$r(a, __getOwnPropDescs$r(b));
  };

  var __objRest$v = function __objRest$v(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$F.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$F) {
      var _iterator68 = _createForOfIteratorHelper(__getOwnPropSymbols$F(source)),
          _step68;

      try {
        for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
          var prop = _step68.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$F.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator68.e(err);
      } finally {
        _iterator68.f();
      }
    }

    return target;
  };

  var Snackbar = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        actionButton = _b.actionButton,
        anchorOrigin = _b.anchorOrigin,
        _b$bottomDistance2 = _b.bottomDistance,
        bottomDistance = _b$bottomDistance2 === void 0 ? 8 : _b$bottomDistance2,
        _b$horizontalDistance = _b.horizontalDistance,
        horizontalDistance = _b$horizontalDistance === void 0 ? 8 : _b$horizontalDistance,
        _b$duration2 = _b.duration,
        duration = _b$duration2 === void 0 ? 3e3 : _b$duration2,
        message = _b.message,
        onClose = _b.onClose,
        open = _b.open,
        sx = _b.sx,
        _b$variant7 = _b.variant,
        variant = _b$variant7 === void 0 ? "simple" : _b$variant7,
        supportIcon = _b.supportIcon,
        zIndex = _b.zIndex,
        otherProps = __objRest$v(_b, ["actionButton", "anchorOrigin", "bottomDistance", "horizontalDistance", "duration", "message", "onClose", "open", "sx", "variant", "supportIcon", "zIndex"]);

    var renderSnackbarTypeIcon = function renderSnackbarTypeIcon() {
      var iconColor = "";
      var IconToRender = null;

      switch (variant) {
        case "success":
          iconColor = "feedback.success.shape";
          IconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.CheckRound, null);
          break;

        case "error":
          iconColor = "feedback.error.shape";
          IconToRender = /* @__PURE__ */React__default["default"].createElement(almaIcons.WarningRound, null);
          break;

        case "custom":
          IconToRender = supportIcon ? supportIcon : /* @__PURE__ */React__default["default"].createElement(almaIcons.App, null);
          break;
      }

      if (IconToRender) {
        return /* @__PURE__ */React__default["default"].createElement(Icon, {
          color: iconColor,
          sx: iconTypeStyle
        }, IconToRender);
      }

      return null;
    };

    var openRef = React.useRef(false);
    React.useEffect(function () {
      var openTimeout;

      if (!openRef.current && open) {
        openTimeout = window.setTimeout(function () {
          onClose && onClose(false);
        }, duration);
      }

      if (openRef.current !== open) {
        openRef.current = open;
      }

      return function () {
        return clearTimeout(openTimeout);
      };
    });
    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$r(__spreadValues$F({
      sx: __spreadValues$F(__spreadValues$F({}, getContainerStyle$1(zIndex)), sx)
    }, otherProps), {
      className: open ? "show" : "",
      ref: ref
    }), /* @__PURE__ */React__default["default"].createElement(Center, {
      sx: getContentStyle(anchorOrigin, bottomDistance, horizontalDistance, open)
    }, renderSnackbarTypeIcon(), /* @__PURE__ */React__default["default"].createElement(Body, {
      sx: getMessageStyle(actionButton),
      variant: "sm"
    }, message), actionButton && /* @__PURE__ */React__default["default"].createElement(Button, {
      onClick: function onClick() {
        return actionButton.onClick && actionButton.onClick();
      },
      size: "sm",
      variant: "tertiary"
    }, actionButton.label)));
  });
  var __defProp$E = Object.defineProperty;
  var __defProps$q = Object.defineProperties;
  var __getOwnPropDescs$q = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$E = Object.getOwnPropertySymbols;
  var __hasOwnProp$E = Object.prototype.hasOwnProperty;
  var __propIsEnum$E = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$E = function __defNormalProp$E(obj, key, value) {
    return key in obj ? __defProp$E(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$E = function __spreadValues$E(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$E.call(b, prop)) __defNormalProp$E(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$E) {
      var _iterator69 = _createForOfIteratorHelper(__getOwnPropSymbols$E(b)),
          _step69;

      try {
        for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
          var prop = _step69.value;
          if (__propIsEnum$E.call(b, prop)) __defNormalProp$E(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator69.e(err);
      } finally {
        _iterator69.f();
      }
    }

    return a;
  };

  var __spreadProps$q = function __spreadProps$q(a, b) {
    return __defProps$q(a, __getOwnPropDescs$q(b));
  };

  var __objRest$u = function __objRest$u(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$E.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$E) {
      var _iterator70 = _createForOfIteratorHelper(__getOwnPropSymbols$E(source)),
          _step70;

      try {
        for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
          var prop = _step70.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$E.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator70.e(err);
      } finally {
        _iterator70.f();
      }
    }

    return target;
  };

  var headingVariantStyle = {
    lg: {
      fontSize: "xs"
    },
    md: {
      fontSize: "xxs",
      lineHeight: "tiny"
    },
    sm: {
      fontSize: "xxxs",
      letterSpacing: "standard",
      lineHeight: "distant"
    }
  };
  var TextInteraction = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        _b$variant8 = _b.variant,
        variant = _b$variant8 === void 0 ? "lg" : _b$variant8,
        props = __objRest$u(_b, ["brand", "variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadProps$q(__spreadValues$E({
      color: brand ? "interaction.on.brand.select.default" : "interaction.select.default",
      fontFamily: "base",
      fontWeight: "medium",
      letterSpacing: "standard",
      lineHeight: "superdistant",
      ref: ref
    }, props), {
      sx: __spreadValues$E(__spreadValues$E({}, headingVariantStyle[variant]), props.sx)
    }));
  });
  var __defProp$D = Object.defineProperty;
  var __getOwnPropSymbols$D = Object.getOwnPropertySymbols;
  var __hasOwnProp$D = Object.prototype.hasOwnProperty;
  var __propIsEnum$D = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$D = function __defNormalProp$D(obj, key, value) {
    return key in obj ? __defProp$D(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$D = function __spreadValues$D(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$D.call(b, prop)) __defNormalProp$D(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$D) {
      var _iterator71 = _createForOfIteratorHelper(__getOwnPropSymbols$D(b)),
          _step71;

      try {
        for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
          var prop = _step71.value;
          if (__propIsEnum$D.call(b, prop)) __defNormalProp$D(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator71.e(err);
      } finally {
        _iterator71.f();
      }
    }

    return a;
  };

  var getTabStyle = function getTabStyle(brand, disabled, active) {
    var getActiveStyle = function getActiveStyle(isActive) {
      if (isActive) {
        return {
          borderBottomColor: brand ? "interaction.on.brand.select.active" : "interaction.select.active",
          borderBottomWidth: "thin",
          color: brand ? "interaction.on.brand.select.active" : "interaction.select.active"
        };
      }

      return {};
    };

    var getDisabledStyle = function getDisabledStyle() {
      if (disabled) {
        return {
          borderBottomColor: "transparent",
          borderBottomStyle: "solid",
          borderBottomWidth: "thin",
          borderTopColor: "transparent",
          borderTopStyle: "solid",
          borderTopWidth: "thin",
          color: brand ? "typeface.on.brand.meld" : "typeface.meld",
          cursor: "not-allowed"
        };
      }

      return {
        ":active": __spreadValues$D({}, getActiveStyle(true)),
        ":focus:not(:active)": {
          borderColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          borderStyle: "solid",
          borderWidth: "thin",
          color: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          margin: -2
        },
        ":hover:not(:active)": {
          borderBottomColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          borderBottomWidth: "thin",
          color: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus"
        }
      };
    };

    return __spreadValues$D(__spreadValues$D({
      borderBottomColor: brand ? "interaction.on.brand.blend.04" : "interaction.blend.04",
      borderBottomStyle: "solid",
      borderBottomWidth: "hairline",
      borderTopColor: "transparent",
      borderTopStyle: "solid",
      borderTopWidth: "thin",
      color: brand ? "interaction.on.brand.select.default" : "interaction.select.default",
      cursor: "pointer",
      display: "inline-block",
      margin: 0,
      padding: "inset.xs",
      textAlign: "center"
    }, getActiveStyle(active)), getDisabledStyle());
  };

  var getTabContained = function getTabContained(brand, disabled, active) {
    var getActiveStyle = function getActiveStyle(isActive) {
      if (isActive) {
        return {
          backgroundColor: "transparent",
          borderTopColor: brand ? "interaction.on.brand.select.active" : "interaction.select.active",
          borderTopWidth: "thin",
          color: brand ? "interaction.on.brand.select.active" : "interaction.select.active"
        };
      }

      return {};
    };

    var getDisabledStyle = function getDisabledStyle() {
      if (disabled) {
        return {
          backgroundColor: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
          borderBottomColor: "transparent",
          borderBottomStyle: "solid",
          borderBottomWidth: "thin",
          borderTopColor: "transparent",
          borderTopStyle: "solid",
          borderTopWidth: "thin",
          color: brand ? "interaction.inverse.blend.05" : "typeface.meld",
          cursor: "not-allowed"
        };
      }

      return {
        ":active": __spreadValues$D({}, getActiveStyle(true)),
        ":focus:not(:active)": {
          backgroundColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02",
          borderColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          borderStyle: "solid",
          borderWidth: "thin",
          color: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          margin: -2
        },
        ":hover:not(:active)": {
          backgroundColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02",
          borderTopColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          color: brand ? "interaction.inverse.blend.08" : "interaction.select.focus"
        }
      };
    };

    return __spreadValues$D(__spreadValues$D({
      backgroundColor: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
      borderBottomColor: "transparent",
      borderBottomStyle: "solid",
      borderBottomWidth: "thin",
      borderTopColor: "transparent",
      borderTopStyle: "solid",
      borderTopWidth: "thin",
      color: brand ? "interaction.on.brand.select.default" : "interaction.select.default",
      cursor: "pointer",
      display: "inline-block",
      margin: 0,
      padding: "inset.xs",
      textAlign: "center"
    }, getActiveStyle(active)), getDisabledStyle());
  };

  var getTabContainerStyle = function getTabContainerStyle(position) {
    var getPosition = function getPosition() {
      switch (position) {
        case "left":
          return "flex-start";

        case "right":
          return "flex-end";

        case "center":
          return "center";

        default:
          return "center";
      }
    };

    return {
      alignItems: "center",
      display: "flex",
      justifyContent: getPosition()
    };
  };

  var __defProp$C = Object.defineProperty;
  var __defProps$p = Object.defineProperties;
  var __getOwnPropDescs$p = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$C = Object.getOwnPropertySymbols;
  var __hasOwnProp$C = Object.prototype.hasOwnProperty;
  var __propIsEnum$C = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$C = function __defNormalProp$C(obj, key, value) {
    return key in obj ? __defProp$C(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$C = function __spreadValues$C(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$C.call(b, prop)) __defNormalProp$C(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$C) {
      var _iterator72 = _createForOfIteratorHelper(__getOwnPropSymbols$C(b)),
          _step72;

      try {
        for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
          var prop = _step72.value;
          if (__propIsEnum$C.call(b, prop)) __defNormalProp$C(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator72.e(err);
      } finally {
        _iterator72.f();
      }
    }

    return a;
  };

  var __spreadProps$p = function __spreadProps$p(a, b) {
    return __defProps$p(a, __getOwnPropDescs$p(b));
  };

  var __objRest$t = function __objRest$t(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$C.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$C) {
      var _iterator73 = _createForOfIteratorHelper(__getOwnPropSymbols$C(source)),
          _step73;

      try {
        for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
          var prop = _step73.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$C.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator73.e(err);
      } finally {
        _iterator73.f();
      }
    }

    return target;
  };

  var Tab = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        active = _b.active,
        brand = _b.brand,
        contained = _b.contained,
        sx = _b.sx,
        disabled = _b.disabled,
        label = _b.label,
        handleClick = _b.handleClick,
        tabName = _b.tabName,
        props = __objRest$t(_b, ["active", "brand", "contained", "sx", "disabled", "label", "handleClick", "tabName"]);

    var tabStyle = contained ? __spreadValues$C({}, getTabContained(brand, disabled, active)) : __spreadValues$C({}, getTabStyle(brand, disabled, active));

    var setActive = function setActive(evt) {
      evt.preventDefault();

      if (tabName && handleClick && !disabled) {
        handleClick(tabName, evt);
        return evt.currentTarget.blur();
      }
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$p(__spreadValues$C({}, props), {
      ref: ref
    }), /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      "aria-controls": String(tabName),
      "aria-selected": active,
      brand: brand,
      onClick: setActive,
      sx: __spreadValues$C(__spreadValues$C({}, tabStyle), sx),
      tabIndex: 0,
      variant: "md"
    }, label));
  });
  var TabContainer = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        position = _d.position,
        props = __objRest$t(_d, ["position"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$p(__spreadValues$C({}, props), {
      ref: ref,
      sx: getTabContainerStyle(position)
    }));
  });
  var TabPanesContainer = React__default["default"].forwardRef(function (_ref44, ref) {
    var _ref44$activeTab = _ref44.activeTab,
        activeTab = _ref44$activeTab === void 0 ? "" : _ref44$activeTab,
        children = _ref44.children;
    var childWithProps = React__default["default"].Children.map(children, function (child) {
      var _a;

      if (!React__default["default"].isValidElement(child)) {
        return child;
      }

      var isTabSelected = Boolean(activeTab) && activeTab === ((_a = child == null ? void 0 : child.props) == null ? void 0 : _a.tabName);
      return React__default["default"].cloneElement(child, {
        ref: ref,
        selected: isTabSelected
      });
    });
    return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, childWithProps);
  });
  var TabPane = React__default["default"].forwardRef(function (_e, ref) {
    var _f = _e,
        _f$selected = _f.selected,
        selected = _f$selected === void 0 ? false : _f$selected,
        _f$forceRerender = _f.forceRerender,
        forceRerender = _f$forceRerender === void 0 ? false : _f$forceRerender,
        tabName = _f.tabName,
        props = __objRest$t(_f, ["selected", "forceRerender", "tabName"]);

    var _React$useState25 = React.useState(false),
        _React$useState26 = _slicedToArray(_React$useState25, 2),
        wasSelected = _React$useState26[0],
        setSelectedSituation = _React$useState26[1];

    React.useLayoutEffect(function () {
      if (!wasSelected && selected) {
        setSelectedSituation(selected);
      }
    }, [wasSelected, selected, forceRerender]);
    var shouldRender = forceRerender ? selected : wasSelected;

    if (!shouldRender) {
      return null;
    }

    return selected ? /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$C({
      "aria-labelledby": tabName,
      ref: ref,
      role: "tabpanel",
      tabIndex: 0
    }, props)) : null;
  });

  var getIconColor = function getIconColor(_ref45, suffix) {
    var brand = _ref45.brand,
        disabled = _ref45.disabled;

    if (disabled) {
      return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
    }

    return brand ? "support.on.brand.".concat(suffix) : "support.".concat(suffix);
  };

  var getContainerStyle = function getContainerStyle(props) {
    var brand = props.brand,
        disabled = props.disabled;
    return {
      "& > *": {
        cursor: disabled ? "not-allowed" : "auto"
      },
      "&:active": {
        bg: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02"
      },
      "&:focus:not(:active)": {
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        borderColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.08",
        borderStyle: "solid",
        borderWidth: "thin"
      },
      "&:hover:not(:active)": {
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        "div span > svg": {
          color: getIconColor(props, "02")
        }
      },
      display: "flex",
      "div span > svg": {
        color: getIconColor(props, "01")
      },
      flexDirection: "column",
      minWidth: 320,
      transition: "all 300ms ease-in-out"
    };
  };

  var wrapperStyle = {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    lineHeight: "20%",
    width: "100%"
  };

  var getTextDisabledColor = function getTextDisabledColor(_ref46) {
    var brand = _ref46.brand,
        disabled = _ref46.disabled;

    if (disabled) {
      return {
        color: brand ? "typeface.on.brand.meld" : "typeface.meld"
      };
    }

    return {
      color: ""
    };
  };

  var __defProp$B = Object.defineProperty;
  var __defProps$o = Object.defineProperties;
  var __getOwnPropDescs$o = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$B = Object.getOwnPropertySymbols;
  var __hasOwnProp$B = Object.prototype.hasOwnProperty;
  var __propIsEnum$B = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$B = function __defNormalProp$B(obj, key, value) {
    return key in obj ? __defProp$B(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$B = function __spreadValues$B(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$B.call(b, prop)) __defNormalProp$B(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$B) {
      var _iterator74 = _createForOfIteratorHelper(__getOwnPropSymbols$B(b)),
          _step74;

      try {
        for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
          var prop = _step74.value;
          if (__propIsEnum$B.call(b, prop)) __defNormalProp$B(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator74.e(err);
      } finally {
        _iterator74.f();
      }
    }

    return a;
  };

  var __spreadProps$o = function __spreadProps$o(a, b) {
    return __defProps$o(a, __getOwnPropDescs$o(b));
  };

  var __objRest$s = function __objRest$s(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$B.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$B) {
      var _iterator75 = _createForOfIteratorHelper(__getOwnPropSymbols$B(source)),
          _step75;

      try {
        for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
          var prop = _step75.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$B.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator75.e(err);
      } finally {
        _iterator75.f();
      }
    }

    return target;
  };

  var renderLabel = function renderLabel(props) {
    var brand = props.brand,
        center = props.center,
        children = props.children,
        labelText = props.labelText;
    return /* @__PURE__ */React__default["default"].createElement(Action, {
      brand: brand,
      fontWeight: "medium",
      lineHeight: "superdistant",
      sx: getTextDisabledColor(props)
    }, center || children, labelText);
  };

  var renderDate = function renderDate(props) {
    var brand = props.brand,
        dateText = props.dateText;
    return dateText ? /* @__PURE__ */React__default["default"].createElement(Body, {
      brand: brand,
      lineHeight: 0,
      sx: getTextDisabledColor(props),
      variant: "sm"
    }, dateText) : null;
  };

  var renderBodyText = function renderBodyText(props) {
    var brand = props.brand,
        bodyText = props.bodyText,
        leadingIcon = props.leadingIcon;
    return bodyText ? /* @__PURE__ */React__default["default"].createElement(Box, {
      p: 0,
      pl: leadingIcon ? "inline.xs" : "",
      pt: "inline.nano"
    }, /* @__PURE__ */React__default["default"].createElement(Body, {
      brand: brand,
      sx: getTextDisabledColor(props),
      variant: "sm"
    }, bodyText)) : null;
  };

  var ListItem = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        sx = _b.sx,
        props = __objRest$s(_b, ["sx"]);

    var _a2 = props,
        dividerColor = _a2.dividerColor,
        left = _a2.left,
        leadingIcon = _a2.leadingIcon,
        bodyText = _a2.bodyText,
        brand = _a2.brand,
        labelText = _a2.labelText,
        dateText = _a2.dateText,
        noDivider = _a2.noDivider,
        _a2$insetSpace = _a2.insetSpace,
        insetSpace = _a2$insetSpace === void 0 ? "inset.xs" : _a2$insetSpace,
        disabled = _a2.disabled,
        rest = __objRest$s(_a2, ["dividerColor", "left", "leadingIcon", "bodyText", "brand", "labelText", "dateText", "noDivider", "insetSpace", "disabled"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadValues$B({
      as: "li",
      p: 0,
      sx: __spreadProps$o(__spreadValues$B({}, getContainerStyle(props)), {
        sx: sx
      })
    }, rest), /* @__PURE__ */React__default["default"].createElement(Box, {
      p: insetSpace,
      ref: ref
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: wrapperStyle
    }, left || leadingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      mr: "inline.nano"
    }, leadingIcon), renderLabel(props), /* @__PURE__ */React__default["default"].createElement(Spacer, null), renderDate(props)), renderBodyText(props)), !noDivider && /* @__PURE__ */React__default["default"].createElement(Divider, {
      brand: brand,
      sx: dividerColor ? {
        bg: dividerColor
      } : void 0
    }));
  });
  var __defProp$A = Object.defineProperty;
  var __getOwnPropSymbols$A = Object.getOwnPropertySymbols;
  var __hasOwnProp$A = Object.prototype.hasOwnProperty;
  var __propIsEnum$A = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$A = function __defNormalProp$A(obj, key, value) {
    return key in obj ? __defProp$A(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$A = function __spreadValues$A(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$A.call(b, prop)) __defNormalProp$A(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$A) {
      var _iterator76 = _createForOfIteratorHelper(__getOwnPropSymbols$A(b)),
          _step76;

      try {
        for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
          var prop = _step76.value;
          if (__propIsEnum$A.call(b, prop)) __defNormalProp$A(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator76.e(err);
      } finally {
        _iterator76.f();
      }
    }

    return a;
  };

  var getLabelStyle = function getLabelStyle(brand, disabled) {
    var getFontColor = function getFontColor() {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }

      return "";
    };

    return {
      color: getFontColor(),
      margin: 0,
      paddingLeft: "inline.nano",
      textAlign: "left"
    };
  };

  var getCheckboxStyle = function getCheckboxStyle(brand, checked, disabled) {
    var getBackgroundColor = function getBackgroundColor() {
      if (disabled) {
        return brand ? "interaction.inverse.blend.04" : "interaction.blend.03";
      } else if (checked) {
        return brand ? "interaction.inverse.blend.07" : "interaction.select.active";
      }

      return brand ? "interaction.inverse.blend.07" : "interaction.select.default";
    };

    var getStateBackgroundColor = function getStateBackgroundColor() {
      if (checked) {
        return brand ? "interaction.inverse.blend.08" : "interaction.select.active";
      }

      return brand ? "interaction.inverse.blend.08" : "interaction.select.focus";
    };

    return {
      ":active:not(:disabled), :focus:not(:disabled), :hover:not(:disabled)": {
        backgroundColor: getStateBackgroundColor()
      },
      backgroundColor: getBackgroundColor(),
      border: "none",
      borderRadius: "pill",
      height: "100%",
      position: "relative",
      width: "100%"
    };
  };

  var getSliderStyle = function getSliderStyle(brand, checked, hovered, focused, active, disabled) {
    var getPositionStyle = function getPositionStyle() {
      if (checked) {
        return {
          left: "auto",
          right: "inset.quark"
        };
      }

      return {
        left: "inset.quark",
        right: "auto"
      };
    };

    var getStatusStyle = function getStatusStyle() {
      if (active) {
        return {
          backgroundColor: brand ? "interaction.inverse.blend.04" : "interaction.blend.03"
        };
      } else if (focused) {
        return {
          borderColor: brand ? "interaction.inverse.blend.05" : "interaction.blend.05"
        };
      }

      return {};
    };

    var getBackgroundColor = function getBackgroundColor() {
      if (disabled) {
        return brand ? "neutral.inverse.on.brand.30" : "interaction.inverse.blend.07";
      }

      return brand ? "interaction.accent.01" : "neutral.00";
    };

    return __spreadValues$A({
      "::before": __spreadValues$A({
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.blend.02",
        borderColor: "transparent",
        borderRadius: "circle",
        borderStyle: "solid",
        borderWidth: "thin",
        content: hovered || focused ? "''" : void 0,
        height: 40,
        left: "calc(50% - 22px)",
        position: "absolute",
        top: "calc(50% - 22px)",
        width: 40,
        zIndex: -1
      }, getStatusStyle()),
      backgroundColor: getBackgroundColor(),
      borderRadius: "circle",
      bottom: "inset.quark",
      boxShadow: "01",
      height: 16,
      pointerEvents: "none",
      position: "absolute",
      top: "inset.quark",
      width: 16
    }, getPositionStyle());
  };

  var __defProp$z = Object.defineProperty;
  var __defProps$n = Object.defineProperties;
  var __getOwnPropDescs$n = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$z = Object.getOwnPropertySymbols;
  var __hasOwnProp$z = Object.prototype.hasOwnProperty;
  var __propIsEnum$z = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$z = function __defNormalProp$z(obj, key, value) {
    return key in obj ? __defProp$z(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$z = function __spreadValues$z(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$z.call(b, prop)) __defNormalProp$z(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$z) {
      var _iterator77 = _createForOfIteratorHelper(__getOwnPropSymbols$z(b)),
          _step77;

      try {
        for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
          var prop = _step77.value;
          if (__propIsEnum$z.call(b, prop)) __defNormalProp$z(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator77.e(err);
      } finally {
        _iterator77.f();
      }
    }

    return a;
  };

  var __spreadProps$n = function __spreadProps$n(a, b) {
    return __defProps$n(a, __getOwnPropDescs$n(b));
  };

  var __objRest$r = function __objRest$r(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$z.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$z) {
      var _iterator78 = _createForOfIteratorHelper(__getOwnPropSymbols$z(source)),
          _step78;

      try {
        for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
          var prop = _step78.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$z.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator78.e(err);
      } finally {
        _iterator78.f();
      }
    }

    return target;
  };

  var Switch = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        checked = _b.checked,
        defaultChecked = _b.defaultChecked,
        _b$disabled2 = _b.disabled,
        disabled = _b$disabled2 === void 0 ? false : _b$disabled2,
        id = _b.id,
        _b$label = _b.label,
        label = _b$label === void 0 ? "" : _b$label,
        _onChange4 = _b.onChange,
        _onBlur3 = _b.onBlur,
        _onFocus3 = _b.onFocus,
        sx = _b.sx,
        props = __objRest$r(_b, ["brand", "checked", "defaultChecked", "disabled", "id", "label", "onChange", "onBlur", "onFocus", "sx"]);

    var _React__default$defau3 = React__default["default"].useState(false),
        _React__default$defau4 = _slicedToArray(_React__default$defau3, 2),
        hovered = _React__default$defau4[0],
        setHovered = _React__default$defau4[1];

    var _React__default$defau5 = React__default["default"].useState(false),
        _React__default$defau6 = _slicedToArray(_React__default$defau5, 2),
        focused = _React__default$defau6[0],
        setFocused = _React__default$defau6[1];

    var _React__default$defau7 = React__default["default"].useState(false),
        _React__default$defau8 = _slicedToArray(_React__default$defau7, 2),
        active = _React__default$defau8[0],
        setActive = _React__default$defau8[1];

    var getControlledCheckedInitial = function getControlledCheckedInitial() {
      if (typeof defaultChecked === "boolean") {
        return defaultChecked;
      } else if (typeof checked === "boolean") {
        return checked;
      }

      return false;
    };

    var _React__default$defau9 = React__default["default"].useState(getControlledCheckedInitial()),
        _React__default$defau10 = _slicedToArray(_React__default$defau9, 2),
        controlledChecked = _React__default$defau10[0],
        setControlledChecked = _React__default$defau10[1];

    React__default["default"].useEffect(function () {
      if (typeof checked === "boolean" && checked !== controlledChecked) {
        setControlledChecked(checked);
      }
    }, [checked, controlledChecked]);
    return /* @__PURE__ */React__default["default"].createElement(themeUi.Label, {
      htmlFor: id,
      onMouseDown: function onMouseDown() {
        return !disabled && setActive(true);
      },
      onMouseEnter: function onMouseEnter() {
        return !disabled && setHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return !disabled && setHovered(false);
      },
      onMouseUp: function onMouseUp() {
        return !disabled && setActive(false);
      },
      sx: __spreadValues$z({
        display: "flex"
      }, sx),
      tabIndex: -1
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        height: 24,
        position: "relative",
        width: 48
      }
    }, /* @__PURE__ */React__default["default"].createElement(themeUi.Input, __spreadProps$n(__spreadValues$z({}, props), {
      "aria-checked": !!checked,
      "aria-readonly": disabled,
      checked: checked,
      defaultChecked: defaultChecked,
      disabled: disabled,
      id: id,
      onBlur: function onBlur(evt) {
        if (_onBlur3) {
          _onBlur3(evt);
        }

        !disabled && setFocused(false);
      },
      onChange: function onChange(evt) {
        if (_onChange4) {
          _onChange4(evt);
        }

        setControlledChecked(evt.target.checked);
      },
      onFocus: function onFocus(evt) {
        if (_onFocus3) {
          _onFocus3(evt);
        }

        !disabled && setFocused(true);
      },
      ref: ref,
      role: "switch",
      sx: getCheckboxStyle(brand, controlledChecked, disabled),
      tabIndex: 0,
      type: "checkbox"
    })), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: getSliderStyle(brand, controlledChecked, hovered, focused, active, disabled)
    })), /* @__PURE__ */React__default["default"].createElement(Body, {
      brand: brand,
      sx: getLabelStyle(brand, disabled),
      variant: "lg"
    }, label));
  });

  function objectFilter(object, fn) {
    var result = {};
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      var shouldPass = fn(value, key, object);

      if (shouldPass) {
        result[key] = value;
      }
    });
    return result;
  }

  var filterUndefined = function filterUndefined(object) {
    return objectFilter(object, function (val) {
      return val !== null && val !== void 0;
    });
  };

  var StyledGrid = styled__default["default"](themeUi.Grid)(_templateObject5(), GRID, COMMON);

  var getGridStyle = function getGridStyle() {
    return {
      height: "100%",
      position: "relative",
      width: "100%"
    };
  };

  var getSpan = function getSpan(value) {
    return mapResponsive(value, function (prop) {
      return prop === "auto" ? "auto" : "span ".concat(prop, "/span ").concat(prop);
    });
  };

  var getGridItemStyle = function getGridItemStyle(props) {
    return filterUndefined({
      gridColumn: getSpan(props.colSpan),
      gridColumnEnd: props.colEnd,
      gridColumnStart: props.colStart,
      gridRow: getSpan(props.rowSpan),
      gridRowEnd: props.rowEnd,
      gridRowStart: props.rowStart
    });
  };

  var __defProp$y = Object.defineProperty;
  var __defProps$m = Object.defineProperties;
  var __getOwnPropDescs$m = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
  var __hasOwnProp$y = Object.prototype.hasOwnProperty;
  var __propIsEnum$y = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$y = function __defNormalProp$y(obj, key, value) {
    return key in obj ? __defProp$y(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$y = function __spreadValues$y(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$y.call(b, prop)) __defNormalProp$y(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$y) {
      var _iterator79 = _createForOfIteratorHelper(__getOwnPropSymbols$y(b)),
          _step79;

      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var prop = _step79.value;
          if (__propIsEnum$y.call(b, prop)) __defNormalProp$y(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
    }

    return a;
  };

  var __spreadProps$m = function __spreadProps$m(a, b) {
    return __defProps$m(a, __getOwnPropDescs$m(b));
  };

  var __objRest$q = function __objRest$q(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$y.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$y) {
      var _iterator80 = _createForOfIteratorHelper(__getOwnPropSymbols$y(source)),
          _step80;

      try {
        for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
          var prop = _step80.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$y.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator80.e(err);
      } finally {
        _iterator80.f();
      }
    }

    return target;
  };

  var Grid = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        children = _b.children,
        props = __objRest$q(_b, ["children"]);

    return /* @__PURE__ */React__default["default"].createElement(StyledGrid, __spreadProps$m(__spreadValues$y({
      columns: [6, 8, 8, 12],
      gap: ["inline.nano", "inline.xxxs", "inline.xxs", "inline.xxs"],
      paddingX: ["inline.xxxs", "inline.xxxs", "inline.xxs", "inline.xxs"]
    }, props), {
      ref: ref,
      sx: __spreadValues$y(__spreadValues$y({}, getGridStyle()), props.sx)
    }), children);
  });
  var GridItem = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        colSpan = _d.colSpan,
        rowSpan = _d.rowSpan,
        colStart = _d.colStart,
        colEnd = _d.colEnd,
        rowStart = _d.rowStart,
        rowEnd = _d.rowEnd,
        children = _d.children,
        props = __objRest$q(_d, ["colSpan", "rowSpan", "colStart", "colEnd", "rowStart", "rowEnd", "children"]);

    return /* @__PURE__ */React__default["default"].createElement(StyledGrid, __spreadProps$m(__spreadValues$y({}, props), {
      ref: ref,
      sx: __spreadValues$y(__spreadValues$y({}, getGridItemStyle({
        colEnd: colEnd,
        colSpan: colSpan,
        colStart: colStart,
        rowEnd: rowEnd,
        rowSpan: rowSpan,
        rowStart: rowStart
      })), props.sx)
    }), children);
  });

  var getBreadcrumbStyle = function getBreadcrumbStyle(onClick) {
    return {
      cursor: onClick ? "pointer" : "default",
      margin: 0,
      padding: "inset.quark"
    };
  };

  var __defProp$x = Object.defineProperty;
  var __defProps$l = Object.defineProperties;
  var __getOwnPropDescs$l = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
  var __hasOwnProp$x = Object.prototype.hasOwnProperty;
  var __propIsEnum$x = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$x = function __defNormalProp$x(obj, key, value) {
    return key in obj ? __defProp$x(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$x = function __spreadValues$x(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$x.call(b, prop)) __defNormalProp$x(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$x) {
      var _iterator81 = _createForOfIteratorHelper(__getOwnPropSymbols$x(b)),
          _step81;

      try {
        for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
          var prop = _step81.value;
          if (__propIsEnum$x.call(b, prop)) __defNormalProp$x(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator81.e(err);
      } finally {
        _iterator81.f();
      }
    }

    return a;
  };

  var __spreadProps$l = function __spreadProps$l(a, b) {
    return __defProps$l(a, __getOwnPropDescs$l(b));
  };

  var __objRest$p = function __objRest$p(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$x.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$x) {
      var _iterator82 = _createForOfIteratorHelper(__getOwnPropSymbols$x(source)),
          _step82;

      try {
        for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
          var prop = _step82.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$x.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator82.e(err);
      } finally {
        _iterator82.f();
      }
    }

    return target;
  };

  var Breadcrumb = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        index = _b.index,
        isCurrentIndex = _b.isCurrentIndex,
        label = _b.label,
        handleClick = _b.handleClick,
        sx = _b.sx,
        props = __objRest$p(_b, ["brand", "index", "isCurrentIndex", "label", "handleClick", "sx"]);

    var setActive = function setActive() {
      handleClick && handleClick(index);
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$l(__spreadValues$x({}, props), {
      onClick: function onClick(e) {
        setActive();

        if (props.onClick) {
          props.onClick(e);
        }
      },
      sx: __spreadValues$x(__spreadValues$x({}, getBreadcrumbStyle(!!handleClick)), sx)
    }), /* @__PURE__ */React__default["default"].createElement(LinkStandalone, {
      "aria-current": isCurrentIndex,
      "aria-label": label,
      brand: brand,
      label: label,
      ref: ref,
      variant: "sm"
    }));
  });
  var BreadcrumbContainer = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        activeIndex = _d.activeIndex,
        brand = _d.brand,
        children = _d.children,
        props = __objRest$p(_d, ["activeIndex", "brand", "children"]);

    var renderChildrens = function renderChildrens() {
      if (Array.isArray(children)) {
        var renderSeparator = function renderSeparator(canRender, idx) {
          return canRender && /* @__PURE__ */React__default["default"].createElement(Box, {
            height: 16,
            key: "".concat(idx, "-s"),
            ml: "inline.nano",
            mr: "inline.nano"
          }, /* @__PURE__ */React__default["default"].createElement(Divider, {
            brand: brand,
            variant: "vertical"
          }));
        };

        return children.map(function (ChildrenItem, idx) {
          if (idx > activeIndex) {
            return null;
          }

          return [renderSeparator(idx > 0, idx), ChildrenItem];
        });
      }

      return children;
    };

    return /* @__PURE__ */React__default["default"].createElement(Flex, __spreadProps$l(__spreadValues$x({
      alignItems: "center",
      justifyContent: "center",
      tabIndex: 0
    }, props), {
      ref: ref
    }), renderChildrens());
  });
  var __defProp$w = Object.defineProperty;
  var __defProps$k = Object.defineProperties;
  var __getOwnPropDescs$k = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
  var __hasOwnProp$w = Object.prototype.hasOwnProperty;
  var __propIsEnum$w = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$w = function __defNormalProp$w(obj, key, value) {
    return key in obj ? __defProp$w(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$w = function __spreadValues$w(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$w.call(b, prop)) __defNormalProp$w(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$w) {
      var _iterator83 = _createForOfIteratorHelper(__getOwnPropSymbols$w(b)),
          _step83;

      try {
        for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
          var prop = _step83.value;
          if (__propIsEnum$w.call(b, prop)) __defNormalProp$w(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator83.e(err);
      } finally {
        _iterator83.f();
      }
    }

    return a;
  };

  var __spreadProps$k = function __spreadProps$k(a, b) {
    return __defProps$k(a, __getOwnPropDescs$k(b));
  };

  var __objRest$o = function __objRest$o(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$w.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$w) {
      var _iterator84 = _createForOfIteratorHelper(__getOwnPropSymbols$w(source)),
          _step84;

      try {
        for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
          var prop = _step84.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$w.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator84.e(err);
      } finally {
        _iterator84.f();
      }
    }

    return target;
  };

  var PaginationArrow = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$arrowWay = _b.arrowWay,
        arrowWay = _b$arrowWay === void 0 ? "left" : _b$arrowWay,
        brand = _b.brand,
        disabled = _b.disabled,
        props = __objRest$o(_b, ["arrowWay", "brand", "disabled"]);

    var getIconColor = function getIconColor() {
      if (disabled) {
        return brand ? "interaction.inverse.blend.05" : "typeface.meld";
      }

      return brand ? "interaction.inverse.blend.08" : "interaction.select.active";
    };

    return /* @__PURE__ */React__default["default"].createElement(Flex, {
      alignItems: "center",
      as: "li"
    }, /* @__PURE__ */React__default["default"].createElement(ButtonIcon, __spreadProps$k(__spreadValues$w({
      brand: brand,
      color: getIconColor(),
      disabled: disabled,
      leadingIcon: arrowWay === "left" ? /* @__PURE__ */React__default["default"].createElement(almaIcons.ChevronLeftSm, null) : /* @__PURE__ */React__default["default"].createElement(almaIcons.ChevronRightSm, null),
      size: "sm"
    }, props), {
      ref: ref
    })));
  });

  var getValueColor = function getValueColor(brand, selected, disabled) {
    if (disabled) {
      return brand ? "interaction.inverse.blend.05" : "typeface.meld";
    }

    if (selected) {
      return brand ? "interaction.select.active" : "interaction.inverse.blend.08";
    }

    return brand ? "interaction.inverse.blend.08" : "interaction.select.active";
  };

  var getTextStyle$1 = function getTextStyle$1(brand, selected, disabled) {
    var getColorOnInteraction = function getColorOnInteraction() {
      if (!selected) {
        return brand ? "interaction.inverse.blend.08" : "interaction.select.focus";
      }

      return "";
    };

    return {
      "&:focus, &:hover": {
        color: getColorOnInteraction()
      },
      color: getValueColor(brand, selected, disabled)
    };
  };

  var __defProp$v = Object.defineProperty;
  var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
  var __hasOwnProp$v = Object.prototype.hasOwnProperty;
  var __propIsEnum$v = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$v = function __defNormalProp$v(obj, key, value) {
    return key in obj ? __defProp$v(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$v = function __spreadValues$v(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$v.call(b, prop)) __defNormalProp$v(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$v) {
      var _iterator85 = _createForOfIteratorHelper(__getOwnPropSymbols$v(b)),
          _step85;

      try {
        for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
          var prop = _step85.value;
          if (__propIsEnum$v.call(b, prop)) __defNormalProp$v(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator85.e(err);
      } finally {
        _iterator85.f();
      }
    }

    return a;
  };

  var PaginationItem = React__default["default"].forwardRef(function (props, ref) {
    var _props$selected = props.selected,
        selected = _props$selected === void 0 ? false : _props$selected,
        brand = props.brand,
        disabled = props.disabled,
        value = props.value;
    return /* @__PURE__ */React__default["default"].createElement(Flex, {
      alignItems: "center",
      as: "li"
    }, /* @__PURE__ */React__default["default"].createElement(ButtonIcon, __spreadValues$v({
      "aria-current": selected,
      "aria-label": selected ? "Current Page, Page ".concat(value) : "Goto Page ".concat(value),
      disabled: disabled,
      ref: ref,
      size: "sm",
      sx: {
        "&": {
          bg: selected ? "interaction.select.active" : "transparent"
        },
        "&:hover:enabled:not(:active), &:active:enabled, &:focus:enabled:not(:active)": {
          bg: selected ? "interaction.select.active" : "interaction.blend.02"
        }
      }
    }, props), /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      sx: getTextStyle$1(brand, selected)
    }, value)));
  });
  var __defProp$u = Object.defineProperty;
  var __defProps$j = Object.defineProperties;
  var __getOwnPropDescs$j = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
  var __hasOwnProp$u = Object.prototype.hasOwnProperty;
  var __propIsEnum$u = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$u = function __defNormalProp$u(obj, key, value) {
    return key in obj ? __defProp$u(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$u = function __spreadValues$u(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$u.call(b, prop)) __defNormalProp$u(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$u) {
      var _iterator86 = _createForOfIteratorHelper(__getOwnPropSymbols$u(b)),
          _step86;

      try {
        for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
          var prop = _step86.value;
          if (__propIsEnum$u.call(b, prop)) __defNormalProp$u(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator86.e(err);
      } finally {
        _iterator86.f();
      }
    }

    return a;
  };

  var __spreadProps$j = function __spreadProps$j(a, b) {
    return __defProps$j(a, __getOwnPropDescs$j(b));
  };

  var __objRest$n = function __objRest$n(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$u.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$u) {
      var _iterator87 = _createForOfIteratorHelper(__getOwnPropSymbols$u(source)),
          _step87;

      try {
        for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
          var prop = _step87.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$u.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator87.e(err);
      } finally {
        _iterator87.f();
      }
    }

    return target;
  };

  var Pagination = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        disabled = _b.disabled,
        _b$boundaryCount = _b.boundaryCount,
        boundaryCount = _b$boundaryCount === void 0 ? 1 : _b$boundaryCount,
        brand = _b.brand,
        _b$count = _b.count,
        count = _b$count === void 0 ? 1 : _b$count,
        page = _b.page,
        onChange = _b.onChange,
        _b$siblingCount = _b.siblingCount,
        siblingCount = _b$siblingCount === void 0 ? 1 : _b$siblingCount,
        props = __objRest$n(_b, ["disabled", "boundaryCount", "brand", "count", "page", "onChange", "siblingCount"]);

    var commonProps = {
      brand: brand,
      disabled: disabled
    };

    var _React$useState27 = React.useState(0),
        _React$useState28 = _slicedToArray(_React$useState27, 2),
        selectedPage = _React$useState28[0],
        setSelectedPage = _React$useState28[1];

    React__default["default"].useEffect(function () {
      if (page) {
        setSelectedPage(page - 1);
      }
    }, [page]);

    var handleSelectedPage = function handleSelectedPage(idx) {
      setSelectedPage(idx);

      if (onChange) {
        onChange(idx);
      }
    };

    var handleArrowClick = function handleArrowClick(arrowWay) {
      if (arrowWay === "left") {
        if (selectedPage === 0) {
          return;
        }

        setSelectedPage(selectedPage - 1);

        if (onChange) {
          onChange(selectedPage - 1);
        }
      } else {
        if (selectedPage === count - 1) {
          return;
        }

        setSelectedPage(selectedPage + 1);

        if (onChange) {
          onChange(selectedPage + 1);
        }
      }
    };

    var renderItems = function renderItems() {
      var itemsArray = [];

      var pushItem = function pushItem(idx, isGap) {
        if (isGap) {
          return itemsArray.push( /* @__PURE__ */React__default["default"].createElement(Flex, {
            alignItems: "center",
            "aria-hidden": "true",
            as: "li",
            color: getValueColor(brand, false, false),
            height: 32,
            justifyContent: "center",
            key: idx,
            width: 32
          }, "..."));
        }

        return itemsArray.push( /* @__PURE__ */React__default["default"].createElement(PaginationItem, __spreadValues$u({
          key: idx,
          onClick: function onClick() {
            return handleSelectedPage(idx);
          },
          selected: selectedPage === idx,
          value: idx + 1
        }, commonProps)));
      };

      for (var idx = 0; idx < count; idx++) {
        var isSibling = idx >= selectedPage - siblingCount && idx <= selectedPage + siblingCount;
        var isBoundary = idx <= boundaryCount - 1 || idx >= count - boundaryCount;

        if (siblingCount > 0) {
          if (isSibling || isBoundary) {
            pushItem(idx, false);
            continue;
          } else if (idx >= selectedPage - (siblingCount + 1) && idx <= selectedPage + (siblingCount + 1)) {
            pushItem(idx, true);
            continue;
          } else {
            continue;
          }
        } else {
          if (selectedPage === idx || isBoundary) {
            pushItem(idx, false);
            continue;
          } else if (idx >= selectedPage - (siblingCount + 1) && idx <= selectedPage + (siblingCount + 1)) {
            pushItem(idx, true);
            continue;
          }
        }
      }

      return itemsArray;
    };

    var currentPage = selectedPage + 1;
    return /* @__PURE__ */React__default["default"].createElement(Flex, __spreadValues$u({
      alignItems: "center",
      "aria-label": "Pagination Navigation",
      as: "nav",
      role: "navigation"
    }, props), /* @__PURE__ */React__default["default"].createElement(Flex, {
      alignItems: "center",
      as: "ul"
    }, /* @__PURE__ */React__default["default"].createElement(PaginationArrow, __spreadProps$j(__spreadValues$u({
      "aria-label": "Previous page",
      arrowWay: "left",
      id: "pagination-arrow-left-id",
      onClick: function onClick() {
        return handleArrowClick("left");
      }
    }, commonProps), {
      disabled: currentPage === 1
    })), renderItems(), /* @__PURE__ */React__default["default"].createElement(PaginationArrow, __spreadProps$j(__spreadValues$u({
      "aria-label": "Next page",
      arrowWay: "right",
      id: "pagination-arrow-right-id",
      onClick: function onClick() {
        return handleArrowClick("right");
      }
    }, commonProps), {
      disabled: currentPage === count
    }))));
  });

  var getStepperStyle = function getStepperStyle(active, brand) {
    var getBackgroundColor = function getBackgroundColor() {
      if (active) {
        return brand ? "interaction.on.brand.accent.01" : "interaction.accent.01";
      }

      return brand ? "interaction.on.brand.blend.06" : "interaction.blend.06";
    };

    return {
      backgroundColor: getBackgroundColor(),
      borderRadius: active ? "pill" : "circle",
      cursor: active ? "default" : "pointer",
      height: 8,
      transition: "width 0.2s ease-in, border-radius 0.2s ease-in",
      width: active ? 24 : 8
    };
  };

  var __defProp$t = Object.defineProperty;
  var __defProps$i = Object.defineProperties;
  var __getOwnPropDescs$i = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
  var __hasOwnProp$t = Object.prototype.hasOwnProperty;
  var __propIsEnum$t = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$t = function __defNormalProp$t(obj, key, value) {
    return key in obj ? __defProp$t(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$t = function __spreadValues$t(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$t.call(b, prop)) __defNormalProp$t(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$t) {
      var _iterator88 = _createForOfIteratorHelper(__getOwnPropSymbols$t(b)),
          _step88;

      try {
        for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
          var prop = _step88.value;
          if (__propIsEnum$t.call(b, prop)) __defNormalProp$t(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator88.e(err);
      } finally {
        _iterator88.f();
      }
    }

    return a;
  };

  var __spreadProps$i = function __spreadProps$i(a, b) {
    return __defProps$i(a, __getOwnPropDescs$i(b));
  };

  var __objRest$m = function __objRest$m(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$t.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$t) {
      var _iterator89 = _createForOfIteratorHelper(__getOwnPropSymbols$t(source)),
          _step89;

      try {
        for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
          var prop = _step89.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$t.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator89.e(err);
      } finally {
        _iterator89.f();
      }
    }

    return target;
  };

  var Stepper = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        active = _b.active,
        brand = _b.brand,
        index = _b.index,
        sx = _b.sx,
        props = __objRest$m(_b, ["active", "brand", "index", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$i(__spreadValues$t({}, props), {
      "aria-expanded": active,
      ref: ref,
      sx: __spreadValues$t({
        cursor: active ? "default" : "pointer",
        padding: "inline.quark"
      }, sx)
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: __spreadValues$t(__spreadValues$t({}, getStepperStyle(active, brand)), sx)
    }));
  });
  var StepperContainer = React__default["default"].forwardRef(function (_ref47, ref) {
    var children = _ref47.children;
    return /* @__PURE__ */React__default["default"].createElement(Flex, {
      alignItems: "center",
      justifyContent: "center",
      ref: ref
    }, children);
  });

  var getOverlayStyle = function getOverlayStyle(variant, zIndex) {
    return {
      backgroundColor: "interaction.blend.05",
      height: variant === "screen" ? "100vh" : "100%",
      left: 0,
      position: variant === "screen" ? "fixed" : "absolute",
      top: 0,
      width: variant === "screen" ? "100vw" : "100%",
      zIndex: zIndex
    };
  };

  var __defProp$s = Object.defineProperty;
  var __defProps$h = Object.defineProperties;
  var __getOwnPropDescs$h = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
  var __hasOwnProp$s = Object.prototype.hasOwnProperty;
  var __propIsEnum$s = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$s = function __defNormalProp$s(obj, key, value) {
    return key in obj ? __defProp$s(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$s = function __spreadValues$s(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$s.call(b, prop)) __defNormalProp$s(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$s) {
      var _iterator90 = _createForOfIteratorHelper(__getOwnPropSymbols$s(b)),
          _step90;

      try {
        for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
          var prop = _step90.value;
          if (__propIsEnum$s.call(b, prop)) __defNormalProp$s(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator90.e(err);
      } finally {
        _iterator90.f();
      }
    }

    return a;
  };

  var __spreadProps$h = function __spreadProps$h(a, b) {
    return __defProps$h(a, __getOwnPropDescs$h(b));
  };

  var __objRest$l = function __objRest$l(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$s.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$s) {
      var _iterator91 = _createForOfIteratorHelper(__getOwnPropSymbols$s(source)),
          _step91;

      try {
        for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
          var prop = _step91.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$s.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator91.e(err);
      } finally {
        _iterator91.f();
      }
    }

    return target;
  };

  var Overlay = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant9 = _b.variant,
        variant = _b$variant9 === void 0 ? "screen" : _b$variant9,
        _b$zIndex = _b.zIndex,
        zIndex = _b$zIndex === void 0 ? 1 : _b$zIndex,
        props = __objRest$l(_b, ["variant", "zIndex"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$h(__spreadValues$s({}, props), {
      ref: ref,
      sx: __spreadValues$s(__spreadValues$s({}, getOverlayStyle(variant, zIndex)), props.sx)
    }));
  });

  var getBasicChipStyle = function getBasicChipStyle(variant) {
    return {
      alignItems: "center",
      borderRadius: "pill",
      borderStyle: "solid",
      cursor: "pointer",
      display: "flex",
      height: variant === "lg" ? 32 : 24,
      paddingLeft: "inline.nano",
      position: "relative",
      width: "max-content"
    };
  };

  var getChipTextStyle = function getChipTextStyle(staticText) {
    return {
      color: "inherit",
      paddingBottom: staticText ? "inline.quark" : "stack.nano",
      paddingLeft: staticText ? void 0 : "inline.quark",
      paddingRight: staticText ? void 0 : "inline.quark",
      paddingTop: staticText ? "inline.quark" : "stack.nano"
    };
  };

  var __defProp$r = Object.defineProperty;
  var __defProps$g = Object.defineProperties;
  var __getOwnPropDescs$g = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
  var __hasOwnProp$r = Object.prototype.hasOwnProperty;
  var __propIsEnum$r = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$r = function __defNormalProp$r(obj, key, value) {
    return key in obj ? __defProp$r(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$r = function __spreadValues$r(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$r.call(b, prop)) __defNormalProp$r(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$r) {
      var _iterator92 = _createForOfIteratorHelper(__getOwnPropSymbols$r(b)),
          _step92;

      try {
        for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
          var prop = _step92.value;
          if (__propIsEnum$r.call(b, prop)) __defNormalProp$r(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator92.e(err);
      } finally {
        _iterator92.f();
      }
    }

    return a;
  };

  var __spreadProps$g = function __spreadProps$g(a, b) {
    return __defProps$g(a, __getOwnPropDescs$g(b));
  };

  var getChipInputContainerStyle = function getChipInputContainerStyle(props) {
    var getBackgroundColor = function getBackgroundColor() {
      if (props.disabled) {
        return props.brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
      } else if (props.active) {
        return props.brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (props.hover || props.focus) {
        return props.brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }

      return props.brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
    };

    var getColor = function getColor() {
      if (props.disabled) {
        return props.brand ? "typeface.on.brand.meld" : "typeface.meld";
      } else if (props.hover || props.focus || props.trailingFocus) {
        return props.brand ? "typeface.on.brand.strong" : "typeface.strong";
      }

      return props.brand ? "typeface.on.brand.pure" : "typeface.pure";
    };

    return __spreadProps$g(__spreadValues$r({}, getBasicChipStyle(props.variant)), {
      backgroundColor: getBackgroundColor(),
      borderColor: props.brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
      borderWidth: props.focus ? "thin" : void 0,
      color: getColor(),
      paddingRight: props.variant === "lg" ? 32 : 24,
      pointerEvents: props.disabled ? "none" : void 0
    });
  };

  var getChipTrailingStyle = function getChipTrailingStyle(brand, variant, hover, focus, active, disabled) {
    var getBackgroundColor = function getBackgroundColor() {
      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }

      return "transparent";
    };

    var getBorderColor = function getBorderColor() {
      if (focus) {
        return brand ? "interaction.on.brand.select.focus" : "interaction.select.focus";
      }

      return "transparent";
    };

    return {
      backgroundColor: getBackgroundColor(),
      borderColor: getBorderColor(),
      borderRadius: "circle",
      borderStyle: "solid",
      borderWidth: "thin",
      height: variant === "lg" ? 32 : 24,
      margin: 0,
      pointerEvents: disabled ? "none" : void 0,
      position: "absolute",
      right: 0,
      top: 0,
      width: variant === "lg" ? 32 : 24
    };
  };

  var __defProp$q = Object.defineProperty;
  var __defProps$f = Object.defineProperties;
  var __getOwnPropDescs$f = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
  var __hasOwnProp$q = Object.prototype.hasOwnProperty;
  var __propIsEnum$q = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$q = function __defNormalProp$q(obj, key, value) {
    return key in obj ? __defProp$q(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$q = function __spreadValues$q(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$q.call(b, prop)) __defNormalProp$q(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$q) {
      var _iterator93 = _createForOfIteratorHelper(__getOwnPropSymbols$q(b)),
          _step93;

      try {
        for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
          var prop = _step93.value;
          if (__propIsEnum$q.call(b, prop)) __defNormalProp$q(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator93.e(err);
      } finally {
        _iterator93.f();
      }
    }

    return a;
  };

  var __spreadProps$f = function __spreadProps$f(a, b) {
    return __defProps$f(a, __getOwnPropDescs$f(b));
  };

  var __objRest$k = function __objRest$k(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$q.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$q) {
      var _iterator94 = _createForOfIteratorHelper(__getOwnPropSymbols$q(source)),
          _step94;

      try {
        for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
          var prop = _step94.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$q.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator94.e(err);
      } finally {
        _iterator94.f();
      }
    }

    return target;
  };

  var ChipInput = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        children = _b.children,
        closeProps = _b.closeProps,
        disabled = _b.disabled,
        leadingIcon = _b.leadingIcon,
        _b$label2 = _b.label,
        label = _b$label2 === void 0 ? "" : _b$label2,
        onClose = _b.onClose,
        _b$variant10 = _b.variant,
        variant = _b$variant10 === void 0 ? "lg" : _b$variant10,
        props = __objRest$k(_b, ["brand", "children", "closeProps", "disabled", "leadingIcon", "label", "onClose", "variant"]);

    var _React$useState29 = React.useState(false),
        _React$useState30 = _slicedToArray(_React$useState29, 2),
        containerHover = _React$useState30[0],
        setContainerHover = _React$useState30[1];

    var _React$useState31 = React.useState(false),
        _React$useState32 = _slicedToArray(_React$useState31, 2),
        trailingHover = _React$useState32[0],
        setTrailingHover = _React$useState32[1];

    var _React$useState33 = React.useState(false),
        _React$useState34 = _slicedToArray(_React$useState33, 2),
        containerFocus = _React$useState34[0],
        setContainerFocus = _React$useState34[1];

    var _React$useState35 = React.useState(false),
        _React$useState36 = _slicedToArray(_React$useState35, 2),
        trailingFocus = _React$useState36[0],
        setTrailingFocus = _React$useState36[1];

    var _React$useState37 = React.useState(false),
        _React$useState38 = _slicedToArray(_React$useState37, 2),
        containerActive = _React$useState38[0],
        setContainerActive = _React$useState38[1];

    var _React$useState39 = React.useState(false),
        _React$useState40 = _slicedToArray(_React$useState39, 2),
        trailingActive = _React$useState40[0],
        setTrailingActive = _React$useState40[1];

    var getIconColor = function getIconColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      } else if (containerHover || containerFocus) {
        return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
      }

      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        position: "relative"
      }
    }, /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$f(__spreadValues$q({
      "aria-label": "Deletar ".concat(label),
      role: "button",
      tabIndex: 0
    }, props), {
      onBlur: function onBlur(evt) {
        !disabled && setContainerFocus(false);

        if (props.onBlur) {
          props.onBlur(evt);
        }
      },
      onFocus: function onFocus(evt) {
        if (!disabled && !trailingFocus && !trailingActive && !containerActive) {
          setContainerFocus(true);
        }

        if (props.onFocus) {
          props.onFocus(evt);
        }
      },
      onMouseDown: function onMouseDown(evt) {
        if (!disabled && !trailingActive) {
          setContainerActive(true);
        }

        if (props.onMouseDown) {
          props.onMouseDown(evt);
        }
      },
      onMouseEnter: function onMouseEnter(evt) {
        !disabled && setContainerHover(true);

        if (props.onMouseEnter) {
          props.onMouseEnter(evt);
        }
      },
      onMouseLeave: function onMouseLeave(evt) {
        !disabled && setContainerHover(false);

        if (props.onMouseLeave) {
          props.onMouseLeave(evt);
        }
      },
      onMouseUp: function onMouseUp(evt) {
        if (!disabled) {
          setContainerFocus(false);
          setTrailingFocus(false);
          setContainerActive(false);
        }

        if (props.onMouseUp) {
          props.onMouseUp(evt);
        }
      },
      ref: ref,
      sx: __spreadValues$q(__spreadValues$q({}, getChipInputContainerStyle({
        active: containerActive && !trailingActive,
        brand: brand,
        disabled: disabled,
        focus: containerFocus && !trailingFocus,
        hover: containerHover && !trailingHover,
        trailingFocus: trailingFocus,
        variant: variant
      })), props.sx)
    }), children ? children : /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, leadingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: getIconColor(),
      size: variant === "lg" ? "md" : "xs",
      sx: {
        margin: 0,
        marginBottom: "stack.quark",
        marginTop: "stack.quark",
        padding: 0
      }
    }, leadingIcon), /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      sx: getChipTextStyle(),
      variant: variant === "lg" ? "md" : "sm"
    }, label))), /* @__PURE__ */React__default["default"].createElement(ButtonIcon, __spreadProps$f(__spreadValues$q({
      color: getIconColor(),
      disabled: disabled,
      id: "chip-input-close",
      leadingIcon: /* @__PURE__ */React__default["default"].createElement(almaIcons.Close, null),
      leadingIconSize: variant === "lg" ? "md" : "xs",
      size: variant,
      tabIndex: 0,
      type: "button"
    }, closeProps), {
      onBlur: function onBlur(evt) {
        !disabled && setTrailingFocus(false);

        if (closeProps == null ? void 0 : closeProps.onBlur) {
          closeProps.onBlur(evt);
        }
      },
      onClick: function onClick(evt) {
        if (!disabled && onClose) {
          onClose(evt);
        }

        if (closeProps == null ? void 0 : closeProps.onClick) {
          closeProps.onClick(evt);
        }
      },
      onFocus: function onFocus(evt) {
        if (!disabled && !trailingActive) {
          setContainerFocus(false);
          setTrailingFocus(true);
        }

        if (closeProps == null ? void 0 : closeProps.onFocus) {
          closeProps.onFocus(evt);
        }
      },
      onMouseDown: function onMouseDown(evt) {
        !disabled && setTrailingActive(true);

        if (closeProps == null ? void 0 : closeProps.onMouseDown) {
          closeProps.onMouseDown(evt);
        }
      },
      onMouseEnter: function onMouseEnter(evt) {
        !disabled && setTrailingHover(true);

        if (closeProps == null ? void 0 : closeProps.onMouseEnter) {
          closeProps.onMouseEnter(evt);
        }
      },
      onMouseLeave: function onMouseLeave(evt) {
        !disabled && setTrailingHover(false);

        if (closeProps == null ? void 0 : closeProps.onMouseLeave) {
          closeProps.onMouseLeave(evt);
        }
      },
      onMouseUp: function onMouseUp(evt) {
        if (!disabled) {
          setContainerFocus(false);
          setTrailingFocus(false);
          setTrailingActive(false);
        }

        if (closeProps == null ? void 0 : closeProps.onMouseUp) {
          closeProps.onMouseUp(evt);
        }
      },
      sx: __spreadValues$q(__spreadValues$q({}, getChipTrailingStyle(brand, variant, trailingHover, trailingFocus, trailingActive, disabled)), closeProps == null ? void 0 : closeProps.sx)
    })));
  });
  var __defProp$p = Object.defineProperty;
  var __defProps$e = Object.defineProperties;
  var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
  var __hasOwnProp$p = Object.prototype.hasOwnProperty;
  var __propIsEnum$p = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$p = function __defNormalProp$p(obj, key, value) {
    return key in obj ? __defProp$p(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$p = function __spreadValues$p(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$p.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$p) {
      var _iterator95 = _createForOfIteratorHelper(__getOwnPropSymbols$p(b)),
          _step95;

      try {
        for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
          var prop = _step95.value;
          if (__propIsEnum$p.call(b, prop)) __defNormalProp$p(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator95.e(err);
      } finally {
        _iterator95.f();
      }
    }

    return a;
  };

  var __spreadProps$e = function __spreadProps$e(a, b) {
    return __defProps$e(a, __getOwnPropDescs$e(b));
  };

  var getChipToggleStyle = function getChipToggleStyle(_ref48) {
    var active = _ref48.active,
        brand = _ref48.brand,
        disabled = _ref48.disabled,
        focus = _ref48.focus,
        hover = _ref48.hover,
        selected = _ref48.selected,
        variant = _ref48.variant;

    var getBackgroundColor = function getBackgroundColor() {
      if (selected) {
        if (disabled) {
          return brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
        } else if (active) {
          return brand ? "interaction.on.brand.subtle.03" : "interaction.subtle.03";
        } else if (hover || focus) {
          return brand ? "interaction.on.brand.subtle.02" : "interaction.subtle.02";
        }

        return brand ? "interaction.on.brand.subtle.01" : "interaction.subtle.01";
      }

      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }

      return "transparent";
    };

    var getBorderColor = function getBorderColor() {
      if (selected) {
        if (disabled) {
          return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
        }

        return brand ? "interaction.on.brand.select.active" : "interaction.select.active";
      } else if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }

      return brand ? "interaction.on.brand.select.default" : "interaction.select.default";
    };

    var getColor = function getColor() {
      if (selected) {
        if (disabled) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }

        return brand ? "interaction.on.brand.select.default" : "interaction.select.active";
      } else if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      } else if (hover || focus) {
        return brand ? "typeface.on.brand.strong" : "typeface.strong";
      }

      return brand ? "typeface.on.brand.pure" : "typeface.pure";
    };

    return __spreadProps$e(__spreadValues$p({}, getBasicChipStyle(variant)), {
      backgroundColor: getBackgroundColor(),
      borderColor: getBorderColor(),
      borderWidth: focus ? "thin" : "hairline",
      color: getColor(),
      cursor: disabled ? "default" : "pointer",
      paddingRight: "inline.nano"
    });
  };

  var __defProp$o = Object.defineProperty;
  var __defProps$d = Object.defineProperties;
  var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
  var __hasOwnProp$o = Object.prototype.hasOwnProperty;
  var __propIsEnum$o = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$o = function __defNormalProp$o(obj, key, value) {
    return key in obj ? __defProp$o(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$o = function __spreadValues$o(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$o.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$o) {
      var _iterator96 = _createForOfIteratorHelper(__getOwnPropSymbols$o(b)),
          _step96;

      try {
        for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
          var prop = _step96.value;
          if (__propIsEnum$o.call(b, prop)) __defNormalProp$o(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator96.e(err);
      } finally {
        _iterator96.f();
      }
    }

    return a;
  };

  var __spreadProps$d = function __spreadProps$d(a, b) {
    return __defProps$d(a, __getOwnPropDescs$d(b));
  };

  var __objRest$j = function __objRest$j(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$o.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$o) {
      var _iterator97 = _createForOfIteratorHelper(__getOwnPropSymbols$o(source)),
          _step97;

      try {
        for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
          var prop = _step97.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$o.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator97.e(err);
      } finally {
        _iterator97.f();
      }
    }

    return target;
  };

  var ChipToggle = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        children = _b.children,
        disabled = _b.disabled,
        _b$label3 = _b.label,
        label = _b$label3 === void 0 ? "" : _b$label3,
        selected = _b.selected,
        sx = _b.sx,
        _b$variant11 = _b.variant,
        variant = _b$variant11 === void 0 ? "lg" : _b$variant11,
        _onClick = _b.onClick,
        props = __objRest$j(_b, ["brand", "children", "disabled", "label", "selected", "sx", "variant", "onClick"]);

    var _React$useState41 = React.useState(false),
        _React$useState42 = _slicedToArray(_React$useState41, 2),
        hover = _React$useState42[0],
        setHover = _React$useState42[1];

    var _React$useState43 = React.useState(false),
        _React$useState44 = _slicedToArray(_React$useState43, 2),
        focus = _React$useState44[0],
        setFocus = _React$useState44[1];

    var _React$useState45 = React.useState(false),
        _React$useState46 = _slicedToArray(_React$useState45, 2),
        active = _React$useState46[0],
        setActive = _React$useState46[1];

    var getIconColor = function getIconColor() {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
      }

      return brand ? "interaction.on.brand.select.default" : "interaction.select.active";
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$d(__spreadValues$o({
      "aria-disabled": disabled,
      "aria-label": label,
      onClick: function onClick(e) {
        return !disabled && _onClick && _onClick(e);
      },
      role: "button",
      tabIndex: 0
    }, props), {
      onBlur: function onBlur(evt) {
        !disabled && setFocus(false);

        if (props.onBlur) {
          props.onBlur(evt);
        }
      },
      onFocus: function onFocus(evt) {
        if (!active) {
          !disabled && setFocus(true);
        }

        if (props.onFocus) {
          props.onFocus(evt);
        }
      },
      onMouseDown: function onMouseDown(evt) {
        !disabled && setActive(true);

        if (props.onMouseDown) {
          props.onMouseDown(evt);
        }
      },
      onMouseEnter: function onMouseEnter(evt) {
        !disabled && setHover(true);

        if (props.onMouseEnter) {
          props.onMouseEnter(evt);
        }
      },
      onMouseLeave: function onMouseLeave(evt) {
        !disabled && setHover(false);

        if (props.onMouseLeave) {
          props.onMouseLeave(evt);
        }
      },
      onMouseUp: function onMouseUp(evt) {
        !disabled && setFocus(false);
        !disabled && setActive(false);

        if (props.onMouseUp) {
          props.onMouseUp(evt);
        }
      },
      ref: ref,
      sx: __spreadValues$o(__spreadValues$o({}, getChipToggleStyle({
        active: active,
        brand: brand,
        disabled: disabled,
        focus: focus,
        hover: hover,
        selected: selected,
        variant: variant
      })), sx)
    }), children ? children : /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, selected && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: getIconColor(),
      id: "chip-toggle-id",
      size: variant === "lg" ? "md" : "xs",
      sx: {
        margin: 0,
        marginBottom: "stack.quark",
        marginTop: "stack.quark",
        padding: 0
      }
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.Check, null)), /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      sx: getChipTextStyle(),
      variant: variant === "lg" ? "md" : "sm"
    }, label)));
  });
  var __defProp$n = Object.defineProperty;
  var __defProps$c = Object.defineProperties;
  var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
  var __hasOwnProp$n = Object.prototype.hasOwnProperty;
  var __propIsEnum$n = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$n = function __defNormalProp$n(obj, key, value) {
    return key in obj ? __defProp$n(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$n = function __spreadValues$n(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$n.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$n) {
      var _iterator98 = _createForOfIteratorHelper(__getOwnPropSymbols$n(b)),
          _step98;

      try {
        for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
          var prop = _step98.value;
          if (__propIsEnum$n.call(b, prop)) __defNormalProp$n(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator98.e(err);
      } finally {
        _iterator98.f();
      }
    }

    return a;
  };

  var __spreadProps$c = function __spreadProps$c(a, b) {
    return __defProps$c(a, __getOwnPropDescs$c(b));
  };

  var getChipStaticStyle = function getChipStaticStyle(brand, disabled) {
    var getBackgroundColor = function getBackgroundColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
      }

      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };

    var getColor = function getColor() {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }

      return brand ? "typeface.on.brand.pure" : "typeface.pure";
    };

    return __spreadProps$c(__spreadValues$n({}, getBasicChipStyle("sm")), {
      backgroundColor: getBackgroundColor(),
      color: getColor(),
      cursor: "default",
      paddingRight: "inline.nano"
    });
  };

  var __defProp$m = Object.defineProperty;
  var __defProps$b = Object.defineProperties;
  var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
  var __hasOwnProp$m = Object.prototype.hasOwnProperty;
  var __propIsEnum$m = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$m = function __defNormalProp$m(obj, key, value) {
    return key in obj ? __defProp$m(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$m = function __spreadValues$m(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$m.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$m) {
      var _iterator99 = _createForOfIteratorHelper(__getOwnPropSymbols$m(b)),
          _step99;

      try {
        for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
          var prop = _step99.value;
          if (__propIsEnum$m.call(b, prop)) __defNormalProp$m(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator99.e(err);
      } finally {
        _iterator99.f();
      }
    }

    return a;
  };

  var __spreadProps$b = function __spreadProps$b(a, b) {
    return __defProps$b(a, __getOwnPropDescs$b(b));
  };

  var __objRest$i = function __objRest$i(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$m) {
      var _iterator100 = _createForOfIteratorHelper(__getOwnPropSymbols$m(source)),
          _step100;

      try {
        for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
          var prop = _step100.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator100.e(err);
      } finally {
        _iterator100.f();
      }
    }

    return target;
  };

  var ChipStatic = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        children = _b.children,
        disabled = _b.disabled,
        _b$label4 = _b.label,
        label = _b$label4 === void 0 ? "" : _b$label4,
        sx = _b.sx,
        props = __objRest$i(_b, ["brand", "children", "disabled", "label", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$b(__spreadValues$m({
      "aria-label": label,
      role: "button"
    }, props), {
      ref: ref,
      sx: __spreadValues$m(__spreadValues$m({}, getChipStaticStyle(brand, disabled)), sx)
    }), children ? children : /* @__PURE__ */React__default["default"].createElement(Caption, {
      sx: getChipTextStyle(true)
    }, label));
  });
  var __defProp$l = Object.defineProperty;
  var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
  var __hasOwnProp$l = Object.prototype.hasOwnProperty;
  var __propIsEnum$l = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$l = function __defNormalProp$l(obj, key, value) {
    return key in obj ? __defProp$l(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$l = function __spreadValues$l(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$l.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$l) {
      var _iterator101 = _createForOfIteratorHelper(__getOwnPropSymbols$l(b)),
          _step101;

      try {
        for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
          var prop = _step101.value;
          if (__propIsEnum$l.call(b, prop)) __defNormalProp$l(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator101.e(err);
      } finally {
        _iterator101.f();
      }
    }

    return a;
  };

  var transitionParams = {
    transitionDuration: "0.3s",
    transitionTimingFunction: "ease-in"
  };

  var getAccordionContainerStyle = function getAccordionContainerStyle(brand, open, hover, focus, active) {
    var getBackgroundColor = function getBackgroundColor() {
      if (active) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
      }

      return "transparent";
    };

    var getBorderColor = function getBorderColor() {
      if (focus) {
        return brand ? "interaction.on.brand.select.focus" : "interaction.select.focus";
      }

      return "transparent";
    };

    return __spreadValues$l({
      backgroundColor: getBackgroundColor(),
      borderColor: getBorderColor(),
      borderStyle: "solid",
      borderWidth: "thin",
      overflow: "hidden",
      transitionProperty: "max-height"
    }, transitionParams);
  };

  var accordionLabelContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
    width: "100%"
  };
  var accordionLabelStyle = {
    paddingRight: "inline.nano",
    position: "relative"
  };

  var getAccordionTrailingIconStyle = function getAccordionTrailingIconStyle(open) {
    return __spreadValues$l({
      transform: open ? "rotate(180deg)" : "rotate(0)",
      transitionProperty: "transform"
    }, transitionParams);
  };

  var getAccordionTextStyle = function getAccordionTextStyle(open, leadingIcon) {
    return __spreadValues$l({
      opacity: open ? 1 : 0,
      paddingLeft: leadingIcon ? "inline.xs" : void 0,
      paddingTop: "stack.nano",
      transitionProperty: "opacity, visibility",
      visibility: open ? "visible" : "hidden"
    }, transitionParams);
  };

  var __defProp$k = Object.defineProperty;
  var __defProps$a = Object.defineProperties;
  var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
  var __hasOwnProp$k = Object.prototype.hasOwnProperty;
  var __propIsEnum$k = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$k = function __defNormalProp$k(obj, key, value) {
    return key in obj ? __defProp$k(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$k = function __spreadValues$k(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$k.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$k) {
      var _iterator102 = _createForOfIteratorHelper(__getOwnPropSymbols$k(b)),
          _step102;

      try {
        for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
          var prop = _step102.value;
          if (__propIsEnum$k.call(b, prop)) __defNormalProp$k(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator102.e(err);
      } finally {
        _iterator102.f();
      }
    }

    return a;
  };

  var __spreadProps$a = function __spreadProps$a(a, b) {
    return __defProps$a(a, __getOwnPropDescs$a(b));
  };

  var __objRest$h = function __objRest$h(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$k.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$k) {
      var _iterator103 = _createForOfIteratorHelper(__getOwnPropSymbols$k(source)),
          _step103;

      try {
        for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
          var prop = _step103.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$k.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator103.e(err);
      } finally {
        _iterator103.f();
      }
    }

    return target;
  };

  var Accordion = React__default["default"].memo(React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        disabled = _b.disabled,
        label = _b.label,
        leadingIcon = _b.leadingIcon,
        text = _b.text,
        noOfLines = _b.noOfLines,
        props = __objRest$h(_b, ["brand", "disabled", "label", "leadingIcon", "text", "noOfLines"]);

    var _React$useState47 = React.useState(false),
        _React$useState48 = _slicedToArray(_React$useState47, 2),
        open = _React$useState48[0],
        setOpen = _React$useState48[1];

    var _React$useState49 = React.useState(false),
        _React$useState50 = _slicedToArray(_React$useState49, 2),
        hover = _React$useState50[0],
        setHover = _React$useState50[1];

    var _React$useState51 = React.useState(false),
        _React$useState52 = _slicedToArray(_React$useState51, 2),
        focus = _React$useState52[0],
        setFocus = _React$useState52[1];

    var _React$useState53 = React.useState(false),
        _React$useState54 = _slicedToArray(_React$useState53, 2),
        active = _React$useState54[0],
        setActive = _React$useState54[1];

    var getLeadingIconColor = function getLeadingIconColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      } else if (hover || focus || active) {
        return brand ? "support.on.brand.02" : "support.02";
      }

      return brand ? "support.on.brand.01" : "support.01";
    };

    var getTrailingIconColor = function getTrailingIconColor() {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }

      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };

    var getLabelColor = function getLabelColor() {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }

      return brand ? "typeface.on.brand.strong" : "typeface.pure";
    };

    var getTextColor = function getTextColor() {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }

      return brand ? "typeface.on.brand.pure" : "typeface.smooth";
    };

    return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$a(__spreadValues$k({}, props), {
      "aria-disabled": disabled,
      "aria-expanded": open,
      onBlur: function onBlur(evt) {
        !disabled && setFocus(false);

        if (props.onBlur) {
          props.onBlur(evt);
        }
      },
      onClick: function onClick(evt) {
        !disabled && setOpen(!open);

        if (props.onClick) {
          props.onClick(evt);
        }
      },
      onFocus: function onFocus(evt) {
        if (!active) {
          !disabled && setFocus(true);
        }

        if (props.onFocus) {
          props.onFocus(evt);
        }
      },
      onMouseDown: function onMouseDown() {
        return !disabled && setActive(true);
      },
      onMouseEnter: function onMouseEnter(evt) {
        !disabled && setHover(true);

        if (props.onMouseEnter) {
          props.onMouseEnter(evt);
        }
      },
      onMouseLeave: function onMouseLeave(evt) {
        !disabled && setHover(false);

        if (props.onMouseLeave) {
          props.onMouseLeave(evt);
        }
      },
      onMouseUp: function onMouseUp() {
        !disabled && setFocus(false);
        !disabled && setActive(false);
      },
      ref: ref,
      sx: __spreadValues$k({
        cursor: disabled ? "default" : "pointer",
        position: "relative",
        width: "100%"
      }, props.sx)
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      p: "inset.xs",
      sx: getAccordionContainerStyle(brand, open, hover, focus, active),
      tabIndex: disabled ? -1 : 0
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: accordionLabelContainerStyle
    }, /* @__PURE__ */React__default["default"].createElement(Center, {
      sx: {
        alignItems: "flex-start"
      }
    }, leadingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: getLeadingIconColor(),
      mr: "inline.nano",
      size: "md"
    }, leadingIcon), /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      color: getLabelColor(),
      noOfLines: noOfLines,
      sx: accordionLabelStyle,
      variant: "lg"
    }, label)), /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: getTrailingIconColor(),
      size: "md",
      sx: getAccordionTrailingIconStyle(open)
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.ChevronDownSm, null))), /* @__PURE__ */React__default["default"].createElement(Body, {
      color: getTextColor(),
      display: open ? "block" : "none",
      sx: getAccordionTextStyle(open, leadingIcon),
      variant: "sm"
    }, text))), /* @__PURE__ */React__default["default"].createElement(Divider, {
      brand: brand,
      variant: "horizontal"
    }));
  }));
  Accordion.displayName = "Accordion";
  styled__default$1["default"](Accordion);
  var __defProp$j = Object.defineProperty;
  var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
  var __hasOwnProp$j = Object.prototype.hasOwnProperty;
  var __propIsEnum$j = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$j = function __defNormalProp$j(obj, key, value) {
    return key in obj ? __defProp$j(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$j = function __spreadValues$j(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$j.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$j) {
      var _iterator104 = _createForOfIteratorHelper(__getOwnPropSymbols$j(b)),
          _step104;

      try {
        for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
          var prop = _step104.value;
          if (__propIsEnum$j.call(b, prop)) __defNormalProp$j(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator104.e(err);
      } finally {
        _iterator104.f();
      }
    }

    return a;
  };

  var getBannerStyle = function getBannerStyle(variant, zIndex, open) {
    var getPositionStyle = function getPositionStyle() {
      if (variant === "top") {
        return {
          borderBottomColor: "interaction.blend.02",
          borderBottomWidth: "hairline",
          top: open ? 0 : -150
        };
      }

      return {
        borderTopColor: "interaction.blend.02",
        borderTopWidth: "hairline",
        bottom: open ? 0 : -150
      };
    };

    return __spreadValues$j({
      alignItems: "center",
      backgroundColor: "neutral.00",
      borderStyle: "solid",
      display: "flex",
      justifyContent: "space-between",
      left: 0,
      maxHeight: 128,
      minHeight: 64,
      paddingBottom: "stack.xxxs",
      paddingLeft: "inline.xxs",
      paddingRight: "inline.xxs",
      paddingTop: "stack.xxxs",
      position: "absolute",
      transition: "all 300ms ease-in-out",
      width: "100%",
      zIndex: zIndex
    }, getPositionStyle());
  };

  var bannerMessageStyle = {
    maxHeight: "calc(128px - ".concat(parseInt(defaultTheme$1.space.stack.xxxs, 10) * 2, "px)"),
    overflow: "auto",
    paddingBottom: "stack.quark",
    paddingRight: "inline.xxxs",
    paddingTop: "stack.quark",
    position: "relative"
  };
  var bannerButtonsContainerStyle = {
    alignItems: "center",
    display: "flex",
    minWidth: "min-content"
  };
  var __defProp$i = Object.defineProperty;
  var __defProps$9 = Object.defineProperties;
  var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
  var __hasOwnProp$i = Object.prototype.hasOwnProperty;
  var __propIsEnum$i = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$i = function __defNormalProp$i(obj, key, value) {
    return key in obj ? __defProp$i(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$i = function __spreadValues$i(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$i.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$i) {
      var _iterator105 = _createForOfIteratorHelper(__getOwnPropSymbols$i(b)),
          _step105;

      try {
        for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
          var prop = _step105.value;
          if (__propIsEnum$i.call(b, prop)) __defNormalProp$i(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator105.e(err);
      } finally {
        _iterator105.f();
      }
    }

    return a;
  };

  var __spreadProps$9 = function __spreadProps$9(a, b) {
    return __defProps$9(a, __getOwnPropDescs$9(b));
  };

  var __objRest$g = function __objRest$g(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$i.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$i) {
      var _iterator106 = _createForOfIteratorHelper(__getOwnPropSymbols$i(source)),
          _step106;

      try {
        for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
          var prop = _step106.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$i.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator106.e(err);
      } finally {
        _iterator106.f();
      }
    }

    return target;
  };

  var Banner = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        actionButton = _b.actionButton,
        children = _b.children,
        onClose = _b.onClose,
        _b$open = _b.open,
        open = _b$open === void 0 ? false : _b$open,
        sx = _b.sx,
        _b$variant12 = _b.variant,
        variant = _b$variant12 === void 0 ? "bottom" : _b$variant12,
        _b$zIndex2 = _b.zIndex,
        zIndex = _b$zIndex2 === void 0 ? 1 : _b$zIndex2,
        props = __objRest$g(_b, ["actionButton", "children", "onClose", "open", "sx", "variant", "zIndex"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        height: "100%",
        overflow: "hidden",
        position: "relative",
        width: "100%"
      }
    }, /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$9(__spreadValues$i({
      sx: __spreadValues$i(__spreadValues$i({}, getBannerStyle(variant, zIndex, open)), sx)
    }, props), {
      ref: ref,
      tabIndex: 0
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: bannerMessageStyle
    }, children), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: bannerButtonsContainerStyle
    }, actionButton && /* @__PURE__ */React__default["default"].createElement(Button, {
      id: "banner-button-id",
      ml: "inline.nano",
      mr: "inline.nano",
      onClick: function onClick() {
        return actionButton.onClick && actionButton.onClick();
      },
      size: "sm",
      variant: "primary"
    }, actionButton.label), /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
      leadingIcon: /* @__PURE__ */React__default["default"].createElement(almaIcons.Close, null),
      onClick: function onClick() {
        return onClose && onClose();
      },
      size: "sm"
    }))));
  });
  styled__default$1["default"](Banner);
  var top = 'top';
  var bottom = 'bottom';
  var right = 'right';
  var left = 'left';
  var auto = 'auto';
  var basePlacements = [top, bottom, right, left];
  var start = 'start';
  var end = 'end';
  var clippingParents = 'clippingParents';
  var viewport = 'viewport';
  var popper = 'popper';
  var reference = 'reference';
  var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []); // modifiers that need to read the DOM

  var beforeRead = 'beforeRead';
  var read = 'read';
  var afterRead = 'afterRead'; // pure-logic modifiers

  var beforeMain = 'beforeMain';
  var main = 'main';
  var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

  var beforeWrite = 'beforeWrite';
  var write = 'write';
  var afterWrite = 'afterWrite';
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

  function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
  }

  function getWindow(node) {
    if (node == null) {
      return window;
    }

    if (node.toString() !== '[object Window]') {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView || window : window;
    }

    return node;
  }

  function isElement$1(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }

  function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }

  function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') {
      return false;
    }

    var OwnElement = getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
  } // and applies them to the HTMLElements such as popper and arrow


  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function (name) {
      var style = state.styles[name] || {};
      var attributes = state.attributes[name] || {};
      var element = state.elements[name]; // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe[cannot-write]


      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];

        if (value === false) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, value === true ? '' : value);
        }
      });
    });
  }

  function effect$2(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }

    return function () {
      Object.keys(state.elements).forEach(function (name) {
        var element = state.elements[name];
        var attributes = state.attributes[name] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

        var style = styleProperties.reduce(function (style, property) {
          style[property] = '';
          return style;
        }, {}); // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        }

        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  } // eslint-disable-next-line import/no-unused-modules


  var applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect$2,
    requires: ['computeStyles']
  };

  function getBasePlacement$1(placement) {
    return placement.split('-')[0];
  }

  var max = Math.max;
  var min = Math.min;
  var round = Math.round;

  function getBoundingClientRect(element, includeScale) {
    if (includeScale === void 0) {
      includeScale = false;
    }

    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;

    if (isHTMLElement(element) && includeScale) {
      var offsetHeight = element.offsetHeight;
      var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
      // Fallback to 1 in case both values are `0`

      if (offsetWidth > 0) {
        scaleX = round(rect.width) / offsetWidth || 1;
      }

      if (offsetHeight > 0) {
        scaleY = round(rect.height) / offsetHeight || 1;
      }
    }

    return {
      width: rect.width / scaleX,
      height: rect.height / scaleY,
      top: rect.top / scaleY,
      right: rect.right / scaleX,
      bottom: rect.bottom / scaleY,
      left: rect.left / scaleX,
      x: rect.left / scaleX,
      y: rect.top / scaleY
    };
  } // means it doesn't take into account transforms.


  function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223

    var width = element.offsetWidth;
    var height = element.offsetHeight;

    if (Math.abs(clientRect.width - width) <= 1) {
      width = clientRect.width;
    }

    if (Math.abs(clientRect.height - height) <= 1) {
      height = clientRect.height;
    }

    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: width,
      height: height
    };
  }

  function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

    if (parent.contains(child)) {
      return true;
    } // then fallback to custom implementation with Shadow DOM support
    else if (rootNode && isShadowRoot(rootNode)) {
        var next = child;

        do {
          if (next && parent.isSameNode(next)) {
            return true;
          } // $FlowFixMe[prop-missing]: need a better way to handle this...


          next = next.parentNode || next.host;
        } while (next);
      } // Give up, the result is false


    return false;
  }

  function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
  }

  function isTableElement(element) {
    return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
  }

  function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
    element.document) || window.document).documentElement;
  }

  function getParentNode(element) {
    if (getNodeName(element) === 'html') {
      return element;
    }

    return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
      // $FlowFixMe[incompatible-return]
      // $FlowFixMe[prop-missing]
      element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
      element.parentNode || ( // DOM Element detected
      isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
      // $FlowFixMe[incompatible-call]: HTMLElement is a Node
      getDocumentElement(element) // fallback

    );
  }

  function getTrueOffsetParent(element) {
    if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle(element).position === 'fixed') {
      return null;
    }

    return element.offsetParent;
  } // `.offsetParent` reports `null` for fixed elements, while absolute elements
  // return the containing block


  function getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
    var isIE = navigator.userAgent.indexOf('Trident') !== -1;

    if (isIE && isHTMLElement(element)) {
      // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
      var elementCss = getComputedStyle(element);

      if (elementCss.position === 'fixed') {
        return null;
      }
    }

    var currentNode = getParentNode(element);

    while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
      // create a containing block.
      // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

      if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }

    return null;
  } // Gets the closest ancestor positioned element. Handles some edge cases,
  // such as table ancestors and cross browser bugs.


  function getOffsetParent(element) {
    var window = getWindow(element);
    var offsetParent = getTrueOffsetParent(element);

    while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
      offsetParent = getTrueOffsetParent(offsetParent);
    }

    if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
      return window;
    }

    return offsetParent || getContainingBlock(element) || window;
  }

  function getMainAxisFromPlacement(placement) {
    return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
  }

  function within(min$1, value, max$1) {
    return max(min$1, min(value, max$1));
  }

  function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
  }

  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
  }

  function expandToHashMap(value, keys) {
    return keys.reduce(function (hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }

  var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
      placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  };

  function arrow(_ref) {
    var _state$modifiersData$;

    var state = _ref.state,
        name = _ref.name,
        options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement$1(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left, right].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';

    if (!arrowElement || !popperOffsets) {
      return;
    }

    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top : left;
    var maxProp = axis === 'y' ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds

    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...

    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
  }

  function effect$1(_ref2) {
    var state = _ref2.state,
        options = _ref2.options;
    var _options$element = options.element,
        arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

    if (arrowElement == null) {
      return;
    } // CSS selector


    if (typeof arrowElement === 'string') {
      arrowElement = state.elements.popper.querySelector(arrowElement);

      if (!arrowElement) {
        return;
      }
    }

    if (process.env.NODE_ENV !== "production") {
      if (!isHTMLElement(arrowElement)) {
        console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
      }
    }

    if (!contains(state.elements.popper, arrowElement)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
      }

      return;
    }

    state.elements.arrow = arrowElement;
  } // eslint-disable-next-line import/no-unused-modules


  var arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$1,
    requires: ['popperOffsets'],
    requiresIfExists: ['preventOverflow']
  };

  function getVariation(placement) {
    return placement.split('-')[1];
  }

  var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }; // Round the offsets to the nearest suitable subpixel based on the DPR.
  // Zooming can change the DPR, but it seems to report a value that will
  // cleanly divide the values into the appropriate subpixels.

  function roundOffsetsByDPR(_ref) {
    var x = _ref.x,
        y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: round(x * dpr) / dpr || 0,
      y: round(y * dpr) / dpr || 0
    };
  }

  function mapToStyles(_ref2) {
    var _Object$assign2;

    var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        variation = _ref2.variation,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive,
        roundOffsets = _ref2.roundOffsets,
        isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x,
        x = _offsets$x === void 0 ? 0 : _offsets$x,
        _offsets$y = offsets.y,
        y = _offsets$y === void 0 ? 0 : _offsets$y;

    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };

    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left;
    var sideY = top;
    var win = window;

    if (adaptive) {
      var offsetParent = getOffsetParent(popper);
      var heightProp = 'clientHeight';
      var widthProp = 'clientWidth';

      if (offsetParent === getWindow(popper)) {
        offsetParent = getDocumentElement(popper);

        if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
          heightProp = 'scrollHeight';
          widthProp = 'scrollWidth';
        }
      } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


      offsetParent = offsetParent;

      if (placement === top || (placement === left || placement === right) && variation === end) {
        sideY = bottom;
        var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
        offsetParent[heightProp];
        y -= offsetY - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }

      if (placement === left || (placement === top || placement === bottom) && variation === end) {
        sideX = right;
        var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
        offsetParent[widthProp];
        x -= offsetX - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }

    var commonStyles = Object.assign({
      position: position
    }, adaptive && unsetSides);

    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };

    x = _ref4.x;
    y = _ref4.y;

    if (gpuAcceleration) {
      var _Object$assign;

      return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }

    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
  }

  function computeStyles(_ref5) {
    var state = _ref5.state,
        options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
        _options$roundOffsets = options.roundOffsets,
        roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

    if (process.env.NODE_ENV !== "production") {
      var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

      if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
        return transitionProperty.indexOf(property) >= 0;
      })) {
        console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
      }
    }

    var commonStyles = {
      placement: getBasePlacement$1(state.placement),
      variation: getVariation(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration: gpuAcceleration,
      isFixed: state.options.strategy === 'fixed'
    };

    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
      })));
    }

    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
      })));
    }

    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-placement': state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
  };
  var passive = {
    passive: true
  };

  function effect(_ref) {
    var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
    var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
    var window = getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.addEventListener('resize', instance.update, passive);
    }

    return function () {
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.removeEventListener('scroll', instance.update, passive);
        });
      }

      if (resize) {
        window.removeEventListener('resize', instance.update, passive);
      }
    };
  } // eslint-disable-next-line import/no-unused-modules


  var eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
  };
  var hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };

  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash$1[matched];
    });
  }

  var hash = {
    start: 'end',
    end: 'start'
  };

  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function (matched) {
      return hash[matched];
    });
  }

  function getWindowScroll(node) {
    var win = getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }

  function getViewportRect(element) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.

    if (visualViewport) {
      width = visualViewport.width;
      height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
      // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
      // errors due to floating point numbers, so we need to check precision.
      // Safari returns a number <= 0, usually < -1 when pinch-zoomed
      // Feature detection fails in mobile emulation mode in Chrome.
      // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
      // 0.001
      // Fallback here: "Not Safari" userAgent

      if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }

    return {
      width: width,
      height: height,
      x: x + getWindowScrollBarX(element),
      y: y
    };
  } // of the `<html>` and `<body>` rect bounds if horizontally scrollable


  function getDocumentRect(element) {
    var _element$ownerDocumen;

    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;

    if (getComputedStyle(body || html).direction === 'rtl') {
      x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
    }

    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  }

  function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;

    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }

  function getScrollParent(node) {
    if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return node.ownerDocument.body;
    }

    if (isHTMLElement(node) && isScrollParent(node)) {
      return node;
    }

    return getScrollParent(getParentNode(node));
  }
  /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */


  function listScrollParents(element, list) {
    var _element$ownerDocumen;

    if (list === void 0) {
      list = [];
    }

    var scrollParent = getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)));
  }

  function rectToClientRect(rect) {
    return Object.assign({}, rect, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }

  function getInnerBoundingClientRect(element) {
    var rect = getBoundingClientRect(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }

  function getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  } // A "clipping parent" is an overflowable container with the characteristic of
  // clipping (or hiding) overflowing elements with a position different from
  // `initial`


  function getClippingParents(element) {
    var clippingParents = listScrollParents(getParentNode(element));
    var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

    if (!isElement$1(clipperElement)) {
      return [];
    } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


    return clippingParents.filter(function (clippingParent) {
      return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
    });
  } // Gets the maximum area that the element is visible in due to any number of
  // clipping parents


  function getClippingRect(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent);
      accRect.top = max(rect.top, accRect.top);
      accRect.right = min(rect.right, accRect.right);
      accRect.bottom = min(rect.bottom, accRect.bottom);
      accRect.left = max(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }

  function computeOffsets(_ref) {
    var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement$1(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;

    switch (basePlacement) {
      case top:
        offsets = {
          x: commonX,
          y: reference.y - element.height
        };
        break;

      case bottom:
        offsets = {
          x: commonX,
          y: reference.y + reference.height
        };
        break;

      case right:
        offsets = {
          x: reference.x + reference.width,
          y: commonY
        };
        break;

      case left:
        offsets = {
          x: reference.x - element.width,
          y: commonY
        };
        break;

      default:
        offsets = {
          x: reference.x,
          y: reference.y
        };
    }

    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

    if (mainAxis != null) {
      var len = mainAxis === 'y' ? 'height' : 'width';

      switch (variation) {
        case start:
          offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
          break;

        case end:
          offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
          break;
      }
    }

    return offsets;
  }

  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$placement = _options.placement,
        placement = _options$placement === void 0 ? state.placement : _options$placement,
        _options$boundary = _options.boundary,
        boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = getBoundingClientRect(state.elements.reference);
    var popperOffsets = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      strategy: 'absolute',
      placement: placement
    });
    var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect

    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

    if (elementContext === popper && offsetData) {
      var offset = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function (key) {
        var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
        overflowOffsets[key] += offset[axis] * multiply;
      });
    }

    return overflowOffsets;
  }

  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
      return getVariation(placement) === variation;
    }) : basePlacements;
    var allowedPlacements = placements$1.filter(function (placement) {
      return allowedAutoPlacements.indexOf(placement) >= 0;
    });

    if (allowedPlacements.length === 0) {
      allowedPlacements = placements$1;

      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
      }
    } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


    var overflows = allowedPlacements.reduce(function (acc, placement) {
      acc[placement] = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding
      })[getBasePlacement$1(placement)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function (a, b) {
      return overflows[a] - overflows[b];
    });
  }

  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement$1(placement) === auto) {
      return [];
    }

    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }

  function flip(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;

    if (state.modifiersData[name]._skip) {
      return;
    }

    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement$1(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
      return acc.concat(getBasePlacement$1(placement) === auto ? computeAutoPlacement(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        flipVariations: flipVariations,
        allowedAutoPlacements: allowedAutoPlacements
      }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];

    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];

      var _basePlacement = getBasePlacement$1(placement);

      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
      var len = isVertical ? 'width' : 'height';
      var overflow = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        altBoundary: altBoundary,
        padding: padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }

      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];

      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }

      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }

      if (checks.every(function (check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }

      checksMap.set(placement, checks);
    }

    if (makeFallbackChecks) {
      // `2` may be desired in some cases – research later
      var numberOfChecks = flipVariations ? 3 : 1;

      var _loop = function _loop(_i) {
        var fittingPlacement = placements.find(function (placement) {
          var checks = checksMap.get(placement);

          if (checks) {
            return checks.slice(0, _i).every(function (check) {
              return check;
            });
          }
        });

        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };

      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);

        if (_ret === "break") break;
      }
    }

    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  } // eslint-disable-next-line import/no-unused-modules


  var flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: ['offset'],
    data: {
      _skip: false
    }
  };

  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }

    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }

  function isAnySideFullyClipped(overflow) {
    return [top, right, bottom, left].some(function (side) {
      return overflow[side] >= 0;
    });
  }

  function hide(_ref) {
    var state = _ref.state,
        name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
      referenceClippingOffsets: referenceClippingOffsets,
      popperEscapeOffsets: popperEscapeOffsets,
      isReferenceHidden: isReferenceHidden,
      hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-reference-hidden': isReferenceHidden,
      'data-popper-escaped': hasPopperEscaped
    });
  } // eslint-disable-next-line import/no-unused-modules


  var hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: hide
  };

  function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement$1(placement);
    var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
        skidding = _ref[0],
        distance = _ref[1];

    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left, right].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }

  function offset(_ref2) {
    var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
    var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function (acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;

    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var offset$1 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: offset
  };

  function popperOffsets(_ref) {
    var state = _ref.state,
        name = _ref.name; // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step

    state.modifiersData[name] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      strategy: 'absolute',
      placement: state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
  };

  function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
  }

  function preventOverflow(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement$1(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
      placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
      mainAxis: tetherOffsetValue,
      altAxis: tetherOffsetValue
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
      x: 0,
      y: 0
    };

    if (!popperOffsets) {
      return;
    }

    if (checkMainAxis) {
      var _offsetModifierState$;

      var mainSide = mainAxis === 'y' ? top : left;
      var altSide = mainAxis === 'y' ? bottom : right;
      var len = mainAxis === 'y' ? 'height' : 'width';
      var offset = popperOffsets[mainAxis];
      var min$1 = offset + overflow[mainSide];
      var max$1 = offset - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
      // outside the reference bounds

      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
      // to include its full size in the calculation. If the reference is small
      // and near the edge of a boundary, the popper can overflow even if the
      // reference is not overflowing as well (e.g. virtual elements with no
      // width or height)

      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
      var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = offset + maxOffset - offsetModifierValue;
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _offsetModifierState$2;

      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _len = altAxis === 'y' ? 'height' : 'width';

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

      var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

      var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

      var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

      var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: ['offset']
  };

  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  function getNodeScroll(node) {
    if (node === getWindow(node) || !isHTMLElement(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }

  function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = round(rect.width) / element.offsetWidth || 1;
    var scaleY = round(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
  } // Returns the composite rect of an element relative to its offsetParent.
  // Composite means it takes into account transforms as well as layout.


  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }

    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };

    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }

      if (isHTMLElement(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent, true);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }

    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }

  function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function (modifier) {
      map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively

    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function (dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);

          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }

    modifiers.forEach(function (modifier) {
      if (!visited.has(modifier.name)) {
        // check for visited object
        sort(modifier);
      }
    });
    return result;
  }

  function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase

    return modifierPhases.reduce(function (acc, phase) {
      return acc.concat(orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }

  function debounce$1(fn) {
    var pending;
    return function () {
      if (!pending) {
        pending = new Promise(function (resolve) {
          Promise.resolve().then(function () {
            pending = undefined;
            resolve(fn());
          });
        });
      }

      return pending;
    };
  }

  function format(str) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return [].concat(args).reduce(function (p, c) {
      return p.replace(/%s/, c);
    }, str);
  }

  var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
  var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
  var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];

  function validateModifiers(modifiers) {
    modifiers.forEach(function (modifier) {
      [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
      .filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).forEach(function (key) {
        switch (key) {
          case 'name':
            if (typeof modifier.name !== 'string') {
              console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
            }

            break;

          case 'enabled':
            if (typeof modifier.enabled !== 'boolean') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
            }

            break;

          case 'phase':
            if (modifierPhases.indexOf(modifier.phase) < 0) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
            }

            break;

          case 'fn':
            if (typeof modifier.fn !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'effect':
            if (modifier.effect != null && typeof modifier.effect !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'requires':
            if (modifier.requires != null && !Array.isArray(modifier.requires)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
            }

            break;

          case 'requiresIfExists':
            if (!Array.isArray(modifier.requiresIfExists)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
            }

            break;

          case 'options':
          case 'data':
            break;

          default:
            console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
              return "\"" + s + "\"";
            }).join(', ') + "; but \"" + key + "\" was provided.");
        }

        modifier.requires && modifier.requires.forEach(function (requirement) {
          if (modifiers.find(function (mod) {
            return mod.name === requirement;
          }) == null) {
            console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
          }
        });
      });
    });
  }

  function uniqueBy(arr, fn) {
    var identifiers = new Set();
    return arr.filter(function (item) {
      var identifier = fn(item);

      if (!identifiers.has(identifier)) {
        identifiers.add(identifier);
        return true;
      }
    });
  }

  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function (merged, current) {
      var existing = merged[current.name];
      merged[current.name] = existing ? Object.assign({}, existing, current, {
        options: Object.assign({}, existing.options, current.options),
        data: Object.assign({}, existing.data, current.data)
      }) : current;
      return merged;
    }, {}); // IE11 does not support Object.values

    return Object.keys(merged).map(function (key) {
      return merged[key];
    });
  }

  var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
  var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
  var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
  };

  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return !args.some(function (element) {
      return !(element && typeof element.getBoundingClientRect === 'function');
    });
  }

  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }

    var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var state = {
        placement: 'bottom',
        orderedModifiers: [],
        options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
        modifiersData: {},
        elements: {
          reference: reference,
          popper: popper
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance = {
        state: state,
        setOptions: function setOptions(setOptionsAction) {
          var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
          cleanupModifierEffects();
          state.options = Object.assign({}, defaultOptions, state.options, options);
          state.scrollParents = {
            reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
            popper: listScrollParents(popper)
          }; // Orders the modifiers based on their dependencies and `phase`
          // properties

          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

          state.orderedModifiers = orderedModifiers.filter(function (m) {
            return m.enabled;
          }); // Validate the provided modifiers so that the consumer will get warned
          // if one of the modifiers is invalid for any reason

          if (process.env.NODE_ENV !== "production") {
            var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
              var name = _ref.name;
              return name;
            });
            validateModifiers(modifiers);

            if (getBasePlacement$1(state.options.placement) === auto) {
              var flipModifier = state.orderedModifiers.find(function (_ref2) {
                var name = _ref2.name;
                return name === 'flip';
              });

              if (!flipModifier) {
                console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
              }
            }

            var _getComputedStyle = getComputedStyle(popper),
                marginTop = _getComputedStyle.marginTop,
                marginRight = _getComputedStyle.marginRight,
                marginBottom = _getComputedStyle.marginBottom,
                marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
            // cause bugs with positioning, so we'll warn the consumer


            if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
              return parseFloat(margin);
            })) {
              console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
            }
          }

          runModifierEffects();
          return instance.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }

          var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
          // anymore

          if (!areValidElements(reference, popper)) {
            if (process.env.NODE_ENV !== "production") {
              console.error(INVALID_ELEMENT_ERROR);
            }

            return;
          } // Store the reference and popper rects to be read by modifiers


          state.rects = {
            reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
            popper: getLayoutRect(popper)
          }; // Modifiers have the ability to reset the current update cycle. The
          // most common use case for this is the `flip` modifier changing the
          // placement, which then needs to re-run all the modifiers, because the
          // logic was previously ran for the previous placement and is therefore
          // stale/incorrect

          state.reset = false;
          state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
          // is filled with the initial data specified by the modifier. This means
          // it doesn't persist and is fresh on each update.
          // To ensure persistent data, use `${name}#persistent`

          state.orderedModifiers.forEach(function (modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });
          var __debug_loops__ = 0;

          for (var index = 0; index < state.orderedModifiers.length; index++) {
            if (process.env.NODE_ENV !== "production") {
              __debug_loops__ += 1;

              if (__debug_loops__ > 100) {
                console.error(INFINITE_LOOP_ERROR);
                break;
              }
            }

            if (state.reset === true) {
              state.reset = false;
              index = -1;
              continue;
            }

            var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
                name = _state$orderedModifie.name;

            if (typeof fn === 'function') {
              state = fn({
                state: state,
                options: _options,
                name: name,
                instance: instance
              }) || state;
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: debounce$1(function () {
          return new Promise(function (resolve) {
            instance.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };

      if (!areValidElements(reference, popper)) {
        if (process.env.NODE_ENV !== "production") {
          console.error(INVALID_ELEMENT_ERROR);
        }

        return instance;
      }

      instance.setOptions(options).then(function (state) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state);
        }
      }); // Modifiers have the ability to execute arbitrary code before the first
      // update cycle runs. They will be executed in the same order as the update
      // cycle. This is useful when a modifier adds some persistent data that
      // other modifiers need to use, but the modifier is run after the dependent
      // one.

      function runModifierEffects() {
        state.orderedModifiers.forEach(function (_ref3) {
          var name = _ref3.name,
              _ref3$options = _ref3.options,
              options = _ref3$options === void 0 ? {} : _ref3$options,
              effect = _ref3.effect;

          if (typeof effect === 'function') {
            var cleanupFn = effect({
              state: state,
              name: name,
              instance: instance,
              options: options
            });

            var noopFn = function noopFn() {};

            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }

      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function (fn) {
          return fn();
        });
        effectCleanupFns = [];
      }

      return instance;
    };
  }

  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
  var createPopper = /*#__PURE__*/popperGenerator({
    defaultModifiers: defaultModifiers
  }); // eslint-disable-next-line import/no-unused-modules

  /**!
  * tippy.js v6.3.7
  * (c) 2017-2021 atomiks
  * MIT License
  */

  var BOX_CLASS = "tippy-box";
  var CONTENT_CLASS = "tippy-content";
  var BACKDROP_CLASS = "tippy-backdrop";
  var ARROW_CLASS = "tippy-arrow";
  var SVG_ARROW_CLASS = "tippy-svg-arrow";
  var TOUCH_OPTIONS = {
    passive: true,
    capture: true
  };

  var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
  };

  function hasOwnProperty(obj, key) {
    return {}.hasOwnProperty.call(obj, key);
  }

  function getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
      var v = value[index];
      return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }

    return value;
  }

  function isType(value, type) {
    var str = {}.toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
  }

  function invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
  }

  function debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) {
      return fn;
    }

    var timeout;
    return function (arg) {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn(arg);
      }, ms);
    };
  }

  function removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function (key) {
      delete clone[key];
    });
    return clone;
  }

  function splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
  }

  function normalizeToArray(value) {
    return [].concat(value);
  }

  function pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }

  function unique(arr) {
    return arr.filter(function (item, index) {
      return arr.indexOf(item) === index;
    });
  }

  function getBasePlacement(placement) {
    return placement.split('-')[0];
  }

  function arrayFrom(value) {
    return [].slice.call(value);
  }

  function removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function (acc, key) {
      if (obj[key] !== undefined) {
        acc[key] = obj[key];
      }

      return acc;
    }, {});
  }

  function div() {
    return document.createElement('div');
  }

  function isElement(value) {
    return ['Element', 'Fragment'].some(function (type) {
      return isType(value, type);
    });
  }

  function isNodeList(value) {
    return isType(value, 'NodeList');
  }

  function isMouseEvent(value) {
    return isType(value, 'MouseEvent');
  }

  function isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
  }

  function getArrayOfElements(value) {
    if (isElement(value)) {
      return [value];
    }

    if (isNodeList(value)) {
      return arrayFrom(value);
    }

    if (Array.isArray(value)) {
      return value;
    }

    return arrayFrom(document.querySelectorAll(value));
  }

  function setTransitionDuration(els, value) {
    els.forEach(function (el) {
      if (el) {
        el.style.transitionDuration = value + "ms";
      }
    });
  }

  function setVisibilityState(els, state) {
    els.forEach(function (el) {
      if (el) {
        el.setAttribute('data-state', state);
      }
    });
  }

  function getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;

    var _normalizeToArray = normalizeToArray(elementOrElements),
        element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
  }

  function isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX,
        clientY = event.clientY;
    return popperTreeData.every(function (_ref) {
      var popperRect = _ref.popperRect,
          popperState = _ref.popperState,
          props = _ref.props;
      var interactiveBorder = props.interactiveBorder;
      var basePlacement = getBasePlacement(popperState.placement);
      var offsetData = popperState.modifiersData.offset;

      if (!offsetData) {
        return true;
      }

      var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
      var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
      var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
      var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
      var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
      var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
      var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
      var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
      return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
  }

  function updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      box[method](event, listener);
    });
  }
  /**
   * Compared to xxx.contains, this function works for dom structures with shadow
   * dom
   */


  function actualContains(parent, child) {
    var target = child;

    while (target) {
      var _target$getRootNode;

      if (parent.contains(target)) {
        return true;
      }

      target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }

    return false;
  }

  var currentInput = {
    isTouch: false
  };
  var lastMouseMoveTime = 0;
  /**
   * When a `touchstart` event is fired, it's assumed the user is using touch
   * input. We'll bind a `mousemove` event listener to listen for mouse input in
   * the future. This way, the `isTouch` property is fully dynamic and will handle
   * hybrid devices that use a mix of touch + mouse input.
   */

  function onDocumentTouchStart() {
    if (currentInput.isTouch) {
      return;
    }

    currentInput.isTouch = true;

    if (window.performance) {
      document.addEventListener('mousemove', onDocumentMouseMove);
    }
  }
  /**
   * When two `mousemove` event are fired consecutively within 20ms, it's assumed
   * the user is using mouse input again. `mousemove` can fire on touch devices as
   * well, but very rarely that quickly.
   */


  function onDocumentMouseMove() {
    var now = performance.now();

    if (now - lastMouseMoveTime < 20) {
      currentInput.isTouch = false;
      document.removeEventListener('mousemove', onDocumentMouseMove);
    }

    lastMouseMoveTime = now;
  }
  /**
   * When an element is in focus and has a tippy, leaving the tab/window and
   * returning causes it to show again. For mouse users this is unexpected, but
   * for keyboard use it makes sense.
   * TODO: find a better technique to solve this problem
   */


  function onWindowBlur() {
    var activeElement = document.activeElement;

    if (isReferenceElement(activeElement)) {
      var instance = activeElement._tippy;

      if (activeElement.blur && !instance.state.isVisible) {
        activeElement.blur();
      }
    }
  }

  function bindGlobalEventListeners() {
    document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
    window.addEventListener('blur', onWindowBlur);
  }

  var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined';
  var isIE11 = isBrowser$1 ? // @ts-ignore
  !!window.msCrypto : false;

  function createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
  }

  function clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
  }

  function getDevMessage(message) {
    return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
  }

  function getFormattedMessage(message) {
    return [getDevMessage(message), // title
    'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
    'line-height: 1.5', // footer
    'color: #a6a095;'];
  } // Assume warnings and errors never have the same message


  var visitedMessages;

  if (process.env.NODE_ENV !== "production") {
    resetVisitedMessages();
  }

  function resetVisitedMessages() {
    visitedMessages = new Set();
  }

  function warnWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
      var _console;

      visitedMessages.add(message);

      (_console = console).warn.apply(_console, getFormattedMessage(message));
    }
  }

  function errorWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
      var _console2;

      visitedMessages.add(message);

      (_console2 = console).error.apply(_console2, getFormattedMessage(message));
    }
  }

  function validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
    errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
  }

  var pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
  };
  var renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
  };
  var defaultProps = Object.assign({
    appendTo: TIPPY_DEFAULT_APPEND_TO,
    aria: {
      content: 'auto',
      expanded: 'auto'
    },
    delay: 0,
    duration: [300, 250],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [0, 10],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
  }, pluginProps, renderProps);
  var defaultKeys = Object.keys(defaultProps);

  var setDefaultProps = function setDefaultProps(partialProps) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      validateProps(partialProps, []);
    }

    var keys = Object.keys(partialProps);
    keys.forEach(function (key) {
      defaultProps[key] = partialProps[key];
    });
  };

  function getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function (acc, plugin) {
      var name = plugin.name,
          defaultValue = plugin.defaultValue;

      if (name) {
        var _name;

        acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
      }

      return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
  }

  function getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
      plugins: plugins
    }))) : defaultKeys;
    var props = propKeys.reduce(function (acc, key) {
      var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

      if (!valueAsString) {
        return acc;
      }

      if (key === 'content') {
        acc[key] = valueAsString;
      } else {
        try {
          acc[key] = JSON.parse(valueAsString);
        } catch (e) {
          acc[key] = valueAsString;
        }
      }

      return acc;
    }, {});
    return props;
  }

  function evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
      content: invokeWithArgsOrReturn(props.content, [reference])
    }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, defaultProps.aria, out.aria);
    out.aria = {
      expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
      content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
  }

  function validateProps(partialProps, plugins) {
    if (partialProps === void 0) {
      partialProps = {};
    }

    if (plugins === void 0) {
      plugins = [];
    }

    var keys = Object.keys(partialProps);
    keys.forEach(function (prop) {
      var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
      var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

      if (didPassUnknownProp) {
        didPassUnknownProp = plugins.filter(function (plugin) {
          return plugin.name === prop;
        }).length === 0;
      }

      warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
    });
  }

  var innerHTML = function innerHTML() {
    return 'innerHTML';
  };

  function dangerouslySetInnerHTML(element, html) {
    element[innerHTML()] = html;
  }

  function createArrowElement(value) {
    var arrow = div();

    if (value === true) {
      arrow.className = ARROW_CLASS;
    } else {
      arrow.className = SVG_ARROW_CLASS;

      if (isElement(value)) {
        arrow.appendChild(value);
      } else {
        dangerouslySetInnerHTML(arrow, value);
      }
    }

    return arrow;
  }

  function setContent(content, props) {
    if (isElement(props.content)) {
      dangerouslySetInnerHTML(content, '');
      content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
      if (props.allowHTML) {
        dangerouslySetInnerHTML(content, props.content);
      } else {
        content.textContent = props.content;
      }
    }
  }

  function getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = arrayFrom(box.children);
    return {
      box: box,
      content: boxChildren.find(function (node) {
        return node.classList.contains(CONTENT_CLASS);
      }),
      arrow: boxChildren.find(function (node) {
        return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
      }),
      backdrop: boxChildren.find(function (node) {
        return node.classList.contains(BACKDROP_CLASS);
      })
    };
  }

  function render(instance) {
    var popper = div();
    var box = div();
    box.className = BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = div();
    content.className = CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);

    function onUpdate(prevProps, nextProps) {
      var _getChildren = getChildren(popper),
          box = _getChildren.box,
          content = _getChildren.content,
          arrow = _getChildren.arrow;

      if (nextProps.theme) {
        box.setAttribute('data-theme', nextProps.theme);
      } else {
        box.removeAttribute('data-theme');
      }

      if (typeof nextProps.animation === 'string') {
        box.setAttribute('data-animation', nextProps.animation);
      } else {
        box.removeAttribute('data-animation');
      }

      if (nextProps.inertia) {
        box.setAttribute('data-inertia', '');
      } else {
        box.removeAttribute('data-inertia');
      }

      box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

      if (nextProps.role) {
        box.setAttribute('role', nextProps.role);
      } else {
        box.removeAttribute('role');
      }

      if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
        setContent(content, instance.props);
      }

      if (nextProps.arrow) {
        if (!arrow) {
          box.appendChild(createArrowElement(nextProps.arrow));
        } else if (prevProps.arrow !== nextProps.arrow) {
          box.removeChild(arrow);
          box.appendChild(createArrowElement(nextProps.arrow));
        }
      } else if (arrow) {
        box.removeChild(arrow);
      }
    }

    return {
      popper: popper,
      onUpdate: onUpdate
    };
  } // Runtime check to identify if the render function is the default one; this
  // way we can apply default CSS transitions logic and it can be tree-shaken away


  render.$$tippy = true;
  var idCounter = 1;
  var mouseMoveListeners = []; // Used by `hideAll()`

  var mountedInstances = [];

  function createTippy(reference, passedProps) {
    var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================

    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================

    var id = idCounter++;
    var popperInstance = null;
    var plugins = unique(props.plugins);
    var state = {
      // Is the instance currently enabled?
      isEnabled: true,
      // Is the tippy currently showing and not transitioning out?
      isVisible: false,
      // Has the instance been destroyed?
      isDestroyed: false,
      // Is the tippy currently mounted to the DOM?
      isMounted: false,
      // Has the tippy finished transitioning in?
      isShown: false
    };
    var instance = {
      // properties
      id: id,
      reference: reference,
      popper: div(),
      popperInstance: popperInstance,
      props: props,
      state: state,
      plugins: plugins,
      // methods
      clearDelayTimeouts: clearDelayTimeouts,
      setProps: setProps,
      setContent: setContent,
      show: show,
      hide: hide,
      hideWithInteractivity: hideWithInteractivity,
      enable: enable,
      disable: disable,
      unmount: unmount,
      destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser

    /* istanbul ignore if */

    if (!props.render) {
      if (process.env.NODE_ENV !== "production") {
        errorWhen(true, 'render() function has not been supplied.');
      }

      return instance;
    } // ===========================================================================
    // Initial mutations
    // ===========================================================================


    var _props$render = props.render(instance),
        popper = _props$render.popper,
        onUpdate = _props$render.onUpdate;

    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function (plugin) {
      return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [instance]);

    if (props.showOnCreate) {
      scheduleShow();
    } // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding


    popper.addEventListener('mouseenter', function () {
      if (instance.props.interactive && instance.state.isVisible) {
        instance.clearDelayTimeouts();
      }
    });
    popper.addEventListener('mouseleave', function () {
      if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
      }
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================

    function getNormalizedTouchSettings() {
      var touch = instance.props.touch;
      return Array.isArray(touch) ? touch : [touch, 0];
    }

    function getIsCustomTouchBehavior() {
      return getNormalizedTouchSettings()[0] === 'hold';
    }

    function getIsDefaultRenderFn() {
      var _instance$props$rende; // @ts-ignore


      return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }

    function getCurrentTarget() {
      return currentTarget || reference;
    }

    function getDocument() {
      var parent = getCurrentTarget().parentNode;
      return parent ? getOwnerDocument(parent) : document;
    }

    function getDefaultTemplateChildren() {
      return getChildren(popper);
    }

    function getDelay(isShow) {
      // For touch or keyboard input, force `0` delay for UX reasons
      // Also if the instance is mounted but not visible (transitioning out),
      // ignore delay
      if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
        return 0;
      }

      return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
    }

    function handleStyles(fromHide) {
      if (fromHide === void 0) {
        fromHide = false;
      }

      popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
      popper.style.zIndex = "" + instance.props.zIndex;
    }

    function invokeHook(hook, args, shouldInvokePropsHook) {
      if (shouldInvokePropsHook === void 0) {
        shouldInvokePropsHook = true;
      }

      pluginsHooks.forEach(function (pluginHooks) {
        if (pluginHooks[hook]) {
          pluginHooks[hook].apply(pluginHooks, args);
        }
      });

      if (shouldInvokePropsHook) {
        var _instance$props;

        (_instance$props = instance.props)[hook].apply(_instance$props, args);
      }
    }

    function handleAriaContentAttribute() {
      var aria = instance.props.aria;

      if (!aria.content) {
        return;
      }

      var attr = "aria-" + aria.content;
      var id = popper.id;
      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        var currentValue = node.getAttribute(attr);

        if (instance.state.isVisible) {
          node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
        } else {
          var nextValue = currentValue && currentValue.replace(id, '').trim();

          if (nextValue) {
            node.setAttribute(attr, nextValue);
          } else {
            node.removeAttribute(attr);
          }
        }
      });
    }

    function handleAriaExpandedAttribute() {
      if (hasAriaExpanded || !instance.props.aria.expanded) {
        return;
      }

      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        if (instance.props.interactive) {
          node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
        } else {
          node.removeAttribute('aria-expanded');
        }
      });
    }

    function cleanupInteractiveMouseListeners() {
      getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
      mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
        return listener !== debouncedOnMouseMove;
      });
    }

    function onDocumentPress(event) {
      // Moved finger to scroll instead of an intentional tap outside
      if (currentInput.isTouch) {
        if (didTouchMove || event.type === 'mousedown') {
          return;
        }
      }

      var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

      if (instance.props.interactive && actualContains(popper, actualTarget)) {
        return;
      } // Clicked on the event listeners target


      if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
        return actualContains(el, actualTarget);
      })) {
        if (currentInput.isTouch) {
          return;
        }

        if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
          return;
        }
      } else {
        invokeHook('onClickOutside', [instance, event]);
      }

      if (instance.props.hideOnClick === true) {
        instance.clearDelayTimeouts();
        instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
        // currentTarget. This lets a tippy with `focus` trigger know that it
        // should not show

        didHideDueToDocumentMouseDown = true;
        setTimeout(function () {
          didHideDueToDocumentMouseDown = false;
        }); // The listener gets added in `scheduleShow()`, but this may be hiding it
        // before it shows, and hide()'s early bail-out behavior can prevent it
        // from being cleaned up

        if (!instance.state.isMounted) {
          removeDocumentPress();
        }
      }
    }

    function onTouchMove() {
      didTouchMove = true;
    }

    function onTouchStart() {
      didTouchMove = false;
    }

    function addDocumentPress() {
      var doc = getDocument();
      doc.addEventListener('mousedown', onDocumentPress, true);
      doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
      doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
      doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }

    function removeDocumentPress() {
      var doc = getDocument();
      doc.removeEventListener('mousedown', onDocumentPress, true);
      doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
      doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
      doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }

    function onTransitionedOut(duration, callback) {
      onTransitionEnd(duration, function () {
        if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
          callback();
        }
      });
    }

    function onTransitionedIn(duration, callback) {
      onTransitionEnd(duration, callback);
    }

    function onTransitionEnd(duration, callback) {
      var box = getDefaultTemplateChildren().box;

      function listener(event) {
        if (event.target === box) {
          updateTransitionEndListener(box, 'remove', listener);
          callback();
        }
      } // Make callback synchronous if duration is 0
      // `transitionend` won't fire otherwise


      if (duration === 0) {
        return callback();
      }

      updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
      updateTransitionEndListener(box, 'add', listener);
      currentTransitionEndListener = listener;
    }

    function on(eventType, handler, options) {
      if (options === void 0) {
        options = false;
      }

      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        node.addEventListener(eventType, handler, options);
        listeners.push({
          node: node,
          eventType: eventType,
          handler: handler,
          options: options
        });
      });
    }

    function addListeners() {
      if (getIsCustomTouchBehavior()) {
        on('touchstart', onTrigger, {
          passive: true
        });
        on('touchend', onMouseLeave, {
          passive: true
        });
      }

      splitBySpaces(instance.props.trigger).forEach(function (eventType) {
        if (eventType === 'manual') {
          return;
        }

        on(eventType, onTrigger);

        switch (eventType) {
          case 'mouseenter':
            on('mouseleave', onMouseLeave);
            break;

          case 'focus':
            on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
            break;

          case 'focusin':
            on('focusout', onBlurOrFocusOut);
            break;
        }
      });
    }

    function removeListeners() {
      listeners.forEach(function (_ref) {
        var node = _ref.node,
            eventType = _ref.eventType,
            handler = _ref.handler,
            options = _ref.options;
        node.removeEventListener(eventType, handler, options);
      });
      listeners = [];
    }

    function onTrigger(event) {
      var _lastTriggerEvent;

      var shouldScheduleClickHide = false;

      if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
        return;
      }

      var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
      lastTriggerEvent = event;
      currentTarget = event.currentTarget;
      handleAriaExpandedAttribute();

      if (!instance.state.isVisible && isMouseEvent(event)) {
        // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        mouseMoveListeners.forEach(function (listener) {
          return listener(event);
        });
      } // Toggle show/hide when clicking click-triggered tooltips


      if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
        shouldScheduleClickHide = true;
      } else {
        scheduleShow(event);
      }

      if (event.type === 'click') {
        isVisibleFromClick = !shouldScheduleClickHide;
      }

      if (shouldScheduleClickHide && !wasFocused) {
        scheduleHide(event);
      }
    }

    function onMouseMove(event) {
      var target = event.target;
      var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

      if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
        return;
      }

      var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
        var _instance$popperInsta;

        var instance = popper._tippy;
        var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

        if (state) {
          return {
            popperRect: popper.getBoundingClientRect(),
            popperState: state,
            props: props
          };
        }

        return null;
      }).filter(Boolean);

      if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
        cleanupInteractiveMouseListeners();
        scheduleHide(event);
      }
    }

    function onMouseLeave(event) {
      var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

      if (shouldBail) {
        return;
      }

      if (instance.props.interactive) {
        instance.hideWithInteractivity(event);
        return;
      }

      scheduleHide(event);
    }

    function onBlurOrFocusOut(event) {
      if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
        return;
      } // If focus was moved to within the popper


      if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
        return;
      }

      scheduleHide(event);
    }

    function isEventListenerStopped(event) {
      return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }

    function createPopperInstance() {
      destroyPopperInstance();
      var _instance$props2 = instance.props,
          popperOptions = _instance$props2.popperOptions,
          placement = _instance$props2.placement,
          offset = _instance$props2.offset,
          getReferenceClientRect = _instance$props2.getReferenceClientRect,
          moveTransition = _instance$props2.moveTransition;
      var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
      var computedReference = getReferenceClientRect ? {
        getBoundingClientRect: getReferenceClientRect,
        contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
      } : reference;
      var tippyModifier = {
        name: '$$tippy',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: function fn(_ref2) {
          var state = _ref2.state;

          if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh = getDefaultTemplateChildren(),
                box = _getDefaultTemplateCh.box;

            ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
              if (attr === 'placement') {
                box.setAttribute('data-placement', state.placement);
              } else {
                if (state.attributes.popper["data-popper-" + attr]) {
                  box.setAttribute("data-" + attr, '');
                } else {
                  box.removeAttribute("data-" + attr);
                }
              }
            });
            state.attributes.popper = {};
          }
        }
      };
      var modifiers = [{
        name: 'offset',
        options: {
          offset: offset
        }
      }, {
        name: 'preventOverflow',
        options: {
          padding: {
            top: 2,
            bottom: 2,
            left: 5,
            right: 5
          }
        }
      }, {
        name: 'flip',
        options: {
          padding: 5
        }
      }, {
        name: 'computeStyles',
        options: {
          adaptive: !moveTransition
        }
      }, tippyModifier];

      if (getIsDefaultRenderFn() && arrow) {
        modifiers.push({
          name: 'arrow',
          options: {
            element: arrow,
            padding: 3
          }
        });
      }

      modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
      instance.popperInstance = createPopper(computedReference, popper, Object.assign({}, popperOptions, {
        placement: placement,
        onFirstUpdate: onFirstUpdate,
        modifiers: modifiers
      }));
    }

    function destroyPopperInstance() {
      if (instance.popperInstance) {
        instance.popperInstance.destroy();
        instance.popperInstance = null;
      }
    }

    function mount() {
      var appendTo = instance.props.appendTo;
      var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
      // it's directly after the reference element so the elements inside the
      // tippy can be tabbed to
      // If there are clipping issues, the user can specify a different appendTo
      // and ensure focus management is handled correctly manually

      var node = getCurrentTarget();

      if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
        parentNode = node.parentNode;
      } else {
        parentNode = invokeWithArgsOrReturn(appendTo, [node]);
      } // The popper element needs to exist on the DOM before its position can be
      // updated as Popper needs to read its dimensions


      if (!parentNode.contains(popper)) {
        parentNode.appendChild(popper);
      }

      instance.state.isMounted = true;
      createPopperInstance();
      /* istanbul ignore else */

      if (process.env.NODE_ENV !== "production") {
        // Accessibility check
        warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
      }
    }

    function getNestedPopperTree() {
      return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }

    function scheduleShow(event) {
      instance.clearDelayTimeouts();

      if (event) {
        invokeHook('onTrigger', [instance, event]);
      }

      addDocumentPress();
      var delay = getDelay(true);

      var _getNormalizedTouchSe = getNormalizedTouchSettings(),
          touchValue = _getNormalizedTouchSe[0],
          touchDelay = _getNormalizedTouchSe[1];

      if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
        delay = touchDelay;
      }

      if (delay) {
        showTimeout = setTimeout(function () {
          instance.show();
        }, delay);
      } else {
        instance.show();
      }
    }

    function scheduleHide(event) {
      instance.clearDelayTimeouts();
      invokeHook('onUntrigger', [instance, event]);

      if (!instance.state.isVisible) {
        removeDocumentPress();
        return;
      } // For interactive tippies, scheduleHide is added to a document.body handler
      // from onMouseLeave so must intercept scheduled hides from mousemove/leave
      // events when trigger contains mouseenter and click, and the tip is
      // currently shown as a result of a click.


      if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
        return;
      }

      var delay = getDelay(false);

      if (delay) {
        hideTimeout = setTimeout(function () {
          if (instance.state.isVisible) {
            instance.hide();
          }
        }, delay);
      } else {
        // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function () {
          instance.hide();
        });
      }
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================


    function enable() {
      instance.state.isEnabled = true;
    }

    function disable() {
      // Disabling the instance should also hide it
      // https://github.com/atomiks/tippy.js-react/issues/106
      instance.hide();
      instance.state.isEnabled = false;
    }

    function clearDelayTimeouts() {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
      cancelAnimationFrame(scheduleHideAnimationFrame);
    }

    function setProps(partialProps) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
      }

      if (instance.state.isDestroyed) {
        return;
      }

      invokeHook('onBeforeUpdate', [instance, partialProps]);
      removeListeners();
      var prevProps = instance.props;
      var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
        ignoreAttributes: true
      }));
      instance.props = nextProps;
      addListeners();

      if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
        cleanupInteractiveMouseListeners();
        debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
      } // Ensure stale aria-expanded attributes are removed


      if (prevProps.triggerTarget && !nextProps.triggerTarget) {
        normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
          node.removeAttribute('aria-expanded');
        });
      } else if (nextProps.triggerTarget) {
        reference.removeAttribute('aria-expanded');
      }

      handleAriaExpandedAttribute();
      handleStyles();

      if (onUpdate) {
        onUpdate(prevProps, nextProps);
      }

      if (instance.popperInstance) {
        createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
        // and the nested ones get re-rendered first.
        // https://github.com/atomiks/tippyjs-react/issues/177
        // TODO: find a cleaner / more efficient solution(!)

        getNestedPopperTree().forEach(function (nestedPopper) {
          // React (and other UI libs likely) requires a rAF wrapper as it flushes
          // its work in one
          requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
        });
      }

      invokeHook('onAfterUpdate', [instance, partialProps]);
    }

    function setContent(content) {
      instance.setProps({
        content: content
      });
    }

    function show() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
      } // Early bail-out


      var isAlreadyVisible = instance.state.isVisible;
      var isDestroyed = instance.state.isDestroyed;
      var isDisabled = !instance.state.isEnabled;
      var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
      var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

      if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
        return;
      } // Normalize `disabled` behavior across browsers.
      // Firefox allows events on disabled elements, but Chrome doesn't.
      // Using a wrapper element (i.e. <span>) is recommended.


      if (getCurrentTarget().hasAttribute('disabled')) {
        return;
      }

      invokeHook('onShow', [instance], false);

      if (instance.props.onShow(instance) === false) {
        return;
      }

      instance.state.isVisible = true;

      if (getIsDefaultRenderFn()) {
        popper.style.visibility = 'visible';
      }

      handleStyles();
      addDocumentPress();

      if (!instance.state.isMounted) {
        popper.style.transition = 'none';
      } // If flipping to the opposite side after hiding at least once, the
      // animation will use the wrong placement without resetting the duration


      if (getIsDefaultRenderFn()) {
        var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh2.box,
            content = _getDefaultTemplateCh2.content;

        setTransitionDuration([box, content], 0);
      }

      onFirstUpdate = function onFirstUpdate() {
        var _instance$popperInsta2;

        if (!instance.state.isVisible || ignoreOnFirstUpdate) {
          return;
        }

        ignoreOnFirstUpdate = true; // reflow

        void popper.offsetHeight;
        popper.style.transition = instance.props.moveTransition;

        if (getIsDefaultRenderFn() && instance.props.animation) {
          var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
              _box = _getDefaultTemplateCh3.box,
              _content = _getDefaultTemplateCh3.content;

          setTransitionDuration([_box, _content], duration);
          setVisibilityState([_box, _content], 'visible');
        }

        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
        // popper has been positioned for the first time

        (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
        invokeHook('onMount', [instance]);

        if (instance.props.animation && getIsDefaultRenderFn()) {
          onTransitionedIn(duration, function () {
            instance.state.isShown = true;
            invokeHook('onShown', [instance]);
          });
        }
      };

      mount();
    }

    function hide() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
      } // Early bail-out


      var isAlreadyHidden = !instance.state.isVisible;
      var isDestroyed = instance.state.isDestroyed;
      var isDisabled = !instance.state.isEnabled;
      var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

      if (isAlreadyHidden || isDestroyed || isDisabled) {
        return;
      }

      invokeHook('onHide', [instance], false);

      if (instance.props.onHide(instance) === false) {
        return;
      }

      instance.state.isVisible = false;
      instance.state.isShown = false;
      ignoreOnFirstUpdate = false;
      isVisibleFromClick = false;

      if (getIsDefaultRenderFn()) {
        popper.style.visibility = 'hidden';
      }

      cleanupInteractiveMouseListeners();
      removeDocumentPress();
      handleStyles(true);

      if (getIsDefaultRenderFn()) {
        var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh4.box,
            content = _getDefaultTemplateCh4.content;

        if (instance.props.animation) {
          setTransitionDuration([box, content], duration);
          setVisibilityState([box, content], 'hidden');
        }
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();

      if (instance.props.animation) {
        if (getIsDefaultRenderFn()) {
          onTransitionedOut(duration, instance.unmount);
        }
      } else {
        instance.unmount();
      }
    }

    function hideWithInteractivity(event) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
      }

      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
      pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
      debouncedOnMouseMove(event);
    }

    function unmount() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
      }

      if (instance.state.isVisible) {
        instance.hide();
      }

      if (!instance.state.isMounted) {
        return;
      }

      destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
      // tree by default. This seems mainly for interactive tippies, but we should
      // find a workaround if possible

      getNestedPopperTree().forEach(function (nestedPopper) {
        nestedPopper._tippy.unmount();
      });

      if (popper.parentNode) {
        popper.parentNode.removeChild(popper);
      }

      mountedInstances = mountedInstances.filter(function (i) {
        return i !== instance;
      });
      instance.state.isMounted = false;
      invokeHook('onHidden', [instance]);
    }

    function destroy() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
      }

      if (instance.state.isDestroyed) {
        return;
      }

      instance.clearDelayTimeouts();
      instance.unmount();
      removeListeners();
      delete reference._tippy;
      instance.state.isDestroyed = true;
      invokeHook('onDestroy', [instance]);
    }
  }

  function tippy(targets, optionalProps) {
    if (optionalProps === void 0) {
      optionalProps = {};
    }

    var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      validateTargets(targets);
      validateProps(optionalProps, plugins);
    }

    bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
      plugins: plugins
    });
    var elements = getArrayOfElements(targets);
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      var isSingleContentElement = isElement(passedProps.content);
      var isMoreThanOneReferenceElement = elements.length > 1;
      warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
    }

    var instances = elements.reduce(function (acc, reference) {
      var instance = reference && createTippy(reference, passedProps);

      if (instance) {
        acc.push(instance);
      }

      return acc;
    }, []);
    return isElement(targets) ? instances[0] : instances;
  }

  tippy.defaultProps = defaultProps;
  tippy.setDefaultProps = setDefaultProps;
  tippy.currentInput = currentInput; // every time the popper is destroyed (i.e. a new target), removing the styles
  // and causing transitions to break for singletons when the console is open, but
  // most notably for non-transform styles being used, `gpuAcceleration: false`.

  Object.assign({}, applyStyles$1, {
    effect: function effect(_ref) {
      var state = _ref.state;
      var initialStyles = {
        popper: {
          position: state.options.strategy,
          left: '0',
          top: '0',
          margin: '0'
        },
        arrow: {
          position: 'absolute'
        },
        reference: {}
      };
      Object.assign(state.elements.popper.style, initialStyles.popper);
      state.styles = initialStyles;

      if (state.elements.arrow) {
        Object.assign(state.elements.arrow.style, initialStyles.arrow);
      } // intentionally return no cleanup function
      // return () => { ... }

    }
  });
  tippy.setDefaultProps({
    render: render
  });

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

  function preserveRef(ref, node) {
    if (ref) {
      if (typeof ref === 'function') {
        ref(node);
      }

      if ({}.hasOwnProperty.call(ref, 'current')) {
        ref.current = node;
      }
    }
  }

  function ssrSafeCreateDiv() {
    return isBrowser && document.createElement('div');
  }

  function toDataAttributes(attrs) {
    var dataAttrs = {
      'data-placement': attrs.placement
    };

    if (attrs.referenceHidden) {
      dataAttrs['data-reference-hidden'] = '';
    }

    if (attrs.escaped) {
      dataAttrs['data-escaped'] = '';
    }

    return dataAttrs;
  }

  function deepEqual(x, y) {
    if (x === y) {
      return true;
    } else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
      if (Object.keys(x).length !== Object.keys(y).length) {
        return false;
      }

      for (var prop in x) {
        if (y.hasOwnProperty(prop)) {
          if (!deepEqual(x[prop], y[prop])) {
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    } else {
      return false;
    }
  }

  function uniqueByShape(arr) {
    var output = [];
    arr.forEach(function (item) {
      if (!output.find(function (outputItem) {
        return deepEqual(item, outputItem);
      })) {
        output.push(item);
      }
    });
    return output;
  }

  function deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;

    return Object.assign({}, componentProps, {
      popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
        modifiers: uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
      })
    });
  }

  var useIsomorphicLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

  function useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = React.useRef();

    if (!ref.current) {
      ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
    }

    return ref.current;
  }

  function updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function (name) {
      if (name) {
        box.classList[action](name);
      }
    });
  }

  var classNamePlugin = {
    name: 'className',
    defaultValue: '',
    fn: function fn(instance) {
      var box = instance.popper.firstElementChild;

      var isDefaultRenderFn = function isDefaultRenderFn() {
        var _instance$props$rende;

        return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
      };

      function add() {
        if (instance.props.className && !isDefaultRenderFn()) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn(['@tippyjs/react: Cannot use `className` prop in conjunction with', '`render` prop. Place the className on the element you are', 'rendering.'].join(' '));
          }

          return;
        }

        updateClassName(box, 'add', instance.props.className);
      }

      function remove() {
        if (isDefaultRenderFn()) {
          updateClassName(box, 'remove', instance.props.className);
        }
      }

      return {
        onCreate: add,
        onBeforeUpdate: remove,
        onAfterUpdate: add
      };
    }
  };

  function TippyGenerator(tippy) {
    function Tippy(_ref) {
      var children = _ref.children,
          content = _ref.content,
          visible = _ref.visible,
          singleton = _ref.singleton,
          render = _ref.render,
          reference = _ref.reference,
          _ref$disabled = _ref.disabled,
          disabled = _ref$disabled === void 0 ? false : _ref$disabled,
          _ref$ignoreAttributes = _ref.ignoreAttributes,
          ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes;
      _ref.__source;
      _ref.__self;

      var restOfNativeProps = _objectWithoutPropertiesLoose(_ref, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]);

      var isControlledMode = visible !== undefined;
      var isSingletonMode = singleton !== undefined;

      var _useState = React.useState(false),
          mounted = _useState[0],
          setMounted = _useState[1];

      var _useState2 = React.useState({}),
          attrs = _useState2[0],
          setAttrs = _useState2[1];

      var _useState3 = React.useState(),
          singletonContent = _useState3[0],
          setSingletonContent = _useState3[1];

      var mutableBox = useMutableBox(function () {
        return {
          container: ssrSafeCreateDiv(),
          renders: 1
        };
      });
      var props = Object.assign({
        ignoreAttributes: ignoreAttributes
      }, restOfNativeProps, {
        content: mutableBox.container
      });

      if (isControlledMode) {
        if (process.env.NODE_ENV !== 'production') {
          ['trigger', 'hideOnClick', 'showOnCreate'].forEach(function (nativeStateProp) {
            if (props[nativeStateProp] !== undefined) {
              console.warn(["@tippyjs/react: Cannot specify `" + nativeStateProp + "` prop in", "controlled mode (`visible` prop)"].join(' '));
            }
          });
        }

        props.trigger = 'manual';
        props.hideOnClick = false;
      }

      if (isSingletonMode) {
        disabled = true;
      }

      var computedProps = props;
      var plugins = props.plugins || [];

      if (render) {
        computedProps = Object.assign({}, props, {
          plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [{
            fn: function fn() {
              return {
                onTrigger: function onTrigger(instance, event) {
                  var node = singleton.data.children.find(function (_ref2) {
                    var instance = _ref2.instance;
                    return instance.reference === event.currentTarget;
                  });
                  instance.state.$$activeSingletonInstance = node.instance;
                  setSingletonContent(node.content);
                }
              };
            }
          }]) : plugins,
          render: function render() {
            return {
              popper: mutableBox.container
            };
          }
        });
      }

      var deps = [reference].concat(children ? [children.type] : []); // CREATE

      useIsomorphicLayoutEffect(function () {
        var element = reference;

        if (reference && reference.hasOwnProperty('current')) {
          element = reference.current;
        }

        var instance = tippy(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
          plugins: [classNamePlugin].concat(props.plugins || [])
        }));
        mutableBox.instance = instance;

        if (disabled) {
          instance.disable();
        }

        if (visible) {
          instance.show();
        }

        if (isSingletonMode) {
          singleton.hook({
            instance: instance,
            content: content,
            props: computedProps,
            setSingletonContent: setSingletonContent
          });
        }

        setMounted(true);
        return function () {
          instance.destroy();
          singleton == null ? void 0 : singleton.cleanup(instance);
        };
      }, deps); // UPDATE

      useIsomorphicLayoutEffect(function () {
        var _instance$popperInsta; // Prevent this effect from running on 1st render


        if (mutableBox.renders === 1) {
          mutableBox.renders++;
          return;
        }

        var instance = mutableBox.instance;
        instance.setProps(deepPreserveProps(instance.props, computedProps)); // Fixes #264

        (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.forceUpdate();

        if (disabled) {
          instance.disable();
        } else {
          instance.enable();
        }

        if (isControlledMode) {
          if (visible) {
            instance.show();
          } else {
            instance.hide();
          }
        }

        if (isSingletonMode) {
          singleton.hook({
            instance: instance,
            content: content,
            props: computedProps,
            setSingletonContent: setSingletonContent
          });
        }
      });
      useIsomorphicLayoutEffect(function () {
        var _instance$props$poppe;

        if (!render) {
          return;
        }

        var instance = mutableBox.instance;
        instance.setProps({
          popperOptions: Object.assign({}, instance.props.popperOptions, {
            modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function (_ref3) {
              var name = _ref3.name;
              return name !== '$$tippyReact';
            }), [{
              name: '$$tippyReact',
              enabled: true,
              phase: 'beforeWrite',
              requires: ['computeStyles'],
              fn: function fn(_ref4) {
                var _state$modifiersData;

                var state = _ref4.state;
                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                // loop. This expression _must_ evaluate to false when required

                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) {
                  setAttrs({
                    placement: state.placement,
                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                  });
                }

                state.attributes.popper = {};
              }
            }])
          })
        });
      }, [attrs.placement, attrs.referenceHidden, attrs.escaped].concat(deps));
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children ? /*#__PURE__*/React.cloneElement(children, {
        ref: function ref(node) {
          mutableBox.ref = node;
          preserveRef(children.ref, node);
        }
      }) : null, mounted && /*#__PURE__*/reactDom.createPortal(render ? render(toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }

    return Tippy;
  }

  var forwardRef = function forwardRef(Tippy, defaultProps) {
    return /*#__PURE__*/React.forwardRef(function TippyWrapper(_ref, _ref2) {
      var children = _ref.children,
          props = _objectWithoutPropertiesLoose(_ref, ["children"]);

      return (
        /*#__PURE__*/
        // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        React__default["default"].createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/React.cloneElement(children, {
          ref: function ref(node) {
            preserveRef(_ref2, node);
            preserveRef(children.ref, node);
          }
        }) : null)
      );
    });
  };

  var index = /*#__PURE__*/forwardRef( /*#__PURE__*/TippyGenerator(tippy));
  var Tippy = index;
  var __defProp$h = Object.defineProperty;
  var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
  var __hasOwnProp$h = Object.prototype.hasOwnProperty;
  var __propIsEnum$h = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$h = function __defNormalProp$h(obj, key, value) {
    return key in obj ? __defProp$h(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$h = function __spreadValues$h(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$h.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$h) {
      var _iterator107 = _createForOfIteratorHelper(__getOwnPropSymbols$h(b)),
          _step107;

      try {
        for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
          var prop = _step107.value;
          if (__propIsEnum$h.call(b, prop)) __defNormalProp$h(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator107.e(err);
      } finally {
        _iterator107.f();
      }
    }

    return a;
  };

  var tooltipContainerStyle = function tooltipContainerStyle(sx) {
    return {
      ".tippy-box": __spreadValues$h({
        "> .tippy-content": {
          padding: 0
        },
        backgroundColor: "neutral.inverse.00",
        borderColor: "neutral.inverse.00",
        borderRadius: "xs",
        borderStyle: "solid",
        borderWidth: "hairline",
        boxShadow: "01",
        maxWidth: 240,
        padding: "inset.nano"
      }, sx)
    };
  };

  var tooltipContentStyle = {
    color: "typeface.inverse.strong",
    fontSize: "xxxs",
    fontWeight: "bold",
    letterSpacing: "standard",
    lineHeight: "distant",
    paddingBottom: "stack.quark"
  };
  var __defProp$g = Object.defineProperty;
  var __defProps$8 = Object.defineProperties;
  var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
  var __hasOwnProp$g = Object.prototype.hasOwnProperty;
  var __propIsEnum$g = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$g = function __defNormalProp$g(obj, key, value) {
    return key in obj ? __defProp$g(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$g = function __spreadValues$g(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$g.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$g) {
      var _iterator108 = _createForOfIteratorHelper(__getOwnPropSymbols$g(b)),
          _step108;

      try {
        for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
          var prop = _step108.value;
          if (__propIsEnum$g.call(b, prop)) __defNormalProp$g(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator108.e(err);
      } finally {
        _iterator108.f();
      }
    }

    return a;
  };

  var __spreadProps$8 = function __spreadProps$8(a, b) {
    return __defProps$8(a, __getOwnPropDescs$8(b));
  };

  var __objRest$f = function __objRest$f(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$g.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$g) {
      var _iterator109 = _createForOfIteratorHelper(__getOwnPropSymbols$g(source)),
          _step109;

      try {
        for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
          var prop = _step109.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$g.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator109.e(err);
      } finally {
        _iterator109.f();
      }
    }

    return target;
  };

  var Tooltip = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        children = _b.children,
        message = _b.message,
        _b$offset = _b.offset,
        offset = _b$offset === void 0 ? 10 : _b$offset,
        title = _b.title,
        _b$zIndex3 = _b.zIndex,
        zIndex = _b$zIndex3 === void 0 ? 9999 : _b$zIndex3,
        sx = _b.sx,
        _b$arrow = _b.arrow,
        arrow = _b$arrow === void 0 ? true : _b$arrow,
        props = __objRest$f(_b, ["children", "message", "offset", "title", "zIndex", "sx", "arrow"]);

    var renderContent = function renderContent() {
      return /* @__PURE__ */React__default["default"].createElement(Box, null, title && /* @__PURE__ */React__default["default"].createElement(Body, {
        sx: tooltipContentStyle
      }, title), /* @__PURE__ */React__default["default"].createElement(Caption, {
        brand: true
      }, message));
    };

    var renderArrow = function renderArrow() {
      return "\n            <svg width=\"16\" height=\"6\" viewBox=\"0 0 8 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                <path d=\"M4 0L8 4H0L4 0Z\" fill=\"".concat(defaultTheme$1.colors.neutral.inverse["00"], "\"/>\n            </svg>\n        ");
    };

    return /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: tooltipContainerStyle(sx)
    }, /* @__PURE__ */React__default["default"].createElement(Tippy, __spreadProps$8(__spreadValues$g({
      allowHTML: true,
      appendTo: "parent",
      arrow: arrow ? renderArrow() : "",
      content: renderContent(),
      interactive: true,
      maxWidth: 240,
      offset: [0, offset],
      zIndex: zIndex
    }, props), {
      ref: ref
    }), children));
  });
  var getPackStyle = {
    height: "100%",
    position: "relative",
    width: "100%"
  };
  var __defProp$f = Object.defineProperty;
  var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
  var __hasOwnProp$f = Object.prototype.hasOwnProperty;
  var __propIsEnum$f = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$f = function __defNormalProp$f(obj, key, value) {
    return key in obj ? __defProp$f(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$f = function __spreadValues$f(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$f.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$f) {
      var _iterator110 = _createForOfIteratorHelper(__getOwnPropSymbols$f(b)),
          _step110;

      try {
        for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
          var prop = _step110.value;
          if (__propIsEnum$f.call(b, prop)) __defNormalProp$f(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator110.e(err);
      } finally {
        _iterator110.f();
      }
    }

    return a;
  };

  var __objRest$e = function __objRest$e(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$f.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$f) {
      var _iterator111 = _createForOfIteratorHelper(__getOwnPropSymbols$f(source)),
          _step111;

      try {
        for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
          var prop = _step111.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$f.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator111.e(err);
      } finally {
        _iterator111.f();
      }
    }

    return target;
  };

  var Pack = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        children = _b.children,
        divider = _b.divider,
        spacing = _b.spacing,
        sx = _b.sx,
        props = __objRest$e(_b, ["children", "divider", "spacing", "sx"]);

    var renderChildrens = function renderChildrens() {
      var childrenCount = React__default["default"].Children.count(children);
      var childWithProps = React__default["default"].Children.map(children, function (child, index) {
        if (!React__default["default"].isValidElement(child)) {
          return child;
        }

        var isLastChild = index === childrenCount - 1;

        var getMarginLocation = function getMarginLocation() {
          switch (props.direction) {
            case "row":
            case "row-reverse":
              return {
                marginInline: spacing
              };

            case "column":
            case "column-reverse":
              return {
                marginBlock: spacing
              };

            default:
              return null;
          }
        };

        var renderDivider = function renderDivider() {
          var direction = props.direction ? props.direction : "column";

          if (divider && typeof divider === "boolean" && !isLastChild) {
            return /* @__PURE__ */React__default["default"].createElement(Divider, {
              variant: direction.indexOf("row") >= 0 ? "vertical" : "horizontal"
            });
          } else if (divider && typeof divider !== "boolean" && !isLastChild) {
            return divider;
          }

          return null;
        };

        return [React__default["default"].cloneElement(child, {
          sx: getMarginLocation()
        }), renderDivider()];
      });
      return /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, childWithProps);
    };

    return /* @__PURE__ */React__default["default"].createElement(Flex, __spreadValues$f({
      ref: ref,
      sx: __spreadValues$f(__spreadValues$f({}, getPackStyle), sx)
    }, props), renderChildrens());
  });
  var Keyboard;

  (function (Keyboard2) {
    Keyboard2["Escape"] = "Escape";
    Keyboard2["ArrowDown"] = "ArrowDown";
    Keyboard2["ArrowUp"] = "ArrowUp";
    Keyboard2["ArrowRight"] = "ArrowRight";
    Keyboard2["ArrowLeft"] = "ArrowLeft";
    Keyboard2["Enter"] = "Enter";
    Keyboard2["Home"] = "Home";
    Keyboard2["End"] = "End";
    Keyboard2["PageUp"] = "PageUp";
    Keyboard2["PageDown"] = "PageDown";
    Keyboard2["Space"] = "Space";
    Keyboard2["Tab"] = "Tab";
    Keyboard2["Backspace"] = "Backspace";
  })(Keyboard || (Keyboard = {}));

  var filterList = function filterList(searchText, list) {
    var sensitive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var textFormatter = searchText.toLowerCase();
    return list.filter(function (value) {
      if (sensitive) {
        return value.label.includes(searchText);
      }

      var valueUnsensitive = value.label.toLowerCase();
      return stringNormalize(valueUnsensitive).includes(stringNormalize(textFormatter));
    });
  };

  var getKeyOfKeyboard = function getKeyOfKeyboard(_ref49) {
    var key = _ref49.key,
        code = _ref49.code;
    return key.trim() ? key : code;
  };

  var basicUid = function basicUid() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return "".concat(prefix).concat(new Date().getUTCMilliseconds().toString(36));
  };

  var toggleDropUp = function toggleDropUp(target, dropdown) {
    var gutter = 16;
    var position = target.getBoundingClientRect().top;
    var targetHeight = target.getBoundingClientRect().height;
    var dropdownHeight = dropdown.getBoundingClientRect().height + gutter;
    var _window = window,
        windowHeight = _window.innerHeight;
    return position > dropdownHeight && windowHeight - position < targetHeight + dropdownHeight;
  };

  var getDropdownBaseStyle = function getDropdownBaseStyle(hover, focus, active, disabled) {
    var getBackgroundColor = function getBackgroundColor() {
      if (!disabled && active) {
        return "interaction.blend.02";
      } else if (!disabled && (hover || focus)) {
        return "interaction.blend.01";
      }

      return "transparent";
    };

    return {
      alignItems: "center",
      backgroundColor: getBackgroundColor(),
      borderColor: !disabled && !active && focus ? "interaction.select.focus" : "transparent",
      borderStyle: "solid",
      borderWidth: "thin",
      cursor: disabled ? "default" : "pointer",
      display: "flex",
      justifyContent: "space-between",
      minHeight: 40,
      outline: "none",
      padding: "squish.nano",
      width: "100%"
    };
  };

  var __defProp$e = Object.defineProperty;
  var __defProps$7 = Object.defineProperties;
  var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
  var __hasOwnProp$e = Object.prototype.hasOwnProperty;
  var __propIsEnum$e = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$e = function __defNormalProp$e(obj, key, value) {
    return key in obj ? __defProp$e(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$e = function __spreadValues$e(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$e.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$e) {
      var _iterator112 = _createForOfIteratorHelper(__getOwnPropSymbols$e(b)),
          _step112;

      try {
        for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
          var prop = _step112.value;
          if (__propIsEnum$e.call(b, prop)) __defNormalProp$e(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator112.e(err);
      } finally {
        _iterator112.f();
      }
    }

    return a;
  };

  var __spreadProps$7 = function __spreadProps$7(a, b) {
    return __defProps$7(a, __getOwnPropDescs$7(b));
  };

  var __objRest$d = function __objRest$d(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$e.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$e) {
      var _iterator113 = _createForOfIteratorHelper(__getOwnPropSymbols$e(source)),
          _step113;

      try {
        for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
          var prop = _step113.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$e.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator113.e(err);
      } finally {
        _iterator113.f();
      }
    }

    return target;
  };

  var DropdownModuleBase = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        children = _b.children,
        disabled = _b.disabled,
        selected = _b.selected,
        sx = _b.sx,
        props = __objRest$d(_b, ["children", "disabled", "selected", "sx"]);

    var _React$useState55 = React.useState(false),
        _React$useState56 = _slicedToArray(_React$useState55, 2),
        active = _React$useState56[0],
        setActive = _React$useState56[1];

    var _React$useState57 = React.useState(false),
        _React$useState58 = _slicedToArray(_React$useState57, 2),
        focus = _React$useState58[0],
        setFocus = _React$useState58[1];

    var _React$useState59 = React.useState(false),
        _React$useState60 = _slicedToArray(_React$useState59, 2),
        hover = _React$useState60[0],
        setHover = _React$useState60[1];

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$7(__spreadValues$e({}, props), {
      "aria-selected": selected,
      onBlur: function onBlur() {
        return setFocus(false);
      },
      onFocus: function onFocus() {
        return setFocus(true);
      },
      onMouseDown: function onMouseDown() {
        return setActive(true);
      },
      onMouseEnter: function onMouseEnter() {
        return setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      },
      onMouseUp: function onMouseUp() {
        return setActive(false);
      },
      ref: ref,
      role: "option",
      sx: __spreadValues$e(__spreadValues$e({}, getDropdownBaseStyle(hover, focus, active, disabled)), sx)
    }), children);
  });
  var dropdownModuleSingleLeftStyle = {
    alignItems: "center",
    display: "flex",
    pointerEvents: "none"
  };
  var __defProp$d = Object.defineProperty;
  var __defProps$6 = Object.defineProperties;
  var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
  var __hasOwnProp$d = Object.prototype.hasOwnProperty;
  var __propIsEnum$d = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$d = function __defNormalProp$d(obj, key, value) {
    return key in obj ? __defProp$d(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$d = function __spreadValues$d(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$d.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$d) {
      var _iterator114 = _createForOfIteratorHelper(__getOwnPropSymbols$d(b)),
          _step114;

      try {
        for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
          var prop = _step114.value;
          if (__propIsEnum$d.call(b, prop)) __defNormalProp$d(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator114.e(err);
      } finally {
        _iterator114.f();
      }
    }

    return a;
  };

  var __spreadProps$6 = function __spreadProps$6(a, b) {
    return __defProps$6(a, __getOwnPropDescs$6(b));
  };

  var __objRest$c = function __objRest$c(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$d.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$d) {
      var _iterator115 = _createForOfIteratorHelper(__getOwnPropSymbols$d(source)),
          _step115;

      try {
        for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
          var prop = _step115.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$d.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator115.e(err);
      } finally {
        _iterator115.f();
      }
    }

    return target;
  };

  var DropdownModuleSingle = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        disabled = _b.disabled,
        label = _b.label,
        leadingIcon = _b.leadingIcon,
        selected = _b.selected,
        props = __objRest$c(_b, ["disabled", "label", "leadingIcon", "selected"]);

    return /* @__PURE__ */React__default["default"].createElement(DropdownModuleBase, __spreadProps$6(__spreadValues$d({}, props), {
      disabled: disabled,
      ref: ref,
      selected: selected
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: dropdownModuleSingleLeftStyle
    }, leadingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: disabled ? "interaction.blend.04" : "support.01",
      mr: "inline.nano",
      size: "md"
    }, leadingIcon), selected ? /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      pb: "stack.quark",
      pr: "stack.nano",
      pt: "stack.quark",
      variant: "md"
    }, label) : /* @__PURE__ */React__default["default"].createElement(Body, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      variant: "sm"
    }, label)), selected && /* @__PURE__ */React__default["default"].createElement(Icon, {
      color: disabled ? "interaction.blend.04" : "interaction.blend.07",
      size: "md"
    }, /* @__PURE__ */React__default["default"].createElement(almaIcons.Check, null)));
  });
  var DropdownModuleMultiple = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        checked = _d.checked,
        disabled = _d.disabled,
        label = _d.label,
        props = __objRest$c(_d, ["checked", "disabled", "label"]);

    return /* @__PURE__ */React__default["default"].createElement(DropdownModuleBase, __spreadProps$6(__spreadValues$d({}, props), {
      disabled: disabled,
      ref: ref,
      selected: checked
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: dropdownModuleSingleLeftStyle
    }, /* @__PURE__ */React__default["default"].createElement(CheckBox, {
      checked: checked,
      disabled: disabled,
      readOnly: true
    }), checked ? /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      ml: "inline.nano",
      pb: "stack.quark",
      pr: "stack.nano",
      pt: "stack.quark",
      variant: "md"
    }, label) : /* @__PURE__ */React__default["default"].createElement(Body, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      ml: "inline.nano",
      variant: "sm"
    }, label)));
  });
  var commonCSS = styled.css(_templateObject6(), cssTextEllipsisOneLine, function (_ref50) {
    var focused = _ref50.focused;
    return focused && styled.css(_templateObject7(), defaultTheme$1.colors.interaction.blend["01"]);
  });
  var Option$1 = styled__default$1["default"](DropdownModuleSingle).attrs(function () {
    return {
      role: "option",
      tabIndex: -1
    };
  })(_templateObject8(), commonCSS);
  var OptionMultiple = styled__default$1["default"](DropdownModuleMultiple).attrs(function () {
    return {
      role: "option",
      tabIndex: -1
    };
  })(_templateObject9(), commonCSS);
  var nextId$2 = 0;
  var Option = React__default["default"].forwardRef(function (_ref51, ref) {
    var selected = _ref51.selected,
        focused = _ref51.focused,
        value = _ref51.value,
        multiple = _ref51.multiple,
        onClick = _ref51.onClick,
        onMouseDown = _ref51.onMouseDown;
    var innerId = React__default["default"].useMemo(function () {
      nextId$2 += 1;
      return "".concat(basicUid("o"), "_").concat(nextId$2);
    }, []);
    return /* @__PURE__ */React__default["default"].createElement("div", {
      onMouseDown: onMouseDown
    }, multiple ? /* @__PURE__ */React__default["default"].createElement(OptionMultiple, {
      checked: selected,
      disabled: value.disabled,
      focused: !!focused,
      id: innerId,
      label: value.label,
      onClick: onClick,
      ref: ref
    }) : /* @__PURE__ */React__default["default"].createElement(Option$1, {
      disabled: value.disabled,
      focused: !!focused,
      id: innerId,
      label: value.label,
      leadingIcon: value.leadingIcon,
      onClick: onClick,
      onMouseDown: onMouseDown,
      ref: ref,
      selected: selected
    }));
  });

  var useProps = function useProps() {
    var _React__default$defau11 = React__default["default"].useState(false),
        _React__default$defau12 = _slicedToArray(_React__default$defau11, 2),
        usedAsSupport = _React__default$defau12[0],
        setUsedAsSupport = _React__default$defau12[1];

    var _React__default$defau13 = React__default["default"].useState([]),
        _React__default$defau14 = _slicedToArray(_React__default$defau13, 2),
        options = _React__default$defau14[0],
        setOptions = _React__default$defau14[1];

    var _React__default$defau15 = React__default["default"].useState(null),
        _React__default$defau16 = _slicedToArray(_React__default$defau15, 2),
        activeElement = _React__default$defau16[0],
        setActiveElement = _React__default$defau16[1];

    var _React__default$defau17 = React__default["default"].useState(null),
        _React__default$defau18 = _slicedToArray(_React__default$defau17, 2),
        selectedOptionRef = _React__default$defau18[0],
        setCurrentOptionRef = _React__default$defau18[1];

    var _React__default$defau19 = React__default["default"].useState(),
        _React__default$defau20 = _slicedToArray(_React__default$defau19, 2),
        selectedOption = _React__default$defau20[0],
        setSelectedOption = _React__default$defau20[1];

    var _React__default$defau21 = React__default["default"].useState([]),
        _React__default$defau22 = _slicedToArray(_React__default$defau21, 2),
        selectedOptions = _React__default$defau22[0],
        setSelectedOptions = _React__default$defau22[1];

    var _React__default$defau23 = React__default["default"].useState(),
        _React__default$defau24 = _slicedToArray(_React__default$defau23, 2),
        focusedOption = _React__default$defau24[0],
        setFocusedOption = _React__default$defau24[1];

    var _React__default$defau25 = React__default["default"].useState(false),
        _React__default$defau26 = _slicedToArray(_React__default$defau25, 2),
        multiple = _React__default$defau26[0],
        setMultiple = _React__default$defau26[1];

    var hostRef = React__default["default"].useRef(null);
    var updateSelectedOption = React__default["default"].useCallback(function (selected) {
      setSelectedOption(selected);
      setSelectedOptions(function (previousOptions) {
        if ((selected == null ? void 0 : selected.value) === void 0 || !multiple) {
          return previousOptions;
        }

        if (previousOptions.some(function (option) {
          return option.value === selected.value;
        })) {
          return previousOptions.filter(function (option) {
            return option.value !== selected.value;
          });
        }

        return [].concat(_toConsumableArray(previousOptions), [selected]);
      });
    }, [multiple]);
    var resetSelectedOptions = React__default["default"].useCallback(function () {
      setSelectedOptions([]);
      setSelectedOption(void 0);
    }, []);
    var removeSelectedOption = React__default["default"].useCallback(function () {
      var indexTarget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      setSelectedOptions(function (previousSelectedOptions) {
        if (!previousSelectedOptions.length) {
          setSelectedOption(void 0);
          return previousSelectedOptions;
        }

        var innerIndexTarget = indexTarget !== -1 ? indexTarget : previousSelectedOptions.length - 1;
        var newSelectedOptions = previousSelectedOptions.filter(function (_, index) {
          return index !== innerIndexTarget;
        });

        var lastOption = _toConsumableArray(newSelectedOptions).pop();

        if (lastOption) {
          setSelectedOption(lastOption);
        }

        return newSelectedOptions;
      });
    }, []);
    var optionsRef = React__default["default"].useMemo(function () {
      return Array(options.length).fill("").map(function () {
        return React__default["default"].createRef();
      });
    }, [options.length]);
    var selectedIndexOption = React__default["default"].useMemo(function () {
      return selectedOption ? options.indexOf(selectedOption) : -1;
    }, [options, selectedOption]);
    var focusedIndexOption = React__default["default"].useMemo(function () {
      return focusedOption ? options.indexOf(focusedOption) : -1;
    }, [options, focusedOption]);
    React__default["default"].useEffect(function () {
      if (focusedIndexOption !== -1 && optionsRef[focusedIndexOption]) {
        setCurrentOptionRef(optionsRef[focusedIndexOption].current);
      } else if (selectedIndexOption !== -1 && optionsRef[selectedIndexOption]) {
        setCurrentOptionRef(optionsRef[selectedIndexOption].current);
      } else {
        setCurrentOptionRef(null);
      }
    }, [selectedIndexOption, optionsRef, focusedIndexOption]);

    var updateNextOption = function updateNextOption() {
      var shift = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var nextIndex = focusedIndexOption + shift;
      var index = 0;

      if (options[nextIndex]) {
        index = nextIndex;
      }

      return setFocusedOption(options[index]);
    };

    var updatePreviousOption = function updatePreviousOption() {
      var shift = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var previousIndex = focusedIndexOption - shift;
      var index = options.length - 1;

      if (previousIndex !== -1 && options[previousIndex]) {
        index = previousIndex;
      }

      return setFocusedOption(options[index]);
    };

    var handleKeyboard = function handleKeyboard(key, event) {
      switch (key) {
        case Keyboard.ArrowDown:
        case Keyboard.ArrowRight:
          updateNextOption();
          break;

        case Keyboard.ArrowUp:
        case Keyboard.ArrowLeft:
          updatePreviousOption();
          break;

        case Keyboard.PageUp:
          event.preventDefault();
          setFocusedOption(options[0]);
          break;

        case Keyboard.PageDown:
          event.preventDefault();
          setFocusedOption(function () {
            var index = options.length - 1;
            return options[index];
          });
          break;

        case Keyboard.Escape:
          setFocusedOption(void 0);
          break;

        case Keyboard.Enter:
          if (focusedOption) {
            updateSelectedOption(focusedOption);
          }

          break;
      }
    };

    return {
      activeElement: activeElement,
      focusedIndexOption: focusedIndexOption,
      focusedOption: focusedOption,
      handleKeyboard: handleKeyboard,
      hostRef: hostRef,
      options: options,
      optionsRef: optionsRef,
      removeSelectedOption: removeSelectedOption,
      resetSelectedOptions: resetSelectedOptions,
      selectedIndexOption: selectedIndexOption,
      selectedOption: selectedOption,
      selectedOptionRef: selectedOptionRef,
      selectedOptions: selectedOptions,
      setActiveElement: setActiveElement,
      setFocusedOption: setFocusedOption,
      setMultiple: setMultiple,
      setOptions: setOptions,
      setSelectedOption: setSelectedOption,
      setSelectedOptions: setSelectedOptions,
      setUsedAsSupport: setUsedAsSupport,
      updateNextOption: updateNextOption,
      updatePreviousOption: updatePreviousOption,
      updateSelectedOption: updateSelectedOption,
      usedAsSupport: usedAsSupport
    };
  };

  var Context = React__default["default"].createContext({});

  var useContext = function useContext() {
    return React__default["default"].useContext(Context);
  };

  var Provider = function Provider(_ref52) {
    var children = _ref52.children;
    return /* @__PURE__ */React__default["default"].createElement(Context.Provider, {
      value: useProps()
    }, children);
  };

  var DropDownContent = styled__default$1["default"](Box)(_templateObject10(), function (_ref53) {
    var maxHeight = _ref53.maxHeight;
    return maxHeight > 0 ? "".concat(maxHeight, "px") : "100%";
  }, defaultTheme$1.radii.xs);
  var DropDownContainer = styled__default$1["default"](Box)(_templateObject11(), defaultTheme$1.radii.xs, defaultTheme$1.colors.neutral["00"], defaultTheme$1.shadows["01"], DropDownContent);
  var __defProp$c = Object.defineProperty;
  var __defProps$5 = Object.defineProperties;
  var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
  var __hasOwnProp$c = Object.prototype.hasOwnProperty;
  var __propIsEnum$c = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$c = function __defNormalProp$c(obj, key, value) {
    return key in obj ? __defProp$c(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$c = function __spreadValues$c(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$c.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$c) {
      var _iterator116 = _createForOfIteratorHelper(__getOwnPropSymbols$c(b)),
          _step116;

      try {
        for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
          var prop = _step116.value;
          if (__propIsEnum$c.call(b, prop)) __defNormalProp$c(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator116.e(err);
      } finally {
        _iterator116.f();
      }
    }

    return a;
  };

  var __spreadProps$5 = function __spreadProps$5(a, b) {
    return __defProps$5(a, __getOwnPropDescs$5(b));
  };

  var __objRest$b = function __objRest$b(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$c) {
      var _iterator117 = _createForOfIteratorHelper(__getOwnPropSymbols$c(source)),
          _step117;

      try {
        for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
          var prop = _step117.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator117.e(err);
      } finally {
        _iterator117.f();
      }
    }

    return target;
  };

  var nextId$1 = 0;

  var DropDownBaseWithoutProvider = function DropDownBaseWithoutProvider(_a, ref) {
    var _b = _a,
        open = _b.open,
        ariaLabelledBy = _b["aria-labelledby"],
        optionsProp = _b.options,
        onSelected = _b.onSelected,
        onClose = _b.onClose,
        _b$maxRows = _b.maxRows,
        maxRows = _b$maxRows === void 0 ? 4 : _b$maxRows,
        propId = _b.id,
        _b$focusWhenOpened = _b.focusWhenOpened,
        focusWhenOpened = _b$focusWhenOpened === void 0 ? true : _b$focusWhenOpened,
        filterBy = _b.filterBy,
        loading = _b.loading,
        multiple = _b.multiple,
        defaultValue = _b.defaultValue,
        valueProp = _b.value,
        parentContainerRef = _b.parentContainerRef,
        handleClickOutside = _b.handleClickOutside,
        restProps = __objRest$b(_b, ["open", "aria-labelledby", "options", "onSelected", "onClose", "maxRows", "id", "focusWhenOpened", "filterBy", "loading", "multiple", "defaultValue", "value", "parentContainerRef", "handleClickOutside"]);

    var _useContext = useContext(),
        options = _useContext.options,
        setOptions = _useContext.setOptions,
        selectedOption = _useContext.selectedOption,
        handleKeyboard = _useContext.handleKeyboard,
        usedAsSupport = _useContext.usedAsSupport,
        optionsRef = _useContext.optionsRef,
        hostRef = _useContext.hostRef,
        selectedOptionRef = _useContext.selectedOptionRef,
        activeElement = _useContext.activeElement,
        setActiveElement = _useContext.setActiveElement,
        focusedOption = _useContext.focusedOption,
        setFocusedOption = _useContext.setFocusedOption,
        selectedOptions = _useContext.selectedOptions,
        setMultiple = _useContext.setMultiple,
        updateSelectedOption = _useContext.updateSelectedOption,
        setSelectedOptions = _useContext.setSelectedOptions,
        setSelectedOption = _useContext.setSelectedOption;

    var loadingOption = {
      label: "Carregando...",
      value: "loading"
    };

    var _React__namespace$use = React__namespace.useState(false),
        _React__namespace$use2 = _slicedToArray(_React__namespace$use, 2),
        firedSelection = _React__namespace$use2[0],
        setFiredSelection = _React__namespace$use2[1];

    var currentSelectedOption = React__namespace.useMemo(function () {
      return multiple ? selectedOptions : selectedOption;
    }, [multiple, selectedOption, selectedOptions]);
    var firedDefaultValue = React__namespace.useRef(defaultValue);
    React__namespace.useEffect(function () {
      setMultiple(!!multiple);
    }, [multiple, setMultiple]);
    var updateSelected = React__namespace.useCallback(function (value) {
      var innerValue = Array.isArray(value) ? value : [value || {}];
      innerValue = innerValue.filter(function (item) {
        return optionsProp.some(function (option) {
          return option.value === item.value;
        });
      });

      if (multiple) {
        setSelectedOptions(innerValue);
      } else {
        setSelectedOption(innerValue[0]);
      }
    }, [multiple, optionsProp, setSelectedOption, setSelectedOptions]);
    React__namespace.useEffect(function () {
      if (firedDefaultValue.current && !valueProp) {
        updateSelected(defaultValue);
        firedDefaultValue.current = defaultValue;
      } else {
        updateSelected(valueProp);
      }
    }, [defaultValue, updateSelected, valueProp]);
    React__namespace.useEffect(function () {
      if (!firedSelection) {
        return;
      }

      if (onSelected) {
        onSelected(currentSelectedOption);
      }

      setFiredSelection(false);
    }, [currentSelectedOption, firedSelection, onSelected]);
    var id = React__namespace.useMemo(function () {
      if (propId) {
        return propId;
      }

      nextId$1 += 1;
      return "".concat(basicUid("d"), "_").concat(nextId$1);
    }, [propId]);

    var _React__namespace$use3 = React__namespace.useState(0),
        _React__namespace$use4 = _slicedToArray(_React__namespace$use3, 2),
        maxHeight = _React__namespace$use4[0],
        setMaxHeight = _React__namespace$use4[1];

    var innerOptions = React__namespace.useMemo(function () {
      return !optionsProp ? [] : optionsProp.filter(function (option, index, optionList) {
        return optionList.indexOf(option) === index;
      });
    }, [optionsProp]);
    React__namespace.useEffect(function () {
      if (typeof filterBy === "string") {
        setFocusedOption(void 0);

        if (filterBy) {
          setOptions(filterList(filterBy, innerOptions));
        }
      } else {
        setOptions(innerOptions);
      }
    }, [filterBy, innerOptions, setFocusedOption, setOptions, updateSelectedOption]);
    React__namespace.useEffect(function () {
      var _a2;

      var innerActiveElement = null;

      if (open) {
        innerActiveElement = document.activeElement;

        if (focusWhenOpened && !usedAsSupport) {
          (_a2 = hostRef.current) == null ? void 0 : _a2.focus();
        }
      }

      setActiveElement(innerActiveElement);
      return function () {
        if (!usedAsSupport) {
          innerActiveElement == null ? void 0 : innerActiveElement.focus();
        }
      };
    }, [focusWhenOpened, hostRef, setActiveElement, usedAsSupport, open]);
    React__namespace.useEffect(function () {
      var innerMaxHeight = 0;
      optionsRef.forEach(function (optionRef, index) {
        var _a2;

        var current = optionRef.current;

        if (!current) {
          return;
        }

        innerMaxHeight += current.offsetHeight;
        current.removeAttribute("tabindex");
        (_a2 = current.querySelector("input")) == null ? void 0 : _a2.setAttribute("tabindex", "-1");

        if (index + 1 === maxRows) {
          setMaxHeight(innerMaxHeight);
        }
      });
    }, [maxRows, optionsRef, open]);
    React__namespace.useEffect(function () {
      var hostElement = hostRef.current;

      if (hostElement && selectedOptionRef && hostElement.scrollHeight > hostElement.clientHeight) {
        var scrollBottom = hostElement.clientHeight + hostElement.scrollTop;
        var targetBottom = selectedOptionRef.offsetTop + selectedOptionRef.offsetHeight;

        if (targetBottom > scrollBottom) {
          hostElement.scrollTop = targetBottom - hostElement.clientHeight;
        } else if (selectedOptionRef.offsetTop < hostElement.scrollTop) {
          hostElement.scrollTop = selectedOptionRef.offsetTop;
        }
      }
    }, [selectedOptionRef, hostRef, open]);

    var handleClose = function handleClose() {
      setFocusedOption(void 0);

      if (onClose) {
        onClose(activeElement);
      }
    };

    var handleKeyDown = function handleKeyDown(event) {
      event.preventDefault();
      event.stopPropagation();
      var keyCode = getKeyOfKeyboard(event);
      handleKeyboard(keyCode, event);

      switch (keyCode) {
        case Keyboard.Enter:
          if (!multiple) {
            handleClose();
          }

          break;

        case Keyboard.Escape:
          handleClose();
          break;
      }
    };

    React__namespace.useImperativeHandle(ref, function () {
      return {
        currentSelectedOption: currentSelectedOption,
        setFiredSelection: setFiredSelection
      };
    });
    var containerRef = React__namespace.useRef(null);
    React__namespace.useEffect(function () {
      var handleOutsideContainerClick = function handleOutsideContainerClick(evt) {
        var _a2, _b2;

        var containerRect = (_a2 = containerRef.current) == null ? void 0 : _a2.getBoundingClientRect();
        var parentContainerRect = (_b2 = parentContainerRef == null ? void 0 : parentContainerRef.current) == null ? void 0 : _b2.getBoundingClientRect();

        if (open && containerRect && parentContainerRect) {
          var clickedOutsideX = evt.clientX < containerRect.left || evt.clientX > containerRect.right;
          var clickedOutsideY = evt.clientY < containerRect.top || evt.clientY > containerRect.bottom;
          var parentClickedOutsideX = evt.clientX < parentContainerRect.left || evt.clientX > parentContainerRect.right;
          var parentClickedOutsideY = evt.clientY < parentContainerRect.top || evt.clientY > parentContainerRect.bottom;

          if (clickedOutsideX && parentClickedOutsideX || clickedOutsideY && parentClickedOutsideY) {
            handleClickOutside && handleClickOutside(false);
          }
        }
      };

      window.addEventListener("click", handleOutsideContainerClick);
      return function () {
        return window.removeEventListener("click", handleOutsideContainerClick);
      };
    }, [containerRef, open, handleClickOutside, parentContainerRef]);

    if (!open) {
      return null;
    }

    return /* @__PURE__ */React__namespace.createElement(DropDownContainer, __spreadProps$5(__spreadValues$c({}, restProps), {
      ref: containerRef
    }), /* @__PURE__ */React__namespace.createElement(DropDownContent, {
      "aria-activedescendant": !usedAsSupport ? selectedOptionRef == null ? void 0 : selectedOptionRef.id : void 0,
      "aria-expanded": open,
      "aria-labelledby": ariaLabelledBy,
      id: id,
      maxHeight: maxHeight,
      onBlur: function onBlur() {
        handleClose();
      },
      onKeyDown: handleKeyDown,
      ref: hostRef,
      role: "listbox",
      tabIndex: usedAsSupport ? void 0 : -1
    }, loading ? /* @__PURE__ */React__namespace.createElement(Option, {
      value: loadingOption
    }) : options.map(function (option, index) {
      return /* @__PURE__ */React__namespace.createElement(Option, {
        focused: (focusedOption == null ? void 0 : focusedOption.value) === option.value,
        key: option.value,
        multiple: multiple,
        onClick: function onClick() {
          if (!option.disabled) {
            setFiredSelection(true);

            if (!multiple) {
              handleClose();
            }

            updateSelectedOption(option);
          }
        },
        ref: optionsRef[index],
        selected: multiple ? selectedOptions.some(function (selected) {
          return selected.value === option.value;
        }) : (selectedOption == null ? void 0 : selectedOption.value) === option.value,
        value: option
      });
    })));
  };

  var DropDownWithoutProvider = React__namespace.forwardRef(DropDownBaseWithoutProvider);
  var DropDownComponent = React__namespace.forwardRef(function (props, ref) {
    return /* @__PURE__ */React__namespace.createElement(Provider, null, /* @__PURE__ */React__namespace.createElement(DropDownWithoutProvider, __spreadProps$5(__spreadValues$c({}, props), {
      ref: ref
    })));
  });
  var Select$1 = styled__default$1["default"](Box)(_templateObject12(), cssTextEllipsisOneLine);
  var DropDown = styled__default$1["default"](DropDownWithoutProvider)(_templateObject13(), "0 0 ".concat(defaultTheme$1.radii.xs, " ").concat(defaultTheme$1.radii.xs), function (_ref54) {
    var positionTop = _ref54.positionTop;
    return !!positionTop && styled.css(_templateObject14(), defaultTheme$1.radii.xs, positionTop + Number(defaultTheme$1.space.stack.nano.replace("px", "")), DropDownContent, defaultTheme$1.radii.xs, defaultTheme$1.radii.xs);
  });

  var setReactInputValue = function setReactInputValue(input, value, trackerValue) {
    input.value = value;
    var inputGeneric = input;
    var tracker = inputGeneric._valueTracker;

    if (tracker && tracker.setValue) {
      tracker.setValue(trackerValue);
    } else {
      throw new Error("Not found prop _valueTracker in input");
    }
  };

  var dispatchChangeInputEvent = function dispatchChangeInputEvent(element, newValue) {
    var trackerValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : element.value;
    setReactInputValue(element, newValue, trackerValue);
    var event = new Event("input", {
      bubbles: true
    });
    element.dispatchEvent(event);
  };

  var StyledChipInput = styled__default$1["default"](ChipInput)(_templateObject15(), cssTextEllipsisOneLine);
  var StyledChipStatic = styled__default$1["default"](ChipStatic)(_templateObject16(), cssTextEllipsisOneLine);
  var __defProp$b = Object.defineProperty;
  var __defProps$4 = Object.defineProperties;
  var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
  var __hasOwnProp$b = Object.prototype.hasOwnProperty;
  var __propIsEnum$b = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$b = function __defNormalProp$b(obj, key, value) {
    return key in obj ? __defProp$b(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$b = function __spreadValues$b(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$b.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$b) {
      var _iterator118 = _createForOfIteratorHelper(__getOwnPropSymbols$b(b)),
          _step118;

      try {
        for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
          var prop = _step118.value;
          if (__propIsEnum$b.call(b, prop)) __defNormalProp$b(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator118.e(err);
      } finally {
        _iterator118.f();
      }
    }

    return a;
  };

  var __spreadProps$4 = function __spreadProps$4(a, b) {
    return __defProps$4(a, __getOwnPropDescs$4(b));
  };

  var __objRest$a = function __objRest$a(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$b.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$b) {
      var _iterator119 = _createForOfIteratorHelper(__getOwnPropSymbols$b(source)),
          _step119;

      try {
        for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
          var prop = _step119.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$b.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator119.e(err);
      } finally {
        _iterator119.f();
      }
    }

    return target;
  };

  var SelectChips = function SelectChips(_a) {
    var _b = _a,
        brand = _b.brand,
        disabled = _b.disabled,
        options = _b.options,
        _b$maxVisible = _b.maxVisible,
        maxVisible = _b$maxVisible === void 0 ? 1 : _b$maxVisible,
        onWidth = _b.onWidth,
        _onClose = _b.onClose,
        inputElement = _b.inputElement,
        sx = _b.sx,
        variantSize = _b.variantSize,
        props = __objRest$a(_b, ["brand", "disabled", "options", "maxVisible", "onWidth", "onClose", "inputElement", "sx", "variantSize"]);

    var containerRef = React__default["default"].useRef(null);

    var _React__default$defau27 = React__default["default"].useState(options),
        _React__default$defau28 = _slicedToArray(_React__default$defau27, 2),
        optionsVisible = _React__default$defau28[0],
        setOptionsVisible = _React__default$defau28[1];

    var _React__default$defau29 = React__default["default"].useState(0),
        _React__default$defau30 = _slicedToArray(_React__default$defau29, 2),
        optionsRestCount = _React__default$defau30[0],
        setOptionsRestCount = _React__default$defau30[1];

    var widthRef = React__default["default"].useRef(0);
    React__default["default"].useEffect(function () {
      var _a2;

      if (onWidth) {
        var width = (_a2 = containerRef.current) == null ? void 0 : _a2.getBoundingClientRect().width;

        if (widthRef.current !== width) {
          widthRef.current = width || 0;
          onWidth(width);
        }
      }
    }, [onWidth]);
    React__default["default"].useEffect(function () {
      if (maxVisible >= 0 && options) {
        var innerOptions = _toConsumableArray(options);

        setOptionsVisible(innerOptions.splice(0, maxVisible));
        setOptionsRestCount(innerOptions.length);
      } else {
        setOptionsVisible(options);
      }
    }, [maxVisible, options]);
    React__default["default"].useEffect(function () {
      var _a2;

      (_a2 = containerRef.current) == null ? void 0 : _a2.querySelectorAll("span").forEach(function (element) {
        element.removeAttribute("tabindex");
      });
    }, [options]);

    var _React__default$defau31 = React__default["default"].useState(0),
        _React__default$defau32 = _slicedToArray(_React__default$defau31, 2),
        leftOffset = _React__default$defau32[0],
        setLeftOffset = _React__default$defau32[1];

    React__default["default"].useEffect(function () {
      var _a2;

      var labelElement = (_a2 = inputElement == null ? void 0 : inputElement.parentElement) == null ? void 0 : _a2.querySelector("label");

      if ((labelElement == null ? void 0 : labelElement.offsetWidth) !== leftOffset) {
        setLeftOffset((labelElement == null ? void 0 : labelElement.offsetWidth) || 0);
      }
    }, [leftOffset, inputElement]);

    if (!(optionsVisible == null ? void 0 : optionsVisible.length)) {
      return null;
    }

    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$4(__spreadValues$b({
      ref: containerRef,
      role: "listbox"
    }, props), {
      sx: __spreadValues$b({
        alignItems: "center",
        bottom: 0,
        display: "flex",
        height: variantSize === "sm" ? "100%" : void 0,
        left: variantSize === "sm" ? leftOffset : 0,
        padding: "squish.nano",
        paddingLeft: variantSize === "sm" ? "inline.nano" : void 0,
        position: "absolute",
        zIndex: 1
      }, sx)
    }), optionsVisible.map(function (option, index) {
      return /* @__PURE__ */React__default["default"].createElement(StyledChipInput, {
        brand: brand,
        disabled: disabled,
        key: option.value,
        label: option.label,
        onClose: function onClose() {
          if (_onClose) {
            _onClose(index);
          }
        },
        role: "option",
        sx: {
          ml: index === 0 ? void 0 : "inset.nano"
        },
        tabIndex: 0,
        variant: "sm"
      });
    }), !!optionsRestCount && /* @__PURE__ */React__default["default"].createElement(StyledChipStatic, {
      brand: brand,
      disabled: disabled,
      label: "+".concat(optionsRestCount),
      sx: {
        ml: "inset.nano"
      },
      variant: "sm"
    }));
  };

  var __defProp$a = Object.defineProperty;
  var __defProps$3 = Object.defineProperties;
  var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
  var __hasOwnProp$a = Object.prototype.hasOwnProperty;
  var __propIsEnum$a = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$a = function __defNormalProp$a(obj, key, value) {
    return key in obj ? __defProp$a(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$a = function __spreadValues$a(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$a.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$a) {
      var _iterator120 = _createForOfIteratorHelper(__getOwnPropSymbols$a(b)),
          _step120;

      try {
        for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
          var prop = _step120.value;
          if (__propIsEnum$a.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator120.e(err);
      } finally {
        _iterator120.f();
      }
    }

    return a;
  };

  var __spreadProps$3 = function __spreadProps$3(a, b) {
    return __defProps$3(a, __getOwnPropDescs$3(b));
  };

  var __objRest$9 = function __objRest$9(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$a) {
      var _iterator121 = _createForOfIteratorHelper(__getOwnPropSymbols$a(source)),
          _step121;

      try {
        for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
          var prop = _step121.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator121.e(err);
      } finally {
        _iterator121.f();
      }
    }

    return target;
  };

  var nextId = 0;

  var SelectBase = function SelectBase(_a) {
    var _b = _a,
        optionsProp = _b.options,
        parentId = _b.id,
        propId = _b.inputId,
        _b$variant13 = _b.variant,
        variant = _b$variant13 === void 0 ? "default" : _b$variant13,
        supportMessage = _b.supportMessage,
        label = _b.label,
        placeholder = _b.placeholder,
        required = _b.required,
        multiple = _b.multiple,
        className = _b.className,
        maxRows = _b.maxRows,
        defaultValue = _b.defaultValue,
        valueProp = _b.value,
        loading = _b.loading,
        maxChips = _b.maxChips,
        onSelected = _b.onSelected,
        onBlur = _b.onBlur,
        onFocus = _b.onFocus,
        onChange = _b.onChange,
        name = _b.name,
        inputRefProp = _b.inputRef,
        maskConfig = _b.maskConfig,
        props = __objRest$9(_b, ["options", "id", "inputId", "variant", "supportMessage", "label", "placeholder", "required", "multiple", "className", "maxRows", "defaultValue", "value", "loading", "maxChips", "onSelected", "onBlur", "onFocus", "onChange", "name", "inputRef", "maskConfig"]);

    var _a2, _b2, _c;

    var _useContext2 = useContext(),
        hostRef = _useContext2.hostRef,
        setUsedAsSupport = _useContext2.setUsedAsSupport,
        handleKeyboard = _useContext2.handleKeyboard,
        selectedOptionRef = _useContext2.selectedOptionRef,
        selectedOption = _useContext2.selectedOption,
        setFocusedOption = _useContext2.setFocusedOption,
        selectedOptions = _useContext2.selectedOptions,
        removeSelectedOption = _useContext2.removeSelectedOption,
        updateSelectedOption = _useContext2.updateSelectedOption,
        focusedOption = _useContext2.focusedOption;

    var _React__namespace$use5 = React__namespace.useState(false),
        _React__namespace$use6 = _slicedToArray(_React__namespace$use5, 2),
        open = _React__namespace$use6[0],
        setOpen = _React__namespace$use6[1];

    var _React__namespace$use7 = React__namespace.useState(),
        _React__namespace$use8 = _slicedToArray(_React__namespace$use7, 2),
        filter = _React__namespace$use8[0],
        setFilter = _React__namespace$use8[1];

    var _React__namespace$use9 = React__namespace.useState(""),
        _React__namespace$use10 = _slicedToArray(_React__namespace$use9, 2),
        inputValue = _React__namespace$use10[0],
        setInputValue = _React__namespace$use10[1];

    React__namespace.useEffect(function () {
      if (!multiple && (!valueProp || valueProp && !valueProp.value)) {
        setInputValue(maskConfig ? IMask__default["default"].pipe("", maskConfig) : "");
      }
    }, [multiple, valueProp, maskConfig]);
    var valuePropRef = React__namespace.useRef(valueProp);
    React__namespace.useEffect(function () {
      if (valuePropRef.current && valueProp && !Array.isArray(valuePropRef.current) && !Array.isArray(valueProp) && valuePropRef.current.value !== valueProp.value) {
        setInputValue(maskConfig ? IMask__default["default"].pipe(valueProp.label, maskConfig) : valueProp.label);
        valuePropRef.current = valueProp;
      }
    }, [valueProp, maskConfig]);

    var _React__namespace$use11 = React__namespace.useState(),
        _React__namespace$use12 = _slicedToArray(_React__namespace$use11, 2),
        containerChipsWidth = _React__namespace$use12[0],
        setContainerChipsWidth = _React__namespace$use12[1];

    var _React__namespace$use13 = React__namespace.useState(false),
        _React__namespace$use14 = _slicedToArray(_React__namespace$use13, 2),
        containsMouseDown = _React__namespace$use14[0],
        setcontainsMouseDown = _React__namespace$use14[1];

    var _React__namespace$use15 = React__namespace.useState(),
        _React__namespace$use16 = _slicedToArray(_React__namespace$use15, 2),
        triggerInputFocus = _React__namespace$use16[0],
        setTriggerInputFocus = _React__namespace$use16[1];

    var _React__namespace$use17 = React__namespace.useState(false),
        _React__namespace$use18 = _slicedToArray(_React__namespace$use17, 2),
        firedFocus = _React__namespace$use18[0],
        setFiredFocus = _React__namespace$use18[1];

    var _React__namespace$use19 = React__namespace.useState(false),
        _React__namespace$use20 = _slicedToArray(_React__namespace$use19, 2),
        isDropUp = _React__namespace$use20[0],
        setIsDropUp = _React__namespace$use20[1];

    var inputId = React__namespace.useMemo(function () {
      if (propId) {
        return propId;
      }

      nextId += 1;
      return "".concat(basicUid("s"), "_").concat(nextId);
    }, [propId]);
    var labelId = "l_".concat(inputId);
    var inputRef = React__namespace.useRef(null);
    var selectContainerRef = React__namespace.useRef(null);
    var dropdownStateRef = React__namespace.useRef(null);
    var initialValue = React__namespace.useRef(true);
    var supportMessageVariant = React__namespace.useMemo(function () {
      switch (variant) {
        case "error":
          return "invalid";

        case "success":
          return "valid";

        default:
          return "default";
      }
    }, [variant]);
    React__namespace.useEffect(function () {
      if (selectedOption && initialValue.current && !multiple) {
        setInputValue(maskConfig ? IMask__default["default"].pipe(selectedOption.label, maskConfig) : selectedOption.label);
        initialValue.current = false;
      }
    }, [multiple, selectedOption, maskConfig]);

    var updateCheckDropUp = function updateCheckDropUp() {
      if (selectContainerRef.current && hostRef.current) {
        setIsDropUp(toggleDropUp(selectContainerRef.current, hostRef.current));
      }
    };

    React__namespace.useLayoutEffect(function () {
      updateCheckDropUp();
    });
    React__namespace.useEffect(function () {
      var _a3;

      (_a3 = document.querySelector("[for=\"".concat(inputId, "\"]"))) == null ? void 0 : _a3.setAttribute("id", labelId);
    }, [inputId, labelId]);
    React__namespace.useEffect(function () {
      if (!open) {
        setFilter(void 0);
      }
    }, [open]);
    React__namespace.useEffect(function () {
      var _a3;

      if (multiple) {
        if (!open) {
          setTriggerInputFocus(!!selectedOptions.length);
        } else {
          setFilter(void 0);
          (_a3 = inputRef.current) == null ? void 0 : _a3.focus();
        }
      }
    }, [open, multiple, selectedOptions]);
    React__namespace.useEffect(function () {
      setUsedAsSupport(true);
    }, [setUsedAsSupport]);

    var handleInputKeyDown = function handleInputKeyDown(event) {
      var _a3;

      var keyCode = getKeyOfKeyboard(event);
      handleKeyboard(keyCode, event);

      switch (keyCode) {
        case Keyboard.ArrowUp:
          event.preventDefault();
          setOpen(true);
          break;

        case Keyboard.Escape:
        case Keyboard.Tab:
          setOpen(false);
          break;

        case Keyboard.Enter:
          event.preventDefault();

          if (focusedOption) {
            (_a3 = dropdownStateRef.current) == null ? void 0 : _a3.setFiredSelection(true);
          }

          setOpen(function (previous) {
            if (multiple && previous) {
              return previous;
            }

            return !previous;
          });
          break;

        case Keyboard.Backspace:
          if (multiple && !inputValue.length && selectedOptions.length) {
            removeSelectedOption(-1);

            if (inputRef.current) {
              dispatchChangeInputEvent(inputRef.current, "", " ");
            }
          }

          break;

        default:
          setOpen(true);
          break;
      }
    };

    var handleInputKeyUp = function handleInputKeyUp(event) {
      var keyCode = getKeyOfKeyboard(event);

      if (keyCode === Keyboard.Backspace) {
        setOpen(true);
        return;
      }

      return;
    };

    var handleInputChange = function handleInputChange(event) {
      var _a3;

      var value = event.target.value;
      var valueFormatted = value.replace(/^\s+/g, "").replace(/\s+/g, " ");
      setInputValue(maskConfig ? IMask__default["default"].pipe(valueFormatted, maskConfig) : valueFormatted);
      setFilter(valueFormatted);
      var isEmptyValue = !valueFormatted;

      if (isEmptyValue) {
        updateSelectedOption();
      }

      if (onChange) {
        var selected = (_a3 = dropdownStateRef.current) == null ? void 0 : _a3.currentSelectedOption;

        if (Array.isArray(selected)) {
          onChange(event, selected.length ? selected : void 0);
        } else if (selected == null ? void 0 : selected.label) {
          onChange(event, isEmptyValue ? void 0 : selected);
        } else {
          onChange(event, void 0);
        }
      }
    };

    var handleSelected = React__namespace.useCallback(function (selected) {
      if (onSelected) {
        onSelected(selected);
      }

      if (inputRef.current) {
        if (Array.isArray(selected)) {
          dispatchChangeInputEvent(inputRef.current, "", " ");
        } else {
          dispatchChangeInputEvent(inputRef.current, (selected == null ? void 0 : selected.label) || "");
        }
      }
    }, [onSelected]);

    var handleClose = function handleClose() {
      var _a3;

      if (!multiple) {
        setOpen(false);
        (_a3 = inputRef.current) == null ? void 0 : _a3.focus();
      }
    };

    var handleMouseDown = function handleMouseDown(event) {
      var _a3;

      if (event.button !== 0 || props.disabled) {
        return;
      }

      if (event.target === inputRef.current) {
        setOpen(!open);
      } else if ((_a3 = selectContainerRef.current) == null ? void 0 : _a3.contains(event.target)) {
        setcontainsMouseDown(true);
        setTriggerInputFocus(true);
      }
    };

    var handleChipsWidth = function handleChipsWidth(size) {
      setContainerChipsWidth(size);
    };

    var handleChipsClose = function handleChipsClose(indexTarget) {
      var _a3;

      (_a3 = dropdownStateRef.current) == null ? void 0 : _a3.setFiredSelection(true);
      removeSelectedOption(indexTarget);
      setOpen(true);
    };

    var handleInputFocus = function handleInputFocus(event) {
      if (props.disabled) {
        return;
      }

      if (!firedFocus) {
        if (onFocus) {
          onFocus(event);
        }

        setFiredFocus(true);
        setcontainsMouseDown(false);
      }
    };

    var handleInputBlur = function handleInputBlur(event) {
      if (props.disabled) {
        return;
      }

      if (containsMouseDown) {
        setcontainsMouseDown(false);
      } else {
        setFocusedOption(void 0);
        setOpen(false);
        setFiredFocus(false);
        setTriggerInputFocus(!!selectedOptions.length);

        if (multiple) {
          setInputValue(maskConfig ? IMask__default["default"].pipe("", maskConfig) : "");
        } else if (inputValue !== (selectedOption == null ? void 0 : selectedOption.label)) {
          setInputValue(maskConfig ? IMask__default["default"].pipe((selectedOption == null ? void 0 : selectedOption.label) || "", maskConfig) : (selectedOption == null ? void 0 : selectedOption.label) || "");
        }

        if (onBlur) {
          onBlur(event);
        }
      }
    };

    var handleInputRef = function handleInputRef(node) {
      inputRef.current = node;

      if (!inputRefProp) {
        return;
      }

      if (typeof inputRefProp === "function") {
        inputRefProp(node);
      } else if (inputRefProp) {
        inputRefProp.current = node;
      }
    };

    return /* @__PURE__ */React__namespace.createElement(React__namespace.Fragment, null, /* @__PURE__ */React__namespace.createElement(Select$1, {
      "aria-expanded": open,
      "aria-haspopup": open ? "listbox" : void 0,
      "aria-owns": open ? (_a2 = hostRef.current) == null ? void 0 : _a2.id : void 0,
      className: className,
      id: parentId,
      onMouseDown: handleMouseDown,
      ref: selectContainerRef,
      role: "combobox",
      sx: props.sx,
      width: props.width
    }, /* @__PURE__ */React__namespace.createElement(Box, {
      sx: {
        position: "relative",
        width: props.width
      }
    }, multiple && /* @__PURE__ */React__namespace.createElement(SelectChips, {
      brand: props.brand,
      disabled: props.disabled,
      inputElement: inputRef.current,
      maxVisible: maxChips,
      onClose: handleChipsClose,
      onWidth: handleChipsWidth,
      options: selectedOptions,
      variantSize: props.variantSize
    }), /* @__PURE__ */React__namespace.createElement(Input, __spreadProps$3(__spreadValues$a({
      "aria-activedescendant": open ? selectedOptionRef == null ? void 0 : selectedOptionRef.id : void 0,
      "aria-autocomplete": "list",
      "aria-controls": open ? (_b2 = hostRef.current) == null ? void 0 : _b2.id : void 0,
      autoCapitalize: "none",
      autoComplete: "off",
      id: inputId,
      label: label,
      placeholder: placeholder,
      required: required,
      style: {
        paddingLeft: containerChipsWidth
      },
      trailingIcon: /* @__PURE__ */React__namespace.createElement(Icon, {
        size: "sm"
      }, open ? /* @__PURE__ */React__namespace.createElement(almaIcons.ChevronUp, null) : /* @__PURE__ */React__namespace.createElement(almaIcons.ChevronDown, null)),
      triggerFocus: triggerInputFocus,
      value: inputValue,
      variant: variant
    }, props), {
      onBlur: handleInputBlur,
      onChange: handleInputChange,
      onFocus: handleInputFocus,
      onKeyDown: handleInputKeyDown,
      onKeyUp: handleInputKeyUp,
      ref: handleInputRef
    }))), /* @__PURE__ */React__namespace.createElement(DropDown, {
      "aria-labelledby": labelId,
      defaultValue: defaultValue,
      filterBy: filter,
      handleClickOutside: function handleClickOutside(openState) {
        return setOpen(openState);
      },
      loading: loading,
      maxRows: maxRows,
      multiple: multiple,
      onClose: handleClose,
      onSelected: handleSelected,
      open: open,
      options: optionsProp,
      parentContainerRef: selectContainerRef,
      positionTop: isDropUp ? (_c = inputRef.current) == null ? void 0 : _c.getBoundingClientRect().height : 0,
      ref: dropdownStateRef,
      value: valueProp
    }), /* @__PURE__ */React__namespace.createElement(Wrap, null, typeof supportMessage === "string" ? /* @__PURE__ */React__namespace.createElement(SupportMessage, {
      brand: props.brand,
      disabled: props.disabled,
      value: supportMessage,
      variant: supportMessageVariant
    }) : supportMessage == null ? void 0 : supportMessage.map(function (suptMsg, i) {
      return /* @__PURE__ */React__namespace.createElement(WrapItem, {
        key: i,
        mb: "inline.quark",
        mr: "inline.nano"
      }, /* @__PURE__ */React__namespace.createElement(SupportMessage, {
        brand: props.brand,
        disabled: props.disabled,
        tabIndex: i,
        value: suptMsg,
        variant: supportMessageVariant
      }));
    }))), name && selectedOptions.map(function (option) {
      return /* @__PURE__ */React__namespace.createElement("input", {
        hidden: true,
        key: option.value,
        name: name,
        readOnly: true,
        value: option.value
      });
    }));
  };

  var Select = function Select(props) {
    return /* @__PURE__ */React__namespace.createElement(Provider, null, /* @__PURE__ */React__namespace.createElement(SelectBase, __spreadValues$a({}, props)));
  };

  var boxGridStyle = function boxGridStyle() {
    return {
      height: "100%",
      position: "relative",
      width: "100%"
    };
  };

  var __defProp$9 = Object.defineProperty;
  var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
  var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
  var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$9 = function __defNormalProp$9(obj, key, value) {
    return key in obj ? __defProp$9(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$9 = function __spreadValues$9(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$9.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$9) {
      var _iterator122 = _createForOfIteratorHelper(__getOwnPropSymbols$9(b)),
          _step122;

      try {
        for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
          var prop = _step122.value;
          if (__propIsEnum$9.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator122.e(err);
      } finally {
        _iterator122.f();
      }
    }

    return a;
  };

  var __objRest$8 = function __objRest$8(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$9.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$9) {
      var _iterator123 = _createForOfIteratorHelper(__getOwnPropSymbols$9(source)),
          _step123;

      try {
        for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
          var prop = _step123.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$9.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator123.e(err);
      } finally {
        _iterator123.f();
      }
    }

    return target;
  };

  var SimpleGrid = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        children = _b.children,
        sx = _b.sx,
        props = __objRest$8(_b, ["children", "sx"]);

    var _a2 = props,
        columns = _a2.columns,
        spacingX = _a2.spacingX,
        spacingY = _a2.spacingY,
        spacing = _a2.spacing,
        minChildWidth = _a2.minChildWidth,
        rest = __objRest$8(_a2, ["columns", "spacingX", "spacingY", "spacing", "minChildWidth"]);

    var templateColumns = minChildWidth ? "repeat(auto-fit, minmax(".concat(minChildWidth, "px, 1fr))") : void 0;

    var renderChildrens = function renderChildrens() {
      if (Array.isArray(children)) {
        return children.map(function (value, idx) {
          return /* @__PURE__ */React__default["default"].createElement(GridItem, {
            key: idx
          }, value);
        });
      }

      return children;
    };

    return /* @__PURE__ */React__default["default"].createElement(Grid, __spreadValues$9({
      columns: columns,
      gap: spacing,
      gridColumnGap: spacingX,
      gridRowGap: spacingY,
      gridTemplateColumns: templateColumns,
      ref: ref,
      sx: __spreadValues$9(__spreadValues$9({}, boxGridStyle()), sx)
    }, rest), renderChildrens());
  });
  var __defProp$8 = Object.defineProperty;
  var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
  var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
  var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$8 = function __defNormalProp$8(obj, key, value) {
    return key in obj ? __defProp$8(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$8 = function __spreadValues$8(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$8.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$8) {
      var _iterator124 = _createForOfIteratorHelper(__getOwnPropSymbols$8(b)),
          _step124;

      try {
        for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
          var prop = _step124.value;
          if (__propIsEnum$8.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator124.e(err);
      } finally {
        _iterator124.f();
      }
    }

    return a;
  };

  var Multiselect = function Multiselect(props) {
    return /* @__PURE__ */React__default["default"].createElement(Select, __spreadValues$8({
      multiple: true
    }, props));
  };

  var getShapeStyle = function getShapeStyle(label, variantSize, hover, focus, active, controledOpen) {
    var getShapeWidth = function getShapeWidth() {
      if (!label) {
        return variantSize === "lg" ? 48 : 32;
      }

      return "fit-content";
    };

    var getShapeBackgroundColor = function getShapeBackgroundColor() {
      if (active || controledOpen) {
        return "interaction.blend.02";
      } else if (hover || focus) {
        return "interaction.blend.01";
      }

      return "transparent";
    };

    var getShapePadding = function getShapePadding() {
      if (label) {
        return variantSize === "lg" ? "inline.xxxs" : "inline.nano";
      }

      return null;
    };

    return {
      alignItems: "center",
      backgroundColor: getShapeBackgroundColor(),
      borderColor: focus && !active ? "interaction.select.focus" : "transparent",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "thin",
      cursor: "pointer",
      display: "flex",
      height: variantSize === "lg" ? 48 : 32,
      justifyContent: "center",
      paddingLeft: getShapePadding(),
      paddingRight: getShapePadding(),
      width: getShapeWidth()
    };
  };

  var getTextStyle = function getTextStyle(disabled, trailingIcon, hover, focus, active, controledOpen) {
    var getTextColor = function getTextColor() {
      if (disabled) {
        return "typeface.meld";
      } else if (active || controledOpen) {
        return "interaction.select.active";
      } else if (hover || focus) {
        return "interaction.select.focus";
      }

      return "interaction.select.default";
    };

    return {
      color: getTextColor(),
      marginRight: trailingIcon ? "inline.nano" : void 0
    };
  };

  var getIconStyle = function getIconStyle(disabled, hover, focus, active, controledOpen) {
    var getIconColor = function getIconColor() {
      if (disabled) {
        return "interaction.blend.05";
      } else if (active || controledOpen) {
        return "interaction.select.active";
      } else if (hover || focus) {
        return "interaction.select.focus";
      }

      return "interaction.select.default";
    };

    return {
      color: getIconColor()
    };
  };

  var __defProp$7 = Object.defineProperty;
  var __defProps$2 = Object.defineProperties;
  var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
  var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
  var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$7 = function __defNormalProp$7(obj, key, value) {
    return key in obj ? __defProp$7(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$7 = function __spreadValues$7(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$7.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$7) {
      var _iterator125 = _createForOfIteratorHelper(__getOwnPropSymbols$7(b)),
          _step125;

      try {
        for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
          var prop = _step125.value;
          if (__propIsEnum$7.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator125.e(err);
      } finally {
        _iterator125.f();
      }
    }

    return a;
  };

  var __spreadProps$2 = function __spreadProps$2(a, b) {
    return __defProps$2(a, __getOwnPropDescs$2(b));
  };

  var __objRest$7 = function __objRest$7(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$7) {
      var _iterator126 = _createForOfIteratorHelper(__getOwnPropSymbols$7(source)),
          _step126;

      try {
        for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
          var prop = _step126.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator126.e(err);
      } finally {
        _iterator126.f();
      }
    }

    return target;
  };

  var Menu = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        disabled = _b.disabled,
        dropdownProps = _b.dropdownProps,
        label = _b.label,
        _onBlur4 = _b.onBlur,
        _onClick2 = _b.onClick,
        _onFocus4 = _b.onFocus,
        _onKeyDown = _b.onKeyDown,
        _onMouseDown = _b.onMouseDown,
        _onMouseEnter2 = _b.onMouseEnter,
        _onMouseLeave2 = _b.onMouseLeave,
        _onMouseUp2 = _b.onMouseUp,
        open = _b.open,
        sx = _b.sx,
        trailingIcon = _b.trailingIcon,
        variantSize = _b.variantSize,
        props = __objRest$7(_b, ["disabled", "dropdownProps", "label", "onBlur", "onClick", "onFocus", "onKeyDown", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseUp", "open", "sx", "trailingIcon", "variantSize"]);

    var _React__default$defau33 = React__default["default"].useState(false),
        _React__default$defau34 = _slicedToArray(_React__default$defau33, 2),
        active = _React__default$defau34[0],
        setActive = _React__default$defau34[1];

    var _React__default$defau35 = React__default["default"].useState(false),
        _React__default$defau36 = _slicedToArray(_React__default$defau35, 2),
        focus = _React__default$defau36[0],
        setFocus = _React__default$defau36[1];

    var _React__default$defau37 = React__default["default"].useState(false),
        _React__default$defau38 = _slicedToArray(_React__default$defau37, 2),
        hover = _React__default$defau38[0],
        setHover = _React__default$defau38[1];

    var _React__default$defau39 = React__default["default"].useState(false),
        _React__default$defau40 = _slicedToArray(_React__default$defau39, 2),
        controledOpen = _React__default$defau40[0],
        setControledOpen = _React__default$defau40[1];

    var handleKeyDown = function handleKeyDown(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var keyCode = evt.key.trim() ? evt.key : evt.code;

      switch (keyCode) {
        case "Space":
          !disabled && setControledOpen(!controledOpen);
          break;
      }
    };

    var wrapperRef = React__default["default"].useRef(null);
    return /* @__PURE__ */React__default["default"].createElement(Box, {
      ref: wrapperRef,
      sx: sx
    }, /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps$2(__spreadValues$7({
      tabIndex: disabled ? -1 : 0
    }, props), {
      onBlur: function onBlur(evt) {
        if (_onBlur4) {
          _onBlur4(evt);
        }

        !disabled && setFocus(false);
      },
      onClick: function onClick(evt) {
        if (_onClick2) {
          _onClick2(evt);
        }

        !disabled && setControledOpen(!controledOpen);
      },
      onFocus: function onFocus(evt) {
        if (_onFocus4) {
          _onFocus4(evt);
        }

        !disabled && setFocus(true);
      },
      onKeyDown: function onKeyDown(evt) {
        if (_onKeyDown) {
          _onKeyDown(evt);
        }

        !disabled && handleKeyDown(evt);
      },
      onMouseDown: function onMouseDown(evt) {
        if (_onMouseDown) {
          _onMouseDown(evt);
        }

        !disabled && setActive(true);
      },
      onMouseEnter: function onMouseEnter(evt) {
        if (_onMouseEnter2) {
          _onMouseEnter2(evt);
        }

        !disabled && setHover(true);
      },
      onMouseLeave: function onMouseLeave(evt) {
        if (_onMouseLeave2) {
          _onMouseLeave2(evt);
        }

        !disabled && setHover(false);
      },
      onMouseUp: function onMouseUp(evt) {
        if (_onMouseUp2) {
          _onMouseUp2(evt);
        }

        !disabled && setActive(false);
        !disabled && setFocus(false);
      },
      sx: getShapeStyle(label, variantSize, hover, focus, active, controledOpen)
    }), label && /* @__PURE__ */React__default["default"].createElement(TextInteraction, {
      sx: getTextStyle(disabled, trailingIcon, hover, focus, active, controledOpen),
      variant: "md"
    }, label), trailingIcon && /* @__PURE__ */React__default["default"].createElement(Icon, {
      size: "md",
      sx: getIconStyle(disabled, hover, focus, active, controledOpen)
    }, trailingIcon)), /* @__PURE__ */React__default["default"].createElement(DropDownComponent, __spreadProps$2(__spreadValues$7({
      focusWhenOpened: false
    }, dropdownProps), {
      handleClickOutside: function handleClickOutside(openState) {
        return setControledOpen(openState);
      },
      open: typeof open !== "undefined" ? open : controledOpen,
      parentContainerRef: wrapperRef
    })));
  });
  var StyledDatepickerContainer = styled__default$1["default"](Box)(_templateObject17(), function (_ref55) {
    var _ref55$zIndex = _ref55.zIndex,
        zIndex = _ref55$zIndex === void 0 ? 1 : _ref55$zIndex;
    return zIndex;
  }, defaultTheme$1.colors.typeface.meld, function (_ref56) {
    var zIndex = _ref56.zIndex;
    return zIndex;
  }, defaultTheme$1.colors.neutral[30], defaultTheme$1.colors.interaction.subtle["01"], defaultTheme$1.colors.typeface.smooth, defaultTheme$1.colors.interaction.select.active, defaultTheme$1.radii.xs, defaultTheme$1.colors.interaction.on.brand.select.active, defaultTheme$1.colors.interaction.on.brand.select.active, defaultTheme$1.colors.typeface.meld, defaultTheme$1.colors.interaction.on.brand.select.active, defaultTheme$1.colors.interaction.on.brand.select.active, defaultTheme$1.colors.interaction.select.default);

  var getCalendarContainerStyle = function getCalendarContainerStyle() {
    return {
      backgroundColor: "neutral.00",
      borderColor: "neutral.20",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "hairline",
      boxShadow: "01",
      boxSizing: "border-box",
      display: "flex",
      padding: "inset.xs",
      position: "relative"
    };
  };

  var getCalendarHeaderStyle = function getCalendarHeaderStyle() {
    return {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between"
    };
  };

  var getYearSelectTabStyle = function getYearSelectTabStyle() {
    return {
      margin: "0 auto",
      width: "100%"
    };
  };

  var __defProp$6 = Object.defineProperty;
  var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
  var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
  var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$6 = function __defNormalProp$6(obj, key, value) {
    return key in obj ? __defProp$6(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$6 = function __spreadValues$6(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$6) {
      var _iterator127 = _createForOfIteratorHelper(__getOwnPropSymbols$6(b)),
          _step127;

      try {
        for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
          var prop = _step127.value;
          if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator127.e(err);
      } finally {
        _iterator127.f();
      }
    }

    return a;
  };

  var __objRest$6 = function __objRest$6(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$6) {
      var _iterator128 = _createForOfIteratorHelper(__getOwnPropSymbols$6(source)),
          _step128;

      try {
        for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
          var prop = _step128.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator128.e(err);
      } finally {
        _iterator128.f();
      }
    }

    return target;
  };

  var headingSxVariantStyle = {
    lg: {
      fontSize: "lg"
    },
    md: {
      fontSize: "md",
      letterSpacing: "standard"
    },
    sm: {
      fontSize: "sm",
      letterSpacing: "standard",
      lineHeight: "distant"
    },
    xl: {
      fontSize: "xl",
      lineHeight: "medium"
    },
    xxl: {
      fontSize: "xxl",
      lineHeight: "large"
    },
    xxxl: {
      fontSize: "xxxl",
      lineHeight: "large"
    }
  };
  var Heading = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$variant14 = _b.variant,
        variant = _b$variant14 === void 0 ? "lg" : _b$variant14,
        props = __objRest$6(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$6({
      as: "h1",
      color: getColorTypfaceTokenByProp(props, "strong"),
      fontFamily: "base",
      fontWeight: "bold",
      letterSpacing: "small",
      lineHeight: "large",
      ref: ref,
      sx: __spreadValues$6({}, headingSxVariantStyle[variant])
    }, props));
  });
  var __defProp$5 = Object.defineProperty;
  var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
  var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
  var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$5 = function __defNormalProp$5(obj, key, value) {
    return key in obj ? __defProp$5(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$5 = function __spreadValues$5(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$5) {
      var _iterator129 = _createForOfIteratorHelper(__getOwnPropSymbols$5(b)),
          _step129;

      try {
        for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
          var prop = _step129.value;
          if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator129.e(err);
      } finally {
        _iterator129.f();
      }
    }

    return a;
  };

  var __objRest$5 = function __objRest$5(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$5) {
      var _iterator130 = _createForOfIteratorHelper(__getOwnPropSymbols$5(source)),
          _step130;

      try {
        for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
          var prop = _step130.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator130.e(err);
      } finally {
        _iterator130.f();
      }
    }

    return target;
  };

  var Calendar = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        _b$monthsShown = _b.monthsShown,
        monthsShown = _b$monthsShown === void 0 ? 1 : _b$monthsShown,
        showYearSelect = _b.showYearSelect,
        _b$variant15 = _b.variant,
        variant = _b$variant15 === void 0 ? "default" : _b$variant15,
        value = _b.value,
        yearSelectEnd = _b.yearSelectEnd,
        yearSelectStart = _b.yearSelectStart,
        zIndex = _b.zIndex,
        onChange = _b.onChange,
        selected = _b.selected,
        props = __objRest$5(_b, ["monthsShown", "showYearSelect", "variant", "value", "yearSelectEnd", "yearSelectStart", "zIndex", "onChange", "selected"]);

    var customHeader = function customHeader(_ref57, activeYearSelectTab2, setActiveYearSelectTab2) {
      var changeYear = _ref57.changeYear,
          changeMonth = _ref57.changeMonth,
          date = _ref57.date,
          customHeaderCount = _ref57.customHeaderCount,
          decreaseMonth = _ref57.decreaseMonth,
          increaseMonth = _ref57.increaseMonth,
          monthDate = _ref57.monthDate,
          prevMonthButtonDisabled = _ref57.prevMonthButtonDisabled,
          nextMonthButtonDisabled = _ref57.nextMonthButtonDisabled;
      var shouldRenderLeftArrow = customHeaderCount === 0;
      var shouldRenderRightArrow = customHeaderCount === monthsShown - 1;

      var getYears = function getYears() {
        var startYear = yearSelectStart ? yearSelectStart : new Date().getFullYear() - 100;
        var endYear = yearSelectEnd ? yearSelectEnd : new Date().getFullYear();
        var years = range$1(startYear, endYear + 1);
        return years.map(function (year) {
          return {
            label: year.toString(),
            value: year.toString()
          };
        });
      };

      var getMonths = function getMonths() {
        return months.map(function (key) {
          return {
            label: key,
            value: key
          };
        });
      };

      return /* @__PURE__ */React__default["default"].createElement(Box, null, showYearSelect && /* @__PURE__ */React__default["default"].createElement(Box, null, /* @__PURE__ */React__default["default"].createElement(Box, {
        sx: getYearSelectTabStyle()
      }, /* @__PURE__ */React__default["default"].createElement(TabContainer, {
        mb: "inset.nano"
      }, (variant === "default" || variant === "without-year") && /* @__PURE__ */React__default["default"].createElement(Tab, {
        active: activeYearSelectTab2 === "day",
        id: "year-select-tab-day",
        label: "Dia",
        onClick: function onClick() {
          return setActiveYearSelectTab2("day");
        },
        tabName: "day"
      }), /* @__PURE__ */React__default["default"].createElement(Tab, {
        active: activeYearSelectTab2 === "month",
        id: "year-select-tab-month",
        label: "M\xEAs",
        onClick: function onClick() {
          return setActiveYearSelectTab2("month");
        },
        tabName: "month"
      }), (variant === "default" || variant === "month-picker") && /* @__PURE__ */React__default["default"].createElement(Tab, {
        active: activeYearSelectTab2 === "year",
        id: "year-select-tab-year",
        label: "Ano",
        onClick: function onClick() {
          return setActiveYearSelectTab2("year");
        },
        tabName: "year"
      }))), activeYearSelectTab2 === "year" && /* @__PURE__ */React__default["default"].createElement(DropDownComponent, {
        id: "calendar-year-dropdown",
        maxRows: 0,
        onSelected: function onSelected(e) {
          var selectedYear = parseInt(e.value.toString(), 10);
          changeYear(selectedYear);
          var newDate = selected ? new Date(selected) : new Date();
          newDate.setFullYear(selectedYear);
          onChange(newDate, void 0);
          setActiveYearSelectTab2("month");
        },
        open: true,
        options: getYears(),
        sx: {
          "> #calendar-dropdown": {
            maxHeight: "100%"
          },
          bottom: 0,
          boxShadow: "none",
          height: "calc(100% - 80px)",
          left: 0,
          position: "absolute",
          width: "100%"
        },
        value: {
          label: date.getFullYear().toString(),
          value: date.getFullYear().toString()
        }
      }), activeYearSelectTab2 === "month" && /* @__PURE__ */React__default["default"].createElement(DropDownComponent, {
        id: "calendar-month-dropdown",
        maxRows: 0,
        onSelected: function onSelected(e) {
          var selectedMonth = parseInt(monthParse[e.value].toString(), 10);
          changeMonth(selectedMonth);
          var newDate = selected ? new Date(selected) : new Date();
          newDate.setMonth(selectedMonth);
          onChange(newDate, void 0);

          if ((variant == null ? void 0 : variant.indexOf("default")) !== -1 || (variant == null ? void 0 : variant.indexOf("without-year")) !== -1) {
            setActiveYearSelectTab2("day");
          }
        },
        open: true,
        options: getMonths(),
        sx: {
          "> #calendar-dropdown": {
            maxHeight: "100%"
          },
          bottom: 0,
          boxShadow: "none",
          height: "calc(100% - 80px)",
          left: 0,
          position: "absolute",
          width: "100%"
        },
        value: {
          label: months[date.getMonth()],
          value: months[date.getMonth()]
        }
      })), /* @__PURE__ */React__default["default"].createElement(Box, {
        sx: getCalendarHeaderStyle()
      }, /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
        color: "interaction.blend.07",
        disabled: prevMonthButtonDisabled || !shouldRenderLeftArrow,
        id: "datepicker-previous-month",
        leadingIcon: shouldRenderLeftArrow ? /* @__PURE__ */React__default["default"].createElement(almaIcons.ArrowLeft, null) : void 0,
        onClick: function onClick() {
          return decreaseMonth();
        },
        type: "button"
      }), /* @__PURE__ */React__default["default"].createElement(Heading, {
        variant: "sm"
      }, monthDate.toLocaleString("pt-br", {
        month: "long",
        year: "numeric"
      })), /* @__PURE__ */React__default["default"].createElement(ButtonIcon, {
        color: "interaction.blend.07",
        disabled: nextMonthButtonDisabled || !shouldRenderRightArrow,
        id: "datepicker-next-month",
        leadingIcon: shouldRenderRightArrow ? /* @__PURE__ */React__default["default"].createElement(almaIcons.ArrowRight, null) : void 0,
        onClick: function onClick() {
          return increaseMonth();
        },
        type: "button"
      })));
    };

    var _React__default$defau41 = React__default["default"].useState("day"),
        _React__default$defau42 = _slicedToArray(_React__default$defau41, 2),
        activeYearSelectTab = _React__default$defau42[0],
        setActiveYearSelectTab = _React__default$defau42[1];

    React__default["default"].useEffect(function () {
      if (variant === "default" || variant === "without-year") {
        setActiveYearSelectTab("day");
      } else {
        setActiveYearSelectTab("month");
      }
    }, [variant]);
    return /* @__PURE__ */React__default["default"].createElement(StyledDatepickerContainer, {
      ref: ref,
      zIndex: zIndex
    }, /* @__PURE__ */React__default["default"].createElement(ReactDatePicker__default["default"], __spreadValues$5({
      calendarContainer: function calendarContainer(_ref58) {
        var children = _ref58.children;
        return /* @__PURE__ */React__default["default"].createElement(Box, {
          sx: getCalendarContainerStyle()
        }, children);
      },
      formatWeekDay: function formatWeekDay(formattedDate) {
        return /* @__PURE__ */React__default["default"].createElement(Body, {
          variant: "sm"
        }, weekParser[formattedDate].substring(0, 3));
      },
      inline: true,
      monthsShown: monthsShown,
      onChange: onChange,
      renderCustomHeader: function renderCustomHeader(params) {
        return customHeader(params, activeYearSelectTab, setActiveYearSelectTab);
      },
      renderDayContents: function renderDayContents(dayOfMonth) {
        return /* @__PURE__ */React__default["default"].createElement(Body, {
          variant: "lg"
        }, dayOfMonth);
      },
      selected: selected
    }, props)));
  });
  var __defProp$4 = Object.defineProperty;
  var __defProps$1 = Object.defineProperties;
  var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
  var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
  var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$4 = function __defNormalProp$4(obj, key, value) {
    return key in obj ? __defProp$4(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$4 = function __spreadValues$4(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$4) {
      var _iterator131 = _createForOfIteratorHelper(__getOwnPropSymbols$4(b)),
          _step131;

      try {
        for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
          var prop = _step131.value;
          if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator131.e(err);
      } finally {
        _iterator131.f();
      }
    }

    return a;
  };

  var __spreadProps$1 = function __spreadProps$1(a, b) {
    return __defProps$1(a, __getOwnPropDescs$1(b));
  };

  var __objRest$4 = function __objRest$4(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$4) {
      var _iterator132 = _createForOfIteratorHelper(__getOwnPropSymbols$4(source)),
          _step132;

      try {
        for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
          var prop = _step132.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator132.e(err);
      } finally {
        _iterator132.f();
      }
    }

    return target;
  };

  var applyDateMask = function applyDateMask(dateFormat, value) {
    var cleanValueArray = Array.from(value.replace(/\D/g, ""));
    var dateFormatArray = Array.from(dateFormat.replace(/\w/g, "#"));
    var separator = dateFormat.replace(/\w/g, "").substring(0, 1);
    var newValue = cleanValueArray.slice();
    var loopCount = 0;

    for (var idx = 0; idx < dateFormatArray.length; idx++) {
      if (loopCount === cleanValueArray.length) {
        break;
      }

      if (dateFormatArray[idx] === separator) {
        newValue.splice(idx, 0, separator);
      } else {
        loopCount++;
      }
    }

    return newValue.join("");
  };

  var CustomInput = React__default["default"].forwardRef(function (_a, customInputRef) {
    var _b = _a,
        dateFormat = _b.dateFormat,
        onChange = _b.onChange,
        value = _b.value,
        customInputProps = __objRest$4(_b, ["dateFormat", "onChange", "value"]);

    var _React__default$defau43 = React__default["default"].useState(value || ""),
        _React__default$defau44 = _slicedToArray(_React__default$defau43, 2),
        controlValue = _React__default$defau44[0],
        setControlValue = _React__default$defau44[1];

    React__default["default"].useEffect(function () {
      if (value !== controlValue) {
        setControlValue(applyDateMask(dateFormat, value));
      }
    }, [value, controlValue, dateFormat]);

    var handleOnChange = function handleOnChange(evt) {
      if (onChange) {
        onChange(evt);
      }

      setControlValue(applyDateMask(dateFormat, evt.target.value));
    };

    return /* @__PURE__ */React__default["default"].createElement(Input, __spreadProps$1(__spreadValues$4({
      width: "100%"
    }, customInputProps), {
      onChange: handleOnChange,
      ref: customInputRef,
      value: controlValue
    }));
  });
  var Datepicker = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        dateFormatProp = _d.dateFormat,
        inputProps = _d.inputProps,
        trailingIcon = _d.trailingIcon,
        props = __objRest$4(_d, ["dateFormat", "inputProps", "trailingIcon"]);

    var dateFormat = dateFormatProp || "dd/MM/yyyy";
    return /* @__PURE__ */React__default["default"].createElement(Calendar, __spreadValues$4({
      customInput: /* @__PURE__ */React__default["default"].createElement(CustomInput, __spreadProps$1(__spreadValues$4({}, inputProps), {
        dateFormat: dateFormat,
        ref: ref,
        trailingIcon: trailingIcon
      })),
      dateFormat: dateFormat,
      inline: false
    }, props));
  });
  var DatepickerRanged = React__default["default"].forwardRef(function (_ref59, ref) {
    var endDateProps = _ref59.endDateProps,
        startDateProps = _ref59.startDateProps,
        containerWidth = _ref59.width,
        withPortal = _ref59.withPortal;

    var _a = endDateProps,
        endDateWidth = _a.width,
        endDateRestProps = __objRest$4(_a, ["width"]);

    var _b = startDateProps,
        startDateWidth = _b.width,
        startDateRestProps = __objRest$4(_b, ["width"]);

    return /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        display: "flex",
        position: "relative",
        width: containerWidth ? containerWidth : "100%"
      }
    }, /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        position: "relative",
        width: startDateWidth ? startDateWidth : "50%"
      }
    }, /* @__PURE__ */React__default["default"].createElement(Datepicker, __spreadProps$1(__spreadValues$4({
      withPortal: withPortal
    }, startDateRestProps), {
      endDate: endDateRestProps.endDate,
      monthsShown: 2,
      selected: startDateRestProps.startDate,
      selectsStart: true
    }))), /* @__PURE__ */React__default["default"].createElement(Box, {
      sx: {
        position: "relative",
        width: endDateWidth ? endDateWidth : "50%"
      }
    }, /* @__PURE__ */React__default["default"].createElement(Datepicker, __spreadProps$1(__spreadValues$4({
      withPortal: withPortal
    }, endDateRestProps), {
      minDate: startDateRestProps.startDate,
      monthsShown: 2,
      selected: endDateRestProps.endDate,
      selectsEnd: true,
      startDate: startDateRestProps.startDate
    }))));
  });
  var __defProp$3 = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
  var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
  var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$3 = function __defNormalProp$3(obj, key, value) {
    return key in obj ? __defProp$3(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$3 = function __spreadValues$3(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$3) {
      var _iterator133 = _createForOfIteratorHelper(__getOwnPropSymbols$3(b)),
          _step133;

      try {
        for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
          var prop = _step133.value;
          if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator133.e(err);
      } finally {
        _iterator133.f();
      }
    }

    return a;
  };

  var __spreadProps = function __spreadProps(a, b) {
    return __defProps(a, __getOwnPropDescs(b));
  };

  var __objRest$3 = function __objRest$3(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$3) {
      var _iterator134 = _createForOfIteratorHelper(__getOwnPropSymbols$3(source)),
          _step134;

      try {
        for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
          var prop = _step134.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator134.e(err);
      } finally {
        _iterator134.f();
      }
    }

    return target;
  };

  var getSize = function getSize(variantSize) {
    if (variantSize) {
      if (typeof variantSize === "number") {
        return variantSize;
      }

      switch (variantSize) {
        case "sm":
          return 24;

        case "md":
          return 32;

        case "lg":
          return 40;
      }
    }

    return "1rem";
  };

  var Skeleton = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        brand = _b.brand,
        _b$speed = _b.speed,
        speed = _b$speed === void 0 ? 2 : _b$speed,
        spacing = _b.spacing,
        sx = _b.sx,
        props = __objRest$3(_b, ["brand", "speed", "spacing", "sx"]);

    var customAnimation = react.keyframes({
      from: {
        left: "-100%"
      },
      to: {
        left: "100%"
      }
    });
    return /* @__PURE__ */React__default["default"].createElement(Box, __spreadProps(__spreadValues$3({}, props), {
      ref: ref,
      sx: __spreadValues$3({
        bg: brand ? "neutral.on.brand.30" : "neutral.30",
        marginBottom: spacing,
        overflow: "hidden",
        position: "relative"
      }, sx)
    }), /* @__PURE__ */React__default["default"].createElement(Box, {
      css: react.css(_templateObject18(), customAnimation, speed),
      sx: {
        background: "linear-gradient(\n                        to right,\n                        transparent 0%,\n                        ".concat(brand ? defaultTheme$1.colors.interaction.on.brand.blend["02"] : defaultTheme$1.colors.interaction.blend["02"], " 40%,\n                        ").concat(brand ? defaultTheme$1.colors.interaction.on.brand.blend["02"] : defaultTheme$1.colors.interaction.blend["02"], " 60%,\n                        transparent 100%\n                    )"),
        height: "100%",
        left: "-100%",
        position: "absolute",
        right: 0,
        width: "100%"
      }
    }));
  });
  var SkeletonCircle = React__default["default"].forwardRef(function (_c, ref) {
    var _d = _c,
        _d$variantSize = _d.variantSize,
        variantSize = _d$variantSize === void 0 ? "md" : _d$variantSize,
        sx = _d.sx,
        props = __objRest$3(_d, ["variantSize", "sx"]);

    return /* @__PURE__ */React__default["default"].createElement(Skeleton, __spreadProps(__spreadValues$3({}, props), {
      ref: ref,
      sx: __spreadValues$3({
        borderRadius: "circle",
        height: getSize(variantSize),
        width: getSize(variantSize)
      }, sx)
    }));
  });
  var SkeletonText = React__default["default"].forwardRef(function (_e, ref) {
    var _f = _e,
        _f$noOfLines = _f.noOfLines,
        noOfLines = _f$noOfLines === void 0 ? 1 : _f$noOfLines,
        _f$variant = _f.variant,
        variant = _f$variant === void 0 ? "sharp" : _f$variant,
        _f$variantSize = _f.variantSize,
        variantSize = _f$variantSize === void 0 ? "md" : _f$variantSize,
        sx = _f.sx,
        props = __objRest$3(_f, ["noOfLines", "variant", "variantSize", "sx"]);

    var getBaseComponent = function getBaseComponent(key) {
      return /* @__PURE__ */React__default["default"].createElement(Skeleton, __spreadProps(__spreadValues$3({}, props), {
        key: key,
        ref: ref,
        sx: __spreadValues$3({
          borderRadius: variant === "sharp" ? "none" : "xs",
          height: getSize(variantSize),
          width: "100%"
        }, sx)
      }));
    };

    if (noOfLines && noOfLines > 1) {
      var lines = [];

      for (var idx = 0; idx < noOfLines; idx++) {
        lines.push(getBaseComponent(idx));
      }

      return /* @__PURE__ */React__default["default"].createElement(Box, null, lines);
    }

    return getBaseComponent();
  });
  var __defProp$2 = Object.defineProperty;
  var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
  var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
  var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$2 = function __defNormalProp$2(obj, key, value) {
    return key in obj ? __defProp$2(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$2 = function __spreadValues$2(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$2) {
      var _iterator135 = _createForOfIteratorHelper(__getOwnPropSymbols$2(b)),
          _step135;

      try {
        for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
          var prop = _step135.value;
          if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator135.e(err);
      } finally {
        _iterator135.f();
      }
    }

    return a;
  };

  var __objRest$2 = function __objRest$2(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$2) {
      var _iterator136 = _createForOfIteratorHelper(__getOwnPropSymbols$2(source)),
          _step136;

      try {
        for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
          var prop = _step136.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator136.e(err);
      } finally {
        _iterator136.f();
      }
    }

    return target;
  };

  var Overline = React__default["default"].forwardRef(function (_a, ref) {
    var props = __objRest$2(_a, []);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$2({
      color: getColorTypfaceTokenByProp(props, "smooth"),
      fontFamily: "base",
      fontSize: "xxxs",
      fontWeight: "bold",
      letterSpacing: "medium",
      lineHeight: "distant",
      ref: ref,
      sx: {
        textTransform: "uppercase"
      }
    }, props));
  });
  var __defProp$1 = Object.defineProperty;
  var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
  var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
  var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;

  var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
    return key in obj ? __defProp$1(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues$1 = function __spreadValues$1(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols$1) {
      var _iterator137 = _createForOfIteratorHelper(__getOwnPropSymbols$1(b)),
          _step137;

      try {
        for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
          var prop = _step137.value;
          if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator137.e(err);
      } finally {
        _iterator137.f();
      }
    }

    return a;
  };

  var __objRest$1 = function __objRest$1(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols$1) {
      var _iterator138 = _createForOfIteratorHelper(__getOwnPropSymbols$1(source)),
          _step138;

      try {
        for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
          var prop = _step138.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator138.e(err);
      } finally {
        _iterator138.f();
      }
    }

    return target;
  };

  var isSmallProp = function isSmallProp(variant) {
    return variant === "sm";
  };

  var Subtitle = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        variant = _b.variant,
        props = __objRest$1(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues$1({
      color: getColorTypfaceTokenByProp(props, "pure"),
      fontFamily: "base",
      fontSize: isSmallProp(variant) ? "md" : "lg",
      letterSpacing: isSmallProp(variant) ? "standard" : "small",
      lineHeight: isSmallProp(variant) ? "distant" : "large",
      ref: ref
    }, props));
  });
  Subtitle.defaultProps = {
    variant: "lg"
  };
  var __defProp = Object.defineProperty;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;

  var __defNormalProp = function __defNormalProp(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
      enumerable: true,
      configurable: true,
      writable: true,
      value: value
    }) : obj[key] = value;
  };

  var __spreadValues = function __spreadValues(a, b) {
    for (var prop in b || (b = {})) {
      if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }

    if (__getOwnPropSymbols) {
      var _iterator139 = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
          _step139;

      try {
        for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
          var prop = _step139.value;
          if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
      } catch (err) {
        _iterator139.e(err);
      } finally {
        _iterator139.f();
      }
    }

    return a;
  };

  var __objRest = function __objRest(source, exclude) {
    var target = {};

    for (var prop in source) {
      if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    }

    if (source != null && __getOwnPropSymbols) {
      var _iterator140 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
          _step140;

      try {
        for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
          var prop = _step140.value;
          if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
      } catch (err) {
        _iterator140.e(err);
      } finally {
        _iterator140.f();
      }
    }

    return target;
  };

  var TextAction = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a,
        variant = _b.variant,
        props = __objRest(_b, ["variant"]);

    return /* @__PURE__ */React__default["default"].createElement(Typography, __spreadValues({
      color: getColorTypfaceTokenByProp(props, "strong"),
      fontFamily: "base",
      fontSize: isSmallProp$2(variant) ? "xxs" : "xs",
      fontWeight: "bold",
      letterSpacing: "standard",
      lineHeight: isSmallProp$2(variant) ? "tiny" : "superdistant",
      ref: ref
    }, props));
  });
  TextAction.defaultProps = {
    variant: "lg"
  };
  exports.Accordion = Accordion;
  exports.Action = Action;
  exports.Banner = Banner;
  exports.Body = Body;
  exports.Box = Box;
  exports.BrandAvatar = BrandAvatar;
  exports.Breadcrumb = Breadcrumb;
  exports.BreadcrumbContainer = BreadcrumbContainer;
  exports.Button = Button;
  exports.ButtonFloating = ButtonFloating;
  exports.ButtonIcon = ButtonIcon;
  exports.Calendar = Calendar;
  exports.Caption = Caption;
  exports.Center = Center;
  exports.CheckBox = CheckBox;
  exports.ChipInput = ChipInput;
  exports.ChipStatic = ChipStatic;
  exports.ChipToggle = ChipToggle;
  exports.ColorModeProvider = ColorModeProvider;
  exports.Datepicker = Datepicker;
  exports.DatepickerRanged = DatepickerRanged;
  exports.Divider = Divider;
  exports.Dropdown = DropDownComponent;
  exports.DropdownModuleMultiple = DropdownModuleMultiple;
  exports.DropdownModuleSingle = DropdownModuleSingle;
  exports.Flex = Flex;
  exports.Grid = Grid;
  exports.GridItem = GridItem;
  exports.Heading = Heading;
  exports.Icon = Icon;
  exports.Input = Input;
  exports.InputPassword = InputPassword;
  exports.LinkInline = LinkInline;
  exports.LinkStandalone = LinkStandalone;
  exports.ListItem = ListItem;
  exports.Menu = Menu;
  exports.Multiselect = Multiselect;
  exports.Overlay = Overlay;
  exports.Overline = Overline;
  exports.Pack = Pack;
  exports.Pagination = Pagination;
  exports.PaginationItem = PaginationItem;
  exports.PersonAvatar = PersonAvatar;
  exports.Radio = Radio;
  exports.Search = Search;
  exports.Select = Select;
  exports.SimpleGrid = SimpleGrid;
  exports.Skeleton = Skeleton;
  exports.SkeletonCircle = SkeletonCircle;
  exports.SkeletonText = SkeletonText;
  exports.Snackbar = Snackbar;
  exports.Spacer = Spacer;
  exports.Spacing = Spacing;
  exports.Spinner = Spinner;
  exports.Stepper = Stepper;
  exports.StepperContainer = StepperContainer;
  exports.Subtitle = Subtitle;
  exports.SupportMessage = SupportMessage;
  exports.Switch = Switch;
  exports.Tab = Tab;
  exports.TabContainer = TabContainer;
  exports.TabPane = TabPane;
  exports.TabPanesContainer = TabPanesContainer;
  exports.TextAction = TextAction;
  exports.TextInteraction = TextInteraction;
  exports.ThemeProvider = ThemeProvider;
  exports.Toast = Toast;
  exports.Tooltip = Tooltip;
  exports.Wrap = Wrap;
  exports.colors = defaultColors;
  exports.cssTextEllipsisOneLine = cssTextEllipsisOneLine;
  exports.getCustomTheme = getCustomTheme;
  exports.head = head;
  exports.mapResponsive = mapResponsive;
  exports.stringNormalize = stringNormalize;
  exports.tail = tail$2;
  exports.theme = defaultTheme$1;
  exports.useColorMode = useColorMode;
  exports.useThemeContext = useThemeContext;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});